var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _polygon2, _polygon3, _polygon4, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrmsLogin3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-26",
    d: "M228,360.06a12.1,12.1,0,0,1-6-1.51l-112.45-65a7.1,7.1,0,0,1,0-12.72l145.1-83.77a12.74,12.74,0,0,1,12,0l112.45,65a7.09,7.09,0,0,1,0,12.72L234,358.55A12.13,12.13,0,0,1,228,360.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M109.93,437.29a12.15,12.15,0,0,1-6-1.51l-76.23-44a7.09,7.09,0,0,1,0-12.72L129,320.5a12.74,12.74,0,0,1,12,0l76.23,44a7.09,7.09,0,0,1,0,12.72L115.94,435.78A12.1,12.1,0,0,1,109.93,437.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M358.92,436.43a12.18,12.18,0,0,1-6-1.52l-114.25-66a7.09,7.09,0,0,1,0-12.72l108.89-63a12.76,12.76,0,0,1,12,0l114.25,66a7.09,7.09,0,0,1,0,12.72l-108.89,63A12.18,12.18,0,0,1,358.92,436.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M233.32,486.72a12.18,12.18,0,0,1-6-1.5l-80.76-46.65a7.09,7.09,0,0,1,0-12.72l95.2-55a12.74,12.74,0,0,1,12,0l80.75,46.64a7.09,7.09,0,0,1,0,12.72l-95.19,55A12.24,12.24,0,0,1,233.32,486.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-26",
    points: "319.05 475.48 298.74 463.75 420.6 393.39 440.91 405.12 319.05 475.48",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--meeting-room--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Meeting--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Block--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.55,190.76a2.46,2.46,0,0,1,1.45-2L257.1,105a7.77,7.77,0,0,1,7,0l112.44,65a2.45,2.45,0,0,1,1.46,2v96.29a2.46,2.46,0,0,1-1.46,2L231.48,354.06a7.77,7.77,0,0,1-7,0L112,289.08a2.47,2.47,0,0,1-1.45-2Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.62,104.12a7.17,7.17,0,0,1,3.51.84l112.44,65a2.45,2.45,0,0,1,1.46,2v96.29a2.46,2.46,0,0,1-1.46,2L231.48,354.06a7.17,7.17,0,0,1-3.51.84l-.21-99Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.62,104.12a7.17,7.17,0,0,0-3.51.84L112,188.73a2.47,2.47,0,0,0-1.46,2v96.29a2.48,2.48,0,0,0,1.46,2l112.44,65a7.17,7.17,0,0,0,3.51.84l-.21-99Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.45,257.77,112,192.79c-1.94-1.12-1.94-2.94,0-4.06L257.1,105a7.77,7.77,0,0,1,7,0l112.44,65c1.95,1.12,1.95,2.94,0,4.06L231.48,257.77A7.77,7.77,0,0,1,224.45,257.77Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.45,257.77,112,192.79c-1.94-1.12-1.94-2.94,0-4.06L257.1,105a7.77,7.77,0,0,1,7,0l112.44,65c1.95,1.12,1.95,2.94,0,4.06L231.48,257.77A7.77,7.77,0,0,1,224.45,257.77Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M215.6,239.7l18.14-10.47,18.15,10.47a4.79,4.79,0,0,0,4.33,0l20-11.57a1.32,1.32,0,0,0,0-2.5l-18.15-10.47,28.44-16.42,18.14,10.48a4.79,4.79,0,0,0,4.33,0l20.05-11.58a1.32,1.32,0,0,0,0-2.5l-18.15-10.47,14.1-8.13a1.32,1.32,0,0,0,0-2.5L252.15,132a4.79,4.79,0,0,0-4.33,0l-5.95,3.44-14.09-8.13a4.79,4.79,0,0,0-4.33,0l-20,11.57a1.32,1.32,0,0,0,0,2.5l14.08,8.13-24.37,14.07L179,155.43a4.79,4.79,0,0,0-4.33,0l-44.42,25.64a1.32,1.32,0,0,0,0,2.5l18.15,10.48-6,3.44a1.32,1.32,0,0,0,0,2.5l68.79,39.71A4.79,4.79,0,0,0,215.6,239.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M330.36,172.69c2.31.29,4.69.27,7,.54a25.57,25.57,0,0,1,10.93,3.5,30.37,30.37,0,0,0,4.22,2.64,8.12,8.12,0,0,0,9-13.11,12.39,12.39,0,0,0-3.28-2.31c-9-4.7-20.82-2.81-29.49,1.84-1.83,1-5.76,4.06-2.44,5.9A10.92,10.92,0,0,0,330.36,172.69Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.15,10.76l-.43.25V71a4.62,4.62,0,0,0,1.92,3.68l59.12,34.13A1.29,1.29,0,0,0,320,109l.49-.29a1.69,1.69,0,0,0,.66-1.55v-60Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.76,108.82,259.64,74.69A4.62,4.62,0,0,1,257.72,71V11l63,36.36v60C320.69,108.78,319.83,109.43,318.76,108.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tube--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321,49.23l1.47-2.56L258,9.46h0a.71.71,0,0,0-.76,0,2.33,2.33,0,0,0-1,1.81.74.74,0,0,0,.29.66h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.69,48.55a2.3,2.3,0,0,1,1-1.81c.57-.33,1-.06,1,.61a2.31,2.31,0,0,1-1,1.8C321.15,49.48,320.69,49.21,320.69,48.55Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.7,52.22,263.33,22c-.81-.47-1.47-.09-1.47.85v44.5a3.26,3.26,0,0,0,1.47,2.55l52.37,30.24c.81.47,1.47.09,1.47-.85V54.78A3.26,3.26,0,0,0,315.7,52.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.57 88.3 311.48 89.98 311.48 57.5 308.57 55.82 308.57 88.3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.45 85.34 306.35 87.02 306.35 54.54 303.45 52.86 303.45 85.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.32 82.38 301.23 84.06 301.23 51.58 298.32 49.9 298.32 82.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.19 79.42 296.1 81.1 296.1 48.62 293.19 46.94 293.19 79.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.06 76.46 290.97 78.14 290.97 45.66 288.06 43.98 288.06 76.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.94 73.5 285.84 75.18 285.84 42.7 282.94 41.02 282.94 73.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.84 42.7 282.94 41.02 282.94 55.84 285.84 57.52 285.84 42.7",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.81 70.54 280.71 72.22 280.71 39.73 277.81 38.06 277.81 70.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.68 67.58 275.59 69.26 275.59 36.77 272.68 35.1 272.68 67.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.56 64.62 270.46 66.3 270.46 33.81 267.56 32.14 267.56 64.62",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.48 64.59 308.57 62.91 308.57 81.05 311.48 82.72 311.48 64.59",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.48 82.72 308.57 81.05 308.57 88.3 311.48 89.98 311.48 82.72",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.35 65.75 303.45 64.07 303.45 70.6 306.35 72.28 306.35 65.75",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.35 72.28 303.45 70.6 303.45 85.34 306.35 87.02 306.35 72.28",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.23 54.3 298.32 52.62 298.32 58.32 301.23 59.99 301.23 54.3",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.23 59.99 298.32 58.32 298.32 82.38 301.23 84.06 301.23 59.99",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.1 55.71 293.19 54.03 293.19 68.39 296.1 70.06 296.1 55.71",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.1 70.06 293.19 68.39 293.19 79.42 296.1 81.1 296.1 70.06",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.97 58.58 288.06 56.9 288.06 62.97 290.97 64.65 290.97 58.58",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.97 64.65 288.06 62.97 288.06 76.46 290.97 78.14 290.97 64.65",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.84 57.52 282.94 55.84 282.94 73.5 285.84 75.18 285.84 57.52",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.71 56.91 277.81 55.24 277.81 62.38 280.71 64.06 280.71 56.91",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.71 64.06 277.81 62.38 277.81 70.54 280.71 72.22 280.71 64.06",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.59 42.34 272.68 40.67 272.68 56.81 275.59 58.49 275.59 42.34",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.59 58.49 272.68 56.81 272.68 67.58 275.59 69.26 275.59 58.49",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.46 48.18 267.56 46.51 267.56 52.13 270.46 53.8 270.46 48.18",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.46 53.8 267.56 52.13 267.56 64.62 270.46 66.3 270.46 53.8",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.48 82.72 308.57 81.05 308.57 88.3 311.48 89.98 311.48 82.72",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.48 82.72 308.57 81.05 308.57 88.3 311.48 89.98 311.48 82.72",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.35 72.28 303.45 70.6 303.45 85.34 306.35 87.02 306.35 72.28",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.35 72.28 303.45 70.6 303.45 85.34 306.35 87.02 306.35 72.28",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.23 59.99 298.32 58.32 298.32 82.38 301.23 84.06 301.23 59.99",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.23 59.99 298.32 58.32 298.32 82.38 301.23 84.06 301.23 59.99",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.1 70.06 293.19 68.39 293.19 79.42 296.1 81.1 296.1 70.06",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.1 70.06 293.19 68.39 293.19 79.42 296.1 81.1 296.1 70.06",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.97 64.65 288.06 62.97 288.06 76.46 290.97 78.14 290.97 64.65",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.97 64.65 288.06 62.97 288.06 76.46 290.97 78.14 290.97 64.65",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.84 57.52 282.94 55.84 282.94 73.5 285.84 75.18 285.84 57.52",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.84 57.52 282.94 55.84 282.94 73.5 285.84 75.18 285.84 57.52",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.71 64.06 277.81 62.38 277.81 70.54 280.71 72.22 280.71 64.06",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.71 64.06 277.81 62.38 277.81 70.54 280.71 72.22 280.71 64.06",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.59 58.49 272.68 56.81 272.68 67.58 275.59 69.26 275.59 58.49",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.59 58.49 272.68 56.81 272.68 67.58 275.59 69.26 275.59 58.49",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.46 53.8 267.56 52.13 267.56 64.62 270.46 66.3 270.46 53.8",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-26"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "340.96 166.4 338.97 165.66 339.61 164.32 340.84 165.45 340.96 166.4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343,162.8s.08,1.3.1,1.71-1.71,1.68-2.14,1.89l-.12-1a7.32,7.32,0,0,0-1,1.55,7.64,7.64,0,0,1-1.66,2.44,9.77,9.77,0,0,1-5.66,1.78,6.24,6.24,0,0,1-4-.9,1.43,1.43,0,0,1-.66-1.57C328,168.2,343,162.8,343,162.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.17,158.42l0-.75c-.4,0-.45,1.08-1,2a19.26,19.26,0,0,1-3,3.93c-2.19,2-4.15,3.28-5.13,4.19-1.3,1.22,1,3.13,4.56,2.91,1.76-.11,4.87-1,5.75-2s1.4-2.67,2.1-3.43,2.2-1.53,2.64-2.45a6.36,6.36,0,0,0-.05-2.67c-.13-.92-.17-2.32-.69-2.21l0,.48a2.63,2.63,0,0,1-2.11,1.31C339.41,159.83,337.3,159.91,337.17,158.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,159.75a1.9,1.9,0,0,1-1.69-.88l0,0a1.7,1.7,0,0,1-.45,1.44c-.62.75-4.6,6-4.6,6l4.41-5.15c1.05-1.21,1.39-1.35,2.35-1.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,167.82c.83-.76,2.35-1.79,4.13-3.31-.38.6-.92,1.07-1,1.27-.13.49,1.33,1.17,2.22,1.4s1.88-1.05,3.19-2.2,2.46.18,2.91,1.79a11.43,11.43,0,0,1-1.16,1.91c-.88,1-4,1.94-5.75,2C329,171,326.65,169,328,167.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.1,161.14a.21.21,0,0,0,.24.19.21.21,0,0,0,.19-.24.22.22,0,0,0-.24-.19A.22.22,0,0,0,338.1,161.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.06,162.3a.21.21,0,0,0,.24.19.21.21,0,0,0,.19-.24.22.22,0,0,0-.24-.19A.22.22,0,0,0,337.06,162.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,163.46a.22.22,0,0,0,.24.19.21.21,0,0,0,.19-.24.22.22,0,0,0-.24-.19A.24.24,0,0,0,336,163.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,164.63a.24.24,0,0,0,.24.19.22.22,0,0,0,.19-.24.21.21,0,0,0-.24-.19A.22.22,0,0,0,335,164.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,165.79a.22.22,0,0,0,.44,0,.22.22,0,0,0-.24-.19A.22.22,0,0,0,333.94,165.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.33,161.2l.05,0a.11.11,0,0,0,0-.13,3.56,3.56,0,0,0-2.46-1h0a.09.09,0,0,0-.08.09.1.1,0,0,0,.1.08,3.46,3.46,0,0,1,2.32.91A.06.06,0,0,0,338.33,161.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.29,162.36a.05.05,0,0,0,0,0,.09.09,0,0,0,0-.12,3.56,3.56,0,0,0-2.46-1h0a.09.09,0,0,0-.08.09.1.1,0,0,0,.1.08,3.46,3.46,0,0,1,2.32.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.25,163.53s0,0,.05,0a.08.08,0,0,0,0-.12,3.5,3.5,0,0,0-2.46-1h0a.1.1,0,0,0-.08.09.09.09,0,0,0,.1.08,3.46,3.46,0,0,1,2.32.91A.09.09,0,0,0,336.25,163.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.21,164.69a.05.05,0,0,0,.05,0,.07.07,0,0,0,0-.12,3.59,3.59,0,0,0-2.45-1h0a.09.09,0,0,0,0,.18,3.42,3.42,0,0,1,2.32.9A.09.09,0,0,0,335.21,164.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.17,165.85a.05.05,0,0,0,.05,0,.07.07,0,0,0,0-.12,3.59,3.59,0,0,0-2.45-1h0a.09.09,0,0,0,0,.18,3.52,3.52,0,0,1,2.32.9A.09.09,0,0,0,334.17,165.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.19,172.29a8.11,8.11,0,0,0,.64,4,2.54,2.54,0,0,0,2.85,1.29,3.88,3.88,0,0,0,3.23-2.31,9.42,9.42,0,0,0,.36-4.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,160.19c.47.08.41,2.41.49,4.76.08,2.51.73,3.61.82,5.67.1,2.36-.12,3.39-1.06,4.73s-3.95,2.47-5.2.32c-1-1.75-.91-3.58-.59-5.89a59,59,0,0,0,.62-5.92c.06-1.75.09-3.46.53-3.61,0,.25,0,.58,0,.84s0,1.14.24,1.18a3.7,3.7,0,0,0,.07-.66.76.76,0,0,1,.18-.55,1,1,0,0,1,.56-.2,13.93,13.93,0,0,1,1.45-.09l.73,0a2.1,2.1,0,0,1,.6.14.41.41,0,0,1,.24.26.82.82,0,0,1,0,.27,1.93,1.93,0,0,0,0,.48c0,.07.05.16.12.15a.12.12,0,0,0,.09-.13c0-.28,0-.49,0-.82,0-.15,0-.36,0-.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.44,171a.17.17,0,0,1-.17.17.16.16,0,0,1-.17-.16.16.16,0,0,1,.17-.17A.16.16,0,0,1,358.44,171Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,169.42a.18.18,0,0,1-.17.17.17.17,0,1,1,0-.34A.18.18,0,0,1,358.42,169.42Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.4,167.89a.18.18,0,0,1-.17.17.17.17,0,1,1,.17-.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.38,166.38a.18.18,0,0,1-.17.17.17.17,0,1,1,.17-.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.2,166.3a.17.17,0,0,1-.17.17.17.17,0,0,1,0-.33A.17.17,0,0,1,355.2,166.3Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.22,167.82a.18.18,0,0,1-.17.18.17.17,0,0,1-.17-.17.16.16,0,0,1,.16-.17A.18.18,0,0,1,355.22,167.82Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.23,169.36a.16.16,0,0,1-.16.17.17.17,0,0,1-.17-.17.16.16,0,0,1,.16-.17A.16.16,0,0,1,355.23,169.36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.26,171a.18.18,0,0,1-.17.17.16.16,0,0,1-.17-.17.17.17,0,0,1,.16-.17A.18.18,0,0,1,355.26,171Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.26,170.62a13.05,13.05,0,0,0-.37-2.44,1.15,1.15,0,0,0-.21.23,2.13,2.13,0,0,0-.27.7c-.09.3-.19.64-.26.91a3.24,3.24,0,0,1-1.06,1.89,2.06,2.06,0,0,1-1.4.27,5.36,5.36,0,0,1-1.26-.15c-.52-.19-.61-.69-.73-1.17s-.3-1.2-.47-1.8a1.7,1.7,0,0,0-.39-.81.6.6,0,0,0-.21-.14c-.07.52-.15,1.07-.22,1.67-.32,2.31-.43,4.14.59,5.89,1.25,2.15,4.26,1,5.2-.32S360.36,173,360.26,170.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.61 171.86 356.3 160.52 356.92 160.56 356.61 171.86",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.27,171.13h0a5.15,5.15,0,0,0-3.12-.08A.08.08,0,0,1,355,171a.08.08,0,0,1,0-.11,5.3,5.3,0,0,1,3.24.07.1.1,0,0,1,.06.11A.08.08,0,0,1,358.27,171.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.25,169.51h-.05a4.06,4.06,0,0,0-3.1-.07.1.1,0,0,1-.12-.05.09.09,0,0,1,0-.11,4.23,4.23,0,0,1,3.26.08.08.08,0,0,1,0,.12A.08.08,0,0,1,358.25,169.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.23,168l-.05,0a4.1,4.1,0,0,0-3.1-.06.09.09,0,0,1-.11-.05.08.08,0,0,1,0-.11,4.23,4.23,0,0,1,3.26.08.07.07,0,0,1,0,.11A.08.08,0,0,1,358.23,168Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.21,166.47a.05.05,0,0,1,0,0,4.13,4.13,0,0,0-3.11-.06.09.09,0,0,1-.11,0,.08.08,0,0,1,.05-.11,4.21,4.21,0,0,1,3.25.08.07.07,0,0,1,0,.11A.08.08,0,0,1,358.21,166.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.13,94.66a29.43,29.43,0,0,1,2.58,8.64c1,10.87,1.68,27.59,1.68,27.59.12,1.14.31,3.12.88,8.12.67,5.9.18,25.83.18,25.83s-4.54,1.91-7.19.19c0,0-3.83-27.13-4.68-33-.74-5.12-2.35-17.36-2.35-17.36l-2,16.44s.26,4.61.16,7.59c-.12,3.48-1.32,22.79-1.32,22.79s-4.66,2-8.16-.63c0,0-.4-23.71-.53-27.89-.26-8.18.72-25.41,1.51-34.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.23,114.67l-.66-4s-3.94.1-6-1.75c0,0,.85,2.5,4.85,2.76L345,115l-.51,14.14Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341,71.41c-1.65.26-5.17.61-7.09,2.77-1.68,1.9-5.8,6.85-8.2,10-1.7-1.69-5.82-5.77-6.51-7a19,19,0,0,1-1.58-3.56,13.23,13.23,0,0,1-.59-2.24,12.73,12.73,0,0,1-.11-2.81c0-.85-1.25-.38-1.7,1a7.09,7.09,0,0,0-.32,2.32l-2.06-1c-.75-.32-3.13-1.09-3.32.24,0,.3.06.62-.06.89a2.22,2.22,0,0,1-.25.35A1.5,1.5,0,0,0,309,74a1.21,1.21,0,0,1,.14.7,1.94,1.94,0,0,0,0,.76,3.35,3.35,0,0,0,.31.55,2.27,2.27,0,0,1,.22.77,2.7,2.7,0,0,0,.2.79c.27.58,1,.7,1.54.88a24.88,24.88,0,0,1,2.47.91c1.33.83,5,7.14,8.69,11.16,1.26,1.37,2.38,2.22,3.54,2h0c.94,0,2.09-.93,3.19-1.92,3.49-3.17,9.15-9.08,9.15-9.08C340.79,78.6,341.28,73.35,341,71.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,71.34a12.18,12.18,0,0,0-4.45,1,7.71,7.71,0,0,0-3.18,2.69c-1.42,1.67-7.25,9.17-7.25,9.17a45.91,45.91,0,0,1,1,8.21c3.31-1.38,9.76-8.3,14.69-14.32Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,71.34a12.18,12.18,0,0,0-4.45,1,7.71,7.71,0,0,0-3.18,2.69c-1.42,1.67-7.25,9.17-7.25,9.17a45.91,45.91,0,0,1,1,8.21c3.31-1.38,9.76-8.3,14.69-14.32Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,83.63c-.47.13-.61-.5-.86-.26a9.88,9.88,0,0,1,.43,4.28,4.61,4.61,0,0,1-1.93,3.61l-.49-.49s-.33.5.59,1.26a3.72,3.72,0,0,0,3.18,1.13c1.41-.2,2.58-1.25,2.49-1.89a13.57,13.57,0,0,0-1.41-6C326.88,83.9,326.15,83.5,325.67,83.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.92,72.07c.73.24.93.73.9,1.79a2.88,2.88,0,0,0,.83,2.26,1.64,1.64,0,0,1-.88-.39c-.32-.34-.41-.37-.59-.19a1.17,1.17,0,0,1-.47.27.8.8,0,0,1,.06,1c-.33.54-1.8.54-3-.09,0,0,2,.62,2.41,0s-.57-1.41-1.34-1.63c0,0,1.89.47,2.18-.15s-.48-1.09-1.59-1.38c0,0,1.56.29,1.83-.23A1,1,0,0,0,313.92,72.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.79,73.91A3.56,3.56,0,0,1,359,77,30.74,30.74,0,0,1,358,84.25a43.67,43.67,0,0,0-1.18,8.15l.72,9.56c-2.83,3.17-15.34,4.63-21.7.12,0,0-.35-17.29.23-22.81a12.66,12.66,0,0,1,3.6-7.78,23,23,0,0,1,3.48-.46l6.59-.67Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.79,73.91A3.56,3.56,0,0,1,359,77,30.74,30.74,0,0,1,358,84.25a43.67,43.67,0,0,0-1.18,8.15l.72,9.56c-2.83,3.17-15.34,4.63-21.7.12,0,0-.35-17.29.23-22.81a12.66,12.66,0,0,1,3.6-7.78,23,23,0,0,1,3.48-.46l6.59-.67Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.71,53.81a2.31,2.31,0,0,1,2.38,1.07c.88,1.24.29,3.77-.27,6.42a19.61,19.61,0,0,1-1.58,4.83,2.06,2.06,0,0,1-1.13,1l0-3.12,0-2.18a9,9,0,0,1-1.66-3.41,5.47,5.47,0,0,1,.13-2.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.78,57.41a5.82,5.82,0,1,1-6-5.63A5.82,5.82,0,0,1,349.78,57.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.78,64.76a1.75,1.75,0,0,1-2.19-.37l-.25,6.44s.15,1.23-1.78,2.39c-2.75,1.64-3.81,1.26-5.46,2.88-1.29-2.36-1.77-4,.3-5.6V69a12.4,12.4,0,0,1-2.26.07,3.58,3.58,0,0,1-2.86-2.81c-.77-2.47-.74-6.21.06-11.07,1.56-1.29,6.8-1.67,10.24.35-.07,2.85.77,4.09.8,5.12a2.77,2.77,0,0,0,.64.78c.54.44.93-.75,1.35-1.23a1.55,1.55,0,0,1,2.6.34A3.65,3.65,0,0,1,353.78,64.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,51.44a.28.28,0,0,1,.2-.17.36.36,0,0,1,.2.08,8.85,8.85,0,0,0,1.31.81,4.58,4.58,0,0,1-.09-1.73c0-.36.13-1.18.56-1.28.26-.06.49.15.69.32,1.81,1.58,4.06.74,6.17.74,1.76,0,3.91.64,4.77,2.32a1.63,1.63,0,0,1-.22,2.16,5,5,0,0,1-2.12.88c-3.49.73-8.17,2.09-10.88-1.09a3,3,0,0,1-.76-1.59,2.57,2.57,0,0,1,.16-1.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.85,58.47l1.36.78a.84.84,0,0,0-.3-1.1A.77.77,0,0,0,345.85,58.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.47,59l1.5-.49a.77.77,0,0,0-1-.52A.84.84,0,0,0,339.47,59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.54,60.43a.65.65,0,1,1-.64-.64A.65.65,0,0,1,346.54,60.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.26,60.44a.65.65,0,0,1-1.29,0,.65.65,0,0,1,1.29,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.61,58.64l-.29,4.3-2-.52A7,7,0,0,1,343.61,58.64Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,60.32c-.2,3-1.21,3.95-2.27,4.27-1.68.5-2.85-.55-4.82-.9a6,6,0,0,0-3.11.49c-.18.06-.39.1-.58.15a.68.68,0,0,1-.81-.61,23.16,23.16,0,0,1-.05-3.5l-.3-1s-.18,4.24-.05,5.68.31,2.61,1.47,3.47,3.57,1.26,6.45.68,4-1.53,4.33-2.54c1.18-3.28.76-4.85,1.15-5.46S350.41,60.32,350.41,60.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,64.84l-1.91.49a1,1,0,0,0,1.18.75A1,1,0,0,0,344.86,64.84Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.64,65.17a.65.65,0,0,1,.24,0,1,1,0,0,1-.75.92,1.15,1.15,0,0,1-.32,0A.91.91,0,0,1,344.64,65.17Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,76.1c.82-.49,2.6-1.34,3.48-.39s1.36,1.21,1.95,1a19.11,19.11,0,0,0,3.83-3.13c.86-.93.69-1.35.69-1.35a16.07,16.07,0,0,0-1.41-1.63c-.61-.56-.75-.73-1.26-.77l0,1a5.09,5.09,0,0,1-1.79,1.72C348.09,73.53,345.17,73.82,344.1,76.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,76.1c-.48-.44-1.52-1.54-2.31-1.32s-1.13.7-1.15.28a8.5,8.5,0,0,1,1.28-2.83A6.7,6.7,0,0,1,344.4,70v.83s-1.28,2-1.18,2.71S344,75.41,344.1,76.1Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "324.7 88.68 341.11 91.49 347.6 110.97 331.96 107.89 324.7 88.68",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.67,103.13a3.76,3.76,0,0,0,2.71,2.66,8.18,8.18,0,0,0,4.37-.36l-.54-1.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.65,91.14l-.19-.6c-.1-.33.84-.42,2.1-.21l2.42.4c1.26.21,2.37.65,2.47,1l.19.6Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.34,88.93c-.07-.2.31-.29.84-.19l1,.17s-.4-1.3,1.72-1a3.27,3.27,0,0,1,2.7,1.74l1,.2c.57.11,1.1.36,1.18.57l.15.37-8.45-1.45S328.4,89.14,328.34,88.93Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.34,88.93c-.07-.2.31-.29.84-.19l1,.17s-.4-1.3,1.72-1a3.27,3.27,0,0,1,2.7,1.74l1,.2c.57.11,1.1.36,1.18.57l.15.37-8.45-1.45S328.4,89.14,328.34,88.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,91.78c-.09-.27-.87-.62-1.86-.86a.29.29,0,0,1,0-.09c-.09-.29,0-.48.62-.38l0-.23-5.86-1,.26.24c.77.11,1.1.18,1.26.69l0,.12c-.92-.08-1.53,0-1.45.3s.19.6.19.6l7,1.17Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,91.78c-.09-.27-.87-.62-1.86-.86a.29.29,0,0,1,0-.09c-.09-.29,0-.48.62-.38l0-.23-5.86-1,.26.24c.77.11,1.1.18,1.26.69l0,.12c-.92-.08-1.53,0-1.45.3s.19.6.19.6l7,1.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,100.21c-2,.72-4.22.54-6.29.61-.2,0-.45,0-.53.22a.44.44,0,0,0,.19.47,2.23,2.23,0,0,1,.4.35c.16.23.1.55.15.83a2.07,2.07,0,0,0,.64,1,5.2,5.2,0,0,0,1.05.94,7.38,7.38,0,0,0,4.68.55,16.05,16.05,0,0,0,2.85-.92c.87-.35,6.19-2,6.82-2.29,4.69-1.76,11.15-3.93,11.48-6.18s-1.61-9.64-2.59-15.32c-.94-5.39-2.94-6-6-6.59a10.12,10.12,0,0,0-.74,10.5l2,8.75a101.29,101.29,0,0,1-9.46,5.43,3.78,3.78,0,0,1-1.88-.15,8,8,0,0,0-3.44-.27",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.81,73.44a6.52,6.52,0,0,1,5.45,4.15c1.16,2.3,3.33,14.69,3.24,17.87a11.76,11.76,0,0,0-7.38-2.29l-2.23-8.88C355.07,82.57,353.68,77.2,356.81,73.44Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.81,73.44a6.52,6.52,0,0,1,5.45,4.15c1.16,2.3,3.33,14.69,3.24,17.87a11.76,11.76,0,0,0-7.38-2.29l-2.23-8.88C355.07,82.57,353.68,77.2,356.81,73.44Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.83,92c-.21.11.12.43,0,.85s-.6.61-.51.82a7.58,7.58,0,0,1,4.76,1,3.81,3.81,0,0,1,1.84,2.94l-.43.28s.54.79,1.38-.09a5.07,5.07,0,0,0,1-3.93c-.21-1.38,0-2-.69-2.25S360.5,90.69,357.83,92Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wheel-chair--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.76,143.75l-.81-.46a11.53,11.53,0,0,0-5.55-1.73h-.14a8.14,8.14,0,0,0-.87.05,9.49,9.49,0,0,0-6.49,3.62l-.09.11-.16.21-.1.14-.12.18a3.87,3.87,0,0,0-.21.34l-.08.13-.09.18v0a9.48,9.48,0,0,0-1.14,4.53v.38c0,.17,0,.35,0,.53v.93c0,8.09,5.67,17.93,12.68,22l.81.47a11.5,11.5,0,0,0,5.54,1.72h.55l.28,0H177a9.5,9.5,0,0,0,6.63-3.85l.2-.27,0,0a2.66,2.66,0,0,0,.21-.33,9.44,9.44,0,0,0,1.41-5v-1.84C185.44,157.63,179.76,147.8,172.76,143.75ZM170,172.37c-5.91-3.42-10.7-11.72-10.7-18.55s4.79-9.59,10.7-6.18,10.71,11.72,10.71,18.54S175.89,175.78,170,172.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,145.13l-.81-.47c-3.47-2-6.61-2.21-8.9-.93l-.17.11,0,0-.21.13-.2.14c-.13.1-.26.2-.38.31l-.18.16a4.08,4.08,0,0,0-.36.36c0,.06-.11.12-.16.19s-.11.13-.16.19l-.16.21-.1.14-.12.18a3.87,3.87,0,0,0-.21.34l-.08.13-.09.18-.09.17c-.1.22-.2.44-.29.67s-.1.25-.14.37v0c-.08.23-.15.46-.22.71s-.06.26-.1.4l-.09.47a1.7,1.7,0,0,0,0,.22l-.06.39c0,.15,0,.3-.05.45v.07c0,.13,0,.26,0,.39V151c0,.14,0,.29,0,.44s0,.35,0,.53v.93c0,8.09,5.67,17.93,12.68,22l.81.47a11.51,11.51,0,0,0,5.66,1.73h.43l.28,0h.14l.28,0,.25,0,.23,0,.45-.13.18-.06.21-.07.17-.07.36-.16.17-.09.05,0,.07,0,.11-.06c2.25-1.34,3.64-4.16,3.64-8.16v-.94C183.06,159,177.38,149.17,170.38,145.13ZM170,172.37c-5.91-3.42-10.7-11.72-10.7-18.55s4.79-9.59,10.7-6.18,10.71,11.72,10.71,18.54S175.89,175.78,170,172.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.94,170.61c-1.7,2-4.63,2.31-8,.38-5.25-3-9.51-10.41-9.51-16.48,0-2.71.85-4.71,2.26-5.81a7.76,7.76,0,0,0-1.56,5.12c0,6.07,4.26,13.45,9.52,16.49C173.59,172,176.19,172,177.94,170.61Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.94,170.61c-1.7,2-4.63,2.31-8,.38-5.25-3-9.51-10.41-9.51-16.48,0-2.71.85-4.71,2.26-5.81a7.76,7.76,0,0,0-1.56,5.12c0,6.07,4.26,13.45,9.52,16.49C173.59,172,176.19,172,177.94,170.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,147.64c-5.91-3.41-10.7-.65-10.7,6.18S164.06,169,170,172.37s10.71.64,10.71-6.19S175.89,151.05,170,147.64ZM170,171c-5.25-3-9.51-10.41-9.51-16.48S164.72,146,170,149s9.52,10.42,9.52,16.49S175.23,174,170,171Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.17,162.48c0-.11,0-.22-.07-.32l-8.29-2.23-.19-.27,6.09-3.52a2.07,2.07,0,0,0-.15-.25l-6.09,3.51-.14-.3,2.2-8.21-.25-.21-2.16,8.07-.29-.33L167.7,148l-.32-.09,2.1,10.26-.33-.05-5.71-9.89-.26.14,5.71,9.9-.12.31-7.91-7c0,.11-.07.21-.09.32l8,7.11.15.42-8.22-2.2.06.32,8.36,2.24.19.28-6.22,3.58.15.26,6.21-3.59.15.3-2.26,8.44.24.22,2.23-8.3.29.33,2.19,10.7.31.08-2.16-10.56.34.05,5.83,10.11a1.74,1.74,0,0,0,.26-.15l-5.84-10.1.12-.32,8,7.08c0-.11.06-.21.08-.32l-8.08-7.17-.14-.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.52,155.57a2.44,2.44,0,0,0-2.57-.21l-.47.26a1.1,1.1,0,0,0-.14.09h0l-.18.14,0,0a1.07,1.07,0,0,0-.14.16l-.05.06-.11.16-.06.1-.08.17s0,.08,0,.13l-.06.16c0,.06,0,.12,0,.18s0,.1,0,.15l0,.23a.68.68,0,0,0,0,.14c0,.12,0,.26,0,.39a7.9,7.9,0,0,0,3.57,6.19l.37.18.21.09.15.06.14,0,.2.05.08,0a2.3,2.3,0,0,0,.26,0h0a1.82,1.82,0,0,0,1.17-.27l.52-.29a2.52,2.52,0,0,0,1-2.29A7.9,7.9,0,0,0,170.52,155.57Zm-1,6.86a8.65,8.65,0,0,1-1.8-2.73,4.65,4.65,0,0,0,.62.38c.93.48.91-.17,1.28.28a2.38,2.38,0,0,1,0,2.13Zm1.81-4.23-.15.07-.55.31a.86.86,0,0,0-.27.27,4.92,4.92,0,0,1-1-2.66,5.91,5.91,0,0,1,2.33,1.81.69.69,0,0,1,0,.1A2.84,2.84,0,0,0,171.31,158.2Zm-2.7-.47c.29,1.08.75,1.24.78,1.59-.71-.11-1.85-.79-1.92-1.47a2.72,2.72,0,0,1,.61-1.81C168.38,156.17,168.36,156.85,168.61,157.73Zm2,5.66c-.37-.34,0-.67.23-1.38a1.81,1.81,0,0,0,0-1c.73.58,1.83,2.09,1.55,2.54l0,.05A2.36,2.36,0,0,1,170.62,163.39Zm1.75-2.35c-.78-1-1.09-.68-1.28-1.23a.73.73,0,0,1,.26-.75.92.92,0,0,1,1.12.38,6.8,6.8,0,0,1,.61,2.66C172.89,161.83,172.66,161.43,172.37,161Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.52,155.57a2.44,2.44,0,0,0-2.57-.21l-.47.26a1.1,1.1,0,0,0-.14.09h0l-.18.14,0,0a1.07,1.07,0,0,0-.14.16l-.05.06-.11.16-.06.1-.08.17s0,.08,0,.13l-.06.16c0,.06,0,.12,0,.18s0,.1,0,.15l0,.23a.68.68,0,0,0,0,.14c0,.12,0,.26,0,.39a7.9,7.9,0,0,0,3.57,6.19l.37.18.21.09.15.06.14,0,.2.05.08,0a2.3,2.3,0,0,0,.26,0h0a1.82,1.82,0,0,0,1.17-.27l.52-.29a2.52,2.52,0,0,0,1-2.29A7.9,7.9,0,0,0,170.52,155.57Zm-1,6.86a8.65,8.65,0,0,1-1.8-2.73,4.65,4.65,0,0,0,.62.38c.93.48.91-.17,1.28.28a2.38,2.38,0,0,1,0,2.13Zm1.81-4.23-.15.07-.55.31a.86.86,0,0,0-.27.27,4.92,4.92,0,0,1-1-2.66,5.91,5.91,0,0,1,2.33,1.81.69.69,0,0,1,0,.1A2.84,2.84,0,0,0,171.31,158.2Zm-2.7-.47c.29,1.08.75,1.24.78,1.59-.71-.11-1.85-.79-1.92-1.47a2.72,2.72,0,0,1,.61-1.81C168.38,156.17,168.36,156.85,168.61,157.73Zm2,5.66c-.37-.34,0-.67.23-1.38a1.81,1.81,0,0,0,0-1c.73.58,1.83,2.09,1.55,2.54l0,.05A2.36,2.36,0,0,1,170.62,163.39Zm1.75-2.35c-.78-1-1.09-.68-1.28-1.23a.73.73,0,0,1,.26-.75.92.92,0,0,1,1.12.38,6.8,6.8,0,0,1,.61,2.66C172.89,161.83,172.66,161.43,172.37,161Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,155.88c-2-1.14-3.57-.21-3.57,2.06a7.9,7.9,0,0,0,3.57,6.19c2,1.13,3.57.21,3.57-2.07A7.9,7.9,0,0,0,170,155.88Zm-.88.24a5.37,5.37,0,0,1,2.63,1.88c.24.49-.38.31-.95.51-.72.26-.38,1-.81.78C169.34,159,168.39,156.11,169.09,156.12ZM168,156c.36.06.31.77.58,1.71.33,1.19.84,1.27.77,1.71-.11.66-2.35-.32-2.46-1.28S167.66,156,168,156Zm.93,6.72a8.22,8.22,0,0,1-2-3.2c0-.45.58.17,1.31.54.93.48.91-.17,1.28.28C170.16,161,169.73,163.34,169,162.74Zm3.43.79c-.37.59-1.94.51-2.31.17s0-.67.23-1.38c.24-.89-.29-1.37,0-1.54S172.76,162.94,172.39,163.53Zm-.57-2.18c-.78-1-1.08-.68-1.27-1.23-.28-.81,1.38-1.64,1.92-.68a5.79,5.79,0,0,1,.52,3.31C172.77,163,172.43,162.16,171.82,161.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,161.26c.61.35,1.09.07,1.09-.63a2.4,2.4,0,0,0-1.09-1.89c-.6-.35-1.09-.06-1.09.63A2.4,2.4,0,0,0,170,161.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.68,185l-4.21-8.87h0l-1.34-2.84a10.82,10.82,0,0,0-4-4.54V170a9.8,9.8,0,0,1,3.1,3.74l.64,1.35-3.24-1.84v1.2l4,2.28,4.13,8.72a.52.52,0,0,0,.47.3.43.43,0,0,0,.22-.06A.52.52,0,0,0,200.68,185Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.88,172.49c-1.47,2.78-1,6.32-.94,7.53s-.56,1-.9,0a12.85,12.85,0,0,1,.29-8.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,181.13a7.75,7.75,0,0,0-3.51-6.07,2.39,2.39,0,0,0-2.57-.18h0l-1.5.84,5,8.55,1.48-.84h0A2.45,2.45,0,0,0,191.7,181.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,176a7.75,7.75,0,0,1,3.51,6.07c0,2.24-1.57,3.15-3.51,2a7.77,7.77,0,0,1-3.5-6.08C183.1,175.76,184.67,174.85,186.6,176Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,178.59a2.72,2.72,0,0,1,1.24,2.14c0,.79-.55,1.11-1.24.71a2.72,2.72,0,0,1-1.23-2.14C185.37,178.52,185.92,178.2,186.6,178.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.84,172.37c-1.47,2.78-1,6.33-.94,7.54s-.55,1-.9,0a12.88,12.88,0,0,1,.29-8.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.56,173.75,176.88,165v1.55l12.51,7.4h0l1.61.95.28.17a.72.72,0,0,0,1.08-.69l-.14-1.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.57 199.56 174.53 195.5 197.05 182.49 204.09 186.56 181.57 199.56",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.53 195.5 174.53 197.12 181.57 201.19 181.57 199.56 174.53 195.5",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.53 195.5 174.53 197.12 181.57 201.19 181.57 199.56 174.53 195.5",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.09 186.56 204.09 188.18 181.57 201.19 181.57 199.56 204.09 186.56",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.09 186.56 204.09 188.18 181.57 201.19 181.57 199.56 204.09 186.56",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.21,180.36a.52.52,0,0,1,.71-.19l.44.26a10.78,10.78,0,0,1,4.4,4.76L172.1,188h0l4.21,8.88a.52.52,0,0,1-.25.69.44.44,0,0,1-.22,0,.51.51,0,0,1-.47-.3l-4.14-8.71L166,185.68a.52.52,0,1,1,.51-.91l3.91,2.22-.64-1.35a9.76,9.76,0,0,0-4-4.31l-.44-.26A.51.51,0,0,1,165.21,180.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,186.23c-1.47,2.78-1,6.32-.94,7.53s-.56,1-.9,0a12.85,12.85,0,0,1,.29-8.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.77,194.87a7.75,7.75,0,0,0-3.51-6.07,2.39,2.39,0,0,0-2.57-.18h0l-1.49.84,5,8.55,1.47-.84h0A2.45,2.45,0,0,0,167.77,194.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,189.71a7.75,7.75,0,0,1,3.51,6.07c0,2.24-1.57,3.15-3.51,2a7.77,7.77,0,0,1-3.5-6.08C159.17,189.5,160.74,188.59,162.67,189.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,192.33a2.72,2.72,0,0,1,1.24,2.14c0,.79-.55,1.11-1.24.71a2.72,2.72,0,0,1-1.23-2.14C161.44,192.26,162,191.94,162.67,192.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.91,186.11c-1.47,2.78-1,6.33-.94,7.54s-.55,1-.9,0a12.88,12.88,0,0,1,.29-8.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.41,135.53l1.35-2.34L137,129.88h0a.7.7,0,0,0-.69.06,2.14,2.14,0,0,0-1,1.66.67.67,0,0,0,.27.61h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.13,134.91c0,.61.43.86,1,.55a2.09,2.09,0,0,0,1-1.65c0-.61-.43-.86-1-.55A2.11,2.11,0,0,0,141.13,134.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13,133.79a.39.39,0,0,1,.29,0l.08,0,4,2.31-1.27.74-3.33-1.93-.14-.08a.35.35,0,0,1-.08-.24A1,1,0,0,1,142.13,133.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85,126.61l1.35-2.34L152.47,121h0a.68.68,0,0,0-.68.06,2.13,2.13,0,0,0-1,1.66.66.66,0,0,0,.27.61h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.57,126c0,.61.43.86,1,.56a2.13,2.13,0,0,0,1-1.66c0-.61-.43-.86-1-.55A2.11,2.11,0,0,0,156.57,126Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.57,124.88a.36.36,0,0,1,.29,0l.08,0,4,2.3-1.27.74L157.33,126l-.14-.08a.39.39,0,0,1-.08-.25A1,1,0,0,1,157.57,124.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.37,131.72,159.78,135l25.39,12a6.35,6.35,0,0,1,2.86,4.32l3.48,22.5a.39.39,0,0,0,.58.27h0c.13-.08.2-.22.16-.77l-2-23.9a6.15,6.15,0,0,0-2.35-4.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.43,174.73l-21.09-12.19a2.93,2.93,0,0,1-1.33-2.31V159a2.94,2.94,0,0,1,1.33-2.31l21.09-12.17a2.9,2.9,0,0,1,2.66,0l21.09,12.17a2.94,2.94,0,0,1,1.33,2.31v1.26a2.94,2.94,0,0,1-1.33,2.31l-21.09,12.17A3,3,0,0,1,164.43,174.73Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.82,174.9a2.3,2.3,0,0,1-.39-.17l-21.09-12.19a2.93,2.93,0,0,1-1.33-2.31V159a3,3,0,0,1,1.08-2.13c-.47.42-.39,1,.25,1.36l21,12.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.51,159v1.26a2.94,2.94,0,0,1-1.33,2.31l-21.09,12.17a3,3,0,0,1-2.27.16l-.49-4.55.1.06a3,3,0,0,0,2.66,0l21.09-12.18c.64-.37.73-.94.25-1.36A3,3,0,0,1,189.51,159Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.93,148.84,150.84,161a2.79,2.79,0,0,1-1.56.31l-.24,0h0l-.13,0h0l-.21,0a2.37,2.37,0,0,1-.46-.2l-1.08-.62a3.72,3.72,0,0,1-1.6-2.29l-3.21-17.9a1.84,1.84,0,0,1,0-.33.57.57,0,0,1,0-.13,2.16,2.16,0,0,1,.14-.66,2.41,2.41,0,0,1,.71-1l.09-.07a.42.42,0,0,1,.14-.09l21.09-12.18a3,3,0,0,1,2.66,0l1.09.63a2.76,2.76,0,0,1,.64.52l.1.12a3.21,3.21,0,0,1,.39.52l.08.12.06.11.08.16.07.15a.78.78,0,0,1,.05.14l0,.06,0,.12,0,.15a.43.43,0,0,1,0,.11L173,146.56A2.36,2.36,0,0,1,171.93,148.84Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,142.37l3.21,17.9a1,1,0,0,0,1.6.74l21.09-12.17a2.37,2.37,0,0,0,1.06-2.29l-3.21-17.9a1,1,0,0,0-1.6-.74l-21.09,12.17A2.35,2.35,0,0,0,146,142.37Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,142.37l3.21,17.9a1,1,0,0,0,1.6.74l21.09-12.17a2.37,2.37,0,0,0,1.06-2.29l-3.21-17.9a1,1,0,0,0-1.6-.74l-21.09,12.17A2.35,2.35,0,0,0,146,142.37Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.3,161.23a2.9,2.9,0,0,1-1,.09l-.24,0-.18,0h0l-.21,0a2.37,2.37,0,0,1-.46-.2l-1.08-.62a3.72,3.72,0,0,1-1.6-2.29l-3.21-17.9a1.84,1.84,0,0,1,0-.33.57.57,0,0,1,0-.13,2.16,2.16,0,0,1,.14-.66l3.76,2.14a2.19,2.19,0,0,0-.13,1.15l3.21,17.9a1,1,0,0,0,1,.93A0,0,0,0,0,150.3,161.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.37,184.06c-.45,0-.14.51-.2,1.55a7.32,7.32,0,0,0,.08,3.12c1.25,1.89,2.81,1.75,4.29,3.4a7.32,7.32,0,0,0,5.9,2.9c3.7-.09,5-2.43,4-3.21s-3.88-1.82-7.29-5.24C193.43,184.88,188.37,184.06,188.37,184.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,175.17s1.52,7.27,2.54,9a25.74,25.74,0,0,0,4.72,5.14c.37.35,1.18,1,1.5,1.26.7.57.22,1-.4,1.16a5.82,5.82,0,0,1-4.66-.92,34.94,34.94,0,0,1-4.58-3.63,7.28,7.28,0,0,1-1.47-1.54,2.73,2.73,0,0,1-.36-1.27,4.7,4.7,0,0,0-.22-1.48c-.15-.45-1.52-5-2-6.1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.76,190c-.45,0-.15.5-.23,1.54a7.14,7.14,0,0,0,0,3.12c1.2,1.92,2.76,1.82,4.2,3.5a7.29,7.29,0,0,0,5.84,3c3.7,0,5.08-2.31,4-3.11s-3.83-1.92-7.17-5.41C182.8,191,177.76,190,177.76,190Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,180.75s1,7.74,2,9.52a26,26,0,0,0,4.6,5.25c.36.35,1.15,1,1.47,1.29.69.58.19,1-.43,1.15a5.86,5.86,0,0,1-4.64-1,33.49,33.49,0,0,1-4.49-3.74,7.15,7.15,0,0,1-1.43-1.57,2.61,2.61,0,0,1-.34-1.28,4.71,4.71,0,0,0-.19-1.48c-.13-.46-2.47-6.57-2.47-6.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25,158.73c-1.31-3-6.82-5.67-9.86-7.31s-4.76-2.66-8.25-4.88l-7.41-4.83a15.31,15.31,0,0,0-.11,5.62L151,148.56c0-.06.46,6.9,2.59,9.9s4.92,4.27,7.5,5.54c3.76,1.85,9,4,10.06,4.41a15.62,15.62,0,0,0,.29,3.82,49.14,49.14,0,0,0,2.61,7.63c1.85,4.9,2.43,6.41,2.43,6.41a11.39,11.39,0,0,0,5.3-1.31s-2.18-19.49-2.57-21a4.61,4.61,0,0,0-.89-1.54l2.66.89a13.64,13.64,0,0,0,1.08,5.7c1.09,2.64,1.92,4.05,3.34,7.35,1.2,2.76,2.3,5.1,2.3,5.1a5.75,5.75,0,0,0,4.71-.94S189.55,161.76,188.25,158.73Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25,158.73c-1.31-3-6.82-5.67-9.86-7.31s-4.76-2.66-8.25-4.88l-7.41-4.83a15.31,15.31,0,0,0-.11,5.62L151,148.56c0-.06.46,6.9,2.59,9.9s4.92,4.27,7.5,5.54c3.76,1.85,9,4,10.06,4.41a15.62,15.62,0,0,0,.29,3.82,49.14,49.14,0,0,0,2.61,7.63c1.85,4.9,2.43,6.41,2.43,6.41a11.39,11.39,0,0,0,5.3-1.31s-2.18-19.49-2.57-21a4.61,4.61,0,0,0-.89-1.54l2.66.89a13.64,13.64,0,0,0,1.08,5.7c1.09,2.64,1.92,4.05,3.34,7.35,1.2,2.76,2.3,5.1,2.3,5.1a5.75,5.75,0,0,0,4.71-.94S189.55,161.76,188.25,158.73Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,163.27l-2.66-.87c-1.81-2-10.89-8.1-10.89-8.1a8.7,8.7,0,0,0,4-3.4,8.32,8.32,0,0,1-1.76,3.4S179.71,162.42,181,163.27Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.27,114.54a3.43,3.43,0,0,0,1.27-1.86,1.81,1.81,0,0,0-.92-2,3,3,0,0,0,1.71-1.61,2.88,2.88,0,0,0-.08-2.35,1.24,1.24,0,0,0-.46-.55,1.78,1.78,0,0,0-.86-.11,5.73,5.73,0,0,1-2.35-.5c-1.47-.67-2.37-1.74-4.23-2.2a8.32,8.32,0,0,0-4.79.23,6.46,6.46,0,0,0-2.89,1.89,4,4,0,0,0-.5.72,6.52,6.52,0,0,1-.4.84c-.16.18-.47.23-.67.38s-.56.47-.84.69a3.89,3.89,0,0,0-1.08,1.45,7.9,7.9,0,0,0,1.2,8.23c.37.44.8.85,1.19,1.28a11.19,11.19,0,0,1,2.21,3.77c2.24-1.24,3.66-3.63,5.91-4.85.75-.4,1.57-.66,2.31-1.07a5.19,5.19,0,0,0,1-.71,3,3,0,0,1,1.2-.54,6.38,6.38,0,0,0,2-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.41,123.67c3.07-.48,4.87,1.19,8.18,4.4l5.17,5s3.56-6.86,3.68-7.94c.15-1.28-.37-2.09-.47-3.47a10.89,10.89,0,0,0-.23-2.91c-.28-.6.87-.64,1.27.11s.37,1.76.71,1.61.74-2.29.6-3.87.77-1.9,1.05-1.38a4.32,4.32,0,0,1,.37.87,2.61,2.61,0,0,1,.42,0,.67.67,0,0,1,.58.2,4.63,4.63,0,0,0,.41.49c.16.14.43.15.56.32a6.44,6.44,0,0,1,.62,4.91,18.12,18.12,0,0,1-1.85,4.49c-.16.36-.39,1.56-1,4a33.88,33.88,0,0,1-2.92,8.56c-1.31,2.34-3,1.92-4.74.84-2.43-1.54-9.34-7.13-9.34-7.13C163.92,129.08,163.41,123.67,163.41,123.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,121.59a3.79,3.79,0,0,1,.08,3.75s.91-.46.81-2.11A2.17,2.17,0,0,0,182.47,121.59Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.76,133.09a7.65,7.65,0,0,0-1,4.12,5.69,5.69,0,0,1,.45-4.63Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4,143.52a23.36,23.36,0,0,0-.2-5.45c2.57-2.71,1.87-5.41.42-7.44-3-4.18-5.09-6-6.77-6.9a23.42,23.42,0,0,0-4.82-.08c-.63.12-6.26,1.33-8,1.77a6.32,6.32,0,0,0-1,3.36,12.55,12.55,0,0,0,.95,5.49l1.74,6.57s-.54,1.76-1,3.4a20.3,20.3,0,0,0-1.23,6.8s2.7,3,10.49,1.71c9.21-1.48,10.42-5.41,10.42-5.41A27,27,0,0,0,170.4,143.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,138.07a5.15,5.15,0,0,0,1.35-5.72h0a4.42,4.42,0,0,0-1.91,1.35,6.11,6.11,0,0,1-3.87,1.86c-1.59,0-3.17-.83-4.7-.43-1.36.36-1.94,1.55-2.88,2.44-1.15,1.08-2.41,2-3.62,3a22,22,0,0,0-2.39,2.24c-.14.45-.28.93-.42,1.4a20.3,20.3,0,0,0-1.23,6.8s2.7,3,10.49,1.71c9.21-1.48,10.42-5.41,10.42-5.41a27,27,0,0,0-1-3.82A23.36,23.36,0,0,0,170.2,138.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.24,108.1c.62.65,1.59,1.7,2.07,7,.41,4.48-.92,5.75-1.61,6.15a7.13,7.13,0,0,1-3.11.34l-.55,3.09c.52,1.06,1.69,3.17,1.45,4.85a19.63,19.63,0,0,1-8.16-4.65l.55-6a1.62,1.62,0,0,1-2.4-.17c-1.18-1.2-1.35-2.48-.57-3.47a1.74,1.74,0,0,1,2.92.29c.64,1.15,1.87.82,1.56-1.12-.1-.59-.69-3.77,1.23-5.19C162.25,111.56,165.35,110,165.24,108.1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.16,114.25a.6.6,0,0,1-.49.7.62.62,0,0,1-.2-1.22A.61.61,0,0,1,161.16,114.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33,118.39a.57.57,0,0,1-.46.67.59.59,0,0,1-.66-.49.57.57,0,1,1,1.12-.18Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.61,111.83l-1.23-.66a.68.68,0,0,1,.93-.3A.73.73,0,0,1,165.61,111.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.17,112l-1,.93a.67.67,0,0,1,0-1A.74.74,0,0,1,160.17,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6,113.56a.6.6,0,1,1-.69-.51A.61.61,0,0,1,165.6,113.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.66 113.36 163.69 117.14 165.5 116.03 162.66 113.36",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.59,121.58c-1.46,0-4.91-.58-5.5-1.7a3,3,0,0,0,1.2,1.38,19,19,0,0,0,4.11,1.34Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,122.9a.89.89,0,0,0-.88-.23,1.29,1.29,0,0,0-.55-.94,1.09,1.09,0,0,0-.74,0c0-.37-.41-1-.83-1a4,4,0,0,0-1.09.44,3.94,3.94,0,0,0-.63,1.3l.18-1.36a13.72,13.72,0,0,0,1.38-1.06c.49-.51.23-1.16,0-1.11a11,11,0,0,0-1.5.7c-.61.34-1.43.62-1.51,1.11s-.16,1-.29,2.14-.16,1.42.08,1.93.61,1.55,1.24,2.83a2.64,2.64,0,0,1,.15,2.62c-.22.65-1.83,3.94-3.59,7.21l-1.44-5.26s-1-5.59-3.71-6.86c-2.85.51-3.73,2.19-3.82,3.86-.16,2.93,2.71,10.13,4.26,13.91s3.57,4.7,4.82,4.54,4-2.6,5.08-6.07c1-2.44,2.31-9.86,2.52-10.9a9.74,9.74,0,0,1,.72-2.31,6.34,6.34,0,0,0-.31-3.18c.19.26.58.39.77.12C165,124.9,165,123.21,164.81,122.9Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.81,130.33a4.74,4.74,0,0,0,.26-1,2.19,2.19,0,0,0-.16-1c-.25-.64-.59-1.25-.85-1.89s-.54-1.27-.79-1.92a7.17,7.17,0,0,1,.11-2.07l.13-1c.07-.32,0-.73.3-1a4.13,4.13,0,0,1,.9-.54l.92-.48a10.19,10.19,0,0,1,1-.43c.24-.08.36.2.38.35a.81.81,0,0,1-.07.53,2.52,2.52,0,0,1-.74.75c-.28.22-.56.42-.84.62l0,0-.19,1.35-.11,0c.09-.23.17-.46.28-.68a2.71,2.71,0,0,1,.38-.63h0a6.27,6.27,0,0,1,.58-.29,1.51,1.51,0,0,1,.64-.15.86.86,0,0,1,.54.39,1,1,0,0,1,.22.62l-.06,0a1.57,1.57,0,0,1,.48-.09.64.64,0,0,1,.45.18,1.33,1.33,0,0,1,.42.85l-.05,0a.86.86,0,0,1,.91.26h0a6,6,0,0,1,.17,1.25c0,.42.06.84.12,1.24h0a.4.4,0,0,1-.43.15.78.78,0,0,1-.37-.27l0,0a8.13,8.13,0,0,1,.32,1.38,6.07,6.07,0,0,1,.07,1.41,1.85,1.85,0,0,1-.21.68,6.44,6.44,0,0,0-.25.66,12.53,12.53,0,0,0-.36,1.37,10.18,10.18,0,0,1,.35-1.37c.07-.23.16-.45.25-.67a1.93,1.93,0,0,0,.2-.67,6,6,0,0,0-.08-1.4,8.13,8.13,0,0,0-.32-1.38l-.05-.12.08.1a.62.62,0,0,0,.35.25.33.33,0,0,0,.38-.12h0c-.07-.41-.09-.83-.13-1.25a6.9,6.9,0,0,0-.18-1.22h0a.81.81,0,0,0-.84-.22h0v0a1.2,1.2,0,0,0-.39-.8.51.51,0,0,0-.4-.16,1.71,1.71,0,0,0-.45.09l-.06,0v-.07a1,1,0,0,0-.21-.56.79.79,0,0,0-.48-.35,1.61,1.61,0,0,0-.59.15,3.81,3.81,0,0,0-.57.29h0a2.78,2.78,0,0,0-.35.61c-.1.21-.19.44-.27.66l-.18.51.07-.53.19-1.36v0h0l.84-.6a2.44,2.44,0,0,0,.72-.71.84.84,0,0,0,.07-.47c0-.15-.13-.34-.26-.28a10,10,0,0,0-.94.42,12.68,12.68,0,0,0-1.81,1c-.27.21-.21.61-.28.94l-.15,1a7.47,7.47,0,0,0-.12,2c.24.64.52,1.28.77,1.92s.59,1.25.85,1.9a2.19,2.19,0,0,1,.15,1A4.76,4.76,0,0,1,159.81,130.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,121.8a1.06,1.06,0,0,0-.09-.36c-.3.2-.7.39-.94.58a1,1,0,0,0-.34.64C161.39,122.46,161.71,122.13,162.67,121.8Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.88,123.35a2.16,2.16,0,0,1,1.06-.64,1.78,1.78,0,0,0-.08-.34C163,122.83,162.88,123.35,162.88,123.35Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.39,125.52a7,7,0,0,0-.47-1.25c-.14-.23-.2-.36.09-.43s.57-.54.58-.27-.43.52-.39.71A8,8,0,0,1,164.39,125.52Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.22,137.54c-.5.85-2.28,3.55-1.95,5.55a3.74,3.74,0,0,1,0-3.35,30.58,30.58,0,0,1,1.62-3.41Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wheel--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.72,142.67l.38,2.12,19.26,15.29a6.36,6.36,0,0,1,2.38,4.44L167,188.18a.39.39,0,0,1-.6.36h0l-7.37-4.3v-1.55l6.12,3.58L162.48,166a6.36,6.36,0,0,0-2.87-4.32l-16.43-10.39A5.31,5.31,0,0,1,142.72,142.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.59,158.36l-.8-.47a11.64,11.64,0,0,0-5.55-1.73h-.15a8.11,8.11,0,0,0-.86.05,9.46,9.46,0,0,0-6.49,3.63.48.48,0,0,0-.09.11,1.56,1.56,0,0,0-.16.2l-.1.14-.12.18a4.05,4.05,0,0,0-.21.35L133,161l-.09.17v0a9.38,9.38,0,0,0-1.14,4.54v.37c0,.18,0,.35,0,.53v.94c0,8.09,5.67,17.92,12.68,22l.81.47a11.64,11.64,0,0,0,5.54,1.73h.55l.28,0,.14,0h.08a9.46,9.46,0,0,0,6.63-3.85c.07-.08.13-.18.2-.27l0,0,.21-.33a9.47,9.47,0,0,0,1.4-5v-1.84C160.27,172.23,154.6,162.4,147.59,158.36ZM144.81,187c-5.91-3.42-10.71-11.72-10.71-18.54s4.8-9.6,10.71-6.19,10.71,11.72,10.71,18.55S150.72,190.38,144.81,187Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.22,159.73l-.81-.47c-3.47-2-6.61-2.21-8.9-.93l-.17.11-.05,0-.2.13-.2.14a3.57,3.57,0,0,0-.38.3,1.54,1.54,0,0,0-.19.17,3.85,3.85,0,0,0-.35.35c-.06.06-.11.13-.16.19l-.16.2a1.56,1.56,0,0,0-.16.2l-.1.14-.12.18a4.05,4.05,0,0,0-.21.35L133,161l-.09.17-.09.18c-.1.21-.2.43-.29.66s-.1.25-.14.38h0c-.08.23-.15.47-.22.71s-.07.26-.1.4-.07.31-.09.47a1.57,1.57,0,0,0,0,.23c0,.12,0,.26-.06.39s0,.29-.05.44v.08c0,.12,0,.25,0,.39v.15c0,.15,0,.29,0,.44s0,.35,0,.53v.94c0,8.09,5.67,17.92,12.68,22l.81.47a11.51,11.51,0,0,0,5.66,1.73h.43l.28,0,.14,0,.28,0,.25,0,.23-.05.45-.12.18-.06.21-.08.17-.07.36-.16.17-.09.05,0,.07,0,.11-.07c2.25-1.34,3.64-4.16,3.64-8.16v-.94C157.9,173.61,152.22,163.77,145.22,159.73ZM144.81,187c-5.91-3.42-10.71-11.72-10.71-18.54s4.8-9.6,10.71-6.19,10.71,11.72,10.71,18.55S150.72,190.38,144.81,187Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77,185.22c-1.69,2-4.62,2.3-8,.38-5.25-3-9.52-10.42-9.52-16.49,0-2.71.86-4.7,2.27-5.81a7.79,7.79,0,0,0-1.56,5.13c0,6.06,4.26,13.44,9.52,16.48C148.43,186.59,151,186.59,152.77,185.22Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77,185.22c-1.69,2-4.62,2.3-8,.38-5.25-3-9.52-10.42-9.52-16.49,0-2.71.86-4.7,2.27-5.81a7.79,7.79,0,0,0-1.56,5.13c0,6.06,4.26,13.44,9.52,16.48C148.43,186.59,151,186.59,152.77,185.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,162.24c-5.91-3.41-10.71-.64-10.71,6.18s4.8,15.13,10.71,18.55,10.71.65,10.71-6.18S150.72,165.66,144.81,162.24Zm0,23.35c-5.25-3-9.52-10.41-9.52-16.48s4.27-8.53,9.52-5.49,9.52,10.41,9.52,16.48S150.07,188.63,144.81,185.59Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,177.08c0-.11,0-.21-.07-.32l-8.29-2.22-.19-.28,6.09-3.52-.15-.25L145.31,174l-.14-.31,2.2-8.2-.25-.22L145,173.35l-.29-.33-2.13-10.4-.32-.08,2.1,10.25-.33,0-5.72-9.89L138,163l5.71,9.9-.12.31-7.91-7a1.58,1.58,0,0,0-.09.31l8,7.12.14.42-8.21-2.21.06.32,8.36,2.24.18.28L138,178.26l.14.25,6.22-3.59.15.31-2.26,8.43.24.22,2.23-8.3.29.33,2.19,10.7.31.08-2.16-10.55.34.05,5.83,10.11.25-.15L145.89,176l.12-.31,8,7.07a3,3,0,0,0,.08-.32L146,175.31l-.14-.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.36,170.17a2.46,2.46,0,0,0-2.57-.21l-.47.26-.14.09,0,0h0l-.18.15,0,0-.14.16,0,.06a1.63,1.63,0,0,0-.11.17l-.06.09-.08.17s0,.09-.05.13l-.06.16a1.16,1.16,0,0,0,0,.18.75.75,0,0,0,0,.16l0,.23a.51.51,0,0,0,0,.13c0,.13,0,.26,0,.4a7.9,7.9,0,0,0,3.57,6.18l.37.19.21.08.14.06.15,0,.2.06H146l.26,0h0a1.89,1.89,0,0,0,1.17-.28l.52-.29a2.51,2.51,0,0,0,1-2.28A7.9,7.9,0,0,0,145.36,170.17Zm-1,6.86a8.72,8.72,0,0,1-1.8-2.72,6.74,6.74,0,0,0,.62.38c.93.48.91-.17,1.28.28a2.41,2.41,0,0,1,0,2.13Zm1.81-4.23-.15.07-.55.31a.71.71,0,0,0-.27.28,5,5,0,0,1-1-2.67,5.91,5.91,0,0,1,2.33,1.81.69.69,0,0,1,0,.1A2.62,2.62,0,0,0,146.15,172.8Zm-2.71-.47c.3,1.08.76,1.25.78,1.6-.7-.12-1.84-.8-1.91-1.48a2.67,2.67,0,0,1,.61-1.81C143.22,170.77,143.2,171.45,143.44,172.33Zm2,5.66c-.37-.34,0-.67.23-1.37a1.85,1.85,0,0,0,0-1c.73.58,1.83,2.09,1.55,2.54l0,.05A2.36,2.36,0,0,1,145.46,178Zm1.74-2.35c-.77-1-1.08-.68-1.27-1.23a.69.69,0,0,1,.26-.74.9.9,0,0,1,1.12.38,6.72,6.72,0,0,1,.61,2.66C147.73,176.43,147.5,176,147.2,175.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.36,170.17a2.46,2.46,0,0,0-2.57-.21l-.47.26-.14.09,0,0h0l-.18.15,0,0-.14.16,0,.06a1.63,1.63,0,0,0-.11.17l-.06.09-.08.17s0,.09-.05.13l-.06.16a1.16,1.16,0,0,0,0,.18.75.75,0,0,0,0,.16l0,.23a.51.51,0,0,0,0,.13c0,.13,0,.26,0,.4a7.9,7.9,0,0,0,3.57,6.18l.37.19.21.08.14.06.15,0,.2.06H146l.26,0h0a1.89,1.89,0,0,0,1.17-.28l.52-.29a2.51,2.51,0,0,0,1-2.28A7.9,7.9,0,0,0,145.36,170.17Zm-1,6.86a8.72,8.72,0,0,1-1.8-2.72,6.74,6.74,0,0,0,.62.38c.93.48.91-.17,1.28.28a2.41,2.41,0,0,1,0,2.13Zm1.81-4.23-.15.07-.55.31a.71.71,0,0,0-.27.28,5,5,0,0,1-1-2.67,5.91,5.91,0,0,1,2.33,1.81.69.69,0,0,1,0,.1A2.62,2.62,0,0,0,146.15,172.8Zm-2.71-.47c.3,1.08.76,1.25.78,1.6-.7-.12-1.84-.8-1.91-1.48a2.67,2.67,0,0,1,.61-1.81C143.22,170.77,143.2,171.45,143.44,172.33Zm2,5.66c-.37-.34,0-.67.23-1.37a1.85,1.85,0,0,0,0-1c.73.58,1.83,2.09,1.55,2.54l0,.05A2.36,2.36,0,0,1,145.46,178Zm1.74-2.35c-.77-1-1.08-.68-1.27-1.23a.69.69,0,0,1,.26-.74.9.9,0,0,1,1.12.38,6.72,6.72,0,0,1,.61,2.66C147.73,176.43,147.5,176,147.2,175.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,170.48c-2-1.13-3.57-.21-3.57,2.07a7.9,7.9,0,0,0,3.57,6.18c2,1.13,3.57.21,3.57-2.06A7.9,7.9,0,0,0,144.81,170.48Zm-.88.25a5.35,5.35,0,0,1,2.63,1.87c.24.49-.38.31-.95.51-.72.26-.38,1-.81.78C144.18,173.64,143.22,170.72,143.93,170.73Zm-1.07-.11c.37.06.32.77.58,1.71.34,1.19.85,1.27.78,1.72-.11.65-2.35-.33-2.46-1.29S142.5,170.55,142.86,170.62Zm.94,6.72a8.1,8.1,0,0,1-2-3.2c0-.45.58.17,1.31.55.93.48.91-.17,1.28.28C145,175.63,144.57,177.94,143.8,177.34Zm3.43.79c-.37.59-1.94.51-2.32.17s.05-.67.24-1.38c.24-.89-.29-1.37,0-1.54S147.6,177.55,147.23,178.13Zm-.57-2.18c-.78-1-1.08-.68-1.27-1.23-.28-.81,1.38-1.64,1.92-.67a5.75,5.75,0,0,1,.52,3.3C147.61,177.59,147.27,176.77,146.66,176Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.81,175.87c.6.34,1.09.06,1.09-.63a2.4,2.4,0,0,0-1.09-1.89c-.6-.35-1.09-.07-1.09.63A2.43,2.43,0,0,0,144.81,175.87Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.32,155.29l-3.19-26.64-2.61-.13L245,155.29h0a.34.34,0,0,0,.17.23,1,1,0,0,0,.93,0,.32.32,0,0,0,.21-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.13,128.65l-2.61-.13.77,5a9.87,9.87,0,0,0,1.54-.71,1.57,1.57,0,0,0,.69-.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.46,124.74h-2.62L202,149.9h0a.31.31,0,0,0,.19.29,1,1,0,0,0,.93,0,.31.31,0,0,0,.18-.23h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.84,124.74l-1.06,7a10,10,0,0,0,2,1.23l1.67-8.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,164.23l-2.45-27.1L223.8,137l3.75,27.22h0a.39.39,0,0,0,.18.24,1,1,0,0,0,.93,0c.14-.07.21-.17.2-.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.73,141l-.32-3.9L223.8,137l.53,4.21A4.71,4.71,0,0,0,226.73,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.72,116.45H220.1l-3.8,25.16h0a.34.34,0,0,0,.19.29,1,1,0,0,0,.94,0,.36.36,0,0,0,.18-.23h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201,94.28a14.53,14.53,0,0,0-1.05,4.58c-.29,3.52.84,16.51,1.56,21.61h0c1,8.51,2.3,8.52,4.14,10,3.17,2.45,12.29,7.25,15.3,8.43,5.46,2.15,9.92-1.16,13.25-2.8a77,77,0,0,0,8.81-5.22,2.43,2.43,0,0,0,1.25-1.86c0-.26,0-1.3,0-1.57,0-.82-.73-1.7-2.26-2.69-2.82-1.83-13-7.77-16.95-10,0,0,0,0,0,0-3-1.85-4.82-16-6.92-22.66l-.14-.42c0-.1-.07-.2-.11-.31-.13-.36-.27-.69-.41-1",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26,127.39c0-.82-.73-1.7-2.26-2.69-2.82-1.83-13-7.77-16.95-10,0,0,0,0,0,0-3-1.85-4.82-16-6.92-22.66,0-.06-.17-.58-.44-1.23l0-.09-.12-.27-.06-.13h0a6.28,6.28,0,0,0-1.41-2,2.55,2.55,0,0,0-.69-.48l-1.23-.7c-2.07-1.24-4.77.25-8.15,2.09a10.23,10.23,0,0,0-5,5.07h0a14.53,14.53,0,0,0-1.05,4.58c-.29,3.52.84,16.51,1.56,21.61h0c1,8.51,2.3,8.52,4.14,10,3.17,2.45,12.29,7.25,15.3,8.43,5.46,2.15,9.92-1.16,13.25-2.8a77,77,0,0,0,8.81-5.22,2.43,2.43,0,0,0,1.25-1.86C244.25,128.7,244.26,127.66,244.26,127.39Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26,127.39c0-.82-.73-1.7-2.26-2.69-2.82-1.83-13-7.77-16.95-10,0,0,0,0,0,0-3-1.85-4.82-16-6.92-22.66,0-.06-.17-.58-.44-1.23l0-.09-.12-.27-.06-.13h0a6.28,6.28,0,0,0-1.41-2,2.55,2.55,0,0,0-.69-.48l-1.23-.7c-2.07-1.24-4.77.25-8.15,2.09a10.23,10.23,0,0,0-5,5.07h0a14.53,14.53,0,0,0-1.05,4.58c-.29,3.52.84,16.51,1.56,21.61h0c1,8.51,2.3,8.52,4.14,10,3.17,2.45,12.29,7.25,15.3,8.43,5.46,2.15,9.92-1.16,13.25-2.8a77,77,0,0,0,8.81-5.22,2.43,2.43,0,0,0,1.25-1.86C244.25,128.7,244.26,127.66,244.26,127.39Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.19,134.46a80,80,0,0,0,8.81-5.22c1.89-1.38,1.72-2.78-1-4.54-3.77-2.45-19.13-11.16-19.13-11.16S203.47,125,204.3,127.11s12.86,8.66,16.64,10.15C226.4,139.41,230.86,136.1,234.19,134.46Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.19,134.46a80,80,0,0,0,8.81-5.22c1.89-1.38,1.72-2.78-1-4.54-3.77-2.45-19.13-11.16-19.13-11.16S203.47,125,204.3,127.11s12.86,8.66,16.64,10.15C226.4,139.41,230.86,136.1,234.19,134.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.34,87.82c-2-1.08-4.69.38-8,2.18a10.2,10.2,0,0,0-5,5.08l-1.38-.8a10.23,10.23,0,0,1,5-5.07c3.38-1.84,6.08-3.33,8.15-2.09Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.34,87.82c-2-1.08-4.69.38-8,2.18a10.2,10.2,0,0,0-5,5.08l-1.38-.8a10.23,10.23,0,0,1,5-5.07c3.38-1.84,6.08-3.33,8.15-2.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.1,92.05A9.33,9.33,0,0,0,216,88.3a3.28,3.28,0,0,0-2.23-.85c-1.79,0-3.93,1.18-6.44,2.55-.21.12-.42.23-.62.36l-.23.13-.28.18a1.37,1.37,0,0,0-.2.13,10.84,10.84,0,0,0-1.27,1c-.06.06-.13.11-.19.18a8.42,8.42,0,0,0-.72.74l-.12.14-.14.18-.14.18c0,.06-.09.12-.13.19a7.18,7.18,0,0,0-.5.8.6.6,0,0,0-.06.11l-.12.23c-.06.11-.11.22-.16.33a14.46,14.46,0,0,0-1.14,4.81c-.49,5.78,1.44,26.48,3.42,28.12,0,0-.3-1.86,3.7-4.38a74.47,74.47,0,0,1,7.52-4.56,92.86,92.86,0,0,1,9-4.12C222,112.86,220.2,98.72,218.1,92.05Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.1,92.05A9.33,9.33,0,0,0,216,88.3a3.28,3.28,0,0,0-2.23-.85c-1.79,0-3.93,1.18-6.44,2.55-.21.12-.42.23-.62.36l-.23.13-.28.18a1.37,1.37,0,0,0-.2.13,10.84,10.84,0,0,0-1.27,1c-.06.06-.13.11-.19.18a8.42,8.42,0,0,0-.72.74l-.12.14-.14.18-.14.18c0,.06-.09.12-.13.19a7.18,7.18,0,0,0-.5.8.6.6,0,0,0-.06.11l-.12.23c-.06.11-.11.22-.16.33a14.46,14.46,0,0,0-1.14,4.81c-.49,5.78,1.44,26.48,3.42,28.12,0,0-.3-1.86,3.7-4.38a74.47,74.47,0,0,1,7.52-4.56,92.86,92.86,0,0,1,9-4.12C222,112.86,220.2,98.72,218.1,92.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.08,151.71c0-3.65,3.06-12.89,3.06-12.89l-6.47-4.39s-.45,2.27-1,5.33a13.59,13.59,0,0,1-1.34,4.28,5.63,5.63,0,0,0-1.38,2.56,36.07,36.07,0,0,0,1.16,5.36,18.05,18.05,0,0,0,1.68,5.15c1,1.79,5.69,3.45,5.54,1.63C240.08,156.21,239.19,154.7,239.08,151.71Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.29,144c-.4,0-.89.61-1.26,1.09s-1.2.81-1.13,2.09,1.15,2.28,1.24,4,0,4.71,2.4,7,5.05,2.59,6.06,2.08a1.23,1.23,0,0,0,.64-.72,1,1,0,0,0-.11-.81c-.25-.66-.49-1.32-.69-2a26.63,26.63,0,0,1-1-4.21c-.12-.93-.11-1.78-.33-1.94a3.64,3.64,0,0,0-1.85-.71,3.78,3.78,0,0,0-1.69-.12c-.21.1-.17.39-.2.61s-.09.58-.13.87a.42.42,0,0,1-.06.19.15.15,0,0,1-.17.08c-.07,0-.1-.09-.13-.16a16.93,16.93,0,0,1-.71-3.23,11.09,11.09,0,0,0-.55-1.95c-.15-.41-.37-1-.47-1.35a.76.76,0,0,1,0-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,152.71a66.78,66.78,0,0,0,2.82,7,21.94,21.94,0,0,0,4.11,5.46c.38.36,1.24,1,1.55,1.3a.62.62,0,0,1,0,.95c-.63.74-3.56,1.22-5.34.16s-3.67-3.24-4.76-4.13l-1.44-1.19c-.36-.3-.33-.48-.26-.95l-.14-.76c-.2-1.56-2.31-5.1-2.31-5.1Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.14,160.6c-.35.19-.39,1-.41,1.61s-.54,1.35.24,2.36,2.24,1.24,3.31,2.61,2.66,3.89,5.92,4.38,5.63-.73,6.17-1.72a1.29,1.29,0,0,0,.12-1c-.09-.33-.27-.42-.55-.61-.58-.39-1.15-.81-1.7-1.25a26.87,26.87,0,0,1-3.23-2.89c-.63-.7-1.1-1.41-1.37-1.41a3.72,3.72,0,0,0-1.93.45,3.76,3.76,0,0,0-1.46.87c-.11.2.09.42.18.62l.39.79a.42.42,0,0,1,.06.19.17.17,0,0,1-.09.16.27.27,0,0,1-.21-.06,16.6,16.6,0,0,1-2.41-2.26,8.94,8.94,0,0,0-1.39-1.22c-.35-.25-.81-.52-1.16-.77s-.36-.27-.39-.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1,143.92c.46-2.5,1.17-6.33,1.6-8.89.7-4.07,1.19-8.33.48-10.17s-4.26-4-8-6.41-10.5-6.07-10.5-6.07l-20.56,2.67c.41,3.5.3,5.91,2,9s4.71,4.48,9.32,7c4.13,2.22,9,4.61,10.12,5.17,1.37.72,2.65,1.28,3.26,3.44a37.43,37.43,0,0,0,3.88,10l5.48,9.33s4.74.59,7.34-3.11C246.49,155.85,244.38,150.06,242.1,143.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.56,142.47c-2.16-5.75-4.33-11.45-4.94-12.67-1.31-2.59-12.59-9.87-13-10.1h0l.53-.76a7.54,7.54,0,0,0,1.13-3,8,8,0,0,1-.53,3.36c1.74,1.17,6.15,4.13,7.91,5.39,2.22,1.58,4.58,3.5,5.54,6.2C239,132.94,240.7,139.31,241.56,142.47Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.56,142.47c-2.16-5.75-4.33-11.45-4.94-12.67-1.31-2.59-12.59-9.87-13-10.1h0l.53-.76a7.54,7.54,0,0,0,1.13-3,8,8,0,0,1-.53,3.36c1.74,1.17,6.15,4.13,7.91,5.39,2.22,1.58,4.58,3.5,5.54,6.2C239,132.94,240.7,139.31,241.56,142.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9,157.05l1,2s5.66.92,7.7-3.19l-.76-2C244.92,156.2,240.67,157.67,237.9,157.05Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.65,77.75v19h16v-19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.37,82.89a1.78,1.78,0,0,0-.94.1,5.55,5.55,0,0,0-1,.53q-.74.45-1.5.84a4,4,0,0,1-1.45.54c-.17,0-.54,0-.33-.26a8.16,8.16,0,0,0,.79-1,1.53,1.53,0,0,0,.21-1.21.5.5,0,0,0-.21-.3c-.16-.09-.25,0-.35.09s-.23.19-.35.28l-.75.55c-1.44,1.09-3.15,2-3.87,3.69a11.13,11.13,0,0,0-.76,3.29c-.18,1.91-.78,7.47-.78,7.47s-6.49-3.64-9.05-5.22a15.72,15.72,0,0,0-6-2.61,25.18,25.18,0,0,0-3.95-.2l7.1,9.91s7.61,3.69,11.22,5.2c3.13,1.31,4.32.64,4.75-.16.71-1.33,1.38-1.92,1.22-9.66,0-.6,0-1.2-.05-1.8,0-1.24.28-2.49.78-2.72a14.11,14.11,0,0,0,2.66-1.48,7.25,7.25,0,0,0,1.45-1.37,2.27,2.27,0,0,0,.53-.82c.06-.28,0-.6.07-.88s.22-.33.29-.54a3.35,3.35,0,0,1,.44-1.24c.17-.19.43-.35.42-.6s-.2-.34-.39-.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.09,97.53a14.69,14.69,0,0,0-.23,4.31,7.82,7.82,0,0,1-.57-4.79Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.67,85.74A5.54,5.54,0,0,1,239,88.38a3.27,3.27,0,0,0,1.28-1.09A1.84,1.84,0,0,0,240.67,85.74Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.19,90.38l-5.51,1.17c-.93.36-1.52,5.85-1.4,12.61.11,6.53,2.32,15.74,2.32,15.74s5.39,2,12.86-.65c6.61-2.37,8.29-6.57,8.29-6.57l-2.58-3.37-.1-5.91a7.66,7.66,0,0,0,.24-6.91c-1.7-3.77-6.89-7.38-6.89-7.38l-2.42.21Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.19,90.38l-5.51,1.17c-.93.36-1.52,5.85-1.4,12.61.11,6.53,2.32,15.74,2.32,15.74s5.39,2,12.86-.65c6.61-2.37,8.29-6.57,8.29-6.57l-2.58-3.37-.1-5.91a7.66,7.66,0,0,0,.24-6.91c-1.7-3.77-6.89-7.38-6.89-7.38l-2.42.21Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,104.49a5.23,5.23,0,0,0,8.79-.59,4.31,4.31,0,0,1-4.33,3.52C210.59,107.65,210,104.49,210,104.49Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.56,73.4c1,.58,2.74,3.14,2.3,8.48-.4,4.66-1.81,5.54-2.54,5.87a6.71,6.71,0,0,1-3.23.11v1.89a23.21,23.21,0,0,1,3.26,7.4,61.86,61.86,0,0,0-9.28-6.23l-.07-6.3s-.81.81-2.21-.38c-1.16-1-1.57-2.65-.7-3.57a2,2,0,0,1,3.18.57s-.57-5.46,2.34-7.13S218.4,75.17,218.56,73.4Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.57,79.86a.62.62,0,0,1-.55.7.64.64,0,0,1-.68-.59.62.62,0,1,1,1.23-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,80.29a.62.62,0,0,1-.55.7.64.64,0,0,1-.68-.59.62.62,0,1,1,1.23-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.09,87.86c-1.47-.16-4.49-1-5-2.16a3.07,3.07,0,0,0,1.08,1.5,15.42,15.42,0,0,0,3.9,1.56Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.85,78.57h0a15.63,15.63,0,0,0-.75-2.73.11.11,0,0,0,0,0c0,3.34-4.41,3.13-4.41,3.13.84-2.18-.25-3.08-.25-3.08a4.05,4.05,0,0,1-3.33,3.31,4.74,4.74,0,0,0-.84-3,5.37,5.37,0,0,1-2,5.08,2,2,0,0,0-3.18-.57c-.87.92-.46,2.59.7,3.57,1.4,1.19,2.2.38,2.2.38l0,3.84c-.17-1.55-5-4.52-5.36-10-.29-4.3,1.16-7.29,5.46-8.85a9.25,9.25,0,0,1,7.72.89,4.75,4.75,0,0,1,4.83,3.8A4.86,4.86,0,0,1,220.85,78.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,84.66l-2.12-.43a1,1,0,0,0,.81,1.28A1.13,1.13,0,0,0,217,84.66Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.21,78.47l-1.34-.71a.73.73,0,0,1,1-.34A.81.81,0,0,1,220.21,78.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.55 79.47 217.21 83.39 219.26 82.39 216.55 79.47",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,103.55a1.86,1.86,0,0,1,1.31-.94,8.44,8.44,0,0,1,5.84.69,1.89,1.89,0,0,1,1.06,1.23h0a13.86,13.86,0,0,1-2,7.17l0,0,0,0h0a2.11,2.11,0,0,1-.84.63,4.93,4.93,0,0,1-4.43-.53,2,2,0,0,1-.68-.81h0v0l0,0a14,14,0,0,1-.25-7.43Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.47,102.61c-1.7.51-1.83,1.64-.3,2.54a8.44,8.44,0,0,0,5.84.69c1.7-.51,1.83-1.64.3-2.54A8.44,8.44,0,0,0,226.47,102.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,103.12c-1.35.3-1.44,1-.19,1.65a8.17,8.17,0,0,0,4.71.56c1.35-.3,1.44-1,.19-1.65A8.17,8.17,0,0,0,227,103.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.86,104.12a2.28,2.28,0,0,0-.69.25,2.77,2.77,0,0,0,.62.4,8.17,8.17,0,0,0,4.71.56,2.28,2.28,0,0,0,.69-.25,2.93,2.93,0,0,0-.61-.4A8.22,8.22,0,0,0,226.86,104.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.65,115.49a74,74,0,0,1-3.54-15.1c-.68-5.38.7-8.22,5-9a12.59,12.59,0,0,1,2.8,11.28l1.93,8.85s9.87-.3,12.12-1.82c.79-.52,1.83-3.31,2.79-3.28a14,14,0,0,0,0,1.88c0,.39,1.92,1.28,4,1.17s4.12-1.59,3.66.26a5.34,5.34,0,0,1-1.65,3c-1.12.91-5.25,1.25-6.41,1.76,0,0-9.81,3.65-15.34,4.26C205.93,119.17,204.68,119.05,203.65,115.49Z",
    style: {
      fill: "#b16668"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "302.09 178.68 303.14 178.07 303.14 135.36 302.09 135.97 302.09 178.68",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.09 178.68 301.04 178.07 301.04 135.36 302.09 135.97 302.09 178.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.15 152.16 275.2 151.55 275.2 120.42 274.15 121.03 274.15 152.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.15 152.16 273.1 151.53 273.1 120.41 274.15 121.03 274.15 152.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.1 120.42 302.09 137.18 302.09 135.97 273.1 119.21 273.1 120.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.68 146.58 246.73 145.99 247.11 104.2 246.06 104.79 245.68 146.58",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.68 146.58 244.63 145.99 245.01 104.2 246.06 104.79 245.68 146.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.01 104.2 274.16 121.06 274.16 119.84 245.01 103.01 245.01 104.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246 116.22 274.1 132.47 274.1 131.3 246 115.05 246 116.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "274.15 130.16 301.04 145.64 301.04 146.85 274.15 131.33",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "273.1 130.72 246.06 115.09 246.06 113.89 273.1 129.51",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.1 132.47 302.09 148.63 302.09 147.46 274.1 131.3 274.1 132.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274 155.78 210.42 192.4 210.42 188.87 274 152.16 274 155.78",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.09 139.5 272.94 156.32 272.94 152.8 302.09 135.97 302.09 139.5",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.42 235.82 211.47 235.22 211.47 188.26 210.42 188.87 210.42 235.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.42 235.82 209.37 235.22 209.37 188.26 210.42 188.87 210.42 235.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.48 215.56 183.53 214.95 183.53 173.32 182.48 173.93 182.48 215.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.48 215.56 181.43 214.93 181.43 173.31 182.48 173.93 182.48 215.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.43 175.59 210.42 192.4 210.42 188.87 181.43 172.11 181.43 175.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.39 199.32 155.44 198.74 155.44 157.11 154.39 157.69 154.39 199.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.39 199.32 153.34 198.74 153.34 157.11 154.39 157.69 154.39 199.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.34 159.37 182.48 176.12 182.48 172.74 153.34 155.91 153.34 159.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.33 169.13 182.43 185.37 182.43 184.2 154.33 167.95 154.33 169.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "182.48 183.06 209.37 198.54 209.37 199.75 182.48 184.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "181.43 183.62 154.39 167.99 154.39 166.79 181.43 182.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.43 185.37 210.42 201.53 210.42 200.36 182.43 184.2 182.43 185.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.42 188.87 153.34 155.91 246.06 102.41 303.14 135.36 210.42 188.87",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.42 188.87 153.34 155.91 246.06 102.41 303.14 135.36 210.42 188.87",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.42 235.82 210.42 235.26 211.47 234.66 211.47 235.22 210.42 235.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.42 235.82 210.42 235.26 209.37 234.66 209.37 235.22 210.42 235.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.48 215.56 182.48 215 183.53 214.39 183.53 214.95 182.48 215.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.48 215.56 182.48 215 181.43 214.39 181.43 214.95 182.48 215.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.39 199.32 154.39 198.76 155.44 198.15 155.44 198.71 154.39 199.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.39 199.32 154.39 198.76 153.34 198.15 153.34 198.71 154.39 199.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.09 178.68 302.09 178.12 303.14 177.51 303.14 178.07 302.09 178.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.09 178.68 302.09 178.12 301.04 177.51 301.04 178.07 302.09 178.68",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Things--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebooks--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.22,131.78l-6.56,3.45-.14.22v.17a.25.25,0,0,0,.14.21l8.65,5a.4.4,0,0,0,.22.06.41.41,0,0,0,.23-.06l6.42-3.7V137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,140.71a.4.4,0,0,1-.22-.06l-8.65-5a.25.25,0,0,1-.14-.21.25.25,0,0,1,.14-.22l6.27-3.62,9.25,5.34-6.42,3.7A.41.41,0,0,1,208.53,140.71Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.93,131.11l-6.2,3.58-.07.09v.67h0s0,.06.07.08l8.65,5a.34.34,0,0,0,.31,0l6.2-3.58v-.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.89,136.28l-.08.05-1,.58-.18.11-4.93,2.84a.34.34,0,0,1-.31,0l-8.65-5c-.09-.05-.09-.13,0-.18l.08-.05,6.12-3.53,8.88,5.13h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,139.9v.67a.37.37,0,0,1-.15,0l-8.65-5s-.07-.05-.07-.08v-.67s0,.06.07.09l8.65,5A.26.26,0,0,0,208.53,139.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.89,136.19l-1.12.65-.17.1-4.91,2.83a.34.34,0,0,1-.31,0l-7.75-4.47-.19-.11a1.77,1.77,0,0,1-.63-.55l0,0a.07.07,0,0,1,0-.05.13.13,0,0,1,.1-.15,3.31,3.31,0,0,0,.59-.25h0l5.45-3.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.73,136.11a.09.09,0,0,0,0,.17.3.3,0,0,0,.29,0c.08,0,.08-.12,0-.17A.37.37,0,0,0,213.73,136.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.66,135.58a.37.37,0,0,0-.39,0,1.25,1.25,0,0,0-.48.7l.1,0a1.1,1.1,0,0,1,.44-.63.41.41,0,0,1,.17-.05.23.23,0,0,1,.11,0,.39.39,0,0,1,.14.35v.09l.1.06s0-.1,0-.15A.47.47,0,0,0,214.66,135.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.84,136.22a0,0,0,0,1,0,0h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.87,135.61c-.08,0-.08.12,0,.17a.3.3,0,0,0,.29,0c.08-.05.08-.12,0-.17A.37.37,0,0,0,212.87,135.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,135.07a.38.38,0,0,0-.38,0,1.22,1.22,0,0,0-.49.7.17.17,0,0,0,.1,0,1.16,1.16,0,0,1,.44-.62.41.41,0,0,1,.18-.05.19.19,0,0,1,.1,0,.39.39,0,0,1,.14.35v.09l.1.06a.76.76,0,0,0,0-.15A.5.5,0,0,0,213.79,135.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,135.11c-.08,0-.08.12,0,.17a.3.3,0,0,0,.29,0c.08-.05.08-.12,0-.17A.37.37,0,0,0,212,135.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.93,134.57a.4.4,0,0,0-.39,0,1.22,1.22,0,0,0-.49.7.2.2,0,0,0,.11,0,1.1,1.1,0,0,1,.43-.62.41.41,0,0,1,.18-.05.17.17,0,0,1,.1,0,.39.39,0,0,1,.15.35.28.28,0,0,1,0,.09l.1.06a.76.76,0,0,0,0-.15A.52.52,0,0,0,212.93,134.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.13,134.61c-.08,0-.08.12,0,.17a.3.3,0,0,0,.29,0c.08-.05.08-.12,0-.17A.37.37,0,0,0,211.13,134.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.06,134.07a.4.4,0,0,0-.39,0,1.26,1.26,0,0,0-.49.7.21.21,0,0,0,.11,0,1.11,1.11,0,0,1,.43-.62.49.49,0,0,1,.18-.05.17.17,0,0,1,.1,0,.37.37,0,0,1,.15.35v.09l.1.06s0-.1,0-.15A.52.52,0,0,0,212.06,134.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27,134.11c-.08,0-.08.12,0,.17a.28.28,0,0,0,.28,0c.08-.05.08-.12,0-.17A.34.34,0,0,0,210.27,134.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.19,133.57a.4.4,0,0,0-.39,0,1.25,1.25,0,0,0-.48.7.17.17,0,0,0,.1,0,1.12,1.12,0,0,1,.44-.62.41.41,0,0,1,.17-.05.2.2,0,0,1,.11,0,.39.39,0,0,1,.14.35v.09l.1.06a.76.76,0,0,0,0-.15A.5.5,0,0,0,211.19,133.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.4,133.61c-.08,0-.08.12,0,.17a.37.37,0,0,0,.29,0c.08-.05.08-.12,0-.17A.37.37,0,0,0,209.4,133.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.32,133.07a.38.38,0,0,0-.38,0,1.22,1.22,0,0,0-.49.7h.11a1.06,1.06,0,0,1,.43-.62.41.41,0,0,1,.18-.05l.1,0a.42.42,0,0,1,.15.36s0,.06,0,.09l.1.06a.76.76,0,0,0,0-.15A.5.5,0,0,0,210.32,133.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,133.11c-.08,0-.08.12,0,.17a.37.37,0,0,0,.29,0c.08-.05.08-.12,0-.17A.37.37,0,0,0,208.53,133.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.46,132.57a.4.4,0,0,0-.39,0,1.23,1.23,0,0,0-.49.7h.11a1.06,1.06,0,0,1,.43-.62.49.49,0,0,1,.18-.05l.1,0a.4.4,0,0,1,.15.36.28.28,0,0,1,0,.09l.11,0s0-.09,0-.14A.52.52,0,0,0,209.46,132.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.67,132.61c-.08,0-.08.12,0,.17a.34.34,0,0,0,.28,0c.08-.05.08-.12,0-.17A.28.28,0,0,0,207.67,132.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.59,132.07a.4.4,0,0,0-.39,0,1.18,1.18,0,0,0-.48.7h.1a1.08,1.08,0,0,1,.44-.62.41.41,0,0,1,.17-.05l.11,0a.42.42,0,0,1,.14.36v.09l.1,0a.61.61,0,0,0,0-.14A.49.49,0,0,0,208.59,132.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.8,132.11c-.08,0-.08.12,0,.17a.37.37,0,0,0,.29,0c.08-.05.08-.12,0-.17A.3.3,0,0,0,206.8,132.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.72,131.57a.38.38,0,0,0-.38,0,1.15,1.15,0,0,0-.49.7H207a1.06,1.06,0,0,1,.43-.62.31.31,0,0,1,.18-.05l.1,0a.42.42,0,0,1,.15.36s0,.06,0,.08l.1.06a.66.66,0,0,0,0-.14A.49.49,0,0,0,207.72,131.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.93,131.61c-.08,0-.08.12,0,.17a.37.37,0,0,0,.29,0c.08-.05.08-.12,0-.17A.3.3,0,0,0,205.93,131.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.86,131.07a.4.4,0,0,0-.39,0,1.15,1.15,0,0,0-.49.7h.11a1.06,1.06,0,0,1,.43-.62.31.31,0,0,1,.18-.05.16.16,0,0,1,.1,0,.42.42,0,0,1,.15.36.19.19,0,0,1,0,.08l.1.06a.68.68,0,0,0,0-.14A.51.51,0,0,0,206.86,131.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.67,139a.18.18,0,0,1-.1-.34l4.78-2.76a.19.19,0,0,1,.25.07.18.18,0,0,1-.07.25l-4.77,2.75A.16.16,0,0,1,207.67,139Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.09,138.63a.17.17,0,0,1-.16-.09.18.18,0,0,1,.07-.25l4.77-2.75a.19.19,0,0,1,.25.06.18.18,0,0,1-.07.25l-4.77,2.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.51,138.3a.19.19,0,0,1-.16-.09.18.18,0,0,1,.07-.25l4.77-2.76a.18.18,0,1,1,.18.32l-4.77,2.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.93,138a.2.2,0,0,1-.16-.1.17.17,0,0,1,.07-.24l4.77-2.76a.18.18,0,0,1,.25.07.18.18,0,0,1-.06.24L206,137.94A.16.16,0,0,1,205.93,138Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.35,137.63a.16.16,0,0,1-.15-.09.19.19,0,0,1,.06-.25l4.78-2.75a.18.18,0,0,1,.24.06.19.19,0,0,1-.06.25l-4.78,2.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.77,137.3a.18.18,0,0,1-.09-.34l4.78-2.76a.19.19,0,0,1,.25.07.18.18,0,0,1-.07.25l-4.77,2.75A.17.17,0,0,1,204.77,137.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,137a.17.17,0,0,1-.16-.09.17.17,0,0,1,.07-.24l4.77-2.76a.18.18,0,0,1,.25.07.17.17,0,0,1-.07.24l-4.77,2.76A.15.15,0,0,1,204.2,137Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.62,136.63a.19.19,0,0,1-.16-.09.18.18,0,0,1,.07-.25l4.77-2.75a.17.17,0,0,1,.25.06.18.18,0,0,1-.07.25l-4.77,2.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,136.3a.22.22,0,0,1-.16-.09A.18.18,0,0,1,203,136l4.77-2.76a.18.18,0,0,1,.25.07.18.18,0,0,1-.07.25l-4.77,2.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.46,136a.16.16,0,0,1-.15-.09.18.18,0,0,1,.06-.25l4.78-2.75a.18.18,0,0,1,.24.06.19.19,0,0,1-.06.25l-4.78,2.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.88,135.63a.16.16,0,0,1-.15-.09.19.19,0,0,1,.06-.25l4.78-2.76a.19.19,0,0,1,.25.07.19.19,0,0,1-.07.25L202,135.6A.17.17,0,0,1,201.88,135.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.31,135.3a.18.18,0,0,1-.16-.1.17.17,0,0,1,.07-.24L206,132.2a.18.18,0,0,1,.25.07.17.17,0,0,1-.07.24l-4.77,2.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.73,135a.19.19,0,0,1-.16-.09.18.18,0,0,1,.07-.25l4.77-2.75a.19.19,0,0,1,.25.06.18.18,0,0,1-.07.25l-4.77,2.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.25,139.3a.16.16,0,0,1-.15-.09.18.18,0,0,1,.06-.25l5.05-2.92a.18.18,0,0,1,.25.07.19.19,0,0,1-.07.25l-5,2.92Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.78,135.59a.44.44,0,0,0-.2-.13l-.09-.05c-.05-.07-.11-.18,0-.2a.7.7,0,0,1,.19.06s0,0,0,0-.25-.14-.28,0a.24.24,0,0,0,0,.14l-.13,0s-.07,0-.09.06,0,0,0,0a0,0,0,0,0,0,0h-.05c-.06,0-.22,0-.26,0s0,.08,0,.09l-.14.06v0h-.18c-.09,0-.33,0-.3.12s0,0,0,0a0,0,0,0,0,0,0s0,0,0,0-.05,0-.06,0,0,.07,0,.11-.25-.05-.33,0,0,.2-.1.2,0,0,0,0,.1,0,.13-.11.27-.05.4-.08a0,0,0,0,0,0,0s0-.09.06-.11,0,0,0,0-.06-.11,0-.15h.45s0,0,0,0,.11,0,.14-.06,0,0,0,0,.17-.1.27-.08,0,0,0,0-.13-.11,0-.13l.11,0a.72.72,0,0,0,.24.25C210.75,135.73,210.85,135.7,210.78,135.59Zm-.05,0s-.06,0-.07,0a.3.3,0,0,1-.12-.13l.07,0A.22.22,0,0,1,210.73,135.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.39,136.59c0-.07,0-.14,0-.15s0-.05,0-.05-.11.08-.1.17l-.11,0c-.06,0-.09,0-.11,0s0,.05,0,.08,0,0,0,0H208c-.07,0-.08,0-.12,0s.06.06-.06,0l-.1,0s-.07,0-.06.08.05.05.05.07-.12,0-.16,0a0,0,0,0,0,0,0c0,.06,0,.08,0,.08l-.08,0s-.1.07-.17.06,0,0,0,0,.05.08-.05.12h-.12s0,0,0,0,.2.07.24,0,0-.09,0-.12.08,0,.09,0,.06,0,.08,0,0,0,0,0h.06s0,0,0,0,0,0,0,0,0,0,.07,0,.09,0,.12,0,0-.09,0-.13.12,0,.18-.05,0,0,0,0,.17,0,.23,0l0,0a.64.64,0,0,0,0-.07c0-.07.1-.06.14,0s.15.27.26.23,0,0,0,0S208.49,136.65,208.39,136.59Zm0,.11,0,0s.08.06.08.08S208.44,136.72,208.43,136.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.12,137.3a.36.36,0,0,0-.19-.13l-.1,0c0-.08-.1-.19,0-.21a.76.76,0,0,1,.18.06s0,0,0,0-.25-.14-.29,0a.24.24,0,0,0,0,.14.27.27,0,0,0-.12,0s-.08,0-.09.06,0,0,0,0a.06.06,0,0,0,0,0h0c-.06,0-.22,0-.26,0s0,.08,0,.09a.73.73,0,0,0-.14.06s0,0,0,0a1,1,0,0,1-.17,0c-.1,0-.33,0-.3.12s0,0,0,0,0,0,0,0l0,0s0,0-.05,0,0,.07,0,.11-.25-.05-.33,0,0,.2-.1.2,0,0,0,0,.11,0,.13-.11.28-.05.41-.08a0,0,0,0,0,0,0c0-.05,0-.09.06-.11s0,0,0,0-.07-.11,0-.15h.45s0,0,0,0,.12-.05.15-.06a0,0,0,0,0,0,0c-.06-.15.18-.1.27-.08s0,0,0,0-.13-.11,0-.13l.1,0a.84.84,0,0,0,.25.25C210.1,137.44,210.19,137.41,210.12,137.3Zm0,0s-.06,0-.07,0a.4.4,0,0,1-.13-.13l.08,0A.22.22,0,0,1,210.08,137.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.59,136.09c0-.07,0-.15,0-.16s0,0,0,0-.11.07-.1.16l-.11,0s-.09,0-.11.05,0,.05,0,.08.05,0,0,.05h-.08a.13.13,0,0,0-.12,0s.07.05-.06,0a.16.16,0,0,0-.1,0s-.07,0-.06.07,0,.05,0,.07-.12,0-.16,0,0,0,0,0,0,.07,0,.07l-.08,0c-.05,0-.1.07-.17.06a0,0,0,0,0,0,0c0,.05,0,.08-.06.13l-.11,0s0,.05,0,.05.2.07.24,0,0-.1,0-.13.08,0,.1,0l.07,0,0,0s0,0,.06,0l0,0s0,0,0,0a.15.15,0,0,1,.07,0s.09,0,.13,0,0-.09,0-.13.13,0,.18-.05,0,0,0,0,.17,0,.23,0a0,0,0,0,0,0,0l0-.07c0-.06.1-.06.14,0s.15.27.26.23a0,0,0,0,0,0,0C211.8,136.24,211.7,136.15,211.59,136.09Zm0,.1a0,0,0,0,1,0,0,.59.59,0,0,1,.08.08C211.72,136.31,211.64,136.21,211.63,136.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.25,133.64c0-.07-.13-.09-.19-.13l-.1,0c0-.07-.1-.19,0-.2s.13,0,.18,0,0,0,0,0-.24-.14-.28,0a.22.22,0,0,0,0,.13.18.18,0,0,0-.12,0c-.05,0-.08,0-.09,0s0,0,0,.05,0,0,0,.05,0,0,0,0-.23,0-.27,0,0,.08,0,.09-.12,0-.14.06,0,0,0,0a1,1,0,0,1-.17,0c-.1,0-.34,0-.3.12s0,0,0,0v0l0,0s0,0-.05,0,0,.07,0,.11-.24-.05-.32,0,0,.2-.11.2,0,0,0,0,.11,0,.13-.11.27-.05.41-.08a.06.06,0,0,0,0,0c0-.05,0-.08.05-.11s0,0,0,0-.06-.11,0-.14l.14,0h.31s0,0,0,0,.12-.05.15-.06a0,0,0,0,0,0,0c-.06-.15.17-.1.27-.08a0,0,0,0,0,0,0c0-.05-.14-.11,0-.13l.11,0a.66.66,0,0,0,.25.25C207.23,133.78,207.32,133.75,207.25,133.64Zm0,0s-.07,0-.08,0a.3.3,0,0,1-.12-.13l.07,0A.28.28,0,0,1,207.21,133.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.86,134.64c0-.06,0-.14,0-.15s0,0,0,0-.11.07-.1.16l-.11,0c-.05,0-.09,0-.11.05s0,0,0,.08,0,0,0,.05h-.08c-.07,0-.07,0-.11,0s.06.05-.07,0l-.09,0c-.05,0-.07,0-.07.08s.06,0,.06.07-.12,0-.17,0a0,0,0,0,0,0,0c0,.06,0,.08,0,.08l-.08,0s-.1.07-.16.06,0,0,0,0,0,.08-.06.12h-.11s0,.05,0,.05.2.07.25,0,0-.1,0-.13.09,0,.1,0l.08,0,0,0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,.07,0,.1,0,.13,0,0-.09,0-.13.13,0,.18,0a0,0,0,0,0,0,0c0-.11.16,0,.22,0s0,0,0,0l0-.07c0-.06.1-.06.15-.05s.14.27.25.23l0,0C205.07,134.8,205,134.71,204.86,134.64Zm0,.11v0a.29.29,0,0,1,.08.08C205,134.87,204.91,134.77,204.9,134.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6,135.35a.53.53,0,0,0-.2-.13l-.09,0c-.05-.07-.1-.19,0-.2s.14,0,.19.05,0,0,0,0-.25-.14-.28,0a.08.08,0,1,1-.11.11s-.07,0-.09,0,0,0,0,.05,0,0,0,0h0c-.06,0-.22,0-.26,0s0,.08,0,.09a1.47,1.47,0,0,0-.14.06s0,0,0,0h-.18c-.09,0-.33,0-.3.12s0,0,0,0a0,0,0,0,0,0,0l0,0s0,0-.06,0,0,.07,0,.11-.24,0-.33,0,0,.2-.1.2,0,0,0,0,.1,0,.13-.11.27,0,.4-.08,0,0,0,0,0-.08.06-.11,0,0,0,0-.06-.11,0-.14a.52.52,0,0,1,.14,0h.31s0,0,0,0,.12-.05.15-.06,0,0,0,0c-.07-.16.17-.11.27-.09s0,0,0,0-.13-.11,0-.13l.11,0a.72.72,0,0,0,.24.25C206.57,135.49,206.67,135.46,206.6,135.35Zm0,0s-.06,0-.07,0a.3.3,0,0,1-.12-.13l.07,0A.22.22,0,0,1,206.55,135.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.06,134.14c0-.07,0-.15.05-.16s0,0,0,0-.11.07-.1.16l-.1,0c-.06,0-.1,0-.12.05s0,0,0,.09,0,0,0,0h-.08c-.06,0-.07,0-.11,0s.06,0-.06,0-.07,0-.1,0-.07,0-.06.07.05,0,.05.07-.12,0-.17,0,0,0,0,0,0,.07-.05.07-.06,0-.08,0-.1.07-.16.06,0,0,0,0,0,.08-.05.13l-.12,0s0,.05,0,.05.2.07.25,0,0-.1,0-.13.09,0,.1,0l.08,0s0,0,0,0h.05a.05.05,0,0,0,0,0s0,0,0,0,.05,0,.07,0,.1,0,.13,0,0-.09,0-.12.13,0,.18-.06,0,0,0,0,.16,0,.23,0l0,0a.36.36,0,0,1,0-.07c0-.06.11-.05.15,0s.14.26.26.22v0C208.27,134.29,208.17,134.2,208.06,134.14Zm.05.1s0,0,0,0l.08.08C208.19,134.36,208.12,134.26,208.11,134.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,136.53a.39.39,0,0,0-.2-.13l-.09-.05c0-.07-.1-.18,0-.2s.13,0,.18.06,0,0,0,0-.24-.14-.28,0a.24.24,0,0,0,0,.14.31.31,0,0,0-.13,0s-.07,0-.08.05,0,0,0,.06a0,0,0,0,0,0,0h0c-.06,0-.23,0-.27,0s0,.08,0,.09l-.14,0s0,0,0,.05-.14,0-.17,0-.34,0-.3.12,0,0,0,0v0s0,0,0,0l-.05,0c-.05.06,0,.08,0,.12s-.24-.05-.32,0,0,.19-.11.2,0,0,0,0,.11,0,.13-.11.27,0,.41-.08a.06.06,0,0,0,0,0c0-.06,0-.09.05-.11s0,0,0,0-.06-.1,0-.14H206s0,0,0,0,.12,0,.15-.06,0,0,0,0c-.06-.16.17-.1.27-.08a0,0,0,0,0,0,0c0-.06-.14-.11,0-.13l.11,0a.72.72,0,0,0,.24.25C206.94,136.67,207,136.63,207,136.53Zm0,0s-.07,0-.08,0a.49.49,0,0,1-.12-.13l.07,0A.35.35,0,0,1,206.92,136.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,135.42c0-.07,0-.14,0-.15s0-.05,0-.05-.11.07-.1.16l-.11,0c-.05,0-.09,0-.11,0s0,.06,0,.09,0,0,0,0h-.08a.1.1,0,0,0-.11,0s.06,0-.07,0-.06,0-.09,0-.07,0-.07.08.06,0,.06.06-.12,0-.17,0l0,0c0,.05,0,.07,0,.08l-.08,0s-.1.06-.16.06,0,0,0,0,0,.08-.06.12h-.12s0,0,0,0,.2.07.24,0,0-.1,0-.13.09,0,.1,0l.07,0s0,0,0,0h.06s0,0,0,0,0,0,0,0,0,0,.07,0,.1,0,.13,0,0-.08,0-.12.13,0,.18,0a0,0,0,0,0,0,0c0-.11.16,0,.22,0s0,0,0,0l0-.07c0-.07.1-.06.15-.05s.14.26.25.23a0,0,0,0,0,0,0C208.33,135.57,208.23,135.48,208.12,135.42Zm0,.11v0a.29.29,0,0,1,.08.08C208.25,135.64,208.17,135.55,208.16,135.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.45,134.53v0c0-.07-.09,0-.11,0s0,.06,0,.09,0,0,0,0h-.08a.1.1,0,0,0-.11,0s.06.06-.07,0-.06,0-.09,0-.07,0-.07.08.06.05.06.06-.12,0-.17,0,0,0,0,0,0,.08,0,.08l-.08,0c-.05,0-.1.07-.16.06s0,0,0,0,0,.08-.06.12h-.11s0,0,0,0,.2.06.25,0,0-.1,0-.12l.1,0a.15.15,0,0,1,.08,0s0,0,0,0,0,0,.05,0,0,0,0,0,0,0,0,0,.05,0,.07,0,.1,0,.13,0,0-.08,0-.12.13,0,.18-.05a0,0,0,0,0,0,0c0-.1.16,0,.22,0s0,0,0,0,0-.09,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M210.67,141.08c.09.25.36.41.81.47l6.44-3.77.83-.85a.06.06,0,0,0-.06-.11l-1.54.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21,136.76l1.37-.27s.06,0,0,.07l-.93,1.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,136.56s0-.08,0-.07l-.27.06h0a.23.23,0,0,1,.11.21v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.57,140.55l.12-.07.13-.07,4.87-2.79a.66.66,0,0,0,0-.46.65.65,0,0,0-.44-.4l-4.87,2.79-.25.15C212.26,139.61,212.75,140.46,212.57,140.55Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,140.3l.25-.14c.08,0,0-.22-.05-.41s-.34-.49-.44-.44l-.18.11-.07,0c.1-.06.32.19.44.44s.12.35.06.4h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.06,140.27c.18-.09-.32-.94-.49-.85l-.25.14c.17-.09.66.76.49.85Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.57,140.55l.25-.14c.17-.09-.3-.91-.48-.86h0l-.24.15C212.26,139.61,212.75,140.46,212.57,140.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,136.52l0,0-1,.55-5.14,3s0,0,0,0c.15.23.26.52.16.57l.12-.07.13-.07,4.87-2.79h0l.93-1.06A0,0,0,0,0,218.62,136.52Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.52,141.15l1-.6c.08,0,0-.22,0-.41s-.34-.49-.43-.44h0l-1.05.6c-.21.12,0,.58.22.78A.24.24,0,0,0,211.52,141.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.59,140.82a.79.79,0,0,0-.43-.52.2.2,0,0,0-.16,0c-.16.14,0,.56.25.75a.24.24,0,0,0,.27.07C211.6,141.11,211.63,141,211.59,140.82Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.93,121.13l-11.76-6.79a.69.69,0,0,0-.68,0l-20.41,11.79a.15.15,0,0,0,0,.26L230,133.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05,119.7V120a1.08,1.08,0,0,1-.54.94l-19,11a1.07,1.07,0,0,1-1.09,0l-10.36-6a1.09,1.09,0,0,1-.54-.94v-.37h0a.14.14,0,0,0,.07.12L230,131.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05,119.7l-11.27-6.5a.61.61,0,0,0-.64,0l-19.56,11.29a.15.15,0,0,0,0,.25L230,131.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.85 130.35 223.78 126.84 241.55 116.58 247.66 120.07 229.85 130.35",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.66 120.07 247.43 120.2 241.55 116.85 224.01 126.98 223.78 126.84 241.55 116.58 247.66 120.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.87 120.6 226.98 120.66 229.96 122.38 235.26 119.32 235.37 119.26 232.28 117.47 226.87 120.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.98 120.66 229.96 122.38 235.26 119.32 232.28 117.6 226.98 120.66",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,131.31V132a1,1,0,0,0,.54-.15l19-11a1.07,1.07,0,0,0,.54-.94v-.27Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,131.31V132a1,1,0,0,0,.54-.15l19-11a1.07,1.07,0,0,0,.54-.94v-.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.26,131.47a1.28,1.28,0,0,0,1.11-.09l18.93-10.93a1.31,1.31,0,0,0,.63-.9L253,107.2a1.49,1.49,0,0,0,0-.21,1.27,1.27,0,0,0-.39-.92L233,117.43a.94.94,0,0,0-.47.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,131.31l.13.07.17.09,2.24-13.38a.94.94,0,0,1,.47-.66l19.66-11.36a1.37,1.37,0,0,0-.26-.2l-19.71,11.38a1,1,0,0,0-.46.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.69,117.68l-.31-.18a1,1,0,0,0-.18.42L230,131.31l.13.07.17.09,2.24-13.38A1,1,0,0,1,232.69,117.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.92,120.06a4.17,4.17,0,0,1,1.91-2.45c.92-.53,1.55-.29,1.41.54a4.23,4.23,0,0,1-1.91,2.45C241.41,121.13,240.79,120.89,240.92,120.06Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.13,150.27l-11.76-6.79a.69.69,0,0,0-.68,0l-20.41,11.78a.15.15,0,0,0,0,.26l11.88,6.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.25,148.84v.26a1.09,1.09,0,0,1-.54,1l-19,11a1.13,1.13,0,0,1-1.09,0l-10.36-6a1.11,1.11,0,0,1-.54-.94v-.37h0a.13.13,0,0,0,.07.12l11.38,6.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.25,148.84,188,142.33a.68.68,0,0,0-.65,0l-19.55,11.29a.14.14,0,0,0,0,.25l11.38,6.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.05 159.49 172.97 155.98 190.75 145.72 196.86 149.2 179.05 159.49",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.86 149.2 196.63 149.34 190.75 145.98 173.21 156.11 172.97 155.98 190.75 145.72 196.86 149.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.07 149.73 176.18 149.8 179.16 151.52 184.46 148.46 184.57 148.39 181.47 146.61 176.07 149.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.18 149.8 179.16 151.52 184.46 148.46 181.47 146.74 176.18 149.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,160.44v.73a1.08,1.08,0,0,0,.54-.15l19-11a1.09,1.09,0,0,0,.54-1v-.26Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,160.44v.73a1.08,1.08,0,0,0,.54-.15l19-11a1.09,1.09,0,0,0,.54-1v-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.46,160.6a1.31,1.31,0,0,0,1.11-.08l18.93-10.93a1.27,1.27,0,0,0,.62-.9l2.08-12.36a1.48,1.48,0,0,0,0-.21,1.25,1.25,0,0,0-.38-.91l-19.66,11.35a1,1,0,0,0-.47.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.16,160.44l.13.08.17.08,2.24-13.37a1,1,0,0,1,.47-.67l19.66-11.35a.86.86,0,0,0-.26-.2l-19.71,11.38a1,1,0,0,0-.46.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89,146.82l-.31-.18a1,1,0,0,0-.18.41l-2.24,13.39.13.08.17.08,2.24-13.37A.91.91,0,0,1,181.89,146.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.12,149.2a4.22,4.22,0,0,1,1.91-2.46c.92-.53,1.54-.28,1.41.54a4.22,4.22,0,0,1-1.91,2.46C190.61,150.27,190,150,190.12,149.2Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.69,165.12a1,1,0,0,1-.5-.13L228,156.82a.58.58,0,0,1-.31-.49.56.56,0,0,1,.29-.49l11.7-7.44a1.07,1.07,0,0,1,.55-.15,1,1,0,0,1,.5.13l4.22,2.43a.77.77,0,0,1,.29,1l-.17.34a.15.15,0,0,0,.06.18l8.48,4.94a.57.57,0,0,1,.31.48.56.56,0,0,1-.29.5L243.25,165A1.11,1.11,0,0,1,242.69,165.12Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M242.9,164.28l10.61-6.14a.23.23,0,0,0,0-.44L239,149.43a.83.83,0,0,0-.75,0L227.7,155.5a.23.23,0,0,0,0,.44l14.44,8.34A.85.85,0,0,0,242.9,164.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.69,155.48l11.93-7.58a.8.8,0,0,1,.75,0l4.3,2.48a.48.48,0,0,1,.17.61l-.17.34a.47.47,0,0,0,.18.61l8.66,5a.25.25,0,0,1,0,.46l-10.63,6.84a.8.8,0,0,1-.75,0l-14.44-8.34A.25.25,0,0,1,227.69,155.48Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M211.87,129.56c-1.39.77-1.39,2,0,2.78a5.79,5.79,0,0,0,5,0c1.39-.77,1.39-2,0-2.78A5.79,5.79,0,0,0,211.87,129.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.86,130.84a3.39,3.39,0,0,0-2.61-.94h.09A3,3,0,0,1,216.86,130.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.55,125a7.35,7.35,0,0,0-4.43.12c-1.19.49-1.17,1.23,0,1.66a7.37,7.37,0,0,0,4.43-.12C217.83,126.17,217.81,125.43,216.55,125Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.55,125a7.35,7.35,0,0,0-4.43.12c-1.19.49-1.17,1.23,0,1.66a7.37,7.37,0,0,0,4.43-.12C217.83,126.17,217.81,125.43,216.55,125Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M217.5,123.47l-6.38.17.68,7.51h0c0,.27.3.53.79.73a5.67,5.67,0,0,0,3.83-.1c.5-.22.75-.5.78-.77h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.12,123.64l.14,1.53a3.39,3.39,0,0,0,.54.27,7.83,7.83,0,0,0,5.08-.13l.17-.09a3.36,3.36,0,0,0,.39-.23l.06-1.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.91,123.68l0-1.15-.74,0a2.52,2.52,0,0,0-.33-.14,7.72,7.72,0,0,0-5.09.13,2.11,2.11,0,0,0-.3.16l-.73,0,0,1.15h0c0,.37.37.74,1.06,1a7.8,7.8,0,0,0,5.09-.14C217.57,124.44,217.92,124.06,217.91,123.68Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.91,123.68l0-1.15-.74,0a2.52,2.52,0,0,0-.33-.14,7.72,7.72,0,0,0-5.09.13,2.11,2.11,0,0,0-.3.16l-.73,0,0,1.15h0c0,.37.37.74,1.06,1a7.8,7.8,0,0,0,5.09-.14C217.57,124.44,217.92,124.06,217.91,123.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,121.53a7.69,7.69,0,0,0-5.08.13c-1.36.6-1.34,1.53.06,2.07a7.77,7.77,0,0,0,5.08-.14C218.25,123,218.23,122.06,216.78,121.53Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21,122.27h0l-.26-.94-1.82,0a7.38,7.38,0,0,0-1.82.05l-1.77,0-.21,1h0c-.11.35.17.71.85,1a6.54,6.54,0,0,0,4.19-.11C217.07,123,217.34,122.61,217.21,122.27Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.21,122.27h0l-.26-.94-1.82,0a7.38,7.38,0,0,0-1.82.05l-1.77,0-.21,1h0c-.11.35.17.71.85,1a6.54,6.54,0,0,0,4.19-.11C217.07,123,217.34,122.61,217.21,122.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.15,120.75a6.4,6.4,0,0,0-3.85.1c-1,.42-1,1.05,0,1.42a6.49,6.49,0,0,0,3.85-.1C217.26,121.75,217.24,121.11,216.15,120.75Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,121.45a.48.48,0,0,1-.12.13,1.64,1.64,0,0,1-.44.24,5.52,5.52,0,0,1-1.8.32,5.31,5.31,0,0,1-1.79-.22,1.63,1.63,0,0,1-.43-.22c-.09-.07-.12-.12-.12-.13s.09-.2.53-.38a5.55,5.55,0,0,1,1.78-.32,5.77,5.77,0,0,1,1.81.23C216.49,121.25,216.6,121.41,216.61,121.45Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.61,121.45a.48.48,0,0,1-.12.13,1.64,1.64,0,0,1-.44.24,5.52,5.52,0,0,1-1.8.32,5.31,5.31,0,0,1-1.79-.22,1.63,1.63,0,0,1-.43-.22c-.09-.07-.12-.12-.12-.13s.09-.2.53-.38a5.55,5.55,0,0,1,1.78-.32,5.77,5.77,0,0,1,1.81.23C216.49,121.25,216.6,121.41,216.61,121.45Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216.49,121.58a1.64,1.64,0,0,1-.44.24,5.52,5.52,0,0,1-1.8.32,5.31,5.31,0,0,1-1.79-.22,1.63,1.63,0,0,1-.43-.22,1.45,1.45,0,0,1,.42-.24,5.25,5.25,0,0,1,1.77-.31,5.54,5.54,0,0,1,1.82.22A2.16,2.16,0,0,1,216.49,121.58Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.49,121.58a1.64,1.64,0,0,1-.44.24,5.52,5.52,0,0,1-1.8.32,5.31,5.31,0,0,1-1.79-.22,1.63,1.63,0,0,1-.43-.22,1.45,1.45,0,0,1,.42-.24,5.25,5.25,0,0,1,1.77-.31,5.54,5.54,0,0,1,1.82.22A2.16,2.16,0,0,1,216.49,121.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.41,121.64a.53.53,0,0,1,.42-.1c.08,0,0,.16-.13.25a.5.5,0,0,1-.43.09C215.19,121.84,215.25,121.73,215.41,121.64Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M211.49,128.72c0,.29.3.56.87.76a6.87,6.87,0,0,0,4.18-.1c.57-.23.86-.52.85-.81l.11-2.76c0,.3-.29.61-.91.85a7.37,7.37,0,0,1-4.43.12c-.6-.22-.91-.51-.92-.81Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.44,128.84a5.22,5.22,0,0,1-.26-.47,1.32,1.32,0,0,0-.73-.61.09.09,0,0,0-.12,0,1.09,1.09,0,0,0,1.39,1.33s0,0,0,0A1.23,1.23,0,0,1,213.44,128.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.62,127.67a1.75,1.75,0,0,1,.46.26,1.37,1.37,0,0,1,.34.45,1.3,1.3,0,0,0,.43.53.08.08,0,0,0,.12,0,1,1,0,0,0-.25-1.16,1,1,0,0,0-1.12-.22A.09.09,0,0,0,212.62,127.67Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheets--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220.24,159.59l13.08,7.55a.79.79,0,0,0,.73,0l9.62-5.55c.21-.12.21-.31,0-.43l-13.07-7.55a.87.87,0,0,0-.74,0l-9.62,5.56C220,159.29,220,159.48,220.24,159.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M220.24,159l13.08,7.55a.85.85,0,0,0,.73,0l9.62-5.56c.21-.12.21-.31,0-.42l-13.07-7.55a.81.81,0,0,0-.74,0l-9.62,5.55A.23.23,0,0,0,220.24,159Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,153.06l-9.13,5.27,12.59,7.27a.79.79,0,0,0,.73,0l9.14-5.27-12.59-7.27A.81.81,0,0,0,229.86,153.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.24,157.71l13.08,7.55a.85.85,0,0,0,.73,0l9.62-5.56a.22.22,0,0,0,0-.42l-13.07-7.55a.81.81,0,0,0-.74,0l-9.62,5.55A.23.23,0,0,0,220.24,157.71Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M297,135.14a.09.09,0,0,1-.05.12l-11.85,6.84a.24.24,0,0,1-.15,0,.21.21,0,0,1-.14,0l-16.55-9.55a.08.08,0,0,1,0-.05.08.08,0,0,1,0-.09h0l0,0,11.85-6.84a.32.32,0,0,1,.3,0l16.54,9.55,0,0h0l0,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--List--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.77,131.71V132a.29.29,0,0,0,.14.24l15.87,9.17a.34.34,0,0,0,.28,0l11.37-6.57a.3.3,0,0,0,.15-.24v-.29a.3.3,0,0,0-.15-.24l-15.87-9.17a.34.34,0,0,0-.28,0l-11.37,6.57A.29.29,0,0,0,268.77,131.71Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.45,134.08c.06,0,.06.11,0,.15l-11.37,6.57a.26.26,0,0,1-.14,0v.61a.32.32,0,0,0,.14,0l11.37-6.57a.3.3,0,0,0,.15-.24v-.29A.32.32,0,0,0,296.45,134.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.89,131.49h0v0h0a.41.41,0,0,0-.07.15V132a.29.29,0,0,0,.14.24l15.87,9.17a.32.32,0,0,0,.14,0v-.61a.32.32,0,0,1-.14,0l-15.87-9.17s-.05,0-.05,0a.08.08,0,0,1,0-.08Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.07,127.65c0,.26.35.53.45.76a.08.08,0,0,1,0,.05c-.05.16-.2.28-.23.38a.22.22,0,0,0,0,.08v.21a.77.77,0,0,0,0,.15.53.53,0,0,1,0,.16,1.31,1.31,0,0,0,0,.27v.21a.19.19,0,0,0,.11.19l.64.37,4.76-2.75v-.21l-.64-.37a.54.54,0,0,0-.32-.06h0l-.43,0a3.73,3.73,0,0,1-.72,0h-.32a3.39,3.39,0,0,1-1.11.12h0a8.8,8.8,0,0,0-1.3-.27h0a1.15,1.15,0,0,0-.51.14c-.17.1-.23.2-.23.31Zm.72.15a.26.26,0,0,1,.12-.11l.11,0a1.27,1.27,0,0,1,.88.13.59.59,0,0,1,.25.25.29.29,0,0,1-.11.11.93.93,0,0,1-.65.05,1.26,1.26,0,0,1-.34-.13A.63.63,0,0,1,273.79,127.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.78,127.09h0l-.43,0a3.73,3.73,0,0,1-.72,0h-.32a3.39,3.39,0,0,1-1.11.12h0a8.8,8.8,0,0,0-1.3-.27h0a1.15,1.15,0,0,0-.51.14c-.58.34.08.74.22,1.06s-.16.49-.21.65.09.25,0,.6,0,.42.06.46l.64.37,4.76-2.75-.64-.37A.54.54,0,0,0,277.78,127.09Zm-3.57,2.68a.34.34,0,0,1-.26,0c-.08-.05-.1-.12,0-.16a.31.31,0,0,1,.26,0C274.26,129.66,274.28,129.73,274.21,129.77Zm.83-1.64a.93.93,0,0,1-.65.05,1.26,1.26,0,0,1-.34-.13c-.32-.18-.38-.44-.14-.57l.11,0a1.27,1.27,0,0,1,.88.13C275.21,127.74,275.27,128,275,128.13Zm2.85-.49a.27.27,0,0,1-.26,0c-.09,0-.1-.11,0-.15a.34.34,0,0,1,.26,0C277.93,127.54,278,127.61,277.89,127.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.48,139.8l9.9-5.71a.22.22,0,0,0,.08-.15v-.11a.22.22,0,0,0-.08-.15l-13.08-7.54a.15.15,0,0,0-.16,0l-9.9,5.71a.17.17,0,0,0-.08.14v.12a.17.17,0,0,0,.08.14l13.07,7.55A.17.17,0,0,0,284.48,139.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.4,133.7a0,0,0,0,1,0,.08l-9.9,5.71a.11.11,0,0,1-.08,0v.31l.08,0,9.9-5.71a.22.22,0,0,0,.08-.15v-.11A.2.2,0,0,0,294.4,133.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.22,131.86l0,0v0a.08.08,0,0,0,0,0,0,0,0,0,0,0,0v.13a.18.18,0,0,0,.08.15l13.07,7.55.09,0v-.31a.15.15,0,0,1-.09,0L271.24,132A.06.06,0,0,1,271.22,131.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.14,127.88l.12.06c.06,0,.06.1,0,.13l-7.95,4.59a.22.22,0,0,1-.22,0l-.12-.07c-.06,0-.06-.09,0-.13l7.95-4.58A.22.22,0,0,1,282.14,127.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.84,128.28l.11.06c.06,0,.06.1,0,.13L275,133.06a.24.24,0,0,1-.23,0l-.11-.07c-.06,0-.06-.09,0-.13l7.94-4.58A.24.24,0,0,1,282.84,128.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.53,128.68l.11.06c.06,0,.06.1,0,.13l-7.94,4.59a.24.24,0,0,1-.23,0l-.11-.07c-.06,0-.06-.09,0-.13l7.94-4.58A.24.24,0,0,1,283.53,128.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.06,129.56l.11.07c.06,0,.06.09,0,.13l-7.94,4.58a.24.24,0,0,1-.23,0l-.11-.06c-.07,0-.07-.1,0-.14l7.94-4.58A.24.24,0,0,1,285.06,129.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75,130l.11.07c.07,0,.07.09,0,.13l-7.94,4.58a.22.22,0,0,1-.22,0l-.12-.06c-.06,0-.06-.1,0-.13l7.94-4.59A.24.24,0,0,1,285.75,130Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.44,130.36l.11.06c.07,0,.07.1,0,.14l-7.94,4.58a.22.22,0,0,1-.22,0l-.12-.07c-.06,0-.06-.09,0-.13l7.94-4.58A.24.24,0,0,1,286.44,130.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,131.24l.11.07c.07,0,.07.09,0,.13L280.14,136a.22.22,0,0,1-.22,0l-.12-.06c-.06,0-.06-.1,0-.13l7.94-4.59A.24.24,0,0,1,288,131.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.66,131.64l.12.07c.06,0,.06.09,0,.13l-7.94,4.58a.24.24,0,0,1-.23,0l-.12-.06c-.06,0-.06-.1,0-.13l7.95-4.59A.28.28,0,0,1,288.66,131.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.35,132l.12.07c.06,0,.06.09,0,.13l-7.94,4.58a.24.24,0,0,1-.23,0l-.12-.06c-.06,0-.06-.1,0-.13l7.95-4.59A.22.22,0,0,1,289.35,132Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,130.48v.21a.48.48,0,0,0,.11.29l5.83-3.36v-.21a1.3,1.3,0,0,0-.57-.14h0a.88.88,0,0,0-.39.08l-.8.36a.44.44,0,0,1-.4-.06h0l-.17-.16-.47-.43a.28.28,0,0,0-.23-.08h0l-.11,0a1.64,1.64,0,0,1-.49,0,1.07,1.07,0,0,1-.52-.2,1.2,1.2,0,0,0-.81-.29h0a1.07,1.07,0,0,0-.53.13.58.58,0,0,0-.36.63.56.56,0,0,0,.21.54.5.5,0,0,1,.13.25.52.52,0,0,1-.12.27.2.2,0,0,0-.06.14v.21a.15.15,0,0,0,0,.11l.55.5.17.16,0,0a.25.25,0,0,1,0,.06l-.7.55A.55.55,0,0,0,274.6,130.48Zm1.55-3.2a.42.42,0,0,1-.2.22.88.88,0,0,1-.62,0,.79.79,0,0,1-.23-.14.42.42,0,0,1-.11-.16.4.4,0,0,1,.21-.22l.08,0a.79.79,0,0,1,.76.13A.51.51,0,0,1,276.15,127.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,127.27h0a.88.88,0,0,0-.39.08l-.8.36a.44.44,0,0,1-.4-.06h0l-.17-.16-.47-.43a.28.28,0,0,0-.23-.08h0l-.11,0a1.64,1.64,0,0,1-.49,0,1.07,1.07,0,0,1-.52-.2,1.2,1.2,0,0,0-.81-.29h0a1.07,1.07,0,0,0-.53.13.55.55,0,0,0-.15,1,.57.57,0,0,1,0,.73c-.13.16,0,.25,0,.25l.55.5.17.16c.13.12,0,.29,0,.29l-.7.55c-.31.27-.29.5-.13.71l5.83-3.36A1.3,1.3,0,0,0,280,127.27Zm-3.93-.36a.34.34,0,0,1-.09.59.88.88,0,0,1-.62,0,.79.79,0,0,1-.23-.14.34.34,0,0,1,.1-.59l.08,0A.8.8,0,0,1,276,126.91Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.83,148.12a1.09,1.09,0,0,0,.51.84l11,6.37a1.14,1.14,0,0,0,1,0l19.41-11.21a1.09,1.09,0,0,0,.51-.84,1.07,1.07,0,0,0-.51-.84l-11-6.37a1.14,1.14,0,0,0-1,0l-19.41,11.21A1.09,1.09,0,0,0,249.83,148.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34,147.86l11,6.37a1.14,1.14,0,0,0,1,0L281.79,143a.31.31,0,0,0,0-.58l-11-6.37a1.14,1.14,0,0,0-1,0l-19.41,11.21A.31.31,0,0,0,250.34,147.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.87,154.35v1.1a1.07,1.07,0,0,1-.51-.12l-11-6.37a.95.95,0,0,1-.05-1.65c-.23.16-.21.4.05.55l11,6.37A1.07,1.07,0,0,0,261.87,154.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36,147.3c-.27-.16-.25-.41-.25-.73V131.34a1.1,1.1,0,0,1,.5-.88L269,119.25a1.09,1.09,0,0,1,1,0c.26.15.25.41.25.73v15.23a1.13,1.13,0,0,1-.51.88l-19.41,11.21A1.09,1.09,0,0,1,249.36,147.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.26,120c0-.32-.23-.45-.51-.29l-19.41,11.21a1,1,0,0,0-.36.38l-.72-.42h0a1,1,0,0,1,.35-.38L269,119.25a1.09,1.09,0,0,1,1,0C270.27,119.38,270.26,119.64,270.26,120Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,147.31a1.09,1.09,0,0,1-.92,0c-.27-.16-.25-.41-.25-.73V131.34a.91.91,0,0,1,.15-.5l.72.42h0a1,1,0,0,0-.15.5V147C249.83,147.28,250,147.42,250.28,147.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.61,131.46l18.72-10.8c.17-.1.3,0,.3.17v13.3a.65.65,0,0,1-.3.52l-18.72,10.81c-.17.1-.3,0-.3-.18V132A.68.68,0,0,1,250.61,131.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.74,147.31l18-10.41a.57.57,0,0,1,.51,0l.3.17a.15.15,0,0,1,0,.29l-18,10.4a.55.55,0,0,1-.5,0l-.3-.16A.15.15,0,0,1,251.74,147.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.15,148.15l18-10.41a.52.52,0,0,1,.47,0l4.69,2.71c.11.06.09.18-.05.26l-18,10.39a.5.5,0,0,1-.46,0l-4.71-2.7C253,148.35,253,148.23,253.15,148.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.77,142.11l.56-.32s0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.57.33a0,0,0,0,0,0,0l.54.32A.08.08,0,0,0,268.77,142.11Zm-.83-1.12-.56.32s0,0,0,.05l.54.31a.11.11,0,0,0,.08,0l.56-.33s0,0,0,0L268,141A.1.1,0,0,0,267.94,141Zm-1.82,1-.95.55s0,0,0,0l.54.31a.11.11,0,0,0,.08,0l1-.56a0,0,0,0,0,0,0l-.54-.31A.06.06,0,0,0,266.12,142Zm1-.58-.56.33s0,0,0,.05l.54.31a.08.08,0,0,0,.08,0l.57-.32s0,0,0,0l-.54-.31A.11.11,0,0,0,267.12,141.46Zm-2.21,1.28-.57.33a0,0,0,0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.56-.32s0,0,0,0l-.54-.31A.11.11,0,0,0,264.91,142.74Zm-.83.48-.56.32s0,0,0,.05l.54.31h.08l.57-.33a0,0,0,0,0,0,0l-.54-.32A.08.08,0,0,0,264.08,143.22Zm2.12,1.27.56-.33s0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.57.32s0,0,0,.05l.54.31Zm-.83.47.57-.32s0,0,0,0l-.54-.31h-.08l-.56.33s0,0,0,0l.54.31A.08.08,0,0,0,265.37,145Zm-.82.48.56-.33s0,0,0,0l-.54-.31a.06.06,0,0,0-.08,0l-.57.32s0,0,0,0l.54.31S264.52,145.45,264.55,145.44Zm-.83.48.57-.33s0,0,0-.05l-.54-.31h-.08l-.56.33s0,0,0,.05l.54.31A.11.11,0,0,0,263.72,145.92Zm4.22-3.33.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31ZM267,144l1.26-.72s0,0,0,0l-1.31-.76h-.09l-.65.38s0,0,0,0l.69.4s0,0,0,.05l-.52.3s0,0,0,0l.54.31A.06.06,0,0,0,267,144Zm-3.76-.32-.57.33s0,0,0,0l.54.31a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31Zm-.83.48-.56.32s0,0,0,0l.54.31s.06,0,.09,0l.56-.33s0,0,0,0l-.54-.31A.06.06,0,0,0,262.43,144.17Zm-4.56,5.08H258l.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.57.32s0,0,0,.05Zm-2-1.27-.56.32s0,0,0,0l.54.31h.08l.56-.33s0,0,0,0l-.54-.31A.07.07,0,0,0,255.83,148Zm1,1H257l.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05Zm2.28.51.56-.32s0,0,0-.05l-.54-.31h-.09l-.56.33s0,0,0,0l.54.31A.1.1,0,0,0,259.16,149.44Zm-.91.48s.06,0,.08,0l.57-.33a0,0,0,0,0,0,0l-.54-.31a.06.06,0,0,0-.08,0l-.57.32s0,0,0,.05Zm-1.59-2.42-.56.33s0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.57-.32s0,0,0-.05l-.54-.31Zm4.12-2.38-.56.33s0,0,0,0l.54.32a.1.1,0,0,0,.09,0l.56-.32s0,0,0,0l-.54-.31Zm-3.3,1.91-.56.32s0,0,0,.05l.53.31h.09l.56-.33s0,0,0,0l-.54-.31A.1.1,0,0,0,257.48,147Zm4.13-2.39L261,145a0,0,0,0,0,0,.05l.54.31h.08l.56-.33s0,0,0-.05l-.54-.31Zm-1.65,1-.57.32s0,0,0,.05l.54.31H260l.57-.33a0,0,0,0,0,0,0l-.54-.32A.08.08,0,0,0,260,145.6Zm-.83.47-.56.33s0,0,0,0l.54.31a.14.14,0,0,0,.09,0l.56-.33s0,0,0-.05l-.54-.31Zm-.82.48-.57.33a0,0,0,0,0,0,0l.54.31a.06.06,0,0,0,.08,0l.57-.32s0,0,0,0l-.54-.31S258.33,146.54,258.31,146.55Zm3.76.32.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31Zm7.7-6.94-.57.33s0,0,0,.05l.54.31h.08l.56-.33s0,0,0,0l-.54-.31A.11.11,0,0,0,269.77,139.93Zm-1,.58-.56.33s0,0,0,0l.54.31a.06.06,0,0,0,.08,0l.57-.32s0,0,0-.05l-.54-.31S268.79,140.5,268.77,140.51Zm1.82-1-.56.32s0,0,0,.05l.54.31a.14.14,0,0,0,.09,0l.56-.33s0,0,0,0l-.54-.32A.08.08,0,0,0,270.59,139.46ZM266,143.69l.57-.32s0,0,0-.05l-.54-.31H266l-.56.33s0,0,0,0l.54.31A.06.06,0,0,0,266,143.69ZM271.5,139h-.08l-.57.33a0,0,0,0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05Zm-8.6,7.41.56-.32s0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.57.33a0,0,0,0,0,0,0l.54.32A.08.08,0,0,0,262.9,146.39ZM273,140.55l.57-.32s0,0,0,0l-.54-.31H273l-.56.33s0,0,0,0l.54.32A.08.08,0,0,0,273,140.55Zm-1.59,0,.56-.32s0,0,0,0l-.54-.31a.14.14,0,0,0-.09,0l-.56.33s0,0,0,.05l.54.31A.1.1,0,0,0,271.42,140.58Zm.85-1.16a.08.08,0,0,0-.08,0l-.57.32s0,0,0,.05l.54.31h.08l.57-.33a0,0,0,0,0,0,0Zm.17-.1,1.32.76h.08l.56-.33s0,0,0-.05L273.1,139H273l-.56.33S272.42,139.31,272.44,139.32Zm-1.9,1.06-.57.32s0,0,0,.05l.54.31s.06,0,.08,0l.57-.32s0,0,0-.05l-.54-.31S270.56,140.37,270.54,140.38ZM264.33,144l-.56.33s0,0,0,.05l.54.31a.08.08,0,0,0,.08,0l.57-.32s0,0,0,0l-.54-.31A.11.11,0,0,0,264.33,144Zm7.78-2.93s.05,0,.08,0l.56-.33s0,0,0,0l-.54-.31a.07.07,0,0,0-.09,0l-.56.32s0,0,0,.05Zm-6.95,2.46-.57.32s0,0,0,.05l.54.31a.11.11,0,0,0,.08,0l.56-.33s0,0,0,0l-.54-.32A.08.08,0,0,0,265.16,143.49Zm-6.47,5.29a.1.1,0,0,0,.09,0l.56-.32s0,0,0,0l-.54-.31h-.08l-.56.33s0,0,0,0Zm-1-1-.56.33s0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.56-.32s0,0,0,0l-.54-.31A.14.14,0,0,0,257.73,147.77Zm1.87.53.56-.33s0,0,0-.05l-.54-.31a.08.08,0,0,0-.08,0l-.57.32a0,0,0,0,0,0,.05l.54.31Zm.82-.48.57-.32s0,0,0-.05l-.54-.31s-.05,0-.08,0l-.56.33s0,0,0,0l.54.31A.06.06,0,0,0,260.42,147.82Zm.83-.47.56-.33s0,0,0-.05l-.54-.31h-.08l-.57.33s0,0,0,0l.54.31A.11.11,0,0,0,261.25,147.35Zm-2.69,0-.56.32s0,0,0,0l.54.31a.11.11,0,0,0,.08,0l.57-.33s0,0,0-.05l-.54-.31A.08.08,0,0,0,258.56,147.3Zm.82-.48-.56.33s0,0,0,0l.54.31a.08.08,0,0,0,.09,0l.56-.32s0,0,0-.05l-.54-.31A.1.1,0,0,0,259.38,146.82Zm3.3-1.91-.56.33s0,0,0,0l.54.31a.14.14,0,0,0,.09,0l.56-.33s0,0,0-.05l-.54-.31Zm-.82.48-.57.33a0,0,0,0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.57-.32s0,0,0-.05l-.54-.31Zm1.65-.95-.57.32s0,0,0,.05l.54.31s.06,0,.08,0l.56-.33s0,0,0,0l-.54-.31A.06.06,0,0,0,263.51,144.44Zm-3.3,1.9-.57.33s0,0,0,.05l.54.31h.08l.57-.33a0,0,0,0,0,0,0l-.54-.31Zm.82-.47-.56.32s0,0,0,.05l.54.31h.09l.56-.33s0,0,0,0l-.54-.32A.1.1,0,0,0,261,145.87Zm-1,3.1.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.57.32s0,0,0,0l.54.31Zm-4.35-.21-.54-.31H255l-.56.33s0,0,0,.05l.54.31a.11.11,0,0,0,.08,0l.57-.33S255.65,148.78,255.63,148.76Zm1.08.27-.54-.31h-.08l-.87.51s0,0,0,0l.54.31a.06.06,0,0,0,.08,0l.87-.5S256.73,149.05,256.71,149Zm-1.88-.88-.54-.31a.07.07,0,0,0-.09,0l-.69.4s0,0,0,0l.54.31a.11.11,0,0,0,.08,0l.69-.41S254.85,148.16,254.83,148.15Zm.53-.31h.08l.56-.33s0,0,0,0l-.54-.31a.08.08,0,0,0-.08,0l-.57.32a0,0,0,0,0,0,.05Zm2.34,1.51-.54-.31h-.09l-1.08.63s0,0,0,.05l.54.31h.09l1.08-.63S257.72,149.36,257.7,149.35Zm.38.67-.54-.31a.14.14,0,0,0-.09,0l-.69.41s0,0,0,0l.54.31a.07.07,0,0,0,.09,0l.69-.4S258.1,150,258.08,150Zm3.41-5.72h.08l.57-.33s0,0,0-.05l-.54-.31a.11.11,0,0,0-.08,0l-.56.33s0,0,0,.05Zm-1.65.95h.08l.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05Zm-3.66,2.11s.06,0,.09,0l.56-.32s0,0,0,0l-.54-.31s-.05,0-.08,0l-.56.32s0,0,0,.05Zm4.49-2.58a.08.08,0,0,0,.08,0l.56-.32s0,0,0,0l-.54-.31h-.09l-.56.33s0,0,0,0Zm-1.65.95a.11.11,0,0,0,.08,0l.56-.33s0,0,0-.05l-.54-.31h-.08l-.57.33s0,0,0,0Zm-.54,4.33s-.06,0-.08,0l-.87.5s0,0,0,.05l.54.31a.11.11,0,0,0,.08,0l.87-.5s0,0,0,0Zm-.65-3.65h.08l.57-.33s0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0Zm-.82.48a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31H257l-.57.33s0,0,0,.05Zm16.75-5.65a.06.06,0,0,0-.08,0l-1.39.8s0,0,0,.05l.54.31h.09l1.38-.81s0,0,0,0Zm-1.82,1h-.09l-.56.33s0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05Zm-11.13,6.2.56-.32s0,0,0,0l-.54-.31s-.05,0-.08,0l-.56.33s0,0,0,0l.54.31A.07.07,0,0,0,260.81,148.49Zm9.48-5.25a.14.14,0,0,0-.09,0l-.56.33s0,0,0,.05l.54.31h.08l.56-.33s0,0,0,0Zm4.29-2.48h-.08l-.56.33s0,0,0,0l.54.31a.08.08,0,0,0,.08,0l.57-.32s0,0,0-.05Zm1.37-.16-1.31-.76h-.08l-.57.33a0,0,0,0,0,0,0l1.31.76h.08l.56-.33S276,140.61,276,140.6ZM267.21,145a.14.14,0,0,0-.09,0l-.69.4s0,0,0,.05l.54.31h.09l.69-.4s0,0,0,0Zm2.08-1.2s-.06,0-.08,0l-.87.5s0,0,0,.05l.54.31H269l.86-.5s0,0,0-.05Zm-4,2.3a.1.1,0,0,0-.09,0l-4.64,2.68s0,0,0,0l.54.32a.1.1,0,0,0,.09,0l4.64-2.68s0,0,0,0ZM260.39,149a.08.08,0,0,0-.08,0l-.7.4s0,0,0,0l.54.31a.08.08,0,0,0,.08,0l.7-.4a0,0,0,0,0,0,0Zm5.86-3.38h-.08l-.7.4s0,0,0,.05l.54.31s.06,0,.08,0l.7-.4s0,0,0-.05Zm-6.81,3.94a.08.08,0,0,0-.09,0l-.69.4s0,0,0,.05l.54.31h.09l.69-.41s0,0,0,0Zm8.72-5h-.08l-.7.4s0,0,0,0l.54.31a.11.11,0,0,0,.08,0l.69-.4s0,0,0-.05Zm2.95-1.71a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0l.54.31a.11.11,0,0,0,.08,0l.57-.33a0,0,0,0,0,0,0Zm1.85-1.28.56-.33s0,0,0-.05l-.54-.31h-.08l-.57.33s0,0,0,0l.54.31A.11.11,0,0,0,273,141.48Zm-3.37.16.57-.33s0,0,0-.05l-.54-.31a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31A.11.11,0,0,0,269.59,141.64Zm-2.19,3,1.65-1s0,0,0,0l-.54-.31h-.08l-1.65,1s0,0,0,0l.54.32A.08.08,0,0,0,267.4,144.68Zm4.65-2.73a.06.06,0,0,0,.08,0l.57-.32s0,0,0,0l-.54-.31s-.05,0-.08,0l-.56.33s0,0,0,0Zm-.69-.44.57-.33s0,0,0-.05l-.54-.31h-.08l-.56.33s0,0,0,0l.54.31A.11.11,0,0,0,271.36,141.51Zm-4.78,3.65.56-.33s0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.57.32s0,0,0,0l.54.31Zm3.65-2.15a.08.08,0,0,0,.08,0l.57-.32s0,0,0-.05l-.54-.31h-.08l-.57.33a0,0,0,0,0,0,0Zm-7.78,4.53.57-.33s0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0l.54.31A.11.11,0,0,0,262.45,147.54Zm.83-.48.56-.32s0,0,0-.05l-.54-.31h-.08l-.57.33a0,0,0,0,0,0,0l.54.32A.08.08,0,0,0,263.28,147.06Zm-1.65,1,.56-.33s0,0,0-.05l-.54-.31a.11.11,0,0,0-.08,0l-.57.33s0,0,0,.05l.54.31Zm3.3-1.91.56-.32s0,0,0,0l-.54-.31s-.06,0-.08,0l-.57.33a0,0,0,0,0,0,0l.54.31A.06.06,0,0,0,264.93,146.11Zm-.83.48.57-.33s0,0,0,0l-.54-.31a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31Zm1.65-1,.57-.33a0,0,0,0,0,0-.05l-.54-.31h-.08l-.56.33s0,0,0,.05l.54.31A.11.11,0,0,0,265.75,145.64Zm4.5-6.63a.14.14,0,0,0,.09,0l.56-.33s0,0,0,0l-.15-.09a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05Zm-4.09,2.6a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31h-.09l-.56.33s0,0,0,.05Zm1.64-1a.08.08,0,0,0,.09,0l.56-.32s0,0,0-.05l-.54-.31a.1.1,0,0,0-.09,0l-.56.33s0,0,0,0Zm-2.65,1.54h.08l.56-.33s0,0,0-.05l-.54-.31h-.08l-.57.33s0,0,0,0Zm1.83-1.06h.08l.57-.33s0,0,0-.05l-.54-.31a.08.08,0,0,0-.08,0l-.57.32s0,0,0,0Zm-3.48,2a.11.11,0,0,0,.08,0l.56-.33s0,0,0-.05l-.54-.31a.08.08,0,0,0-.08,0l-.57.32s0,0,0,.05Zm.82-.48a.07.07,0,0,0,.09,0l.56-.32s0,0,0-.05l-.54-.31s-.05,0-.08,0l-.56.33s0,0,0,0Zm4.28-2.7a.1.1,0,0,0,.09,0l.56-.32s0,0,0,0l-.15-.09a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0Zm2.48-1.42a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.14-.08a.1.1,0,0,0-.09,0l-.56.32s0,0,0,0Zm1.13.65h.08l.57-.33s0,0,0-.05l-.54-.31a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0Zm1.57,1.81.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31Zm-4.35-1.51a.08.08,0,0,0,.08,0l.57-.32a0,0,0,0,0,0,0l-.14-.08h-.09l-.56.33s0,0,0,0Zm-6.76,4.13a.1.1,0,0,0,.09,0l.56-.32s0,0,0,0l-.53-.31a.14.14,0,0,0-.09,0l-.56.33s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.11 147.87 265.23 147.94 268.3 149.71 273.77 146.56 273.88 146.49 270.69 144.65 265.11 147.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.23 147.94 268.3 149.71 273.77 146.56 270.69 144.78 265.23 147.94",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.68,171.82a1.11,1.11,0,0,0,.51.85l11,6.36a1.14,1.14,0,0,0,1,0l19.41-11.21a.95.95,0,0,0,0-1.68l-11-6.37a1.12,1.12,0,0,0-1,0L198.19,171A1.11,1.11,0,0,0,197.68,171.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19,171.57l11,6.37a1.14,1.14,0,0,0,1,0l19.41-11.21c.28-.17.28-.43,0-.59l-11-6.37a1.12,1.12,0,0,0-1,0L198.19,171C197.91,171.15,197.91,171.41,198.19,171.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,178.06v1.09a1.07,1.07,0,0,1-.51-.12l-11-6.36a1.11,1.11,0,0,1-.51-.85,1.08,1.08,0,0,1,.45-.8c-.22.16-.2.4.06.55l11,6.37A1.07,1.07,0,0,0,209.72,178.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2,171c-.26-.15-.24-.41-.24-.73V155a1.13,1.13,0,0,1,.5-.88L216.88,143a1.09,1.09,0,0,1,1,0c.26.15.25.4.25.73V158.9a1.11,1.11,0,0,1-.51.87L198.19,171A1.08,1.08,0,0,1,197.2,171Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.11,143.67c0-.33-.23-.46-.51-.3l-19.41,11.21a1.1,1.1,0,0,0-.36.38l-.72-.42h0a1.1,1.1,0,0,1,.36-.38L216.88,143a1.09,1.09,0,0,1,1,0C218.12,143.09,218.11,143.34,218.11,143.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.13,171a1.08,1.08,0,0,1-.93,0c-.26-.15-.24-.41-.24-.73V155a1,1,0,0,1,.15-.5l.72.42h0a1.07,1.07,0,0,0-.15.5v15.23C197.68,171,197.88,171.13,198.13,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,155.17l18.72-10.81c.17-.09.3,0,.3.18v13.29a.66.66,0,0,1-.3.53l-18.72,10.8c-.17.1-.31,0-.31-.17v-13.3A.67.67,0,0,1,198.46,155.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.59,171l18-10.4a.57.57,0,0,1,.51,0l.3.16a.16.16,0,0,1,0,.3l-18,10.4a.55.55,0,0,1-.5,0l-.3-.16A.16.16,0,0,1,199.59,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,171.85l18-10.4a.56.56,0,0,1,.47,0l4.69,2.71c.11.07.09.19-.05.27l-18,10.39a.54.54,0,0,1-.46,0l-4.71-2.7C200.84,172.05,200.86,171.93,201,171.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,165.82l.56-.33s0,0,0,0l-.54-.32a.1.1,0,0,0-.09,0l-.56.32s0,0,0,0l.54.31A.11.11,0,0,0,216.62,165.82Zm-.83-1.13-.56.33s0,0,0,0l.54.31a.1.1,0,0,0,.09,0l.56-.32s0,0,0-.05l-.54-.31ZM214,165.74l-.95.56s0,0,0,0l.54.31a.06.06,0,0,0,.08,0l1-.55s0,0,0,0l-.54-.31A.11.11,0,0,0,214,165.74Zm1-.57-.57.32s0,0,0,0l.54.31s.06,0,.08,0l.57-.33a0,0,0,0,0,0,0l-.54-.31A.06.06,0,0,0,215,165.17Zm-2.21,1.28-.57.32s0,0,0,0l.54.31h.08l.56-.33s0,0,0,0l-.54-.32A.08.08,0,0,0,212.76,166.45Zm-.83.47-.56.33s0,0,0,.05l.54.31a.08.08,0,0,0,.08,0l.57-.32s0,0,0-.05l-.54-.31Zm2.12,1.27.56-.32s0,0,0-.05l-.54-.31H214l-.56.33s0,0,0,0l.54.31A.1.1,0,0,0,214.05,168.19Zm-.83.48.57-.33a0,0,0,0,0,0,0l-.54-.31a.06.06,0,0,0-.08,0l-.57.32s0,0,0,.05l.54.31S213.2,168.68,213.22,168.67Zm-.82.48.56-.33s0,0,0,0l-.54-.31a.14.14,0,0,0-.09,0l-.56.33s0,0,0,.05l.53.31Zm-.83.47.57-.32s0,0,0-.05l-.54-.31h-.08l-.56.33s0,0,0,0l.54.32A.08.08,0,0,0,211.57,169.62Zm4.22-3.32.57-.33a0,0,0,0,0,0-.05l-.54-.31a.11.11,0,0,0-.08,0l-.56.33s0,0,0,.05l.54.31Zm-.92,1.42,1.26-.73s0,0,0-.05l-1.31-.75s0,0-.08,0l-.65.38s0,0,0,0l.69.4s0,0,0,.05l-.52.3s0,0,0,0l.54.31Zm-3.76-.32-.57.32s0,0,0,.05l.54.31s0,0,.08,0l.56-.33s0,0,0,0l-.54-.31A.06.06,0,0,0,211.11,167.4Zm-.83.47-.56.33s0,0,0,.05l.54.31h.08l.57-.33s0,0,0,0l-.54-.31ZM205.72,173h.08l.56-.33s0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.57.33s0,0,0,.05Zm-2-1.28-.56.33s0,0,0,.05l.54.31h.09l.56-.33s0,0,0,0l-.54-.31A.14.14,0,0,0,203.68,171.68Zm1,1a.11.11,0,0,0,.08,0l.57-.33a0,0,0,0,0,0-.05l-.54-.31h-.08l-.57.33s0,0,0,.05Zm2.27.51.57-.33s0,0,0,0l-.54-.31a.06.06,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31S207,173.16,207,173.15Zm-.9.48h.08l.56-.33s0,0,0-.05l-.54-.31h-.08l-.57.33a0,0,0,0,0,0,0Zm-1.59-2.42-.57.32s0,0,0,.05l.54.31a.11.11,0,0,0,.08,0l.57-.33a0,0,0,0,0,0,0l-.54-.32A.08.08,0,0,0,204.51,171.21Zm4.12-2.38-.56.32s0,0,0,0l.54.31a.11.11,0,0,0,.08,0l.57-.33a0,0,0,0,0,0,0l-.54-.32A.08.08,0,0,0,208.63,168.83Zm-3.3,1.9-.56.33s0,0,0,0l.54.32a.1.1,0,0,0,.09,0l.56-.32s0,0,0-.05l-.54-.31Zm4.13-2.38-.57.33a0,0,0,0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31Zm-1.65,1-.57.33s0,0,0,.05l.54.31a.08.08,0,0,0,.08,0l.56-.32s0,0,0,0l-.54-.31A.11.11,0,0,0,207.81,169.3Zm-.83.48-.56.32s0,0,0,.05l.54.31a.06.06,0,0,0,.08,0l.57-.32s0,0,0,0l-.54-.31S207,169.77,207,169.78Zm-.82.48-.57.32s0,0,0,0l.54.31h.08l.56-.33s0,0,0-.05l-.54-.31A.08.08,0,0,0,206.16,170.26Zm3.76.31.57-.32a0,0,0,0,0,0-.05l-.54-.31h-.08l-.56.33s0,0,0,.05l.54.31A.08.08,0,0,0,209.92,170.57Zm7.7-6.93-.57.33a0,0,0,0,0,0,0l.54.31a.06.06,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31S217.64,163.63,217.62,163.64Zm-1,.58-.57.32s0,0,0,.05l.54.31h.08l.57-.33s0,0,0,0l-.54-.31A.08.08,0,0,0,216.62,164.22Zm1.82-1.06-.56.33s0,0,0,0l.54.31a.11.11,0,0,0,.08,0l.57-.33a0,0,0,0,0,0-.05l-.54-.31Zm-4.56,4.24.57-.33s0,0,0,0l-.54-.31a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31Zm5.47-4.72a.08.08,0,0,0-.08,0l-.57.32s0,0,0,.05l.54.31h.08l.56-.33s0,0,0,0Zm-8.6,7.42.56-.33s0,0,0,0l-.54-.32a.1.1,0,0,0-.09,0l-.56.32s0,0,0,0l.54.31A.11.11,0,0,0,210.75,170.1Zm10.11-5.84.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.57.32s0,0,0,0l.54.31A.11.11,0,0,0,220.86,164.26Zm-1.59,0,.56-.33s0,0,0,0l-.54-.31a.06.06,0,0,0-.08,0l-.56.32s0,0,0,0l.54.31S219.24,164.3,219.27,164.29Zm.85-1.16H220l-.57.33s0,0,0,0l.54.31a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05Zm.17-.1,1.31.76a.1.1,0,0,0,.09,0l.56-.32s0,0,0-.05l-1.31-.76a.08.08,0,0,0-.08,0l-.56.32S220.27,163,220.29,163Zm-1.9,1.05-.57.33a0,0,0,0,0,0,.05l.54.31h.08l.56-.33s0,0,0-.05l-.54-.31A.11.11,0,0,0,218.39,164.08Zm-6.21,3.59-.56.32s0,0,0,0l.54.31s.06,0,.08,0l.57-.33a0,0,0,0,0,0,0l-.54-.31A.06.06,0,0,0,212.18,167.67Zm7.77-2.93H220l.56-.33s0,0,0,0l-.54-.31a.14.14,0,0,0-.09,0l-.56.33s0,0,0,.05ZM213,167.19l-.57.33s0,0,0,0l.54.31a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31Zm-6.47,5.29a.11.11,0,0,0,.08,0l.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0Zm-1-1-.56.32s0,0,0,0l.54.31h.09l.56-.33s0,0,0,0l-.53-.32A.1.1,0,0,0,205.58,171.48Zm1.87.52.56-.32s0,0,0-.05l-.54-.31h-.08l-.57.33a0,0,0,0,0,0,0l.54.32A.08.08,0,0,0,207.45,172Zm.82-.47.57-.33s0,0,0,0l-.54-.31a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31Zm.83-.48.56-.32s0,0,0,0l-.54-.31s-.06,0-.08,0l-.57.32s0,0,0,.05l.54.31S209.07,171.06,209.1,171.05Zm-2.69-.05-.57.33a0,0,0,0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31Zm.82-.47-.56.32s0,0,0,.05l.54.31h.09l.56-.33s0,0,0,0l-.54-.31A.08.08,0,0,0,207.23,170.53Zm3.3-1.91L210,169s0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.57-.32s0,0,0,0l-.54-.31Zm-.82.48-.57.32s0,0,0,.05l.54.31h.08l.56-.33s0,0,0,0l-.54-.32A.08.08,0,0,0,209.71,169.1Zm1.65-1-.57.33a0,0,0,0,0,0,.05l.54.31h.08l.56-.33s0,0,0-.05l-.54-.31Zm-3.3,1.91-.57.32s0,0,0,0l.54.31s.06,0,.08,0l.56-.32s0,0,0,0l-.54-.31S208.08,170,208.06,170.05Zm.82-.48-.56.33s0,0,0,0l.54.31a.08.08,0,0,0,.08,0l.57-.32a0,0,0,0,0,0-.05l-.54-.31Zm-1,3.1.56-.32s0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.57.33s0,0,0,.05l.54.31A.08.08,0,0,0,207.83,172.67Zm-4.35-.2-.54-.31s-.06,0-.08,0l-.57.33a0,0,0,0,0,0,0l.54.31a.06.06,0,0,0,.08,0l.57-.32S203.5,172.48,203.48,172.47Zm1.08.27-.54-.31a.1.1,0,0,0-.09,0l-.86.5s0,0,0,0l.54.31a.11.11,0,0,0,.08,0l.87-.5S204.58,172.75,204.56,172.74Zm-1.89-.89-.53-.31h-.09l-.69.41s0,0,0,0l.54.31a.07.07,0,0,0,.09,0l.69-.4S202.7,171.87,202.67,171.85Zm.54-.3a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31a.11.11,0,0,0-.08,0l-.57.33a0,0,0,0,0,0,0Zm2.33,1.51-.54-.31s-.05,0-.08,0l-1.08.63s0,0,0,0l.54.32a.08.08,0,0,0,.08,0l1.09-.62S205.57,173.07,205.54,173.06Zm.38.67-.54-.31h-.08l-.69.4s0,0,0,.05l.54.31h.09l.69-.4S206,173.74,205.92,173.73Zm3.42-5.72a.08.08,0,0,0,.08,0l.57-.32s0,0,0-.05l-.54-.31h-.08l-.57.33a0,0,0,0,0,0,0Zm-1.65,1h.08l.57-.33a0,0,0,0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.57.33s0,0,0,.05ZM204,171.07a.11.11,0,0,0,.08,0l.57-.33s0,0,0-.05l-.54-.31h-.08l-.56.33s0,0,0,0Zm4.48-2.59a.14.14,0,0,0,.09,0l.56-.33s0,0,0,0l-.54-.32a.1.1,0,0,0-.09,0l-.56.32s0,0,0,0Zm-1.65,1a.08.08,0,0,0,.09,0l.56-.32s0,0,0-.05l-.54-.31a.1.1,0,0,0-.09,0l-.56.33s0,0,0,0Zm-.53,4.33a.08.08,0,0,0-.08,0l-.87.5s0,0,0,0l.54.32a.1.1,0,0,0,.09,0l.86-.5s0,0,0-.05Zm-.65-3.64a.08.08,0,0,0,.08,0l.57-.32s0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.56.33s0,0,0,.05Zm-.82.47s0,0,.08,0l.56-.33s0,0,0,0l-.54-.31a.06.06,0,0,0-.08,0l-.57.32s0,0,0,.05Zm16.75-5.65h-.08l-1.39.81s0,0,0,0l.54.32a.08.08,0,0,0,.08,0l1.39-.8s0,0,0-.05ZM219.78,166a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31h.09l.56-.33s0,0,0,0Zm-11.13,6.21.57-.33s0,0,0-.05l-.54-.31a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0l.54.31A.11.11,0,0,0,208.65,172.2Zm9.49-5.25a.1.1,0,0,0-.09,0l-.56.32s0,0,0,0l.54.31a.1.1,0,0,0,.09,0l.56-.32s0,0,0-.05Zm4.29-2.48a.06.06,0,0,0-.08,0l-.56.32s0,0,0,.05l.54.31s.06,0,.08,0l.57-.33a0,0,0,0,0,0,0Zm1.37-.17-1.31-.76a.1.1,0,0,0-.09,0l-.56.32s0,0,0,0l1.32.76a.08.08,0,0,0,.08,0l.56-.32S223.82,164.31,223.8,164.3Zm-8.75,4.43a.06.06,0,0,0-.08,0l-.69.4s0,0,0,.05l.54.31h.08l.7-.41a0,0,0,0,0,0,0Zm2.09-1.21a.08.08,0,0,0-.08,0l-.87.5s0,0,0,0l.54.32a.08.08,0,0,0,.08,0l.87-.5s0,0,0,0Zm-4,2.31a.11.11,0,0,0-.08,0l-4.64,2.68s0,0,0,.05l.54.31H209l4.65-2.68s0,0,0-.05Zm-4.9,2.83h-.08l-.7.4s0,0,0,.05l.54.31s.06,0,.08,0l.69-.4s0,0,0-.05Zm5.86-3.38s-.06,0-.08,0l-.7.4a0,0,0,0,0,0,0l.54.31a.11.11,0,0,0,.08,0l.69-.4s0,0,0,0Zm-6.82,3.93a.11.11,0,0,0-.08,0l-.69.4s0,0,0,0l.54.31a.06.06,0,0,0,.08,0l.7-.4s0,0,0,0Zm8.73-5a.08.08,0,0,0-.08,0l-.7.4s0,0,0,0l.54.31a.08.08,0,0,0,.08,0l.69-.4s0,0,0,0Zm3-1.7h-.08l-.57.33s0,0,0,0l.54.31a.08.08,0,0,0,.08,0l.57-.32a0,0,0,0,0,0-.05Zm1.85-1.29.56-.32s0,0,0-.05l-.54-.31s-.06,0-.09,0l-.56.32s0,0,0,.05l.54.31S220.78,165.19,220.81,165.18Zm-3.37.16L218,165s0,0,0-.05l-.54-.31h-.08l-.57.33a0,0,0,0,0,0,0l.54.32A.08.08,0,0,0,217.44,165.34Zm-2.19,3,1.65-.95s0,0,0-.05l-.54-.31a.14.14,0,0,0-.09,0l-1.65.95s0,0,0,.05l.54.31A.11.11,0,0,0,215.25,168.39Zm4.65-2.73H220l.57-.33s0,0,0-.05L220,165a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0Zm-.69-.45.57-.32s0,0,0,0l-.54-.31s-.06,0-.08,0l-.57.33a0,0,0,0,0,0,0l.54.31A.06.06,0,0,0,219.21,165.21Zm-4.78,3.65.56-.32s0,0,0,0l-.54-.31a.14.14,0,0,0-.09,0l-.56.33s0,0,0,.05l.53.31A.1.1,0,0,0,214.43,168.86Zm3.65-2.15h.08l.56-.33s0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.57.32s0,0,0,.05Zm-7.78,4.54.57-.33a0,0,0,0,0,0,0l-.54-.31h-.08l-.56.33s0,0,0,.05l.54.31Zm.83-.48.56-.33s0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0l-.57.32s0,0,0,.05l.54.31Zm-1.65.95.56-.32s0,0,0-.05l-.54-.31s-.06,0-.08,0l-.57.33a0,0,0,0,0,0,0l.54.31A.06.06,0,0,0,209.48,171.72Zm3.3-1.9.56-.33s0,0,0-.05l-.54-.31a.1.1,0,0,0-.09,0l-.56.32s0,0,0,0l.54.31A.11.11,0,0,0,212.78,169.82Zm-.83.47.57-.32s0,0,0-.05l-.54-.31a.11.11,0,0,0-.08,0l-.56.33s0,0,0,0l.54.32A.08.08,0,0,0,212,170.29Zm1.65-.95.57-.32s0,0,0-.05l-.54-.31s-.06,0-.08,0L213,169s0,0,0,.05l.54.31S213.58,169.35,213.6,169.34Zm4.5-6.62a.08.08,0,0,0,.08,0l.57-.32s0,0,0,0l-.14-.08h-.08l-.57.33a0,0,0,0,0,0,0Zm-4.1,2.59h.09l.56-.33s0,0,0,0l-.54-.31a.06.06,0,0,0-.08,0l-.56.32s0,0,0,.05Zm1.65-.95h.08l.57-.33s0,0,0-.05l-.54-.31a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05ZM213,165.89s.05,0,.08,0l.56-.32s0,0,0,0l-.54-.31s-.06,0-.08,0l-.57.32s0,0,0,.05Zm1.83-1a.08.08,0,0,0,.08,0l.56-.32s0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.57.33a0,0,0,0,0,0,0Zm-3.48,2a.08.08,0,0,0,.08,0l.56-.32s0,0,0-.05l-.54-.31h-.08l-.57.33a0,0,0,0,0,0,0Zm.82-.48h.08l.57-.33s0,0,0,0l-.54-.31a.08.08,0,0,0-.08,0l-.56.32s0,0,0,.05Zm4.28-2.7a.14.14,0,0,0,.09,0l.56-.33s0,0,0-.05l-.14-.08a.11.11,0,0,0-.08,0l-.57.33s0,0,0,.05Zm2.48-1.43H219l.56-.33s0,0,0,0l-.15-.09a.08.08,0,0,0-.08,0l-.56.32s0,0,0,0Zm1.13.66a.08.08,0,0,0,.08,0l.57-.32s0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.56.33s0,0,0,0Zm1.57,1.8.57-.32a0,0,0,0,0,0,0l-.54-.31a.11.11,0,0,0-.08,0l-.56.33s0,0,0,.05l.54.31A.08.08,0,0,0,221.63,164.7Zm-4.35-1.51s.06,0,.08,0l.56-.33s0,0,0,0l-.14-.09a.1.1,0,0,0-.09,0l-.56.32s0,0,0,.05Zm-6.76,4.13a.11.11,0,0,0,.08,0l.57-.33a0,0,0,0,0,0,0l-.54-.32a.08.08,0,0,0-.08,0L210,167s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.96 171.58 213.08 171.64 216.15 173.42 221.62 170.26 221.73 170.2 218.54 168.35 212.96 171.58",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.08 171.64 216.15 173.42 221.62 170.26 218.54 168.49 213.08 171.64",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--legs--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.68,178.62c0-.06,1-3.62,1-3.62s-.32.33-2.38-.21a11.85,11.85,0,0,1-2.24-.94l-.59,2.6c-.55,1-2.37.54-4.36.31-.33,0-.68-.09-1-.15h0c-1.08-.06-2.15.58-1,1.5s3,1.27,4.66,1.57C278.73,180.05,282.32,180.65,282.68,178.62Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.39,178.31a2,2,0,0,0-.15,1.09A5.25,5.25,0,0,0,271,182c1.73.82,3.87.88,4.88,1.17s1.92.86,3.1,1.15a4.11,4.11,0,0,0,3.54-.34,2.62,2.62,0,0,0,.39-1.19C282.71,182.56,268.39,178.31,268.39,178.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.15,176.8c-.76.52-2.34.16-4,0s-3.41-.74-4.51-.37-2,1.67-.53,3.32a6.44,6.44,0,0,0,2.06,1.57,35,35,0,0,0,4.66,1c1.54.37,2.38,1.05,3.8,1.22,1.84.21,3-.26,3.32-.75s.61-4.45-.18-4.37c0,0-.33,1.28-3.33,0C278.08,177.89,278.1,177.09,278.15,176.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.05,178.92s.17-1.67,1.41-2.11a.63.63,0,0,1,.68.09s-1.15.16-1.52,2.12c0,0-.06.13-.31.09C273.22,179.09,273,179.06,273.05,178.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.19,177s0-.06-.29-.11a.55.55,0,0,0-.34,0s-.92.4-1.09,2.15a.32.32,0,0,0,.28.27.25.25,0,0,0,.33-.17S275.27,177.36,276.19,177Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.18,177.06s-.05-.1-.27-.1-.33.11-.33.11a3.15,3.15,0,0,0-.67,2.13s0,.25.32.27.3-.25.3-.25S276.64,177.36,277.18,177.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.15,155.14c-1.15,4.85-4.69,19.38-4.69,19.38s2.59,2.33,5.41,1.27c3-7.93,8.39-13.35,8.35-19.16Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.15,155.14c-1.15,4.85-4.69,19.38-4.69,19.38s2.59,2.33,5.41,1.27c3-7.93,8.39-13.35,8.35-19.16Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.35,183.65c.31-.45,1.46-3.62,1.46-3.62a4.73,4.73,0,0,1-3.28.19,4.87,4.87,0,0,1-2-1.39l-.88,3c-.52,1-2.21.68-4.21.5-.34,0-.68-.08-1-.13h0c-1.07,0-2.14.64-1,1.53s3,1.19,4.7,1.45C268.1,185.55,271.2,185.36,272.35,183.65Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.86,183.56a2.25,2.25,0,0,0-.13,1.18,5.67,5.67,0,0,0,3,2.68c1.89.84,4.19.84,5.27,1.12s2.09.88,3.37,1.16a4.39,4.39,0,0,0,3.78-.46,2.77,2.77,0,0,0,.39-1.29C272.35,187.74,256.86,183.56,256.86,183.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.28,181.65a2.85,2.85,0,0,1-.37.23,1.22,1.22,0,0,1-.42.09,5.68,5.68,0,0,1-1,0c-.84,0-1.68-.17-2.52-.24-1.73-.16-3.69-.71-4.85-.28s-2.23,1.84-.6,3.57a7.88,7.88,0,0,0,2.19,1.65c1.93.81,3.93.66,5.21.94,1.66.37,2.58,1.08,4.11,1.22,2,.18,3.21-.36,3.54-.9.18-.3,0-1.85.23-3,.21-1,.16-1.75-.22-1.7a2,2,0,0,1-.29.37,1.34,1.34,0,0,1-.44.34,3.07,3.07,0,0,1-.74.25,4,4,0,0,1-1.38.19.61.61,0,0,1-.37-.12.77.77,0,0,1-.22-.46c0-.16-.07-.31-.1-.46a.62.62,0,0,0-.08-.24.63.63,0,0,0-.24-.19,2,2,0,0,1-.75-.57,1.78,1.78,0,0,1-.22-.71.22.22,0,0,0-.05-.12c-.06,0-.14,0-.2,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.89,184.09s.14-1.8,1.45-2.3a.71.71,0,0,1,.74.07s-1.23.21-1.58,2.33c0,0-.06.14-.33.1C262.08,184.27,261.88,184.24,261.89,184.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.21,182s0-.06-.31-.12a.63.63,0,0,0-.37,0s-1,.46-1.11,2.34c0,0,0,.22.31.28a.28.28,0,0,0,.35-.19S264.23,182.36,265.21,182Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.27,182s-.06-.11-.29-.11-.36.13-.36.13a3.41,3.41,0,0,0-.65,2.3s0,.27.34.29.31-.28.31-.28S265.7,182.32,266.27,182Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.36,159.76c-1.18,3.64-4.21,14-5.59,19.36a8.65,8.65,0,0,0,5.68,2c1.69-4,9.41-15,8.48-19.77-.6-3-3.85-2.11-3.85-2.11Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.36,159.76c-1.18,3.64-4.21,14-5.59,19.36a8.65,8.65,0,0,0,5.68,2c1.69-4,9.41-15,8.48-19.77-.6-3-3.85-2.11-3.85-2.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,165.76c-1.11-.78-3.6-2.33-3.89-3.12a6.52,6.52,0,0,0,3.48,4.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.78,196.49,318.49,169l-2.7-.13,4.64,27.65h0a.34.34,0,0,0,.18.24,1.05,1.05,0,0,0,1,.05.34.34,0,0,0,.21-.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.85,166.48h-2.7l-3.92,26h0a.33.33,0,0,0,.2.29,1,1,0,0,0,1,0,.37.37,0,0,0,.19-.23h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.15,166.48l-1.09,7.25a10.35,10.35,0,0,0,2.07,1.27l1.72-8.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,205.72l-2.53-28-2.7-.14,3.88,28.12h0a.36.36,0,0,0,.18.24,1.12,1.12,0,0,0,1,0,.35.35,0,0,0,.21-.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.59,181.83l-.37-4.09-2.7-.14.61,4.42A4.84,4.84,0,0,0,301.59,181.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.58,157.92h-2.7l-3.92,26h0a.32.32,0,0,0,.19.3,1.1,1.1,0,0,0,1,0,.4.4,0,0,0,.19-.23h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.49,165.94c-.38-2.12,1.36-3.79,4.62-6a77.38,77.38,0,0,1,9.45-5.31c2.73-1.25,5.52-1.13,9,.66,4.85,2.49,19.46,11.35,19.46,11.35S301.2,179,297,178.43s-14.71-7.38-15.54-9.79S280.49,165.94,280.49,165.94Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.49,165.94c-.38-2.12,1.36-3.79,4.62-6a77.38,77.38,0,0,1,9.45-5.31c2.73-1.25,5.52-1.13,9,.66,4.85,2.49,19.46,11.35,19.46,11.35S301.2,179,297,178.43s-14.71-7.38-15.54-9.79S280.49,165.94,280.49,165.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.11,175.84c-3.14,2.83-6.42.39-11.6-3-5.87-3.81-7-6.93-7-6.93a12.64,12.64,0,0,0,.44,3.43c.44,1.1,1.39,2.34,5.62,5.25s7.29,4.38,10.14,4.92l2.24-.31",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.51,172.87c-5.87-3.81-7-6.93-7-6.93a12.64,12.64,0,0,0,.44,3.43c.44,1.1,1.39,2.34,5.62,5.25s7.29,4.38,10.14,4.92l2.24-.31.18-3.39C296,178.67,292.69,176.23,287.51,172.87Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.84,154.69c-4.06-.4-15.62-3.3-18.45-3.79-5.39-.92-8.14-1.06-9.7-.57a5.79,5.79,0,0,0-3.36,4.08c-.56,2.2-.85,3.32-.85,3.32s11.86,4.17,17.86,4.87S314.84,154.69,314.84,154.69Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.84,154.69c-4.06-.4-15.62-3.3-18.45-3.79-5.39-.92-8.14-1.06-9.7-.57a5.79,5.79,0,0,0-3.36,4.08c-.56,2.2-.85,3.32-.85,3.32s11.86,4.17,17.86,4.87S314.84,154.69,314.84,154.69Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.84,154.69c.22,5.74,0,11.07-2.72,14-1.85,1.94-11.15,7-17.15,5s-18.15-11-19.38-12-2.35-1.53-2.23-1.92c1.65-5.48,4.06-5.91,8.54-4.93,5.47,1.21,17.48,6.11,17.48,6.11Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.84,154.69c.22,5.74,0,11.07-2.72,14-1.85,1.94-11.15,7-17.15,5s-18.15-11-19.38-12-2.35-1.53-2.23-1.92c1.65-5.48,4.06-5.91,8.54-4.93,5.47,1.21,17.48,6.11,17.48,6.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.42 124.37 293.66 130.91 300.8 128.72 298.61 121.23 291.42 124.37",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.87,115.62s-1.69,2.44-1.51,2.69,1.37.49,1.37.49Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.88,117.23a2,2,0,1,1,2-2A2,2,0,0,1,286.88,117.23Zm0-3.67a1.65,1.65,0,1,0,1.65,1.65A1.65,1.65,0,0,0,286.88,113.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.56,108.87c-3.32.62-4.31,2-4.74,7.29-.45,5.48.07,7.22.77,8,.48.51,3.18.66,4.55.32,1.72-.43,5.6-1.71,7.47-4.43,2.2-3.2,2.86-7.58.63-9.44C297.09,108,292.91,108.62,291.56,108.87Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,124.57a6.26,6.26,0,0,1-3.75-.33,4.81,4.81,0,0,0,2.4-.09c1.36-.38,1.62-.85,1.62-.85Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,111h0a7.53,7.53,0,0,0,3.17,1.08,6.43,6.43,0,0,0,.47,2.62c.19.58.88,2.43,1.63,1.42.55-.74,1-1.4,2.08-1.22,1.71.29,1.9,2.49.78,3.8s-2.11.77-2.11.77a6.81,6.81,0,0,0,1.09,4,5.6,5.6,0,0,0,4.47.29,11,11,0,0,0,4.9-4.24c2.41-4.46,2.42-8.74-.5-10-.27-2.14-1.93-3.13-3.83-3.62-2.64-.67-5.38,1-7.93-.11-.54-.23-1-.55-1.58-.75a1.09,1.09,0,0,0-1,0,1.11,1.11,0,0,0-.4.73,2,2,0,0,0,.1,1.52,4.81,4.81,0,0,0-1.2-.44,1.51,1.51,0,0,0-1.21.27,1.55,1.55,0,0,0-.49,1.06A3.25,3.25,0,0,0,286.2,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,110.23l2-1.12a1.15,1.15,0,0,0-2,1.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.45 116.29 285.04 115.09 285.09 114.78 291.51 115.98 291.45 116.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,125.19c4.06-2.21,7.14-.53,8.47,2.32a95.57,95.57,0,0,1,3.19,10C309.29,135.43,299.76,125.19,299.76,125.19Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,125.19c4.06-2.21,7.14-.53,8.47,2.32a95.57,95.57,0,0,1,3.19,10C309.29,135.43,299.76,125.19,299.76,125.19Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.08,126.26l-.32-1.07c4.58-2.18,8.38,1.36,10.85,7.56a61.82,61.82,0,0,1,4.3,23.31,21.11,21.11,0,0,1-8.29,6.14c-5.53,2.19-13.24,1.27-15.64-4.46,0,0,0-3.83-.18-7.13a33.33,33.33,0,0,0-2.52-10.12c-1.3-3-3-8.7.52-10.81,1-.61,2.66-1.28,4.07-2C296.11,128.79,300.5,127.54,300.08,126.26Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.08,126.26l-.32-1.07c4.58-2.18,8.38,1.36,10.85,7.56a61.82,61.82,0,0,1,4.3,23.31,21.11,21.11,0,0,1-8.29,6.14c-5.53,2.19-13.24,1.27-15.64-4.46,0,0,0-3.83-.18-7.13a33.33,33.33,0,0,0-2.52-10.12c-1.3-3-3-8.7.52-10.81,1-.61,2.66-1.28,4.07-2C296.11,128.79,300.5,127.54,300.08,126.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.1,129a13.68,13.68,0,0,1,1.82-3.2,10.35,10.35,0,0,0,4.91-.21c2.52-.78,2.62-1.5,2.62-1.5l-.18-.61s.19-.26.86.27a6.39,6.39,0,0,1,1.27,1.5c.25.35.07,2.07-1.78,3.27s-5.11.69-6.35.54a11.88,11.88,0,0,1-2.24-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.62,136.12c1.2,3-.4,8-.4,8a69.87,69.87,0,0,1,1.19,9.27c0,3.09,1.53,6.36,5.7,5.1s7.26-3.78,10.66-8.46,3.09-8.29,2.52-12.51a63.9,63.9,0,0,1,2.62,18.52,21.11,21.11,0,0,1-8.29,6.14c-5.53,2.19-13.24,1.27-15.64-4.46,0,0,0-3.83-.18-7.13a33.33,33.33,0,0,0-2.52-10.12c-.13-.3-.26-.63-.39-1C289.55,137.1,291.88,134.27,292.62,136.12Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.05,135.77c1.19,3,.17,8.37.17,8.37a69.87,69.87,0,0,1,1.19,9.27c0,3.09,1.53,6.36,5.7,5.1s7.26-3.78,10.66-8.46,3.09-8.29,2.52-12.51a63.9,63.9,0,0,1,2.62,18.52,21.11,21.11,0,0,1-8.29,6.14c-5.53,2.19-13.24,1.27-15.64-4.46,0,0,0-3.83-.18-7.13a33.33,33.33,0,0,0-2.52-10.12c-.13-.3-.26-.63-.39-1C289.55,137.1,291.3,133.92,292.05,135.77Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.56,158.36a5.5,5.5,0,0,1-3.05-3.94,8.28,8.28,0,0,1,1.05-4.57C282.24,148.68,283.56,158.36,283.56,158.36Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.56,158.36a5.5,5.5,0,0,1-3.05-3.94,8.28,8.28,0,0,1,1.05-4.57C282.24,148.68,283.56,158.36,283.56,158.36Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.52,150.05c.51-3.1,1.33-7.89,2.36-12.94s2.36-6.36,4.92-7.43c6.22,3.7,2.76,12.85,2.76,12.85s-2.05,9.52-3.33,12.61c-.83,2-2.93,4.26-5.12,3S281,153.15,281.52,150.05Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.52,150.05c.51-3.1,1.33-7.89,2.36-12.94s2.36-6.36,4.92-7.43c6.22,3.7,2.76,12.85,2.76,12.85s-2.05,9.52-3.33,12.61c-.83,2-2.93,4.26-5.12,3S281,153.15,281.52,150.05Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.93,179.23c1.79-.09,3.18-1.4,7.43-3.17,7.84-3.26,13.71-5.87,15.95-10s3.83-22.51,3.27-27.64a6.91,6.91,0,0,0-.38-1.71l.55-.08-1.43-1.21h0c-1.47-1.19-3.85-.13-5.65.85-5.13,2.79-9.14,5.5-12.31,15.3-2.39,7.37-4,20.65-7.25,24.25",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2,136.73l.55-.08-1.43-1.21h0c-1.47-1.19-3.85-.13-5.65.85-5.13,2.79-9.14,5.5-12.31,15.3-2.39,7.37-4,20.65-7.25,24.25l-.18,3.39c1.79-.09,3.18-1.4,7.43-3.17,7.84-3.26,13.71-5.87,15.95-10s3.83-22.51,3.27-27.64A6.91,6.91,0,0,0,325.2,136.73Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,137c-5.13,2.79-9.95,5.84-12.67,15.89s-4.42,25-10.67,26.7c0,0,2.82,1.13,11.49-2.54a90.13,90.13,0,0,0,8.29-4.52c4.31-2.42,6.92-4.4,7.33-5.14,2.28-4.08,3.83-22.51,3.27-27.64S322.6,135.55,320,137Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320,137c-5.13,2.79-9.95,5.84-12.67,15.89s-4.42,25-10.67,26.7c0,0,2.82,1.13,11.49-2.54a90.13,90.13,0,0,0,8.29-4.52c4.31-2.42,6.92-4.4,7.33-5.14,2.28-4.08,3.83-22.51,3.27-27.64S322.6,135.55,320,137Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--legs--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.23,206.68c-.44,1.18-2.5,1-4.72,1-1.79.05-3.86-.27-5,.31s-1.37,2,.51,3.55c2.35,2,5.46,1.74,7.2,1.91s2.77.78,4.35.74c2-.06,3.25-.77,3.52-1.35s0-5-.89-4.76c0,0,.08-.14-2.92-.24C234.19,207.81,234.23,206.68,234.23,206.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.2,208.38c0-.07.5-4.12.5-4.12s-.08-.35-2.52-.43c-1.2,0-2.59-1-2.72-.1s-.23,3-.23,3c-.44,1.18-2.5,1-4.72,1-.37,0-.76,0-1.14,0h0c-1.18.11-2.26,1-.89,1.82s3.44.91,5.35,1C235.1,210.58,239.12,210.66,239.2,208.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.63,180.75c-.18,4.42.42,25.28.42,25.28s2.11,1,5.53-.17l2.29-22.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.64,211.87c-.4,1.19-3.59,1.71-5.8,1.86-1.79.12-3.87-.14-5,.48s-1.3,2,.63,3.53c2.42,1.88,6.63.89,8.38,1s2.75.47,4.15.46c2,0,2.75-.76,3-1.36s.49-4.95-.36-4.71c0,0,.08-.14-2.92-.14C223.64,213,223.64,211.87,223.64,211.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.66,213.4c0-.07,1.62-6.47,1.62-6.47a4.89,4.89,0,0,1-3.79,2c-1.19,0-2.62-.95-2.72,0s-.09,1.82-.22,2.7-2.76,1.71-5.18,2c-.37,0-1.29.15-1.68.15h0c-1.34.12-2.68,1.18-1.28,2s5,0,7,0C224.64,215.73,228.66,215.68,228.66,213.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.77,188.76c-.51,4.58-1,17.57-1.13,21.2a10,10,0,0,0,5.91.37s4-13,3.7-17.93C233.11,190.07,224.77,188.76,224.77,188.76Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.48,225.8l-3.29-27.52-2.7-.14,4.64,27.65h0a.34.34,0,0,0,.18.24,1.05,1.05,0,0,0,1,.05.32.32,0,0,0,.21-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.55,195.78h-2.69l-3.93,26h0a.33.33,0,0,0,.2.29,1,1,0,0,0,1,0,.32.32,0,0,0,.19-.23h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.86,195.78l-1.1,7.25a10.35,10.35,0,0,0,2.07,1.27l1.72-8.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.46,235l-2.54-28-2.7-.14L253.1,235h0a.36.36,0,0,0,.18.24,1.08,1.08,0,0,0,1,.05c.15-.08.22-.18.21-.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.29,211.13l-.37-4.09-2.7-.14.61,4.43A5,5,0,0,0,252.29,211.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,187.22h-2.7l-3.92,26h0a.31.31,0,0,0,.2.3,1.08,1.08,0,0,0,1,0,.37.37,0,0,0,.19-.23h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,195.25c-.37-2.13,1.36-3.79,4.62-6a77.38,77.38,0,0,1,9.45-5.31c2.73-1.25,5.52-1.13,9,.66,4.85,2.5,19.46,11.35,19.46,11.35s-21.84,12.33-26,11.78-14.71-7.38-15.54-9.79S231.19,195.25,231.19,195.25Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.19,195.25c-.37-2.13,1.36-3.79,4.62-6a77.38,77.38,0,0,1,9.45-5.31c2.73-1.25,5.52-1.13,9,.66,4.85,2.5,19.46,11.35,19.46,11.35s-21.84,12.33-26,11.78-14.71-7.38-15.54-9.79S231.19,195.25,231.19,195.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.81,205.14c-3.14,2.84-6.41.39-11.6-3-5.87-3.81-7-6.92-7-6.92a12.58,12.58,0,0,0,.44,3.42c.44,1.1,1.39,2.34,5.62,5.26s7.29,4.37,10.14,4.91l2.24-.31",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.21,202.17c-5.87-3.81-7-6.92-7-6.92a12.58,12.58,0,0,0,.44,3.42c.44,1.1,1.39,2.34,5.62,5.26s7.29,4.37,10.14,4.91l2.24-.31.18-3.39C246.67,208,243.4,205.53,238.21,202.17Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.06,186.31s-18.33-5.54-21.52-6.41-9.3-2.34-11.09-1.54-2.69,1.73-2.86,4.31c0,.48,0,2.84,0,2.84s8.87,2.74,16.13,2.74S267.06,186.31,267.06,186.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.13,184c1.15,3.93,1.51,7.76-1.24,10.6-2,2.06-5.61,8.23-16.57,7.76-5-.21-18.85-9.9-18.85-9.9s-5.24-.83-5.27-2.67c0-.45-.52-.56-.43-1,.76-4,3.28-6,6.81-5.7,5.86.47,19,4.16,19,4.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.91 152.34 254.73 160.42 261.01 159.45 259.29 150.52 252.91 152.34",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,154.76c2.92-.1,4.94,1.28,6.51,5.24s6.4,13.53,6.52,16.25-8.82,11.53-8.5,11.38c.1,0-2.85-5.14-2.85-5.14l4.44-6.64-2.63-7.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.93,182.72a45.94,45.94,0,0,0-3.42-6.74c2-8.63,2.84-12.11,2.16-16.16-.45-2.64-2.25-5.5-4.9-5-.69.12-1,.11-1.61.24.36,1.35-4.3,2.44-6.42,1.07-1,.23-3.82.63-3.82.63-1.23.46-5.58,7.08-6.31,11.13s3,6.76,3,6.76c-.19,3.51-.06,7.23,0,13.59,0,0,2.27,4.36,12.37,3.22,9-1,10.14-4.84,10.14-4.84A30.87,30.87,0,0,0,267.93,182.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.57,168.53a4.4,4.4,0,0,1,.73-.05,5.6,5.6,0,0,1,1.22.17c.47.11.87.2,1.36.33l-.4-.4a2.44,2.44,0,0,1-.39-.52,1.09,1.09,0,0,1-.08-.62c0-.18.16-.48.39-.46a.43.43,0,0,1,.27.19,11.66,11.66,0,0,0,1.39.76c.35.24.73.42,1.06.67a4.45,4.45,0,0,1,1,1.19,10.87,10.87,0,0,0,1.1,1.43c.85.88,11,3.77,11.15,3.82,0,0,3-6.41,4.93-11.41,2.19-5.62,3.8-6.47,7.56-6.78,3.11,3.42-.61,11.5-.61,11.5s-2.57,5.4-4.72,10.1c-1.07,2.34-2.14,3.78-3.16,4.14s-2.77-.2-3.82-.53a17.88,17.88,0,0,1-2.67-1.23c-1.26-.63-2.52-1.28-3.77-1.94s-2.41-1.38-3.6-2.07a8.58,8.58,0,0,0-2-.93c-.57-.17-1.16-.21-1.73-.39a6.13,6.13,0,0,1-2.73-1.91,2.4,2.4,0,0,0-.74-.64,4.12,4.12,0,0,0-1.16-.17,12.67,12.67,0,0,1-2.31-.26.8.8,0,0,1-.42-.21.34.34,0,0,1-.08-.43,5,5,0,0,1-1.16-.17c-.25-.08-.82-.28-.84-.59s.16-.29.32-.34a.75.75,0,0,0,.45-.23,1.59,1.59,0,0,1-.37-.36.47.47,0,0,1,0-.5.73.73,0,0,1,.29-.19,7.27,7.27,0,0,1,1.33-.54l1.54-.34.37-.07C218.36,168.53,218.46,168.55,218.57,168.53Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.06,144.81s-1.5,2.6-1.28,2.82a4.53,4.53,0,0,0,1.42.34Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.86,137.28c-1.36.89-3.7,2.51-3.81,7.86s.78,7.32,1.59,8c.55.43,4.14.37,5.13,0a14.06,14.06,0,0,0,6.34-6.1c1.68-3.49,1.66-7.93-.83-9.42A8.72,8.72,0,0,0,250.86,137.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.31,153.05a5,5,0,0,1-2.15-1,7.3,7.3,0,0,1-1.83-3.56s1,.64,2.18-.61,1.14-3.52-.59-3.91c-1.23-.29-2,.69-2.46,1.68-.07.16-.16.34-.33.38s-.47-.21-.58-.45a2.21,2.21,0,0,0-.45-.81,2.27,2.27,0,0,1-.76-1.38,5.26,5.26,0,0,1,0-1.37,4.54,4.54,0,0,0-1.16,1.83,2.87,2.87,0,0,1-.09-2.57,5.08,5.08,0,0,0-1.07,2.36,2.55,2.55,0,0,1-.89-1.59,5.58,5.58,0,0,1,1.34-4.62,9.72,9.72,0,0,1,4.12-2.7,13,13,0,0,1,4.72-.76,8.26,8.26,0,0,1,5.88,2.22,4.79,4.79,0,0,1,1,2.28c2.1.94,2.26,3.5,1.89,5.48a11.79,11.79,0,0,1-2.45,4.7c-.55.72-1.12,1.42-1.64,2.17a9,9,0,0,0-.71,1.1c-.3.61-.51,1.12-.51,1.12A10.47,10.47,0,0,1,256.31,153.05Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.31,153.05a5,5,0,0,1-2.15-1,7.3,7.3,0,0,1-1.83-3.56s1,.64,2.18-.61,1.14-3.52-.59-3.91c-1.23-.29-2,.69-2.46,1.68-.07.16-.16.34-.33.38s-.47-.21-.58-.45a2.21,2.21,0,0,0-.45-.81,2.27,2.27,0,0,1-.76-1.38,5.26,5.26,0,0,1,0-1.37,4.54,4.54,0,0,0-1.16,1.83,2.87,2.87,0,0,1-.09-2.57,5.08,5.08,0,0,0-1.07,2.36,2.55,2.55,0,0,1-.89-1.59,5.58,5.58,0,0,1,1.34-4.62,9.72,9.72,0,0,1,4.12-2.7,13,13,0,0,1,4.72-.76,8.26,8.26,0,0,1,5.88,2.22,4.79,4.79,0,0,1,1,2.28c2.1.94,2.26,3.5,1.89,5.48a11.79,11.79,0,0,1-2.45,4.7c-.55.72-1.12,1.42-1.64,2.17a9,9,0,0,0-.71,1.1c-.3.61-.51,1.12-.51,1.12A10.47,10.47,0,0,1,256.31,153.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.63,208.53c1.79-.09,3.19-1.4,7.43-3.16,7.84-3.27,13.72-5.88,16-10s3.82-22.51,3.26-27.64a6.93,6.93,0,0,0-.38-1.7l.55-.08L275,164.74h0c-1.46-1.19-3.85-.13-5.64.85-5.13,2.79-9.15,5.51-12.32,15.3-2.39,7.37-4,20.65-7.25,24.25",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.9,166l.55-.08L275,164.74h0c-1.46-1.19-3.85-.13-5.64.85-5.13,2.79-9.15,5.51-12.32,15.3-2.39,7.37-4,20.65-7.25,24.25l-.18,3.39c1.79-.09,3.19-1.4,7.43-3.16,7.84-3.27,13.72-5.88,16-10s3.82-22.51,3.26-27.64A6.93,6.93,0,0,0,275.9,166Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.74,166.25c-5.14,2.79-10,5.85-12.67,15.89s-4.43,25-10.68,26.7c0,0,2.83,1.13,11.49-2.54a90.13,90.13,0,0,0,8.29-4.52c4.31-2.42,6.92-4.4,7.33-5.14,2.28-4.08,3.83-22.51,3.27-27.64S273.31,164.85,270.74,166.25Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.74,166.25c-5.14,2.79-10,5.85-12.67,15.89s-4.43,25-10.68,26.7c0,0,2.83,1.13,11.49-2.54a90.13,90.13,0,0,0,8.29-4.52c4.31-2.42,6.92-4.4,7.33-5.14,2.28-4.08,3.83-22.51,3.27-27.64S273.31,164.85,270.74,166.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.53,168.81a3.3,3.3,0,0,1-1.52-1.14.88.88,0,0,0,.08.39,2.44,2.44,0,0,0,.39.52l.4.4a5.4,5.4,0,0,1,1.52.5A1.41,1.41,0,0,0,222.53,168.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92,156.71c-1.22.14-3.43.09-5,1.86s-2.21,3.75-3.94,7.64-3.72,8.65-3.72,8.65l-6.91-2L228,177.14a64,64,0,0,0,6.8,3.88c3.25,1.53,5.19,2.1,6.32,1.77s1.8-1.12,3-3.38,6.47-13.52,6.47-13.52S252.46,160.31,249.92,156.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.12,153.25l-.18-.84a8.12,8.12,0,0,1-2.42.56,4.72,4.72,0,0,1-2.12-.1,1.7,1.7,0,0,0,.24.23C249.1,153.46,251.71,153.47,253.12,153.25Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.71,140.69a9.14,9.14,0,0,1,1.08,4.56c.13,3.79-.34,7.59.07,11.36a2.71,2.71,0,0,0,.31,1.16,3.06,3.06,0,0,0,1.43,1,6.25,6.25,0,0,1-4.46.68,4.59,4.59,0,0,1-2.28-1.2,5,5,0,0,1-1.24-2.66,14.74,14.74,0,0,1-.08-3,44.28,44.28,0,0,0-.26-8.77,4.18,4.18,0,0,0-.59-1.77,3.07,3.07,0,0,1-.7-2.65c.25-.8,1.39-1.13,2.15-1.15A5.28,5.28,0,0,1,268.71,140.69Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.71,140.69a9.14,9.14,0,0,1,1.08,4.56c.13,3.79-.34,7.59.07,11.36a2.71,2.71,0,0,0,.31,1.16,3.06,3.06,0,0,0,1.43,1,6.25,6.25,0,0,1-4.46.68,4.59,4.59,0,0,1-2.28-1.2,5,5,0,0,1-1.24-2.66,14.74,14.74,0,0,1-.08-3,44.28,44.28,0,0,0-.26-8.77,4.18,4.18,0,0,0-.59-1.77,3.07,3.07,0,0,1-.7-2.65c.25-.8,1.39-1.13,2.15-1.15A5.28,5.28,0,0,1,268.71,140.69Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.59,153.64c0-3.19.31-9.06-.89-11.12-.85-1.43-1.46-1.18-1.78-2.58a3.29,3.29,0,0,0,.77,2.28,4.22,4.22,0,0,1,.59,1.77,44.4,44.4,0,0,1,.26,8.78,14.74,14.74,0,0,0,.08,3,5,5,0,0,0,1.24,2.66,4.67,4.67,0,0,0,2.28,1.2l.19,0C265.22,158.92,264.56,156.82,264.59,153.64Z",
    style: {
      opacity: 0.15
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--office-2--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Office--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--block--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.69,304.68a2.47,2.47,0,0,1,1.46-2l108.9-63a7.77,7.77,0,0,1,7,0l114.25,66a2.48,2.48,0,0,1,1.46,2v57a2.48,2.48,0,0,1-1.46,2l-108.9,63a7.77,7.77,0,0,1-7,0l-114.25-66a2.47,2.47,0,0,1-1.46-2Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,238.79a7.17,7.17,0,0,1,3.51.84l114.25,66a2.48,2.48,0,0,1,1.46,2v57a2.48,2.48,0,0,1-1.46,2l-108.9,63a7.17,7.17,0,0,1-3.51.84V370.78Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,238.79a7.17,7.17,0,0,0-3.51.84l-108.9,63a2.47,2.47,0,0,0-1.46,2v57a2.47,2.47,0,0,0,1.46,2l114.26,66a7.13,7.13,0,0,0,3.5.84V370.78Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.4,372.68l-114.25-66c-1.94-1.12-1.94-2.94,0-4.06l108.9-63a7.77,7.77,0,0,1,7,0l114.25,66c1.95,1.12,1.95,2.94,0,4.06l-108.9,63A7.77,7.77,0,0,1,355.4,372.68Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.4,372.68l-114.25-66c-1.94-1.12-1.94-2.94,0-4.06l108.9-63a7.77,7.77,0,0,1,7,0l114.25,66c1.95,1.12,1.95,2.94,0,4.06l-108.9,63A7.77,7.77,0,0,1,355.4,372.68Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M399.84,343.77,380,332.42l-26.27,15.16a4.79,4.79,0,0,1-4.33,0l-56.6-32.67a1.32,1.32,0,0,1,0-2.5l10-5.79-18.15-10.48a1.32,1.32,0,0,1,0-2.5l28.17-16.26a4.79,4.79,0,0,1,4.33,0l18.14,10.48L369.69,268a4.79,4.79,0,0,1,4.33,0l56.6,32.68a1.32,1.32,0,0,1,0,2.5l-18.15,10.48L432.33,325a1.32,1.32,0,0,1,0,2.5l-28.16,16.26A4.79,4.79,0,0,1,399.84,343.77Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-26",
    points: "451.72 316.29 434.55 306.4 450.8 297.02 467.97 306.9 451.72 316.29",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--office-workers--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.22,299.74,332,273.1l-2.61-.13,4.49,26.77h0a.36.36,0,0,0,.17.23,1.05,1.05,0,0,0,.93,0,.32.32,0,0,0,.21-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,273.1l-2.61-.13.77,5a10.88,10.88,0,0,0,1.54-.71,1.64,1.64,0,0,0,.69-.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,269.19h-2.62l-3.8,25.16h0a.31.31,0,0,0,.19.29,1,1,0,0,0,.93,0,.34.34,0,0,0,.18-.23h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.74,269.19l-1.06,7a10.5,10.5,0,0,0,2,1.23l1.67-8.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.76,308.67l-2.45-27.09-2.61-.13,3.75,27.22h0a.35.35,0,0,0,.18.23,1,1,0,0,0,.93.05.3.3,0,0,0,.2-.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.63,285.48l-.32-3.9-2.61-.13.53,4.21A4.82,4.82,0,0,0,315.63,285.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.61,260.9H309l-3.8,25.16h0a.35.35,0,0,0,.19.29,1,1,0,0,0,.94,0,.42.42,0,0,0,.18-.23h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.89,238.72a14.6,14.6,0,0,0-1.05,4.59c-.29,3.52.84,16.51,1.56,21.6h0c1,8.51,2.3,8.52,4.14,9.95,3.17,2.45,12.29,7.25,15.3,8.43,5.46,2.15,9.92-1.16,13.25-2.8a78.45,78.45,0,0,0,8.81-5.22,2.43,2.43,0,0,0,1.25-1.86c0-.26,0-1.3,0-1.57,0-.82-.73-1.71-2.26-2.69-2.82-1.83-13-7.78-16.95-10a.07.07,0,0,0,0,0c-3-1.84-4.82-16-6.92-22.65-.05-.15-.09-.28-.14-.42s-.07-.21-.11-.31c-.13-.36-.27-.69-.41-1",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.16,271.84c0-.82-.73-1.71-2.26-2.69-2.82-1.83-13-7.78-16.95-10a.07.07,0,0,0,0,0c-3-1.84-4.82-16-6.92-22.65a12.36,12.36,0,0,0-.44-1.23l0-.09-.12-.27-.06-.14h0a6.34,6.34,0,0,0-1.41-2,2.72,2.72,0,0,0-.69-.49l-1.23-.69c-2.07-1.24-4.77.24-8.15,2.09a10.24,10.24,0,0,0-5,5.06h0a14.6,14.6,0,0,0-1.05,4.59c-.29,3.52.84,16.51,1.56,21.6h0c1,8.51,2.3,8.52,4.14,9.95,3.17,2.45,12.29,7.25,15.3,8.43,5.46,2.15,9.92-1.16,13.25-2.8a78.45,78.45,0,0,0,8.81-5.22,2.43,2.43,0,0,0,1.25-1.86C333.15,273.15,333.16,272.11,333.16,271.84Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.16,271.84c0-.82-.73-1.71-2.26-2.69-2.82-1.83-13-7.78-16.95-10a.07.07,0,0,0,0,0c-3-1.84-4.82-16-6.92-22.65a12.36,12.36,0,0,0-.44-1.23l0-.09-.12-.27-.06-.14h0a6.34,6.34,0,0,0-1.41-2,2.72,2.72,0,0,0-.69-.49l-1.23-.69c-2.07-1.24-4.77.24-8.15,2.09a10.24,10.24,0,0,0-5,5.06h0a14.6,14.6,0,0,0-1.05,4.59c-.29,3.52.84,16.51,1.56,21.6h0c1,8.51,2.3,8.52,4.14,9.95,3.17,2.45,12.29,7.25,15.3,8.43,5.46,2.15,9.92-1.16,13.25-2.8a78.45,78.45,0,0,0,8.81-5.22,2.43,2.43,0,0,0,1.25-1.86C333.15,273.15,333.16,272.11,333.16,271.84Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.09,278.9a77,77,0,0,0,8.81-5.22c1.89-1.37,1.72-2.78-1-4.53C327.14,266.7,311.78,258,311.78,258s-19.41,11.46-18.58,13.57,12.86,8.66,16.64,10.15C315.3,283.86,319.76,280.55,323.09,278.9Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.09,278.9a77,77,0,0,0,8.81-5.22c1.89-1.37,1.72-2.78-1-4.53C327.14,266.7,311.78,258,311.78,258s-19.41,11.46-18.58,13.57,12.86,8.66,16.64,10.15C315.3,283.86,319.76,280.55,323.09,278.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.24,232.26c-2-1.07-4.69.39-8,2.19a10.2,10.2,0,0,0-5,5.08l-1.38-.81a10.24,10.24,0,0,1,5-5.06c3.38-1.85,6.08-3.33,8.15-2.09Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.24,232.26c-2-1.07-4.69.39-8,2.19a10.2,10.2,0,0,0-5,5.08l-1.38-.81a10.24,10.24,0,0,1,5-5.06c3.38-1.85,6.08-3.33,8.15-2.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,236.5a9.26,9.26,0,0,0-2.07-3.75,3.28,3.28,0,0,0-2.23-.85c-1.79,0-3.93,1.17-6.44,2.55l-.62.35-.23.14-.28.18-.21.13a11.64,11.64,0,0,0-1.26,1l-.19.17a8.56,8.56,0,0,0-.72.75l-.12.14-.14.18-.14.18c0,.06-.09.12-.13.19a7.18,7.18,0,0,0-.5.8.6.6,0,0,0-.06.11l-.12.22-.16.34a14.34,14.34,0,0,0-1.14,4.81c-.49,5.78,1.44,26.48,3.42,28.12,0,0-.3-1.87,3.69-4.38a77.78,77.78,0,0,1,7.53-4.57,96.74,96.74,0,0,1,9-4.12C310.88,257.31,309.1,243.17,307,236.5Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,236.5a9.26,9.26,0,0,0-2.07-3.75,3.28,3.28,0,0,0-2.23-.85c-1.79,0-3.93,1.17-6.44,2.55l-.62.35-.23.14-.28.18-.21.13a11.64,11.64,0,0,0-1.26,1l-.19.17a8.56,8.56,0,0,0-.72.75l-.12.14-.14.18-.14.18c0,.06-.09.12-.13.19a7.18,7.18,0,0,0-.5.8.6.6,0,0,0-.06.11l-.12.22-.16.34a14.34,14.34,0,0,0-1.14,4.81c-.49,5.78,1.44,26.48,3.42,28.12,0,0-.3-1.87,3.69-4.38a77.78,77.78,0,0,1,7.53-4.57,96.74,96.74,0,0,1,9-4.12C310.88,257.31,309.1,243.17,307,236.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.16,285.71a3.86,3.86,0,0,0-3.55,1.67,5.35,5.35,0,0,0,.61,3.49,11.09,11.09,0,0,1,.79,5c-.14,1.45-.84,5.05.61,6.86s4.68,3.41,5.84.93c.38-.81-.37-3.62-.7-5.67-.66-4.09-1.17-8.16-1.17-8.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.58,289a39,39,0,0,1,.44,6,7.14,7.14,0,0,0,1.17,4.62c.84,1.08,2.92,1.69,2.68-.57-.17-1.57-1.28-9.21-1.28-9.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.22,286.66a17,17,0,0,0,2.45,7.95c1.78,2.95,4.4,6.42,4.89,8.52a25.52,25.52,0,0,0-.64-4.31l0-.1a2.56,2.56,0,0,1,0-.27l0-.13c0-.11,0-.23-.05-.34v0c-.2-1.28-.4-2.56-.56-3.71-.13-.92-.25-1.76-.34-2.45-.05-.35-.09-.66-.13-.93l-.05-.37c-.05-.44-.09-.7-.09-.7l-2.43-4.09-.35,0A4.08,4.08,0,0,0,318.22,286.66Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8,263.51a59.41,59.41,0,0,0-13.09-5.38l-6.13,4.79,6.21,5.56,7.92,5.35s1.51-.11.58,2.24c-.29.75-.74,2.25-1.21,3.95l3.68,10.12s2-3.52,4.85-9.92c2.67-5.94,3.32-9.88,3.05-11.2C334.31,267.3,333.57,266.33,328.8,263.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.91,265.63l-.77-.53a6.1,6.1,0,0,0,2.72-3.56,6.31,6.31,0,0,1-1.45,3.79c.54.32,8.35,4.9,9.81,6.56s2.43,2.23,2.61,6.17c.15,3.33.6,9.14.6,9.14l-10.57-13.11-4.55-7.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,303.11c-.45,0-.48.73-.75,1.69a4.92,4.92,0,0,0-.14,2.89c.36,1.22,2.29,1.47,3.23,3.09s2.3,4.53,5.71,5.5,6.12,0,6.84-1,.21-2-1.92-3.42L335.18,310Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.72,297.37a51.29,51.29,0,0,0,1.72,6,24.5,24.5,0,0,0,4,6.31c.36.43,1.18,1.25,1.48,1.6a.66.66,0,0,1-.1,1c-.77.71-4,.81-5.73-.58s-3.32-4.28-4.36-5.38a16.81,16.81,0,0,1-1.11-1.29,2.22,2.22,0,0,1-.52-1.44,6.41,6.41,0,0,0-.09-2.07,20.89,20.89,0,0,0-.78-2.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.09,255c-2.45,4.09-2.69,9.21-1.74,11.77,1.3,3.48,2.74,5.05,7.54,8,4,2.44,9.48,3.92,10.67,4.48s1.59,1.88,2.14,4.24a40.73,40.73,0,0,0,3.63,10.63c2.57,5,3.27,6.51,3.27,6.51a5.75,5.75,0,0,0,5.76-1.07S327,278.44,326,275.42,312.58,264,312.58,264s1.66-4.93,2.64-8.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.92,244.2s-4.35-10.39-5.84-11.79c-1.74-1.63-3.83-1-6-.46,0,0,.21,2.5.6,4.47,0,0,5.84,11.32,6.44,12.36",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.83,231a12.12,12.12,0,0,1,3.39.24c1.56.36,2.26,1.34,3.11,2.92s3,6.55,3,6.55-3.07,3.29-6.76,3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.17 255.61 335.17 255.61 335.16 255.6 335.17 255.61",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-26",
    d: "M305,231.62a50.17,50.17,0,0,0-8.49,2.64s.33,10,1.46,15c1.09,4.85-1.88,8.67-1.46,14.64,9.65,3.15,21.23-1.39,21-5.44,0,0-2-5.31-2.17-7.77,0,0-.2-3.26-.11-4.71,5.88-5.52-2.29-12.58-4.41-15A43.08,43.08,0,0,0,305,231.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.29,217.29a3,3,0,0,0-.06,2.13,4.36,4.36,0,0,1,.3,1.73,3.51,3.51,0,0,1-1.29,1.85,4.34,4.34,0,0,1-.49.35c-.15.08-.32.11-.47.2a2.13,2.13,0,0,0-.76.76,5.92,5.92,0,0,0-.55,1.47,4.84,4.84,0,0,1-.58,1.45,3,3,0,0,1-2.67,1.27,3.79,3.79,0,0,1-2.29-1,1.66,1.66,0,0,1-.46-.6,2.92,2.92,0,0,0,.48,2,3.41,3.41,0,0,1-4-3.83c.09-.66.37-1.28.52-1.94.39-1.75-1.18-2.71-1.44-4.31a2.48,2.48,0,0,1,1.26-2.53c.54-.28,1.25-.43,1.48-1s0-.92,0-1.39a2.27,2.27,0,0,1,1.75-1.9c.88-.28,1.83-.28,2.71-.54a26.47,26.47,0,0,1,2.77-1,3.57,3.57,0,0,1,3.15,1.07c.36.39.56.84.88,1.24s.82.61,1.06,1.08a2.18,2.18,0,0,1,.06,2C305.31,216.35,304.63,216.69,304.29,217.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,219.37c-.11-3.07-1.89-7.45-8.49-6.89a8.21,8.21,0,0,0-7.73,9.4c.82,4.3,3.95,4.58,4.76,7.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.64,221.72a1.53,1.53,0,0,1,1.61-.53,1.48,1.48,0,0,1,.8.52c.3.33.29.77.5,1.15a.84.84,0,0,0,.63.45c.88.08.56-1.35.6-1.87,1.67-.59,1.63-1.21,1.86-2.68a3.74,3.74,0,0,1,5-.25c1.08-2.07,2.24-1.81,2.74-1.16a8.25,8.25,0,0,1,.76,2.4,16.07,16.07,0,0,1,.28,3.79c-.22,4.93-1.85,6.12-2.66,6.45s-1.79.09-3.29-.19v3a25.06,25.06,0,0,1,2.72,10.35c-2.38-4.51-6.11-6.93-7.87-8.56a6.58,6.58,0,0,1-1.07-1.24v-7.8s-.65.7-1.68-.12C298.15,224.3,297.73,222.75,298.64,221.72Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,229.8a10.27,10.27,0,0,1-3.63-1.56,4.53,4.53,0,0,1-1.4-2,4.71,4.71,0,0,0,1.07,2.76,16.25,16.25,0,0,0,4,1.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.83,222.88a.59.59,0,0,1-.5.67.6.6,0,0,1-.16-1.19A.6.6,0,0,1,307.83,222.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,222.34a.54.54,0,0,1-.45.62.52.52,0,0,1-.6-.48.53.53,0,1,1,1.05-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.06 221.47 309.55 225.58 311.66 224.78 309.06 221.47",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,221l-1.28,1.11a.89.89,0,0,1,.09-1.23A.84.84,0,0,1,307,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.76,226.1l2.22.75a1.23,1.23,0,0,1-1.53.75A1.15,1.15,0,0,1,306.76,226.1Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.82,226.61a1.17,1.17,0,0,1,1.09,1,1.22,1.22,0,0,1-.46-.06,1.15,1.15,0,0,1-.75-1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.65,221l-1.69-.23a.81.81,0,0,1,.93-.74A.88.88,0,0,1,312.65,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.29,224.13a7.62,7.62,0,0,1,1.6.75,1.41,1.41,0,0,1,.49,1.91l-.61-.12s.31-.72,0-1.1a4.62,4.62,0,0,0-1.44-.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13,226.39c-.5-.24-.73.07-1.08.91s-.11,1.06.31,1.23.75-.11,1-.81S315.66,226.65,315.13,226.39Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.17,226.4c-.5-.24-.73.07-1.08.9s-.11,1.07.31,1.24.75-.12,1-.81S315.7,226.66,315.17,226.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.42,213.5c-1.47,1.37-2.89,3.3-1.84,7.78a2.43,2.43,0,0,0-.61,2.52,2.7,2.7,0,0,0,3,2,2.23,2.23,0,0,0,1.5-3,2.71,2.71,0,0,0-2.33-2,7,7,0,0,1-.05-4.63c1.12-3.7,5.43-4,7.32-3.7C306.74,211.65,302.36,211.7,300.42,213.5Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.42,213.5c-1.47,1.37-2.89,3.3-1.84,7.78a2.43,2.43,0,0,0-.61,2.52,2.7,2.7,0,0,0,3,2,2.23,2.23,0,0,0,1.5-3,2.71,2.71,0,0,0-2.33-2,7,7,0,0,1-.05-4.63c1.12-3.7,5.43-4,7.32-3.7C306.74,211.65,302.36,211.7,300.42,213.5Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.7,222.79a3,3,0,0,0-3.29-2.25,2.32,2.32,0,0,0-.59.22l-.71.47a2.62,2.62,0,0,0-.91,3,3,3,0,0,0,3.28,2.25,1.89,1.89,0,0,0,.7-.29l.66-.43A2.65,2.65,0,0,0,302.7,222.79Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.7,222.79a3,3,0,0,0-3.29-2.25,2.32,2.32,0,0,0-.59.22l-.71.47a2.62,2.62,0,0,0-.91,3,3,3,0,0,0,3.28,2.25,1.89,1.89,0,0,0,.7-.29l.66-.43A2.65,2.65,0,0,0,302.7,222.79Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.14,223.16a3,3,0,0,0-3.29-2.25,2.49,2.49,0,0,0-1.65,3.3,3,3,0,0,0,3.28,2.25A2.49,2.49,0,0,0,302.14,223.16Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.14,223.16a3,3,0,0,0-3.29-2.25,2.49,2.49,0,0,0-1.65,3.3,3,3,0,0,0,3.28,2.25A2.49,2.49,0,0,0,302.14,223.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.83,223.44a1.4,1.4,0,0,0-1.55-1.06,1.18,1.18,0,0,0-.78,1.56,1.42,1.42,0,0,0,1.55,1.06A1.18,1.18,0,0,0,300.83,223.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,230.75c1,.29,3.9,4.23,4.85,5.65l-1.07,2.72a12.59,12.59,0,0,1,1.69,2.18l-2.18,6.33s.2-8.44-3.29-14.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.43,242.8c.77,2,.88,6.68.88,6.68s-.78-4.35-4.43-5.88c0-.21,0-3.18,0-3.18S302,239.17,301,238.7L299.93,233s.7-1.76,1.3-1.81v1.23a58.13,58.13,0,0,1,4.63,4.07C308.52,239.1,309.66,240.79,310.43,242.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.47,244s-.73-7.78-3.94-9.6a6.93,6.93,0,0,0-3.93,4c-.54,2-.25,4.92.86,9.36.92,3.72,1.89,7.53,2.91,10.36l6.69-1.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,234.27c-2.16,1-3.58,2.15-4.1,4.56s-.07,4.51.48,7,1.79,6.62,1.79,6.62,4.67.18,7.32-1.75l-1.7-9.54s-.9-5.66-3.65-6.85",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk-legs--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.56,255.89V298a.43.43,0,0,1-.21.35l-.43.25a.43.43,0,0,1-.41,0l-.44-.25a.43.43,0,0,1-.21-.35V255.89c0-.13.09-.18.21-.11l.44.25a.49.49,0,0,0,.41,0l.43-.25C379.47,255.71,379.56,255.76,379.56,255.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.51,298.62l-.44-.25a.43.43,0,0,1-.21-.35V255.89c0-.13.09-.18.21-.11l.44.25a.44.44,0,0,1,.2.35v42.13C378.71,298.64,378.62,298.69,378.51,298.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.9,284.22l-27.19-15.69v-1l.85-.49,27.19,15.69c.11.07.11.18,0,.24l-.44.25a.47.47,0,0,0-.2.36v.5C406.11,284.24,406,284.29,405.9,284.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.71,267.55l.85-.49h0l27.19,15.69c.11.07.11.18,0,.24l-.44.25a.43.43,0,0,1-.41,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.36,271.94v42.12a.49.49,0,0,1-.21.36l-.44.25a.43.43,0,0,1-.41,0l-.44-.25a.47.47,0,0,1-.2-.36V271.94c0-.13.09-.18.2-.12l.44.25a.43.43,0,0,0,.41,0l.44-.25C407.26,271.76,407.36,271.81,407.36,271.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.3,314.67l-.44-.25a.47.47,0,0,1-.2-.36V271.94c0-.13.09-.18.2-.12l.44.25a.49.49,0,0,1,.21.36v42.12C406.51,314.68,406.41,314.74,406.3,314.67Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom-character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.8,313.53l.69-4.24s-.33.41-2.74,0a13.56,13.56,0,0,1-2.66-.8l-.35,3c-.51,1.2-2.63.9-4.92.88-.39,0-.79,0-1.19-.05h0c-1.23.06-2.38.93-1,1.84s3.53,1.08,5.5,1.22C383.48,315.63,387.63,315.88,387.8,313.53Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.5,314.9a2.35,2.35,0,0,0,0,1.26,6,6,0,0,0,3.44,2.59c2.07.73,4.52.53,5.7.74s2.29.75,3.67.93a4.7,4.7,0,0,0,4-.81,3,3,0,0,0,.3-1.4C388.31,318,371.5,314.9,371.5,314.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.42,312c-.8.69-2.64.46-4.6.45s-4-.44-5.18.13-1.49,2,.39,3.68a8.25,8.25,0,0,0,1.76,1.42c2,.95,4.22.66,5.6.85,1.8.25,2.84.92,4.47.93,2.12,0,3.39-.66,3.69-1.25s.16-5.14-.73-4.95c0,0-.22,1.5-3.79.44C382.47,313.24,382.4,312.33,382.42,312Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.79,317.68s-.41-4.73,2.29-5.25h.34s0-.33-1.08-.48c-2-.28-3.29-.11-4.19.7a2.64,2.64,0,0,0-.67,2.19C371.69,315.78,372.66,316.89,374.79,317.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.88,315s0-1.92,1.34-2.57a.74.74,0,0,1,.79,0s-1.28.32-1.47,2.6c0,0-.06.16-.35.13C377.1,315.21,376.88,315.19,376.88,315Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23,312.5s0-.07-.35-.09a.6.6,0,0,0-.38.08s-1,.57-1,2.57a.36.36,0,0,0,.35.28.3.3,0,0,0,.36-.24S379.22,313,380.23,312.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.35,312.42s-.07-.12-.31-.09-.37.16-.37.16a3.62,3.62,0,0,0-.5,2.51s0,.29.39.27.31-.32.31-.32S380.78,312.82,381.35,312.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.14,286.07c-.44,4.18-1.54,23.72-1.54,23.72a6.4,6.4,0,0,0,5.76,1.42l3.45-22.29Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.14,286.07c-.44,4.18-1.54,23.72-1.54,23.72a6.4,6.4,0,0,0,5.76,1.42l3.45-22.29Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.79,320c0-.07,1-4,1-4s-.8.46-3.22.17a10.66,10.66,0,0,1-2.37-.61l-.57,2.93c-.47,1.22-2.6,1-4.9,1-.38,0-.78,0-1.18,0h0c-1.23.1-2.35,1-.94,1.87s3.55,1,5.53,1.05C371.52,322.49,375.69,322.35,375.79,320Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.52,322.13a2.39,2.39,0,0,0,0,1.26,6.06,6.06,0,0,0,3.52,2.48c2.1.66,4.53.39,5.72.57s2.31.68,3.7.82a4.69,4.69,0,0,0,4-.94,3,3,0,0,0,.26-1.41C376.42,324.71,359.52,322.13,359.52,322.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.36,318.89c-.79.72-2.63.55-4.6.59s-4-.31-5.17.29-1.42,2,.51,3.67a8,8,0,0,0,1.8,1.36c2,.89,4.24.54,5.63.68,1.8.19,2.85.84,4.49.8,2.12,0,3.37-.76,3.65-1.37s0-5.14-.88-4.92c0,0-.18,1.5-3.78.56C370.44,320.14,370.34,319.23,370.36,318.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9,324.8s-.55-4.72,2.12-5.32h.35s0-.32-1.09-.44c-2-.22-3.29,0-4.17.83a2.62,2.62,0,0,0-.6,2.21C359.74,323,360.74,324.08,362.9,324.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.91,322.1s-.07-1.93,1.26-2.62a.76.76,0,0,1,.79,0s-1.27.37-1.4,2.65c0,0,0,.16-.33.15C365.13,322.26,364.91,322.25,364.91,322.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.17,319.46s0-.07-.34-.08a.61.61,0,0,0-.38.09s-1,.6-.91,2.61c0,0,0,.23.37.26a.29.29,0,0,0,.34-.25S367.18,320,368.17,319.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3,319.34s-.07-.11-.32-.07-.36.17-.36.17a3.62,3.62,0,0,0-.42,2.52s0,.29.4.26.29-.33.29-.33S368.74,319.76,369.3,319.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,293.57c-.77,4.32-2,16.88-2.76,23.15a8.7,8.7,0,0,0,6.24,1.09l5.91-22.3Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,293.57c-.77,4.32-2,16.88-2.76,23.15a8.7,8.7,0,0,0,6.24,1.09l5.91-22.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.76,331.18l-3.27-27.35-2.68-.13,4.6,27.47h0a.34.34,0,0,0,.18.24,1,1,0,0,0,.95,0,.33.33,0,0,0,.21-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,301.35h-2.69l-3.9,25.82h0a.32.32,0,0,0,.19.3,1.08,1.08,0,0,0,1,0,.4.4,0,0,0,.19-.23h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.38,301.35l-1.08,7.21a10.63,10.63,0,0,0,2.05,1.26l1.72-8.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.85,340.34l-2.52-27.8-2.68-.14,3.85,27.94h0a.34.34,0,0,0,.18.24,1,1,0,0,0,.95.05.3.3,0,0,0,.21-.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.7,316.6l-.37-4.06-2.68-.14.61,4.4A4.89,4.89,0,0,0,401.7,316.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.7,292.84H397l-3.9,25.83h0a.31.31,0,0,0,.19.29,1.08,1.08,0,0,0,1,0,.37.37,0,0,0,.19-.23h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.73,300.82c-.37-2.11,1.35-3.76,4.59-5.95a76.49,76.49,0,0,1,9.39-5.28c2.71-1.24,5.49-1.13,9,.66,4.82,2.47,19.34,11.28,19.34,11.28s-21.7,12.25-25.88,11.7-14.61-7.34-15.43-9.73S380.73,300.82,380.73,300.82Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.73,300.82c-.37-2.11,1.35-3.76,4.59-5.95a76.49,76.49,0,0,1,9.39-5.28c2.71-1.24,5.49-1.13,9,.66,4.82,2.47,19.34,11.28,19.34,11.28s-21.7,12.25-25.88,11.7-14.61-7.34-15.43-9.73S380.73,300.82,380.73,300.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.23,310.65c-3.12,2.82-6.37.39-11.52-2.95-5.83-3.78-7-6.88-7-6.88a12.52,12.52,0,0,0,.44,3.41c.43,1.08,1.38,2.32,5.58,5.22s7.25,4.35,10.08,4.88l2.23-.3",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.71,307.7c-5.83-3.78-7-6.88-7-6.88a12.52,12.52,0,0,0,.44,3.41c.43,1.08,1.38,2.32,5.58,5.22s7.25,4.35,10.08,4.88l2.23-.3.17-3.38C396.11,313.47,392.86,311,387.71,307.7Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.11,293.59s-17.08-6.36-20.06-7.39-8.7-2.78-10.44-2.13-2.67,1.48-3,3.92c-.06.46-.17,2.7-.17,2.7s8.6,4.15,15.49,4.59S416.11,293.59,416.11,293.59Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.11,293.59s-17.08-6.36-20.06-7.39-8.7-2.78-10.44-2.13-2.67,1.48-3,3.92c-.06.46-.17,2.7-.17,2.7s8.6,4.15,15.49,4.59S416.11,293.59,416.11,293.59Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.31,291.41c.86,3.8,1,7.47-1.82,10-2,1.83-10.34,8.31-17.11,5.76C389.82,304.31,381,297,381,297s-6-.2-5.88-1.95c0-.43-1.82-1.07-1.77-1.54.57-5.11,4.15-7,9.24-5.77,5.34,1.33,17.2,5.54,17.2,5.54Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.31,291.41c.86,3.8,1,7.47-1.82,10-2,1.83-10.34,8.31-17.11,5.76C389.82,304.31,381,297,381,297s-6-.2-5.88-1.95c0-.43-1.82-1.07-1.77-1.54.57-5.11,4.15-7,9.24-5.77,5.34,1.33,17.2,5.54,17.2,5.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.7,306.39c1.6-4.66,3.54-10.57,3.54-10.57L403,297.61c-1.77,4.56-2.67,7-6.31,6.2S381,297,381,297s8.78,7.28,16.34,10.14C400.41,308.31,403.75,307.64,406.7,306.39Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.74,291.86v42.95a.47.47,0,0,1-.2.36l-.44.25a.49.49,0,0,1-.41,0l-.44-.25a.47.47,0,0,1-.2-.36V291.86c0-.13.09-.18.2-.11l.44.25a.49.49,0,0,0,.41,0l.44-.25C371.65,291.68,371.74,291.73,371.74,291.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,335.42l-.44-.25a.47.47,0,0,1-.2-.36V291.86c0-.13.09-.18.2-.11l.44.25a.44.44,0,0,1,.2.35V335.3C370.89,335.43,370.8,335.48,370.69,335.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.89 329.13 352.55 339.7 352.55 302.52 370.89 291.94 370.89 329.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.89 293.83 370.89 294.77 352.55 305.35 352.55 304.41 370.89 293.83",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.89 305.28 370.89 306.23 352.55 316.8 352.55 315.87 370.89 305.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.12 298.22 367.12 299.07 357.58 304.57 357.58 303.72 367.12 298.22",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.12 299.08 366.22 298.75 367.12 298.23 367.12 299.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.12 310.05 367.12 310.9 357.58 316.4 357.58 315.55 367.12 310.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.89 316.73 370.89 317.67 352.55 328.25 352.55 327.31 370.89 316.73",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.89 328.18 370.89 329.13 352.55 339.7 352.55 338.77 370.89 328.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.12 321.12 367.12 321.97 357.58 327.47 357.58 326.62 367.12 321.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.12 310.9 366.22 310.57 367.12 310.05 367.12 310.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.12 321.97 366.22 321.64 367.12 321.12 367.12 321.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.55 339.7 324.75 323.65 324.75 286.47 352.55 302.52 352.55 339.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.81,270.17v42.95a.49.49,0,0,1-.21.36l-.44.25a.49.49,0,0,1-.41,0l-.44-.25a.47.47,0,0,1-.2-.36V270.17c0-.13.09-.18.2-.11l.44.25a.49.49,0,0,0,.41,0l.44-.25C297.71,270,297.81,270,297.81,270.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,313.73l-.44-.25a.47.47,0,0,1-.2-.36V270.17c0-.13.09-.18.2-.11l.44.25a.43.43,0,0,1,.21.35v42.95C297,313.74,296.87,313.79,296.75,313.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.15,299.34,297,283.64v-1l.85-.49L325,297.87a.12.12,0,0,1,0,.23l-.44.26a.43.43,0,0,0-.21.35v.51C324.35,299.35,324.26,299.4,324.15,299.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,282.66l.85-.49h0L325,297.87a.12.12,0,0,1,0,.23l-.44.26a.49.49,0,0,1-.41,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.6,286.22v42.95a.47.47,0,0,1-.2.36l-.44.25a.49.49,0,0,1-.41,0l-.44-.25a.49.49,0,0,1-.21-.36V286.22c0-.13.1-.18.21-.12l.44.26a.49.49,0,0,0,.41,0l.44-.26C325.51,286,325.6,286.09,325.6,286.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.55,329.78l-.44-.25a.49.49,0,0,1-.21-.36V286.22c0-.13.1-.18.21-.12l.44.26a.44.44,0,0,1,.2.35v43C324.75,329.79,324.66,329.84,324.55,329.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.94,315.38l-27.19-15.7v-1l.85-.49,27.19,15.7a.12.12,0,0,1,0,.23l-.44.26a.44.44,0,0,0-.2.35v.51C352.15,315.39,352.06,315.44,351.94,315.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.75,298.7l.85-.49h0l27.19,15.7a.12.12,0,0,1,0,.23l-.44.26a.49.49,0,0,1-.41,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,302.27v42.94a.45.45,0,0,1-.21.36l-.44.25a.43.43,0,0,1-.41,0l-.44-.25a.44.44,0,0,1-.2-.36V302.27c0-.13.09-.19.2-.12l.44.25a.43.43,0,0,0,.41,0l.44-.25C353.3,302.08,353.4,302.14,353.4,302.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.34,345.82l-.44-.25a.44.44,0,0,1-.2-.36V302.27c0-.13.09-.19.2-.12l.44.25a.46.46,0,0,1,.21.36V345.7C352.55,345.84,352.46,345.89,352.34,345.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.31,271.2v-.15a.82.82,0,0,0-.37-.65l-57.23-33a.83.83,0,0,0-.75,0l-56,32.35a.84.84,0,0,0-.37.64v.15a.84.84,0,0,0,.37.65l57.23,33.05a.83.83,0,0,0,.75,0l56-32.34A.82.82,0,0,0,409.31,271.2Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.31,271.2v-.15a.82.82,0,0,0-.37-.65l-57.23-33a.83.83,0,0,0-.75,0l-56,32.35a.84.84,0,0,0-.37.64v.15a.84.84,0,0,0,.37.65l57.23,33.05a.83.83,0,0,0,.75,0l56-32.34A.82.82,0,0,0,409.31,271.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,303.27v1a.75.75,0,0,0,.37-.09l56-32.34a.82.82,0,0,0,.37-.65v-.15a.85.85,0,0,0-.3-.6c.13.12.11.28-.07.38l-56,32.35A.75.75,0,0,1,352.55,303.27Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.55,303.27v1a.75.75,0,0,0,.37-.09l56-32.34a.82.82,0,0,0,.37-.65v-.15a.85.85,0,0,0-.3-.6c.13.12.11.28-.07.38l-56,32.35A.75.75,0,0,1,352.55,303.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.94,270.83l-56,32.35a.83.83,0,0,1-.75,0l-57.23-33.05a.23.23,0,0,1,0-.43l56-32.35a.83.83,0,0,1,.75,0l57.23,33C409.15,270.52,409.15,270.71,408.94,270.83Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.94,270.83l-56,32.35a.83.83,0,0,1-.75,0l-57.23-33.05a.23.23,0,0,1,0-.43l56-32.35a.83.83,0,0,1,.75,0l57.23,33C409.15,270.52,409.15,270.71,408.94,270.83Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.13,276.71a1,1,0,0,0,.52-.13l8-4.61-11.41-6.59-7.27,4.2a.83.83,0,0,0-.43.72.81.81,0,0,0,.43.71l9.64,5.57A1.07,1.07,0,0,0,311.13,276.71Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.55,266.21l-7.32,3.85-.15.24v.19a.28.28,0,0,0,.15.23l9.65,5.57a.55.55,0,0,0,.5,0l7.15-4.13V272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.13,276.16a.51.51,0,0,1-.25-.06l-9.65-5.57a.26.26,0,0,1,0-.47l7-4,10.3,6-7.15,4.13A.51.51,0,0,1,311.13,276.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.23,265.46l-6.92,4-.07.1v.75h0a.12.12,0,0,0,.07.09L311,276a.34.34,0,0,0,.34,0l6.92-4v-.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.22,271.23l-.09,0-1.13.65-.21.12-5.49,3.17a.4.4,0,0,1-.34,0l-9.65-5.57c-.09,0-.09-.14,0-.2l.09-.05,6.83-3.94,9.9,5.72h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.13,275.26V276a.31.31,0,0,1-.17,0l-9.65-5.57a.12.12,0,0,1-.07-.09v-.75s0,.07.07.1l9.65,5.57A.31.31,0,0,0,311.13,275.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.22,271.13l-1.25.72-.19.11-5.48,3.16a.34.34,0,0,1-.34,0l-8.64-5-.22-.13a2.19,2.19,0,0,1-.7-.61v0a.16.16,0,0,1,.1-.23,3.48,3.48,0,0,0,.65-.27h0l6.08-3.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.93,271a.1.1,0,0,0,0,.19.36.36,0,0,0,.32,0,.1.1,0,0,0,0-.19A.36.36,0,0,0,316.93,271Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,270.44a.42.42,0,0,0-.43,0,1.31,1.31,0,0,0-.55.78l.12,0a1.23,1.23,0,0,1,.49-.7.35.35,0,0,1,.19-.06.27.27,0,0,1,.12,0,.46.46,0,0,1,.16.4.38.38,0,0,1,0,.1l.12.06a.86.86,0,0,0,0-.16A.55.55,0,0,0,318,270.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.16,271.16v0h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,270.48a.1.1,0,0,0,0,.19.36.36,0,0,0,.32,0,.1.1,0,0,0,0-.19A.36.36,0,0,0,316,270.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,269.88a.42.42,0,0,0-.43,0,1.37,1.37,0,0,0-.54.78l.12,0a1.15,1.15,0,0,1,.48-.69.41.41,0,0,1,.2-.06.2.2,0,0,1,.11,0,.42.42,0,0,1,.16.39v.1l.11.06a.81.81,0,0,0,0-.16A.56.56,0,0,0,317,269.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,269.93a.1.1,0,0,0,0,.18.36.36,0,0,0,.32,0c.09-.05.09-.13,0-.18A.31.31,0,0,0,315,269.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,269.32a.42.42,0,0,0-.43,0,1.37,1.37,0,0,0-.54.78.25.25,0,0,0,.12,0,1.19,1.19,0,0,1,.48-.69.41.41,0,0,1,.2-.06.2.2,0,0,1,.11,0,.42.42,0,0,1,.17.39.31.31,0,0,1,0,.1l.11.06a.78.78,0,0,0,0-.16A.55.55,0,0,0,316,269.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,269.37c-.09.05-.09.13,0,.18a.36.36,0,0,0,.32,0c.09-.05.09-.13,0-.18A.36.36,0,0,0,314,269.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.06,268.77a.42.42,0,0,0-.43,0,1.31,1.31,0,0,0-.55.78h.12a1.2,1.2,0,0,1,.49-.69.38.38,0,0,1,.19-.06l.12,0a.44.44,0,0,1,.16.4v.09l.11.07a.92.92,0,0,0,0-.16A.55.55,0,0,0,315.06,268.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.06,268.81c-.09.05-.09.13,0,.19a.36.36,0,0,0,.32,0c.09-.06.09-.14,0-.19A.36.36,0,0,0,313.06,268.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.09,268.21a.42.42,0,0,0-.43,0,1.34,1.34,0,0,0-.54.78.24.24,0,0,0,.12,0,1.22,1.22,0,0,1,.48-.69.41.41,0,0,1,.2-.06.2.2,0,0,1,.11,0,.46.46,0,0,1,.16.4v.09l.11.07a.86.86,0,0,0,0-.16A.55.55,0,0,0,314.09,268.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,268.25a.11.11,0,0,0,0,.19.36.36,0,0,0,.32,0,.1.1,0,0,0,0-.19A.36.36,0,0,0,312.09,268.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.12,267.65a.42.42,0,0,0-.43,0,1.34,1.34,0,0,0-.54.78l.12,0a1.22,1.22,0,0,1,.48-.7.41.41,0,0,1,.2-.06l.12,0a.46.46,0,0,1,.16.4.38.38,0,0,1,0,.1l.11.06a.88.88,0,0,0,0-.16A.53.53,0,0,0,313.12,267.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.13,267.69a.1.1,0,0,0,0,.19.36.36,0,0,0,.32,0,.1.1,0,0,0,0-.19A.36.36,0,0,0,311.13,267.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.16,267.09a.42.42,0,0,0-.43,0,1.38,1.38,0,0,0-.55.78l.12,0a1.2,1.2,0,0,1,.49-.69.38.38,0,0,1,.19-.06l.12,0a.42.42,0,0,1,.16.39v.1l.11.06a.81.81,0,0,0,0-.16A.56.56,0,0,0,312.16,267.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,267.14c-.09.05-.09.13,0,.18a.36.36,0,0,0,.32,0c.09-.05.09-.13,0-.18A.31.31,0,0,0,310.16,267.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.19,266.53a.42.42,0,0,0-.43,0,1.37,1.37,0,0,0-.54.78.23.23,0,0,0,.12,0,1.19,1.19,0,0,1,.48-.69.41.41,0,0,1,.2-.06.2.2,0,0,1,.11,0,.41.41,0,0,1,.16.39v.1l.11.06a.81.81,0,0,0,0-.16A.57.57,0,0,0,311.19,266.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.19,266.58a.1.1,0,0,0,0,.18.38.38,0,0,0,.33,0,.1.1,0,0,0,0-.18A.38.38,0,0,0,309.19,266.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.23,266a.44.44,0,0,0-.44,0,1.34,1.34,0,0,0-.54.78h.12a1.19,1.19,0,0,1,.48-.69.41.41,0,0,1,.2-.06l.12,0a.44.44,0,0,1,.16.4.28.28,0,0,1,0,.09l.12.07c0-.06,0-.11,0-.16A.55.55,0,0,0,310.23,266Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.23,266c-.09.05-.09.13,0,.19a.36.36,0,0,0,.32,0c.09-.06.09-.14,0-.19A.36.36,0,0,0,308.23,266Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.26,265.42a.42.42,0,0,0-.43,0,1.39,1.39,0,0,0-.55.78.25.25,0,0,0,.12,0,1.24,1.24,0,0,1,.49-.69.38.38,0,0,1,.19-.06.24.24,0,0,1,.12,0,.46.46,0,0,1,.16.4V266l.11.07a.86.86,0,0,0,0-.16A.55.55,0,0,0,309.26,265.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,274.13a.11.11,0,0,1-.06-.21l5.32-3.07a.11.11,0,0,1,.16,0,.13.13,0,0,1,0,.16l-5.32,3.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.52,273.76a.11.11,0,0,1-.1-.06.1.1,0,0,1,0-.15l5.32-3.08a.12.12,0,0,1,.16,0,.11.11,0,0,1,0,.15l-5.33,3.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.87,273.39a.11.11,0,0,1-.1-.06.12.12,0,0,1,.05-.16l5.32-3.07a.11.11,0,0,1,.11.2l-5.32,3.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.23,273a.11.11,0,0,1-.1-.06.12.12,0,0,1,0-.16l5.32-3.07a.13.13,0,0,1,.16,0,.12.12,0,0,1,0,.16L308.29,273Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,272.64a.14.14,0,0,1-.1-.05.12.12,0,0,1,0-.16l5.32-3.07a.1.1,0,0,1,.15,0,.12.12,0,0,1,0,.16l-5.32,3.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.94,272.27a.11.11,0,0,1-.06-.21L312.2,269a.11.11,0,1,1,.12.19L307,272.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.3,271.9a.11.11,0,0,1-.1-.06.1.1,0,0,1,0-.15l5.32-3.08a.12.12,0,0,1,.16.05.11.11,0,0,1-.05.15l-5.32,3.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.65,271.53a.11.11,0,0,1-.1-.06.13.13,0,0,1,0-.16l5.32-3.07a.12.12,0,1,1,.12.2l-5.32,3.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,271.16a.11.11,0,0,1-.1-.06.11.11,0,0,1,0-.16l5.32-3.07a.13.13,0,0,1,.16,0,.12.12,0,0,1-.05.16l-5.32,3.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.36,270.78a.11.11,0,0,1-.06-.21l5.32-3.07a.12.12,0,0,1,.16,0,.13.13,0,0,1,0,.16l-5.32,3.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.72,270.41a.11.11,0,0,1-.1-.06.11.11,0,0,1,0-.15l5.32-3.07a.12.12,0,0,1,.16,0,.13.13,0,0,1,0,.16l-5.33,3.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.07,270a.11.11,0,0,1-.1-.06.11.11,0,0,1,0-.15l5.32-3.08a.11.11,0,0,1,.15.05.1.1,0,0,1,0,.15L303.13,270Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.43,269.67a.11.11,0,0,1-.1-.06.13.13,0,0,1,0-.16l5.32-3.07a.12.12,0,0,1,.12.2l-5.32,3.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.82,274.5a.12.12,0,0,1-.1-.05.11.11,0,0,1,0-.16l5.63-3.25a.11.11,0,0,1,.11.19l-5.63,3.26Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.63,270.45a.55.55,0,0,0-.22-.14l-.1-.05c-.05-.08-.12-.21,0-.22a.51.51,0,0,1,.2.06s0,0,0-.05-.28-.15-.32,0a.27.27,0,0,0,0,.15.32.32,0,0,0-.14,0s-.08,0-.09.06,0,0,0,.06a.05.05,0,0,0,.05.05H313c-.07,0-.25-.05-.3,0s0,.08,0,.1l-.16.06s0,0,0,0a1.2,1.2,0,0,1-.19,0c-.11,0-.37,0-.34.13s0,0,0,0v0l0,0-.06,0c-.05.07,0,.09,0,.13s-.27-.06-.36,0,0,.22-.12.22,0,.05,0,.05.12,0,.15-.12.3-.06.45-.1,0,0,0,0,0-.09.07-.12,0,0,0,0-.08-.12,0-.16l.16,0h.34s0,0,0,0,.13-.06.17-.07,0,0,0,0c-.07-.18.19-.12.3-.1a0,0,0,0,0,0,0c0-.06-.15-.12,0-.14s.07,0,.12,0a.91.91,0,0,0,.27.28C313.6,270.61,313.71,270.57,313.63,270.45Zm-.05,0s-.07,0-.08,0a.41.41,0,0,1-.14-.15l.08.05A.28.28,0,0,1,313.58,270.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,271.57c0-.07,0-.16,0-.17s0,0,0,0-.13.08-.11.18l-.12,0c-.06,0-.1,0-.13.05s0,.07,0,.1,0,0,0,.05h-.09a.15.15,0,0,0-.13,0s.07.06-.07,0-.07,0-.1,0-.08,0-.07.09.05.05.05.07-.13,0-.18,0,0,0,0,0,0,.08-.05.09l-.09,0c-.05,0-.11.08-.18.07s0,0,0,0,.05.09-.06.14l-.13,0s0,.06,0,.06.23.07.28,0,0-.11,0-.15.1,0,.11,0l.08,0,.05,0h.06l0,0s0,0,0,0,0,0,.08,0,.1.05.14,0,0-.09,0-.13.14,0,.2-.06,0,0,0,0,.19,0,.26,0l0,0a.34.34,0,0,0,0-.08c0-.07.12-.06.16-.05s.16.29.29.25a0,0,0,0,0,0,0C311.2,271.74,311.09,271.64,311,271.57Zm0,.13s0,0,0,0a.37.37,0,0,1,.09.09C311.11,271.82,311,271.72,311,271.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,272.36a.55.55,0,0,0-.22-.14l-.1-.05c-.05-.08-.12-.21,0-.23s.15.05.21.07,0,0,0-.05-.28-.15-.32,0a.19.19,0,0,0,0,.14l-.14,0c-.05,0-.09,0-.1.06s0,0,0,.06,0,0,0,.05h0c-.07,0-.25-.05-.29,0s0,.08,0,.09-.13.05-.15.07,0,0,0,0-.16,0-.2,0-.37,0-.33.14c0,0,0,0,0,0s0,0,0,0l0,0s0,0-.06,0,0,.09,0,.12-.28-.05-.37,0,0,.21-.12.22,0,0,0,.05.11,0,.14-.13.3,0,.45-.09a0,0,0,0,0,0,0c0-.06,0-.1.07-.12s0,0,0,0-.07-.12,0-.16l.16,0h.34s0,0,0,0,.14-.06.17-.07a0,0,0,0,0,0,0c-.07-.17.19-.11.3-.09s0,0,0,0-.15-.11,0-.14l.12,0a.81.81,0,0,0,.27.28C312.88,272.52,313,272.48,312.9,272.36Zm0,0c0,.05-.07,0-.08,0a.5.5,0,0,1-.14-.15l.08,0A.36.36,0,0,1,312.85,272.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.54,271c0-.08,0-.16,0-.17s0,0,0,0-.13.08-.11.18l-.12,0c-.07,0-.11,0-.13.05s0,.06,0,.09,0,0,0,.05a.14.14,0,0,1-.09,0,.18.18,0,0,0-.13,0s.07.06-.07,0a.37.37,0,0,0-.11,0c-.05,0-.07,0-.07.08l.06.07c0,.13-.13,0-.18,0s0,0,0,0,0,.09-.05.09l-.09,0c-.06,0-.11.07-.18.07s0,0,0,0,.05.09-.06.13h-.13s0,.05,0,.05.22.08.28,0,0-.11,0-.14.1,0,.11,0l.08,0s0,0,.05,0,0,0,.06,0,0,0,0,0,0,0,0,0,.05,0,.08,0,.1,0,.14,0,0-.1,0-.14.15,0,.2-.06a0,0,0,0,0,0,0c0-.12.19,0,.25,0s0,0,0,0l0-.08c0-.07.12-.06.16,0s.16.3.29.26l0,0C314.77,271.18,314.65,271.08,314.54,271Zm0,.12s0,0,0,0,.08.07.08.09S314.59,271.15,314.58,271.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.7,268.28a.55.55,0,0,0-.22-.14l-.1-.05c-.05-.08-.12-.21,0-.22a.51.51,0,0,1,.2.06s0,0,0-.05-.28-.15-.32,0a.28.28,0,0,0,0,.15.32.32,0,0,0-.14,0s-.08,0-.09.06,0,0,0,.06,0,0,.05.05H309c-.07,0-.25,0-.3,0s0,.08,0,.09l-.16.07s0,0,0,0-.15,0-.19,0-.37,0-.34.13,0,0,0,0v0l0,0s-.05,0-.06,0,0,.09,0,.13-.27-.06-.36,0,0,.22-.12.22,0,.05,0,.05.12,0,.15-.12.3-.06.45-.1,0,0,0,0,0-.1.07-.12a.06.06,0,0,0,0,0s-.08-.12,0-.16l.16,0h.34s0,0,0,0,.13-.06.17-.06,0,0,0,0,.19-.11.3-.09,0,0,0,0-.15-.12,0-.15l.12,0a.81.81,0,0,0,.27.28C309.67,268.44,309.78,268.4,309.7,268.28Zm-.05,0c0,.05-.07,0-.08,0a.5.5,0,0,1-.14-.15l.08,0A.36.36,0,0,1,309.65,268.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,269.4c0-.07,0-.16,0-.17s0-.05,0-.05-.13.08-.11.18l-.12,0c-.06,0-.11,0-.13.05s0,.06,0,.1,0,0,0,0h-.09a.15.15,0,0,0-.13,0s.07.06-.07,0-.07,0-.1,0-.08,0-.07.08.05.06.05.08-.13,0-.18,0,0,0,0,0,0,.08-.05.09l-.09,0c-.05,0-.11.08-.18.07s0,0,0,0,.05.09-.06.14l-.13,0s0,.05,0,.06.23.07.28,0,0-.11,0-.14.1,0,.11,0l.08,0s0,0,.05,0h.06s0,0,0,0,0,0,0-.05.05,0,.08,0,.1,0,.14,0,0-.1,0-.14.14,0,.19-.06,0,0,0,0,.19,0,.26,0,0,0,0,0l0-.07c0-.07.12-.07.16-.05s.16.29.29.25l0,0C307.27,269.57,307.16,269.47,307,269.4Zm0,.12v0a.37.37,0,0,1,.09.09C307.18,269.65,307.09,269.54,307.08,269.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,270.19a.4.4,0,0,0-.22-.14l-.1-.05c0-.08-.12-.21,0-.23s.15.05.21.06,0,0,0,0-.28-.16-.32,0a.21.21,0,0,0,0,.15.24.24,0,0,0-.14,0s-.09,0-.1.05a.16.16,0,0,0,0,.07.06.06,0,0,0,.05,0h-.05c-.07,0-.25-.05-.29,0s0,.08,0,.09-.13.05-.15.07,0,0,0,0h-.2c-.1,0-.37,0-.33.14,0,0,0,0,0,0s0,0,0,0l0,0-.06,0c0,.06,0,.08,0,.12s-.28,0-.37,0,0,.21-.12.22,0,0,0,0,.11,0,.14-.12.3-.05.45-.09a0,0,0,0,0,0,0c0-.06,0-.1.07-.13a0,0,0,0,0,0,0s-.07-.12,0-.16l.16,0h.34s0,0,0,0,.14-.06.17-.07a0,0,0,0,0,0,0c-.07-.18.19-.11.3-.09s0,0,0,0-.15-.12,0-.14l.12,0a.81.81,0,0,0,.27.28C309,270.34,309.05,270.31,309,270.19Zm-.05,0s-.07,0-.08,0-.1-.09-.14-.14a.29.29,0,0,1,.08,0A.36.36,0,0,1,308.92,270.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.61,268.84c0-.08,0-.16.05-.17s0-.06,0-.06-.13.08-.11.19l-.12-.05c-.07,0-.11,0-.13.05s0,.07,0,.1.05,0,0,.05-.07,0-.09,0a.15.15,0,0,0-.13,0s.07.06-.07,0l-.11,0c-.05,0-.07,0-.07.09s.06.06.06.07-.13,0-.18,0l0,0c0,.06,0,.08,0,.09l-.09,0c-.06,0-.11.07-.18.06s0,0,0,0,.05.08-.06.13h-.13s0,.05,0,.05.22.08.28,0,0-.11,0-.14.1,0,.11,0l.08,0,.05,0s0,0,.06,0a.05.05,0,0,0,0,0s0,0,0,0,.05,0,.08,0,.1,0,.14,0,0-.09,0-.13.15,0,.2-.06a0,0,0,0,0,0,0c0-.12.18,0,.25,0s0,0,0,0l0-.08c0-.07.12-.06.16-.05s.16.29.29.25l0,0C310.84,269,310.72,268.9,310.61,268.84Zm0,.12s0,0,0,0,.08.07.08.09S310.66,269,310.65,269Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.37,271.5c0-.07-.14-.1-.21-.14l-.11-.05c-.05-.08-.11-.21,0-.23s.16.05.21.06,0,0,0,0-.27-.15-.31,0a.24.24,0,0,0,0,.14.36.36,0,0,0-.14,0s-.08,0-.1.06,0,0,0,.06,0,0,0,0h-.05c-.06,0-.25-.05-.29,0s0,.08,0,.09-.14.05-.16.07,0,0,0,0h-.19c-.11,0-.37,0-.34.14s0,0,0,0a.16.16,0,0,1,0,0l0,0s-.05,0-.06,0,0,.08,0,.12-.27,0-.36,0,0,.21-.12.22,0,0,0,.05.12,0,.14-.13.31-.05.46-.09a.06.06,0,0,0,0,0c0-.06,0-.1.06-.12a0,0,0,0,0,0,0s-.07-.12,0-.16l.16,0h.35s0,0,0,0,.13-.06.16-.07,0,0,0,0c-.07-.17.19-.11.3-.09s0,0,0,0-.15-.11,0-.14l.12,0a.92.92,0,0,0,.28.28C309.35,271.66,309.45,271.62,309.37,271.5Zm0,0c0,.05-.07,0-.09,0s-.1-.09-.13-.14l.08,0A.45.45,0,0,1,309.33,271.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.67,270.27c0-.08,0-.16.05-.17s0-.05,0-.05-.12.08-.11.18l-.12,0c-.06,0-.1,0-.12.05s0,.06,0,.09.05,0,0,.05-.06,0-.08,0a.16.16,0,0,0-.13,0c-.05,0,.07.06-.07,0s-.07,0-.11,0-.08,0-.07.08.06.06.06.07-.14,0-.19,0l0,0c0,.06,0,.09,0,.09l-.1,0c-.05,0-.1.07-.18.06s0,0,0,0,.05.09-.06.13h-.13s0,.05,0,.05.22.08.27,0,0-.11,0-.14.1,0,.11,0l.09,0,0,0h.07l0,0s0,0,0,0,.05,0,.08,0,.1,0,.14,0,0-.1,0-.14.14,0,.2-.06a0,0,0,0,0,0,0c0-.12.18,0,.25,0l0,0,0-.08c0-.07.12-.06.17-.05s.16.3.28.26,0,0,0,0S310.79,270.34,310.67,270.27Zm.05.12s0,0,0,0l.09.09C310.81,270.52,310.73,270.41,310.72,270.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.15,269.27a0,0,0,0,0,0,0c0-.07-.1,0-.12,0s0,.06,0,.09,0,0,0,.05h-.09c-.08,0-.08,0-.13,0s.07.05-.07,0a.37.37,0,0,0-.11,0c-.05,0-.08,0-.07.08s.06.06.06.08-.13,0-.18,0,0,0,0,0,0,.09,0,.09l-.09,0c-.06,0-.11.07-.18.07s0,0,0,0,.05.09-.07.14l-.12,0s0,.05,0,.05.22.08.27,0,0-.11,0-.14.1,0,.11,0l.09,0s0,0,.05,0,0,0,.06,0,0,0,0,0,0,0,0,0,.06,0,.08,0,.11,0,.14,0,0-.1,0-.14.14,0,.2-.06a0,0,0,0,0,0,0c0-.12.18,0,.25,0s0,0,0,0,0-.1,0-.15Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M313.71,266.39l6.36,3.71a.74.74,0,0,0,.68,0l17.89-10.32c.19-.11.19-.28,0-.39l-6.36-3.7a.74.74,0,0,0-.68,0L313.71,266A.21.21,0,0,0,313.71,266.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.15,258.63a.22.22,0,0,0-.14-.19l-5.66-3.27a.72.72,0,0,0-.67,0l-17.28,10a.23.23,0,0,0-.14.19v.6a.23.23,0,0,0,.14.19l5.66,3.27a.74.74,0,0,0,.68,0l17.27-10a.24.24,0,0,0,.14-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.06,268.8l-5.66-3.25c-.19-.11-.19-.28,0-.39l17.28-10a.72.72,0,0,1,.67,0l5.66,3.27c.19.1.19.28,0,.39l-17.27,10A.74.74,0,0,1,320.06,268.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.38,268.88v.61a.66.66,0,0,1-.32-.08l-5.66-3.27a.23.23,0,0,1-.14-.19v-.6a.26.26,0,0,0,.14.2l5.66,3.25A.66.66,0,0,0,320.38,268.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29,265.3l.76-.43.57.33-.76.44-.56-.32h0Zm.88.51.6-.34.56.33-.6.35-.56-.33Zm.19-1.12.59-.34.57.33-.6.35-.56-.33h0Zm.69,1.63,1-.56.57.34-1,.55-.56-.32Zm0-1,.47-.27.57.33-.48.28-.56-.33h0Zm.18-1.12.6-.34.56.33-.59.35-.56-.33h0Zm.6.67.47-.27.56.33-.47.28-.56-.32h0Zm.07,2,.76-.44.57.34-.76.44-.56-.32h0Zm.23-3.17,4.32-2.49.56.34L318.72,264l-.56-.33h0Zm.16,1.94.48-.28.56.34-.47.27-.56-.32Zm.31-1.19.47-.28.57.34-.48.27-.56-.32Zm.18,2.93.48-.27.56.33-.47.27-.56-.32Zm.19-1.12.47-.27.56.33-.47.28-.56-.33Zm.1-1.07.47-.28.57.34-.48.27-.56-.32Zm.31-1.19.47-.28.56.34-.47.27-.56-.32Zm.18,2.93.47-.27.57.33-.48.28-.56-.33h0Zm.18-1.12.48-.27.56.33-.47.28-.56-.33h0Zm.11-1.07.47-.27.56.33-.47.27-.56-.32h0Zm0,3.25.59-.34.57.33-.6.35-.56-.32h0Zm.3-4.44.48-.27.56.33-.47.27-.56-.32Zm.18,2.93.48-.27.56.33-.47.28-.56-.32h0Zm.19-1.12L321,265l.57.34-.48.27-.56-.32h0Zm.1-1.07.48-.27.56.33-.47.28-.56-.33h0Zm.31-1.19.47-.27.57.33-.48.28-.56-.33h0Zm.15,4.18.48-.27.56.33-.47.28-.56-.33Zm0-1.24.47-.28.57.34-.48.27-.56-.32Zm.19-1.12.47-.28.56.34-.47.27-.56-.32h0Zm.1-1.08.47-.27.57.33-.48.28-.56-.32h0Zm.31-1.19.47-.27.56.33-.47.28-.56-.33h0Zm.15,4.18.47-.27.57.33-.48.28-.56-.33h0Zm0-1.24.47-.28.56.34-.47.27-.56-.32Zm.18-1.12.47-.28.57.34-.48.27-.56-.32Zm.1-1.07.48-.28.56.34-.47.27-.56-.32Zm.31-1.19.48-.28.56.34-.47.27-.56-.32Zm.16,4.17.47-.27.56.34-.47.27-.56-.32h0Zm0-1.24.48-.27.56.33-.47.27-.56-.32Zm.09-4.1.59-.35.57.34-.6.34-.56-.32Zm.1,3,.47-.27.57.33-.48.27-.56-.32Zm.1-1.07.47-.28.57.34-.48.27-.56-.32Zm.31-1.19.47-.28.57.34-.48.27-.56-.32Zm.15,4.18.47-.28.57.34-.48.27-.56-.32Zm0-1.25.47-.27.57.33L324,265l-.56-.33h0Zm.18-1.12.48-.27.56.33-.47.28-.56-.33h0Zm0-3,.59-.34.57.33-.6.34-.56-.32Zm.08,2,.47-.27.56.33-.47.27-.56-.32Zm.3-1.19.48-.27.56.33-.47.27-.56-.32Zm.18,2.93.48-.27.56.33-.47.28-.56-.33h0Zm.19-1.12.47-.27.57.33-.48.28-.56-.32h0Zm.1-1.07.48-.27.56.33-.47.28-.56-.33h0Zm0,3.24L325,265l.56.33-.47.28-.56-.33h0Zm0-5.29.59-.34.57.33-.6.35-.56-.33h0Zm.26.86.47-.27.57.33-.48.28-.56-.33h0Zm.18,2.94.47-.28.57.34-.48.27-.56-.32Zm.19-1.12.47-.28.56.34-.47.27-.56-.32h0Zm.1-1.08.47-.27.57.33-.48.28-.56-.33h0Zm0,3.25.47-.28.57.34-.48.27-.56-.32Zm.14-5.37.76-.44.57.34-.76.44-.56-.33h0Zm.15.93,1.49-.86.57.33-1.5.87-.56-.33h0Zm.18,2.94.47-.28.56.34-.47.27-.56-.32Zm.18-1.12.48-.28.56.34-.47.27-.57-.32Zm.11-1.07.47-.28.56.34-.47.27-.56-.32h0Zm0,3.24.47-.28.56.34-.47.27-.56-.32Zm.46-1.5.48-.27.56.33-.47.27-.56-.32Zm.13-4.13.47-.27.57.34-.48.27-.56-.32h0Zm.06,3,.47-.27.57.33-.48.27-.56-.32Zm.1-1.07L328,260l1.44.84-.56.32-.73-.43a.33.33,0,0,0-.15,0,.25.25,0,0,0-.13,0l-.44.25-.56-.32Zm0,3.24.48-.27.56.33-.47.27-.56-.32Zm.47-1.5.47-.27.57.33-.48.28-.56-.33h0Zm.13-4.12.47-.28.56.34-.47.27-.56-.32Zm0,3L328,261l.56.33-.47.28-.56-.33h0Zm.47,2,.47-.28.56.34-.47.27-.56-.32Zm.13-1.31.47-.27.56.33-.47.28-.56-.33h0Zm.12-4.12.48-.28.56.34-.47.27-.56-.32Zm.1.95.48-.27.56.33-.47.28-.56-.33h0Zm.42,4,.48-.28.56.34-.47.27-.56-.32Zm.13-1.31.84-.48.57.33-.85.49-.56-.32h0Zm.29-4.21,1.25-.73.57.34-1.26.72-.56-.32Zm.14,2.95.48-.27.56.33-.48.28-.56-.32h0Zm.22,2.12.47-.27.57.33-.48.27-.56-.32Zm.52-4.57.47-.27.57.33-.48.28-.56-.33h0Zm0,2,.47-.28.57.34-.48.27-.56-.32Zm.1.95.47-.27.57.33-.48.28-.56-.33Zm.12,1.16.47-.27.56.33-.47.28-.56-.33h0Zm.41-5.52.48-.27.56.33-.47.27-.56-.32Zm.1.95.48-.27.56.34-.47.27-.56-.32h0Zm0,2,.48-.28.56.34-.47.27-.56-.32Zm.07-1.05.47-.27.56.33-.47.27-.56-.32h0Zm0,2,.48-.27.56.33-.47.28-.56-.33h0Zm.29,1.06.48-.27.56.34-.47.27-.56-.32h0Zm.25-5.42.47-.27,1.44.84-.47.27-1.44-.83h0Zm.1,1,.47-.28.57.34-.48.27-.56-.32Zm.1,1,.48-.27.56.33-.47.28-.56-.33Zm0,2,.47-.27.57.33-.48.28-.56-.32h0Zm.06-1,.48-.28.56.34-.47.27-.56-.32Zm.23,2.11.47-.28.57.34-.48.27-.56-.32Zm.45-3.52.47-.27.57.33-.48.28-.56-.33h0Zm.1,1,.47-.28.57.34-.48.27-.56-.32Zm.1.95.47-.27.57.33-.48.28-.56-.33h0Zm.13,1.16.47-.27.56.33-.47.27-.56-.32h0Zm.44-3.52.48-.27,1.44.84-.48.28-1.43-.83h0Zm.11,1,.47-.27.56.33-.47.27-.56-.32h0Zm.1.95.47-.27.56.33-.47.28-.56-.33h0Zm.51,1.2.47-.28.25.15-.48.28-.24-.14Zm.26-1.64.48-.28.56.34-.47.27-.56-.32Zm.52,1.19.47-.27.24.15-.47.27-.24-.14ZM335,258l.47-.28.57.34-.48.27L335,258Zm.51,1.19.47-.27.25.15-.48.27-.23-.14Zm.78-.45.47-.27.24.15-.47.27-.24-.14h0Z",
    style: {
      fill: "#0B1D51"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hands--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.15,261.88A9.44,9.44,0,0,0,321,260c-.13,0-.32-.09-.7-.14a7.8,7.8,0,0,0,1-.3,1.75,1.75,0,0,0,.78-.64c.08-.12.12-.3,0-.38a.22.22,0,0,0-.14,0,11.42,11.42,0,0,1-1.17,0,7.23,7.23,0,0,1-1.14,0,4.81,4.81,0,0,0-.65-.08,7.23,7.23,0,0,0-1.54.21A10.52,10.52,0,0,1,313,259a24.62,24.62,0,0,1-3.29-.68l-3.89-1.08-2.57-.71-.19-.06-6.69,1.65c1,2.81,1.35,4,3.28,4.33,3.22.5,12.76.87,12.76.87s.27.1.71.22a11.3,11.3,0,0,0,1.69.54,10.08,10.08,0,0,0,3.36-.47,9.85,9.85,0,0,1,3.45.38c.9.25,1.8-1.18,2.25-1.07S325,262.58,324.15,261.88Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.1,248.78c.59,1,1.32,1.34,2.71,1.7,2.12.55,9.58,1.88,9.58,1.88l.38.12a1.33,1.33,0,0,1,.66.46,3.5,3.5,0,0,1,.41.7c.39.85.36,1.14.76,2.06s.6.84,1.24,1.55.85,1.1,1.14,1,.44-.81.23-1.44a8.61,8.61,0,0,0-.92-1.46c-.08-.23-.06-.64.65-.48a6.88,6.88,0,0,1,2.32,1.64,22.4,22.4,0,0,0,1.88,1.89c.63.39.6-.26.64-.82s.79-1.72.8-2.62a4,4,0,0,0-1.68-2.61c-.9-.73-2.59-2.27-3-2.54-1.26-.74-3.68-1.76-3.68-1.76-2.24-.87-9.26-3.89-9.26-3.89",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86,259.38a3.36,3.36,0,0,0-1.3.36,7.15,7.15,0,0,1,1.75.11,7.8,7.8,0,0,0,1-.3A1.76,1.76,0,0,0,322,259,3.84,3.84,0,0,1,319.86,259.38Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327,277.64a1,1,0,0,0,.94,0l26.17-15.11a1.06,1.06,0,0,0,.49-.83V240.61a.91.91,0,0,0-1.39-.8l-26.18,15.11a1.1,1.1,0,0,0-.48.84v21.06A1,1,0,0,0,327,277.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,277.62l26.17-15.11a1.06,1.06,0,0,0,.49-.84V240.61c0-.31-.22-.43-.49-.28L328,255.44a1.07,1.07,0,0,0-.48.84v21.06C327.48,277.65,327.69,277.78,328,277.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.71,255.28l.91.52a1.12,1.12,0,0,0-.15.48V277.4c0,.29.18.41.42.32a1.05,1.05,0,0,1-.87,0,1,1,0,0,1-.45-.82V255.76A1.06,1.06,0,0,1,326.71,255.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379.56,254.52l1-9.6-1-.62-52.82,30.58a6.75,6.75,0,0,0-3.16,5.15v7l1,.6v-1.23Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.56,254.52l1-9.6-1-.62-52.82,30.58a6.75,6.75,0,0,0-3.16,5.15v7l1,.6v-1.23Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,255.14V244.92L327.77,275.5a6.74,6.74,0,0,0-3.15,5.15v6.94Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,255.14V244.92L327.77,275.5a6.74,6.74,0,0,0-3.15,5.15v6.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--green-post--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "347.86 265.63 347.86 271.6 352.8 268.74 352.8 262.78 347.86 265.63",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,269l-3.28,1.83c-.37.21-.61-.38-.61-.74-.37.23-1.12.38-1.16-.09l-.26-3.39,4.94-2.86Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.37,269l-3.28,1.83c-.37.21-.61-.38-.61-.74-.37.23-1.12.38-1.16-.09l-.26-3.39,4.94-2.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353 263.79 348.06 266.65 348.06 265.73 353 262.88 353 263.79",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353 263.79 348.06 266.65 348.06 265.73 353 262.88 353 263.79",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.48 270.29 349.83 270.89 349.41 269.79 348.48 270.29",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.48 270.29 349.83 270.89 349.41 269.79 348.48 270.29",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.38,266.19a5.85,5.85,0,0,1-.33.82c-.05.11-.21.5,0,.54.07,0,.29-.64.34-.75a.86.86,0,0,0,0-.61s-.07-.05-.08,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.9,266.34a6.08,6.08,0,0,1-.21.6,1,1,0,0,0-.15.52c0,.06.11.17.16.09a2.84,2.84,0,0,0,.27-.62.86.86,0,0,0,.08-.52c0-.05-.12-.18-.15-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.42,266.9c.09,0,.05-.18,0-.18s-.05.18,0,.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.09,267.72c.09,0,0-.18,0-.18s0,.18,0,.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.15,266.77a1.13,1.13,0,0,0-.72.9c0,.35.42.41.67.25a1.07,1.07,0,0,0,.45-.73.42.42,0,0,0-.45-.48c-.09,0,0,.15,0,.16.25,0,.22.2.14.39a.94.94,0,0,1-.28.4.39.39,0,0,1-.19.1c-.16,0-.15-.06-.11-.18a1.14,1.14,0,0,1,.57-.63c.09-.05,0-.22-.11-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,267.15c-.24,0-.5.33-.58.53a.49.49,0,0,0,.27.63.52.52,0,0,0,.69-.35.84.84,0,0,0-.2-.89c-.05,0-.11,0-.09.06s.17.37.12.6-.29.54-.54.35.29-.63.38-.82a.07.07,0,0,0,0-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.22,268.45c-.34.64.76.32,1,.2l-.11-.15c-.38.69.22,1,.73.44l-.15-.08a.66.66,0,0,0,1.24.12s0-.14-.06-.11c-.21.17-.93.57-1,0,0-.06-.09-.15-.15-.09s-.34.37-.49.15,0-.17,0-.32,0-.18-.11-.15-.9.36-.82.07c0,0-.05-.17-.09-.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Papers--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M356,299.07a1.08,1.08,0,0,1-.52-.13l-8.71-5a.43.43,0,0,1,0-.8l1.55-.9-.74-.43a.42.42,0,0,1,0-.79l12.82-7.41a1.12,1.12,0,0,1,.53-.13,1.08,1.08,0,0,1,.52.13l8.71,5a.43.43,0,0,1,0,.8l-1.55.9.74.43a.48.48,0,0,1,.27.4.49.49,0,0,1-.27.4l-12.82,7.4A1.12,1.12,0,0,1,356,299.07Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.49,290.46a.31.31,0,0,0-.18-.25l-8.72-5a1,1,0,0,0-.87,0l-12.83,7.4a.31.31,0,0,0-.18.26v.39a.31.31,0,0,0,.18.25l8.72,5a1,1,0,0,0,.87,0l12.83-7.41a.31.31,0,0,0,.18-.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.89,292.58l12.83-7.4a1,1,0,0,1,.87,0l8.72,5a.26.26,0,0,1,0,.5l-12.83,7.41a1,1,0,0,1-.87,0l-8.72-5A.27.27,0,0,1,346.89,292.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,298.23v.39a.88.88,0,0,1-.43-.1l-8.72-5a.33.33,0,0,1-.18-.26v-.4a.31.31,0,0,0,.18.26l8.72,5A.89.89,0,0,0,356,298.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.3,288.34a.31.31,0,0,0-.18-.26l-8.72-5a1,1,0,0,0-.87,0l-12.83,7.41a.31.31,0,0,0-.18.25v.4a.31.31,0,0,0,.18.25l8.72,5a1,1,0,0,0,.87,0L370.12,289a.28.28,0,0,0,.18-.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.7,290.46l12.83-7.41a1,1,0,0,1,.87,0l8.72,5a.27.27,0,0,1,0,.51L357.29,296a1,1,0,0,1-.87,0l-8.72-5A.26.26,0,0,1,347.7,290.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.85,296.1v.39a.88.88,0,0,1-.43-.1l-8.72-5a.31.31,0,0,1-.18-.25v-.4a.31.31,0,0,0,.18.25l8.72,5A.79.79,0,0,0,356.85,296.1Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--black-pencil--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-26",
    points: "365.36 280.27 373.33 284.87 372.37 285.42 364.46 280.8 363.67 279.69 365.36 280.27",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.58,280.5l-.94-1.13a0,0,0,0,1,0-.07l1.45.32Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.67 279.3 363.68 279.3 365.13 279.62 364.84 280.09 364.68 279.99 363.67 279.35 363.67 279.3",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.68,279.3a0,0,0,0,0,0,.07l.18.22h0a.24.24,0,0,1,.15-.21h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.67,283.57l-.12-.07-.14-.09-6.28-3.79a.63.63,0,0,0-.4.27.68.68,0,0,0-.15.61l6.29,3.79.27.16C371,284.34,371.5,283.46,371.67,283.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.67,283.57l-.12-.07-.14-.09-6.28-3.79a.7.7,0,0,0-.46.36l6.55,4s0,0,0,0C371.37,283.76,371.57,283.51,371.67,283.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.23,283.3l-.27-.16c-.07,0-.22.09-.34.26s-.28.57-.19.63l.2.12.07,0c-.1-.07,0-.4.18-.63s.26-.3.34-.26h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.16,283.26c-.17-.11-.7.78-.53.89l.26.16c-.17-.12.36-1,.53-.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.67,283.57l-.26-.16c-.17-.11-.68.74-.54.88h0l.26.15C371,284.34,371.5,283.46,371.67,283.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.63,279.32l0,0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.76,284.23l-1.09-.66c-.07-.05-.22.08-.35.25s-.28.57-.18.63h0l1.09.66c.22.13.54-.28.61-.6A.25.25,0,0,0,372.76,284.23Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.43,284.34a.78.78,0,0,0-.26.66.17.17,0,0,0,.1.13c.22.07.51-.31.57-.61a.26.26,0,0,0-.08-.29C372.68,284.19,372.56,284.22,372.43,284.34Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M369.68,277.81l6.36,3.7a.74.74,0,0,0,.68,0l17.89-10.31c.19-.11.19-.29,0-.39l-6.36-3.71a.74.74,0,0,0-.68,0l-17.89,10.32A.21.21,0,0,0,369.68,277.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.12,270.05a.22.22,0,0,0-.14-.2l-5.66-3.27a.72.72,0,0,0-.67,0l-17.28,10a.26.26,0,0,0-.14.2v.59a.26.26,0,0,0,.14.2l5.66,3.26a.74.74,0,0,0,.68,0l17.27-10a.22.22,0,0,0,.14-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,280.22,370.37,277a.21.21,0,0,1,0-.39l17.28-10a.72.72,0,0,1,.67,0l5.66,3.27c.19.11.19.28,0,.39l-17.27,10A.77.77,0,0,1,376,280.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.35,280.3v.6a.66.66,0,0,1-.32-.08l-5.66-3.26a.26.26,0,0,1-.14-.2v-.59a.23.23,0,0,0,.14.19l5.66,3.26A.79.79,0,0,0,376.35,280.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.39,279.7h0l-.56-.32.76-.44.58.32-.76.44Zm-.88-.51h0l-.56-.32.6-.35.58.33-.6.34Zm1.94-.1h0l-.56-.33.6-.34.58.32-.6.35Zm-2.81-.4h0l-.56-.33,1-.55.58.32-1,.56Zm1.77,0h0l-.56-.32.47-.27.58.32-.47.27Zm1.94-.11h0l-.56-.33.6-.34.58.32-.6.35Zm-1.16-.34h0l-.56-.33.47-.27.58.32-.47.28Zm-3.43-.05h0l-.56-.32.76-.44.58.32-.76.44Zm5.49-.13h0l-.56-.33,4.31-2.49.58.33-4.31,2.49ZM375.9,278h0l-.56-.32.48-.27.57.32-.47.28Zm2.07-.18h0l-.56-.33.48-.27.58.33-.48.27Zm-5.09-.11h0l-.56-.32.47-.27.58.32-.47.27Zm1.94-.1h0l-.56-.33.47-.27.58.32-.47.28Zm1.86-.06h0l-.56-.33.47-.27.58.32-.47.28Zm2.06-.18h0l-.56-.32.47-.28.58.33-.47.27Zm-5.08-.1h0l-.56-.32.47-.27.58.32-.47.28Zm1.94-.11h0l-.56-.33.47-.27.58.33-.47.27Zm1.86-.06h0l-.56-.33.48-.27.58.33-.48.27Zm-5.64,0h0l-.56-.33.59-.34.58.33-.59.34Zm7.7-.18h0l-.57-.32.48-.28.58.33-.47.27Zm-5.08-.1h0l-.56-.33.48-.27.58.32-.48.28Zm1.94-.11h0l-.56-.32.48-.28.58.33-.48.27Zm1.85-.06h0l-.56-.32.47-.28.58.33-.47.27Zm2.06-.18h0l-.56-.32.48-.27.57.32-.47.27Zm-7.23-.08h0l-.56-.32.48-.27.58.32-.48.28Zm2.15,0h0l-.56-.33.47-.27.58.33-.47.27Zm1.94-.11h0l-.56-.32.47-.28.58.33-.47.27Zm1.86-.06h0l-.56-.32.47-.28.58.33-.47.27Zm2.06-.17h0l-.56-.32.47-.27.58.32-.47.28Zm-7.24-.09h0l-.56-.33.47-.27.58.32-.47.28Zm2.16,0h0l-.57-.32.48-.28.58.33-.47.27Zm1.94-.1h0l-.56-.32.48-.27.58.32-.48.28Zm1.85-.06h0l-.56-.32.48-.27.58.32-.48.28Zm2.07-.18h0l-.56-.33.48-.27.58.32-.48.28Zm-7.24-.09h0l-.56-.33.48-.27.58.33-.48.27Zm2.15,0h0l-.56-.32.48-.27.57.32-.47.27Zm7.11-.05h0l-.56-.32.6-.35.58.33-.6.34Zm-5.17-.05h0l-.56-.33.47-.27.58.32-.47.28Zm1.86-.06h0l-.56-.33.47-.27.58.32-.47.28Zm2.06-.18h0l-.56-.32.47-.28.58.33-.47.27Zm-7.24-.09h0l-.56-.32.47-.28.58.33-.47.27Zm2.16,0h0l-.56-.32.47-.27.58.32-.47.28Zm1.94-.11h0l-.56-.33.47-.27.58.33-.47.27Zm5.29,0h0l-.56-.32.6-.34.58.32-.6.35Zm-3.43-.05h0l-.56-.33.48-.27.58.33-.48.27Zm2.06-.18h0l-.56-.32.47-.28.58.33-.47.27Zm-5.08-.1h0l-.56-.33.48-.27.58.32-.48.28Zm1.94-.11h0l-.56-.32.48-.28.58.33-.48.27Zm1.85-.06h0l-.56-.32.47-.28.58.33-.47.27Zm-5.61,0h0l-.56-.33.48-.27.58.33-.48.27Zm9.16,0h0l-.56-.33.6-.34.58.32-.6.35Zm-1.49-.16h0l-.56-.32.48-.27.58.32-.48.27Zm-5.08-.1h0l-.56-.33.47-.27.58.33-.47.27ZM381,274h0l-.56-.32.47-.28.58.33L381,274Zm1.86-.06h0l-.56-.32.47-.28.58.33-.47.27Zm-5.62,0h0l-.56-.32.47-.28.58.33-.47.27Zm9.29-.08h0l-.56-.33.76-.44.58.33-.76.44Zm-1.61-.08h0l-.56-.32,1.49-.86.58.32-1.49.87Zm-5.08-.11h0l-.56-.32.47-.28.58.33-.47.27Zm1.94-.1h0l-.57-.32.48-.27.58.32-.48.27Zm1.85-.06h0l-.56-.32.48-.27.58.32-.48.28Zm-5.61,0h0l-.56-.32.47-.28.58.33-.47.27Zm2.59-.27h0l-.56-.32.48-.28.58.33-.48.27Zm7.15-.07h0l-.56-.32.47-.28.58.33-.47.27Zm-5.21,0h0l-.56-.33.48-.27.57.32-.47.28Zm1.86-.06h0l-.56-.33.43-.25a.09.09,0,0,0,0-.16l-.74-.42.56-.33,1.46.84-1.13.65Zm-5.61,0h0l-.56-.32.48-.27.58.32-.48.27Zm2.59-.27h0l-.56-.32.47-.27.58.32-.47.28Zm7.14-.08h0l-.56-.32.48-.28.58.33-.48.27Zm-5.2,0h0l-.56-.33.47-.27.58.33-.47.27Zm-3.42-.27h0l-.56-.32.47-.28.58.33-.47.27Zm2.26-.07h0l-.56-.33.48-.27.58.32-.48.28Zm7.14-.08h0l-.56-.32.47-.27.58.32-.47.27Zm-1.65-.05h0l-.56-.32.48-.27.58.32-.48.28Zm-7-.25h0l-.56-.32.48-.28.58.33-.48.27Zm2.25-.07h0l-.56-.33.84-.48.58.32-.84.49Zm7.31-.17h0l-.56-.32,1.25-.73.58.33-1.25.72Zm-5.12-.08h0l-.56-.32.48-.28.58.33-.48.27Zm-3.67-.12h0l-.56-.32.47-.27.58.32-.47.28Zm7.91-.3h0l-.56-.32.47-.27.58.32-.47.28Zm-3.47,0h0l-.56-.32.47-.28.58.33-.47.27Zm-1.65,0h0l-.56-.32.47-.27.58.32-.47.27Zm-2-.07h0l-.57-.33.48-.27.58.32-.48.28Zm9.56-.24h0l-.56-.32.47-.27.58.32-.47.28Zm-1.65-.06h0l-.56-.33.47-.27.58.32-.47.28Zm-3.47,0h0l-.56-.32.47-.27.58.32-.47.27Zm1.82,0h0l-.56-.33.48-.27.58.33-.48.27Zm-3.47,0h0l-.56-.32.48-.27.58.32-.48.28Zm-1.84-.17h0l-.56-.33.48-.27.58.33-.48.27Zm9.39-.14h0l-1.44-.83.47-.28,1.46.83-.47.28Zm-1.65-.06h0l-.56-.33.48-.27.58.33-.48.27Zm-1.66-.06h0l-.56-.32.47-.28.58.33-.47.27Zm-3.47,0h0l-.56-.33.47-.27.58.33-.47.27Zm1.82,0h0l-.56-.32.47-.28.58.33-.47.27ZM384,270h0l-.56-.32.47-.28.58.33L384,270Zm6.09-.26h0l-.56-.32.47-.28.58.33-.47.27Zm-1.66,0h0l-.56-.32.48-.27.58.32-.48.27Zm-1.65-.06h0l-.56-.32.47-.27.58.32-.47.28Zm-2-.08h0l-.57-.32.48-.28.58.33-.48.27Zm6.08-.25h0l-1.44-.83.48-.27,1.46.83-.48.27Zm-1.65-.06h0l-.56-.32.47-.27.58.32-.47.28Zm-1.65-.06h0l-.57-.33.48-.27.58.32-.48.28Zm-2.07-.3h0l-.24-.14.47-.27.26.14-.47.27Zm2.84-.15h0l-.56-.33.48-.27.57.33-.47.27Zm-2.06-.3h0l-.25-.14.48-.27.26.14-.48.27Zm2.84-.15h0l-.56-.32.47-.28.58.33-.47.27ZM387,268h0l-.24-.13.47-.28.26.14L387,268Zm.78-.45h0l-.25-.14.48-.28.26.14-.47.28Z",
    style: {
      fill: "#0B1D51"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M358.48,276.49l-3.52-2a.58.58,0,0,1,0-1.1l25.23-14.57a2.14,2.14,0,0,1,1.91,0l3.52,2a.59.59,0,0,1,0,1.11l-25.23,14.56A2.08,2.08,0,0,1,358.48,276.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.8,271.94l3.88-2.24a1,1,0,0,0,.6-.83v-.54l-3.65-2.07a.88.88,0,0,1-.38-.67v-4.78l-6.77,3.91v4.78a.85.85,0,0,0,.38.67l3.05,1.77A3.2,3.2,0,0,0,374.8,271.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,270.35v.53l-1.24-.71a.85.85,0,0,1-.38-.67v-4.78l1.29-.74c0,.33.05.66.08,1l-.91.53v3.73a.86.86,0,0,0,.39.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.94,269.23a.86.86,0,0,0,.39.67l2.58,1.5a3.2,3.2,0,0,0,2.89,0l3.88-2.24a.88.88,0,0,0,0-1.67L376.1,266a.87.87,0,0,1-.39-.67v-3.73l-6.77,3.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.88,266.44h0l-.78-.45a.87.87,0,0,1-.39-.67v-3.73l-6.77,3.91v3.73a.86.86,0,0,0,.39.67l.77.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.08,274.39a1.05,1.05,0,0,0,.93,0l26.18-15.11a1.1,1.1,0,0,0,.48-.84V237.35a1,1,0,0,0-.45-.81,1,1,0,0,0-.94,0l-26.17,15.12a1.06,1.06,0,0,0-.49.83v21.07A1,1,0,0,0,358.08,274.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,274.37l26.18-15.12a1.06,1.06,0,0,0,.48-.83V237.35c0-.3-.22-.43-.48-.27L359,252.19a1.05,1.05,0,0,0-.48.83v21.07C358.53,274.4,358.74,274.52,359,274.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.77,252l.9.52a.94.94,0,0,0-.14.47v21.13c0,.28.18.41.41.31a1,1,0,0,1-.86,0,1,1,0,0,1-.46-.82V252.5A1,1,0,0,1,357.77,252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.43,271.27V253.32a.66.66,0,0,1,.29-.5l24.76-14.29c.16-.09.28,0,.28.17v17.94a.64.64,0,0,1-.29.5l-24.76,14.29C359.56,271.52,359.43,271.45,359.43,271.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.14,241.84l-20.08,11.59a.61.61,0,0,0-.26.46V268.5c0,.17.12.24.26.16l20.08-11.59a.61.61,0,0,0,.26-.46V242C382.4,241.83,382.28,241.76,382.14,241.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.14,254.62v9.19a.2.2,0,0,1-.09.15l-1.47.85a.06.06,0,0,1-.09-.05v-9.19a.17.17,0,0,1,.09-.15l1.47-.85C364.1,254.54,364.14,254.56,364.14,254.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,255.07l-.49.28a.14.14,0,0,0-.07.12V256s0,.06.07,0l.49-.28a.15.15,0,0,0,.06-.11v-.56S364,255.05,363.94,255.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,255.5l-.48.29a.14.14,0,0,0-.07.11v.56s0,.06.07,0l.48-.28a.14.14,0,0,0,.07-.12v-.56S363.22,255.48,363.18,255.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,255.92l-.49.28a.14.14,0,0,0-.07.12v.56s0,.06.07,0l.49-.28a.2.2,0,0,0,.06-.12V256S364,255.9,363.94,255.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,256.36l-.48.28a.14.14,0,0,0-.07.11v.56s0,.06.07,0l.48-.28a.14.14,0,0,0,.07-.11v-.57S363.22,256.34,363.18,256.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,256.77l-.49.28a.17.17,0,0,0-.07.12v.56s0,.06.07,0l.49-.28a.16.16,0,0,0,.06-.12v-.56S364,256.75,363.94,256.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,257.21l-.48.28a.14.14,0,0,0-.07.11v.56s0,.06.07,0l.48-.28a.14.14,0,0,0,.07-.11v-.56C363.25,257.2,363.22,257.19,363.18,257.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,257.63l-.49.28a.14.14,0,0,0-.07.11v.56s0,.06.07,0l.49-.28a.16.16,0,0,0,.06-.12v-.56S364,257.6,363.94,257.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,258.06l-.48.28a.14.14,0,0,0-.07.11V259s0,.05.07,0l.48-.28a.14.14,0,0,0,.07-.11v-.56S363.22,258,363.18,258.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,258.48l-.49.28a.14.14,0,0,0-.07.11v.56c0,.05,0,.06.07,0l.49-.28a.15.15,0,0,0,.06-.11v-.56S364,258.46,363.94,258.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,258.91l-.48.28a.14.14,0,0,0-.07.12v.56s0,.06.07,0l.48-.29a.14.14,0,0,0,.07-.11V259S363.22,258.89,363.18,258.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,259.33l-.49.28a.14.14,0,0,0-.07.11v.56c0,.05,0,.06.07,0l.49-.28a.15.15,0,0,0,.06-.11v-.56C364,259.32,364,259.31,363.94,259.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,259.76l-.48.28a.15.15,0,0,0-.07.12v.56s0,.06.07,0l.48-.28a.15.15,0,0,0,.07-.12v-.56S363.22,259.74,363.18,259.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,260.18l-.49.28a.14.14,0,0,0-.07.11v.57s0,.06.07,0l.49-.28a.15.15,0,0,0,.06-.11v-.56S364,260.16,363.94,260.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,260.61l-.48.29a.14.14,0,0,0-.07.11v.56s0,.06.07,0l.48-.28a.14.14,0,0,0,.07-.12v-.56S363.22,260.59,363.18,260.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.94,261l-.49.28a.14.14,0,0,0-.07.12V262s0,.06.07,0l.49-.28a.2.2,0,0,0,.06-.12v-.56S364,261,363.94,261Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,261.47l-.48.28a.14.14,0,0,0-.07.11v.56s0,.06.07,0l.48-.28a.14.14,0,0,0,.07-.11v-.57S363.22,261.45,363.18,261.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.9,262.14l-.72.42a.19.19,0,0,0-.1.17v.83c0,.07,0,.09.1.06l.72-.42a.21.21,0,0,0,.1-.17v-.84C364,262.13,364,262.11,363.9,262.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.77,263.59l.6-.35,0,0v.68l-.6.35,0,0v-.68m-.1-.11a.24.24,0,0,0-.05.13v.84c0,.06,0,.09.1.06l.72-.42.05,0a.24.24,0,0,0,.05-.13v-.84c0-.06,0-.09-.1-.06l-.72.42-.05,0Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.39,246.53l-13.06,7.54a1.13,1.13,0,0,0-.5.87v9.67c0,.32.23.45.5.29l13.06-7.55a1.07,1.07,0,0,0,.5-.86v-9.67C379.89,246.5,379.67,246.37,379.39,246.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,256a.12.12,0,0,1-.1,0,.11.11,0,0,1,0-.16l4.69-2.71a.13.13,0,0,1,.16,0,.12.12,0,0,1-.05.16L366.59,256Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,257.07a.11.11,0,0,1-.1-.06.11.11,0,0,1,0-.16l4.69-2.71a.12.12,0,0,1,.16.05.11.11,0,0,1-.05.15l-4.69,2.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,258.15a.11.11,0,0,1-.1-.06.1.1,0,0,1,0-.15l4.69-2.71a.11.11,0,0,1,.16,0,.12.12,0,0,1-.05.16l-4.69,2.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,259.23a.12.12,0,0,1-.1-.05.11.11,0,0,1,0-.16l4.69-2.71a.13.13,0,0,1,.16,0,.12.12,0,0,1-.05.16l-4.69,2.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.17 252.62 378.73 248.83 378.73 253.16 372.17 256.95 372.17 252.62",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.17 252.62 378.73 248.83 378.73 253.16 372.17 256.95 372.17 252.62",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.64 256.14 378.27 252.9 377.03 252.03 375.8 253.49 374.44 252.24 372.64 256.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.12,251.22c.15-.08.27,0,.27.16a.61.61,0,0,1-.27.47c-.15.08-.27,0-.27-.16A.61.61,0,0,1,376.12,251.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.54 261.29 378.73 254.24 378.73 255.33 366.54 262.37 366.54 261.29",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,260.32a.11.11,0,0,1-.1-.06.11.11,0,0,1,0-.16l4.69-2.71a.12.12,0,0,1,.16.05.11.11,0,0,1,0,.15l-4.7,2.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,263.57a.11.11,0,0,1-.1-.06.11.11,0,0,1,0-.16l12.21-7a.12.12,0,0,1,.12.2l-12.22,7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.8,253.89a.61.61,0,0,1,.26-.46l20.08-11.59c.14-.08.26,0,.26.16v1.12L361.8,255Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.64,264.71a1,1,0,0,0-.45.79c0,.29.2.4.45.26a1,1,0,0,0,.45-.79C373.09,264.69,372.89,264.57,372.64,264.71Z",
    style: {
      fill: "#0B1D51"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.82,266l-1.76,1a1.93,1.93,0,0,1-1.93-.1l-2.9-2.12a.69.69,0,0,1,.07-1.26l.88-.51a2.37,2.37,0,0,1,2-.06l3.58,1.94C395.36,265.23,395.37,265.73,394.82,266Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.18,263.92l2,1.57,1.48,1.16a1.41,1.41,0,0,0,.47.11,1.36,1.36,0,0,0,.7-.15l1.57-.91h0a1.12,1.12,0,0,0,.32-1.59l-.05-.07a2.11,2.11,0,0,0-1.26-.8l-.8-.16a8.7,8.7,0,0,0-2.47-.3l-2,1.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.3,264.8l-.11-.09,1.77-1-1.55-.48.16-.09,1.54.48,1.06-.61.2,0Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.49,266.55h0l-1.41-1-1.9-1.38v-.23h0a6.93,6.93,0,0,1,2,.59l.66.26a2.33,2.33,0,0,1,.57.34,2.1,2.1,0,0,1,.76,1.61v0a1.41,1.41,0,0,1-.47-.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.12,288.33,341,293.61a1.12,1.12,0,0,1-1,0l-10.4-6a.32.32,0,0,1,0-.61l9.14-5.27a1.14,1.14,0,0,1,1.05,0l10.4,6C350.41,287.9,350.41,288.17,350.12,288.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.21,267.22a.21.21,0,0,0-.2,0l-.21.13.13,14a.62.62,0,0,0,.29.49l11,6.34V273.56Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.21,267.22a.21.21,0,0,0-.2,0l-.21.13.13,14a.62.62,0,0,0,.29.49l11,6.34V273.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,267.34c-.16-.09-.28,0-.28.17v14a.62.62,0,0,0,.28.5l11,6.33V273.68Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,267.34c-.16-.09-.28,0-.28.17v14a.62.62,0,0,0,.28.5l11,6.33V273.68Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.28,286.94l-8.12-4.69a.62.62,0,0,1-.29-.49V268.88l-1.06-.61,1.08-.63h0a.19.19,0,0,1,.25,0l9.3,5.37v14.63l-1.19.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,268.31c-.16-.09-.28,0-.28.17v14a.64.64,0,0,0,.28.49l9.31,5.38V273.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.28 273.69 347.46 273 347.46 287.63 346.28 288.31 346.28 273.69",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.89,274.08a.52.52,0,0,0,0-.11.42.42,0,0,0-.09-.14l0,0c-.08-.06-.15,0-.15.11a.4.4,0,0,0,0,.15.33.33,0,0,0,.12.14h0C345.83,274.24,345.89,274.19,345.89,274.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.53,274.79a.73.73,0,0,0,.34-.36.48.48,0,0,0,0-.45h0a.68.68,0,0,0-.3-.28l-.07-.05v.19a.43.43,0,0,1,0,.81,1.57,1.57,0,0,1-1.4,0,.46.46,0,0,1-.29-.45.37.37,0,0,1,.11-.23.42.42,0,0,0-.09-.14.69.69,0,0,0-.16.23.55.55,0,0,0,0,.45.9.9,0,0,0,.3.28A1.68,1.68,0,0,0,347.53,274.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.21,275.08l-10.09-6.79.16-.09a.34.34,0,0,1,.28,0l9.86,6.76Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.21,275.08l-10.09-6.79.16-.09a.34.34,0,0,1,.28,0l9.86,6.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.32,268.31c-.15-.09-.28,0-.28.17v14a.68.68,0,0,0,.28.5l10.06,6.87V275.18Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.19 273.56 349.19 288.18 346.37 289.81 346.37 275.18 349.19 273.56",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.19 273.56 349.19 288.18 346.37 289.81 346.37 275.18 349.19 273.56",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.63,276.76a.51.51,0,0,0-.37-.25.71.71,0,0,0-.49.11A1.7,1.7,0,0,0,347,278a.82.82,0,0,0,.09.4.59.59,0,0,0,.86.15,1.73,1.73,0,0,0,.78-1.36.86.86,0,0,0-.09-.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.86,276.76c.38-.22.7,0,.7.41a1.54,1.54,0,0,1-.7,1.21c-.39.23-.71.05-.71-.4A1.55,1.55,0,0,1,347.86,276.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.72,279.79l.21-.12c.43-.25.77-.05.77.44v6.34a1.71,1.71,0,0,1-.77,1.34l-.21.12c-.43.25-.77,0-.77-.44v-6.34A1.68,1.68,0,0,1,347.72,279.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.02 273.46 346.22 275.07 346.37 275.18 349.19 273.56 349.02 273.46",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.02 273.46 346.22 275.07 346.37 275.18 349.19 273.56 349.02 273.46",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.71,290.06a.27.27,0,0,0,.11-.21V275.51a.26.26,0,0,0-.12-.21l-10.45-6.83-.21.13v14.62l10.45,6.83A.27.27,0,0,0,345.71,290.06Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.56,275.51l.21-.12a.19.19,0,0,1,0,.12v14.34a.27.27,0,0,1-.11.21.27.27,0,0,1-.23,0c.06,0,.12,0,.12-.08V275.64A.28.28,0,0,0,345.56,275.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,268.6l10.44,6.82a.26.26,0,0,1,.09.09.28.28,0,0,1,0,.13V290c0,.08-.06.12-.12.08L335,283.22Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,268.6l.21-.13,10.45,6.83a.24.24,0,0,1,.08.09l-.21.12a.26.26,0,0,0-.09-.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.2 268.69 335.2 283.32 332.39 284.94 332.41 270.3 335.2 268.69",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.2 268.69 335.2 283.32 332.39 284.94 332.41 270.3 335.2 268.69",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.12,290.8a.32.32,0,0,0,.3,0l.57-.33a.34.34,0,0,0,.16-.27V275.93a.33.33,0,0,0-.15-.27L335.85,270l-.88.51v14.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,285.17l9.15,5.63c.08.05.15,0,.15-.09V276.44a.33.33,0,0,0-.15-.27L335,270.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.64,271.55a.23.23,0,0,0,0-.11.29.29,0,0,0-.08-.14l-.05,0c-.08-.05-.15,0-.15.12a.42.42,0,0,0,0,.15.4.4,0,0,0,.11.14h0C335.59,271.71,335.64,271.66,335.64,271.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.22,276.29l.88-.51a.3.3,0,0,1,0,.15V290.2a.36.36,0,0,1-.15.27l-.58.33a.33.33,0,0,1-.26,0c.06,0,.11,0,.11-.11V276.44A.28.28,0,0,0,344.22,276.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.6,270.83a.61.61,0,0,0,.35.53,2.2,2.2,0,0,0,1.56.11,2.05,2.05,0,0,1-.08-.2,2,2,0,0,1-1.38-.09.6.6,0,0,1-.2-.19.29.29,0,0,1,0-.16c0-.2.19-.41.5-.58a2.17,2.17,0,0,1,1.9-.1.49.49,0,0,1,.22.23l.23.14v0a.42.42,0,0,0-.07-.27.81.81,0,0,0-.28-.27,2.41,2.41,0,0,0-2.1.1A1,1,0,0,0,333.6,270.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.92,291.09a.27.27,0,0,0,.11-.21V276.54a.27.27,0,0,0-.12-.21l-11.46-6.24-.21.13v14.62l11.46,6.24A.27.27,0,0,0,343.92,291.09Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.77,276.55l.21-.13a.22.22,0,0,1,0,.13v14.33a.26.26,0,0,1-.11.21.27.27,0,0,1-.23,0c.06,0,.12,0,.12-.07V276.67A.28.28,0,0,0,343.77,276.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.23,270.22l11.45,6.23a.22.22,0,0,1,.09.1.28.28,0,0,1,0,.12V291c0,.08-.06.11-.12.07l-11.46-6.24Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.23,270.22l.21-.13,11.46,6.24a.34.34,0,0,1,.08.09l-.21.13a.22.22,0,0,0-.09-.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.03 268.6 332.23 270.21 332.41 270.3 335.2 268.69 335.03 268.6",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.03 268.6 332.23 270.21 332.41 270.3 335.2 268.69 335.03 268.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.38,270.59a.19.19,0,0,0-.2,0l-.22.12.14,14a.64.64,0,0,0,.28.49l11,6.34V276.92Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.38,270.59a.19.19,0,0,0-.2,0l-.22.12.14,14a.64.64,0,0,0,.28.49l11,6.34V276.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.17,270.71c-.16-.09-.28,0-.28.16v14a.61.61,0,0,0,.28.49l11,6.34V277Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.17,270.71c-.16-.09-.28,0-.28.16v14a.61.61,0,0,0,.28.49l11,6.34V277Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.45,290.31l-8.12-4.69a.63.63,0,0,1-.29-.5V272.24l-1.06-.6,1.08-.63h0a.17.17,0,0,1,.24,0l9.31,5.38V291l-1.18.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.14,271.68c-.16-.09-.28,0-.28.16v14a.61.61,0,0,0,.28.49l9.31,5.38V277.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.44 277.05 341.63 276.37 341.63 290.99 340.45 291.68 340.44 277.05",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.06,277.45a.43.43,0,0,0,0-.11.34.34,0,0,0-.09-.14l0,0c-.09-.05-.15,0-.15.12a.44.44,0,0,0,0,.15.3.3,0,0,0,.12.13h0C340,277.6,340.06,277.56,340.06,277.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.7,278.16a.78.78,0,0,0,.34-.36.48.48,0,0,0,0-.45h0a.82.82,0,0,0-.3-.28l-.07,0v.19c.38.22.38.58,0,.81a1.59,1.59,0,0,1-1.41,0,.48.48,0,0,1-.28-.45.33.33,0,0,1,.11-.23.34.34,0,0,0-.09-.14.6.6,0,0,0-.16.23.53.53,0,0,0,0,.44.93.93,0,0,0,.3.29A1.74,1.74,0,0,0,341.7,278.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,278.45l-10.09-6.79.16-.09a.28.28,0,0,1,.28,0l9.86,6.76Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,278.45l-10.09-6.79.16-.09a.28.28,0,0,1,.28,0l9.86,6.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.49,271.68c-.15-.09-.28,0-.28.16v14a.64.64,0,0,0,.28.49l10.06,6.87V278.55Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.36 276.92 343.36 291.55 340.54 293.18 340.54 278.55 343.36 276.92",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.36 276.92 343.36 291.55 340.54 293.18 340.54 278.55 343.36 276.92",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.8,280.13a.57.57,0,0,0-.38-.26.82.82,0,0,0-.48.11,1.73,1.73,0,0,0-.78,1.37.84.84,0,0,0,.09.4.6.6,0,0,0,.86.14,1.7,1.7,0,0,0,.78-1.36.84.84,0,0,0-.09-.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,280.13c.38-.23.7-.05.7.4a1.57,1.57,0,0,1-.7,1.22c-.39.23-.71,0-.71-.4A1.55,1.55,0,0,1,342,280.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.89,283.15l.21-.12c.43-.24.77,0,.77.45v6.34a1.71,1.71,0,0,1-.77,1.34l-.21.12c-.43.24-.78,0-.78-.45v-6.34A1.72,1.72,0,0,1,341.89,283.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.19 276.82 340.38 278.44 340.54 278.55 343.36 276.92 343.19 276.82",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.19 276.82 340.38 278.44 340.54 278.55 343.36 276.92 343.19 276.82",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-26",
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M356.68,280.28c1.58.91,1.58,2.39,0,3.3a6.33,6.33,0,0,1-5.72,0c-1.58-.91-1.58-2.39,0-3.3A6.33,6.33,0,0,1,356.68,280.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.13,282.06c1.27-1.3,2-4.55.78-5.58h-6.33c-1.25,1-.5,4.28.78,5.58l0,0,.05,0,.11.1,0,0,.1.08.16.1a4.17,4.17,0,0,0,3.8,0h0l.17-.1.09-.07,0,0,.11-.1.05-.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.13,276.06c-1.45.83-1.45,2.19,0,3a5.8,5.8,0,0,0,5.23,0c1.44-.83,1.44-2.19,0-3A5.8,5.8,0,0,0,351.13,276.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.15,276.65a1,1,0,0,0,0,1.84,3.5,3.5,0,0,0,3.18,0,1,1,0,0,0,0-1.84A3.5,3.5,0,0,0,352.15,276.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.33,277.52a3.56,3.56,0,0,0-3.18,0,1.38,1.38,0,0,0-.52.49,1.44,1.44,0,0,0,.52.48,3.5,3.5,0,0,0,3.18,0,1.48,1.48,0,0,0,.53-.48A1.41,1.41,0,0,0,355.33,277.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.79,274.39a3,3,0,1,0-4.5,2.68.87.87,0,0,1,.44.77v.05a3.2,3.2,0,0,0,2,0v-.05a.91.91,0,0,1,.49-.79A3.06,3.06,0,0,0,356.79,274.39Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.88,271.74a.11.11,0,0,1-.07,0l-.13-.12a.09.09,0,0,1,0-.13.09.09,0,0,1,.13,0l.15.14a.1.1,0,0,1,0,.13A.11.11,0,0,1,353.88,271.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.4,277.16h0a.11.11,0,0,1,0-.13,2.57,2.57,0,0,1,.2-.35.09.09,0,0,1,.16.1,2.37,2.37,0,0,0-.19.34A.11.11,0,0,1,354.4,277.16Zm.55-1.05h0a.09.09,0,0,1-.06-.12,3.49,3.49,0,0,0,.1-.38.09.09,0,0,1,.11-.07.1.1,0,0,1,.07.12c0,.13-.06.26-.1.39A.1.1,0,0,1,355,276.11Zm.19-1.16h0a.11.11,0,0,1-.09-.1v-.39a.09.09,0,0,1,.09-.1h0a.11.11,0,0,1,.1.09v.4A.1.1,0,0,1,355.14,275Zm-.1-1.18a.1.1,0,0,1-.1-.08c0-.13-.06-.25-.1-.37a.09.09,0,1,1,.18-.06,3.64,3.64,0,0,1,.11.39.09.09,0,0,1-.07.11Zm-.44-1.1a.1.1,0,0,1-.08-.05,2.2,2.2,0,0,0-.21-.32.09.09,0,0,1,0-.13.09.09,0,0,1,.13,0,4,4,0,0,1,.22.34.1.1,0,0,1,0,.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.16,278.11a.09.09,0,0,1-.09-.08,1.07,1.07,0,0,1,0-.2.1.1,0,0,1,.09-.09h0a.1.1,0,0,1,.09.1.74.74,0,0,0,0,.17.1.1,0,0,1-.08.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.74,278.11a.09.09,0,0,1-.09-.09v-.19a.09.09,0,0,1,.09-.09.09.09,0,0,1,.1.09V278A.09.09,0,0,1,353.74,278.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.74,277.2a.09.09,0,0,1-.09-.09v-.36a.1.1,0,0,1,.09-.1.1.1,0,0,1,.1.1v.36A.09.09,0,0,1,353.74,277.2Zm0-1.08a.09.09,0,0,1-.09-.09v-.36a.1.1,0,0,1,.09-.1.1.1,0,0,1,.1.1V276A.09.09,0,0,1,353.74,276.12Zm0-1.08a.09.09,0,0,1-.09-.09v-.36a.1.1,0,0,1,.09-.1.1.1,0,0,1,.1.1V275A.09.09,0,0,1,353.74,275Zm0-1.08a.09.09,0,0,1-.09-.09v-.36a.1.1,0,0,1,.09-.1.1.1,0,0,1,.1.1v.36A.09.09,0,0,1,353.74,274Zm0-1.08a.09.09,0,0,1-.09-.09v-.36a.09.09,0,0,1,.09-.1.09.09,0,0,1,.1.1v.36A.09.09,0,0,1,353.74,272.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.74,271.8a.09.09,0,0,1-.09-.09v-.19a.1.1,0,0,1,.09-.1.1.1,0,0,1,.1.1v.19A.09.09,0,0,1,353.74,271.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.15,277.21a.09.09,0,0,1-.07,0,.09.09,0,0,1,0-.13,3,3,0,0,0,.22-.28.1.1,0,1,1,.16.12l-.23.28A.13.13,0,0,1,355.15,277.21Zm.61-.93h0a.09.09,0,0,1,0-.13c.05-.1.1-.22.15-.33a.09.09,0,0,1,.12-.06.09.09,0,0,1,.05.12l-.15.36A.11.11,0,0,1,355.76,276.28Zm.37-1.07h0a.09.09,0,0,1-.07-.11c0-.12,0-.24,0-.36a.11.11,0,0,1,.11-.09.09.09,0,0,1,.08.11,2.71,2.71,0,0,1-.06.38A.1.1,0,0,1,356.13,275.21Zm.07-1.12a.11.11,0,0,1-.1-.09c0-.12,0-.24-.05-.36a.08.08,0,0,1,.06-.11.09.09,0,0,1,.12.07,2.32,2.32,0,0,1,.06.38.09.09,0,0,1-.08.11Zm-.34-1.08a.1.1,0,0,1-.09,0,1.43,1.43,0,0,0-.2-.3.11.11,0,0,1,0-.14.09.09,0,0,1,.13,0l.22.32a.1.1,0,0,1,0,.13Zm-.74-.85a.07.07,0,0,1-.06,0l-.3-.21a.09.09,0,0,1,0-.13.11.11,0,0,1,.13,0l.32.23a.09.09,0,0,1,0,.13A.09.09,0,0,1,355.12,272.16Zm-1-.5s0,0,0,0a2.2,2.2,0,0,0-.36,0,.09.09,0,0,1-.09-.09.1.1,0,0,1,.09-.1,1.9,1.9,0,0,1,.4.05.09.09,0,0,1,.07.11A.09.09,0,0,1,354.12,271.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.61,271.74a.09.09,0,0,1-.07,0,.09.09,0,0,1,0-.13l.14-.14a.11.11,0,0,1,.14,0,.09.09,0,0,1,0,.13l-.13.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.08,277.16a.1.1,0,0,1-.08-.05l-.19-.34a.09.09,0,0,1,0-.13.11.11,0,0,1,.13,0l.2.35a.1.1,0,0,1-.05.13Zm-.54-1.05a.1.1,0,0,1-.09-.06c0-.13-.07-.26-.1-.4a.09.09,0,0,1,.07-.11.09.09,0,0,1,.11.07c0,.13.06.26.1.38a.09.09,0,0,1-.06.12Zm-.2-1.17a.09.09,0,0,1-.09-.09v-.4a.11.11,0,0,1,.1-.09h0a.1.1,0,0,1,.09.1v.39a.09.09,0,0,1-.09.09Zm.11-1.17h0a.09.09,0,0,1-.07-.11,2.85,2.85,0,0,1,.11-.39.09.09,0,0,1,.11-.06.11.11,0,0,1,.07.12c0,.12-.08.24-.11.37A.09.09,0,0,1,352.45,273.77Zm.43-1.1h0a.1.1,0,0,1,0-.13,4,4,0,0,1,.22-.34.09.09,0,1,1,.15.11,3.45,3.45,0,0,0-.2.32A.11.11,0,0,1,352.88,272.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.32,278.11h0a.09.09,0,0,1-.08-.1.74.74,0,0,0,0-.17.09.09,0,0,1,.08-.1c.06,0,.1,0,.11.09a1.11,1.11,0,0,1,0,.2A.1.1,0,0,1,353.32,278.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.34,277.21a.13.13,0,0,1-.07,0l-.23-.28a.11.11,0,0,1,0-.14.09.09,0,0,1,.13,0c.07.1.15.19.22.28a.09.09,0,0,1,0,.13A.07.07,0,0,1,352.34,277.21Zm-.61-.93a.11.11,0,0,1-.09,0,3.68,3.68,0,0,1-.15-.35.1.1,0,0,1,.05-.13.09.09,0,0,1,.12.06q.07.18.15.33a.1.1,0,0,1,0,.13Zm-.37-1.07a.08.08,0,0,1-.09-.07,2.71,2.71,0,0,1-.06-.38.09.09,0,0,1,.08-.11.09.09,0,0,1,.1.09l.06.36a.09.09,0,0,1-.07.11Zm-.07-1.12h0a.1.1,0,0,1-.09-.1c0-.13,0-.26.07-.38a.08.08,0,0,1,.11-.07.09.09,0,0,1,.07.11,2.25,2.25,0,0,0-.06.36A.09.09,0,0,1,351.29,274.09Zm.34-1.08h-.05a.09.09,0,0,1,0-.13,3.05,3.05,0,0,1,.22-.32.09.09,0,0,1,.13,0,.11.11,0,0,1,0,.14,2,2,0,0,0-.21.3S351.66,273,351.63,273Zm.74-.85a.11.11,0,0,1-.08,0,.11.11,0,0,1,0-.14,3.62,3.62,0,0,1,.32-.22.1.1,0,0,1,.13,0,.1.1,0,0,1,0,.13l-.3.21A.07.07,0,0,1,352.37,272.16Zm1-.5a.09.09,0,0,1-.09-.08.09.09,0,0,1,.07-.11,1.81,1.81,0,0,1,.39-.05.1.1,0,0,1,.1.1.09.09,0,0,1-.1.09,2.21,2.21,0,0,0-.35,0Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M357.27,245.38c-1.23.68-1.23,1.79,0,2.47a5.11,5.11,0,0,0,4.45,0c1.23-.68,1.23-1.79,0-2.47A5.11,5.11,0,0,0,357.27,245.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.41,241.35a6.5,6.5,0,0,0-3.93.1c-1.05.43-1,1.09,0,1.47a6.48,6.48,0,0,0,3.92-.1C362.53,242.38,362.52,241.73,361.41,241.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.25,240l-5.65.15.6,6.65h0c0,.24.26.47.7.65a5,5,0,0,0,3.39-.09c.44-.2.66-.44.69-.69h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.6,240.14l.12,1.35a2.15,2.15,0,0,0,.48.24,6.82,6.82,0,0,0,4.5-.11l.15-.07a2.7,2.7,0,0,0,.35-.21l.05-1.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.61,240.18l0-1-.65,0-.3-.13a6.87,6.87,0,0,0-4.5.12,1.71,1.71,0,0,0-.27.14l-.64,0,0,1h0c0,.34.32.66.94.9a6.88,6.88,0,0,0,4.5-.12C362.31,240.85,362.62,240.51,362.61,240.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.61,238.27a6.87,6.87,0,0,0-4.5.12c-1.2.53-1.18,1.35.05,1.83a6.88,6.88,0,0,0,4.5-.12C362.91,239.56,362.89,238.74,361.61,238.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,238.93h0l-.23-.83-1.62,0a6.58,6.58,0,0,0-1.6,0l-1.57,0-.18.85h0c-.09.3.15.62.75.84a5.89,5.89,0,0,0,3.71-.1C361.86,239.56,362.11,239.23,362,238.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.05,237.58a5.71,5.71,0,0,0-3.4.09c-.92.37-.91.93,0,1.26a5.72,5.72,0,0,0,3.4-.09C362,238.47,362,237.9,361.05,237.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,238.2s0,.06-.1.12a1.2,1.2,0,0,1-.39.21,5.26,5.26,0,0,1-3.17.09,1.54,1.54,0,0,1-.39-.19c-.08-.06-.1-.11-.1-.12s.08-.17.47-.33a4.41,4.41,0,0,1,1.57-.28,4.67,4.67,0,0,1,1.61.2C361.35,238,361.45,238.17,361.45,238.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35,238.32a1.2,1.2,0,0,1-.39.21,5.26,5.26,0,0,1-3.17.09,1.54,1.54,0,0,1-.39-.19,1.24,1.24,0,0,1,.38-.21,4.41,4.41,0,0,1,1.57-.28,4.58,4.58,0,0,1,1.6.2A1.55,1.55,0,0,1,361.35,238.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M360.39,238.37a.49.49,0,0,1,.38-.08c.07,0,0,.13-.12.22a.49.49,0,0,1-.38.08C360.2,238.55,360.26,238.45,360.39,238.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M356.93,244.64c0,.25.26.5.77.68a6.12,6.12,0,0,0,3.69-.1c.52-.2.77-.46.76-.71l.1-2.45c0,.27-.26.54-.81.76a6.48,6.48,0,0,1-3.92.1c-.54-.19-.81-.45-.82-.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.66,244.74a2.75,2.75,0,0,1-.24-.41,1.19,1.19,0,0,0-.65-.54.07.07,0,0,0-.1,0,.88.88,0,0,0,.26,1,.89.89,0,0,0,1,.21s0,0,0,0A.83.83,0,0,1,358.66,244.74Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,243.71a1.27,1.27,0,0,1,.41.23,1.17,1.17,0,0,1,.3.4,1.23,1.23,0,0,0,.38.47.07.07,0,0,0,.11,0,.83.83,0,0,0-.22-1,.86.86,0,0,0-1-.2A.08.08,0,0,0,357.92,243.71Z",
    style: {
      fill: "#0B1D51"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top-character--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.15,262.57c3.47-.71,6.17.79,6.63,4,.37,2.53-.39,7.17-1.26,11.29,0,0-2,.63-6-1.14Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.85 260.33 407.52 267.49 413.93 267.58 413.71 259.24 406.85 260.33",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.51,265.5c-1.89-3.5-6.71-2.92-6.71-2.92l0,.8c-.37,1.18-3.55,1.4-6.63.46l0-.29a37.42,37.42,0,0,0-5.25,1.62c-2.12,1.06-3.18,3.78-2.37,11.9.6,6-.5,14.33-2.47,18.05,2.93,4.26,10.73,4.2,14,3.77,6.82-.88,8.11-4.43,8.11-4.43s2.21-12.21,2.46-17.53C421.85,272.41,421.71,267.7,420.51,265.5Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.51,265.5c-1.89-3.5-6.71-2.92-6.71-2.92l0,.8c-.37,1.18-3.55,1.4-6.63.46l0-.29a37.42,37.42,0,0,0-5.25,1.62c-2.12,1.06-3.18,3.78-2.37,11.9.6,6-.5,14.33-2.47,18.05,2.93,4.26,10.73,4.2,14,3.77,6.82-.88,8.11-4.43,8.11-4.43s2.21-12.21,2.46-17.53C421.85,272.41,421.71,267.7,420.51,265.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M408.42,283.2c-2,5-2.57,6.92-5.78,15.29a24.51,24.51,0,0,0,8.42.4c6.82-.88,8.11-4.43,8.11-4.43s2.21-12.21,2.46-17.53c.05-1,.08-2,.09-2.93C415.41,275,410.28,278.63,408.42,283.2Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.67,251.33s-1.83,2.44-1.66,2.7,1.39.57,1.39.57Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.77,244.6c-3.43.5-4.51,1.92-5.17,7.29-.69,5.61-.23,7.41.46,8.22.47.54,3.24.81,4.66.51,1.78-.37,5.83-1.52,7.86-4.23,2.39-3.2,3.25-7.67,1-9.67C413.5,243.9,409.17,244.39,407.77,244.6Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,260.11c.39.44,2.35.71,3.82.61l0-.74s-1.62.25-2.45.3a3.14,3.14,0,0,1-1.36-.19Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.18,246.58h0a7.69,7.69,0,0,0,3.21,1.24,6.81,6.81,0,0,0,.38,2.71c.17.61.8,2.54,1.61,1.53.59-.73,1.13-1.4,2.19-1.17,1.75.38,1.84,2.64.64,3.94s-2.2.7-2.2.7-.14,3,1.07,4.75a9.06,9.06,0,0,0,4.27.17c1.71-.26,4.25-2.22,5.4-4.4,2.43-4.61,2.85-8.87-.1-10.34-.19-2.21-1.85-3.3-3.78-3.88-2.68-.79-5.56.79-8.14-.44-.54-.26-1-.61-1.59-.84a1.07,1.07,0,0,0-1,0,1.14,1.14,0,0,0-.45.72,2.08,2.08,0,0,0,0,1.57,4.55,4.55,0,0,0-1.21-.5,1.55,1.55,0,0,0-1.26.23,1.59,1.59,0,0,0-.54,1.06A3.36,3.36,0,0,0,402.18,246.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.06,314c1.77-.09,3.16-1.4,7.38-3.15,7.78-3.25,13.62-5.84,15.85-9.92s3.8-22.37,3.24-27.47a6.32,6.32,0,0,0-.38-1.69l.55-.08-1.42-1.21h0c-1.45-1.19-3.82-.13-5.61.84-5.09,2.78-9.08,5.47-12.23,15.21-2.38,7.32-3.94,20.52-7.21,24.09",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.15,271.8l.55-.08-1.42-1.21h0c-1.45-1.19-3.82-.13-5.61.84-5.09,2.78-9.08,5.47-12.23,15.21-2.38,7.32-3.94,20.52-7.21,24.09l-.17,3.38c1.77-.09,3.16-1.4,7.38-3.15,7.78-3.25,13.62-5.84,15.85-9.92s3.8-22.37,3.24-27.47A6.32,6.32,0,0,0,425.15,271.8Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,272c-5.09,2.77-9.88,5.81-12.59,15.79s-4.39,24.87-10.6,26.53c0,0,2.8,1.12,11.41-2.52a90.57,90.57,0,0,0,8.25-4.5c4.27-2.4,6.87-4.36,7.28-5.1,2.26-4.06,3.8-22.37,3.24-27.47S422.58,270.62,420,272Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,272c-5.09,2.77-9.88,5.81-12.59,15.79s-4.39,24.87-10.6,26.53c0,0,2.8,1.12,11.41-2.52a90.57,90.57,0,0,0,8.25-4.5c4.27-2.4,6.87-4.36,7.28-5.1,2.26-4.06,3.8-22.37,3.24-27.47S422.58,270.62,420,272Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389.18,261.79c.24-.29.67-.29,1-.36a20.24,20.24,0,0,0,1.95-.77,3.55,3.55,0,0,1,2.27.19,4.84,4.84,0,0,1,.72.36,9.72,9.72,0,0,1,1.25.88c1.63,1.33,2.62,3.94,4.22,5.31.59.51,1.15,1,1.7,1.43L397.55,272a25.5,25.5,0,0,0-1.84-1.9,8.22,8.22,0,0,0-3.13-1.29,17.54,17.54,0,0,1-2.29-.95c-.26-.13-.55-.29-.63-.57a.7.7,0,0,1,.58-.79,6.64,6.64,0,0,1,1.26,0c.31,0,1.1.3,1.32,0s0-.36-.06-.52a5.65,5.65,0,0,0-2.5-2.59,2.55,2.55,0,0,1-1-.56A.82.82,0,0,1,389.18,261.79Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53,274.72a10.9,10.9,0,0,0,.89,1.25c1.34,1.63,3,2.57,4.94,4.25,1.53,1.36,3.9,3.36,5.9,5.07a33.61,33.61,0,0,0,6.61,4.35c2,.91,3.1,1.11,4.8-2,.84-1.52,1.56-3.1,2.32-4.66q1.69-3.48,3.36-7s3.73-6.31-1.85-10.6c-2.89,1.12-4,1.58-5.3,4.63-1.57,3.66-4.31,10.92-4.31,10.92a52.45,52.45,0,0,1-5.9-3.63,6.35,6.35,0,0,1-2.08-1.68,11.2,11.2,0,0,1-.74-1.66c-.19-.5-.3-1-.52-1.53a12.32,12.32,0,0,0-1.67-2.51.86.86,0,0,0-.44-.36.54.54,0,0,0-.54.23c-.28.35-.13.77-.07,1.19l.18,1.42a12,12,0,0,1-3.34-4.23,1.67,1.67,0,0,0-.25-.43.61.61,0,0,0-.42-.24c-.42,0-.92.59-1,1a6.29,6.29,0,0,1-.2,1.15c-.15.34-.43.59-.59.92a5.64,5.64,0,0,0-.4,1.06,3.83,3.83,0,0,0,.27,2.4A6.67,6.67,0,0,0,374.53,274.72Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,265.17c-2.46.59-4.3,1.4-5.89,4.79s-3.6,8.9-3.6,8.9-.2,1.18,2.37,3.27a7,7,0,0,0,5.35,1.56l3.16-6.53S408.44,268.58,401.9,265.17Z",
    style: {
      fill: "#0B1D51"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M254.3,299.26c-4.14,2.39-4.14,6.26,0,8.65a16.54,16.54,0,0,0,15,0c4.14-2.39,4.14-6.26,0-8.65A16.54,16.54,0,0,0,254.3,299.26Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.83,303.44c-3.73-3.8-5.92-15.14-2.29-18.16H271c3.63,3,1.45,14.35-2.28,18.16a.94.94,0,0,1-.1.1l-.13.13-.33.3-.09.07-.28.21a5,5,0,0,1-.49.31,12.27,12.27,0,0,1-11.1,0h0c-.16-.09-.32-.2-.48-.31a2.69,2.69,0,0,1-.27-.2l-.11-.08-.32-.29-.15-.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.43,284.06c4.22,2.44,4.22,6.39,0,8.83a16.92,16.92,0,0,1-15.28,0c-4.22-2.44-4.22-6.39,0-8.83A16.92,16.92,0,0,1,269.43,284.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4,285.24c3.1,1.79,3.1,4.69,0,6.48a12.39,12.39,0,0,1-11.22,0c-3.1-1.79-3.1-4.69,0-6.48A12.39,12.39,0,0,1,267.4,285.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.18,288.31a12.39,12.39,0,0,1,11.22,0,5.09,5.09,0,0,1,1.86,1.7,5.11,5.11,0,0,1-1.86,1.71,12.39,12.39,0,0,1-11.22,0,5.28,5.28,0,0,1-1.86-1.71A5.26,5.26,0,0,1,256.18,288.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.64,280.75c.55-.83,1.37-1.47,1.86-2.33,1.05-1.8-.2-3.57.32-5.41a3,3,0,0,1,1.66-1.78,8.72,8.72,0,0,1,2.42-.63,3.78,3.78,0,0,0,1.28-.37c.47-.26.62-.74.92-1.15a7.71,7.71,0,0,1,1.17-1.25,4.6,4.6,0,0,1,3.17-1.37c2.52.11,2.44,2.28,1.72,3.92s-.92,2.17.65,3.88,1.58,3.82-.3,5-3.09,1.34-2.35,3.61c.66,2,1.07,3.76-.8,5.93a6.1,6.1,0,0,1-4.94,2.31A8.12,8.12,0,0,1,258,284.3a5,5,0,0,1,.56-3.42Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.64,280.75c.55-.83,1.37-1.47,1.86-2.33,1.05-1.8-.2-3.57.32-5.41a3,3,0,0,1,1.66-1.78,8.72,8.72,0,0,1,2.42-.63,3.78,3.78,0,0,0,1.28-.37c.47-.26.62-.74.92-1.15a7.71,7.71,0,0,1,1.17-1.25,4.6,4.6,0,0,1,3.17-1.37c2.52.11,2.44,2.28,1.72,3.92s-.92,2.17.65,3.88,1.58,3.82-.3,5-3.09,1.34-2.35,3.61c.66,2,1.07,3.76-.8,5.93a6.1,6.1,0,0,1-4.94,2.31A8.12,8.12,0,0,1,258,284.3a5,5,0,0,1,.56-3.42Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.46,276.27a.18.18,0,0,0-.22-.13,29.91,29.91,0,0,0-5.87,2.22,26.78,26.78,0,0,1,4.62-7.92.19.19,0,0,0,0-.27.18.18,0,0,0-.26,0,26,26,0,0,0-4,6.47,14.44,14.44,0,0,0-1.9-3.08.18.18,0,0,0-.28.24,14.31,14.31,0,0,1,2,3.31c-.21.49-.43,1-.63,1.56a.19.19,0,0,0-.05.13,32.38,32.38,0,0,0-2,11.55.19.19,0,0,0,.18.19h.06a.19.19,0,0,0,.13-.18,32,32,0,0,1,2-11.44,28.54,28.54,0,0,1,6.17-2.42A.19.19,0,0,0,271.46,276.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,291.47a10.12,10.12,0,0,1-1.09.4,12.2,12.2,0,0,1-4.81-.05,6.08,6.08,0,0,1-3.32-1.19,1.42,1.42,0,0,1-.39-1.53c.25-.54,1-.86,1-1.46-1.17-.38-2.55-.08-3.6-.73a4.3,4.3,0,0,1-1.63-2.12,2.39,2.39,0,0,1-.08-1.74c.29-.58,1-.72,1.68-.81a1.34,1.34,0,0,0,.49-.15.44.44,0,0,0,.22-.43c-.05-.21-.27-.31-.47-.38-.43-.14-.88-.22-1.3-.38a2,2,0,0,1-1-.8,2.71,2.71,0,0,1-.2-1.57,24.88,24.88,0,0,1,.38-2.71,17,17,0,0,0,.22-2.34,16.39,16.39,0,0,1,6.83.15c1.24.26,3,.84,3.57,2.12a2.3,2.3,0,0,1,.14,1.16,3.13,3.13,0,0,1-.12.53c0,.11-.13.54.13.34a.55.55,0,0,0,.13-.17l.87-1.74a1.11,1.11,0,0,1,.34-.46c.35-.21,1.28,0,2.27.74a3.79,3.79,0,0,1,1.22,2.15,10.43,10.43,0,0,1-.15,4l.84-1.18c1-1.37,1.6,1.14,1.64,1.68a11.89,11.89,0,0,1-.78,5A8.16,8.16,0,0,1,262.1,291.47Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.1,291.47a10.12,10.12,0,0,1-1.09.4,12.2,12.2,0,0,1-4.81-.05,6.08,6.08,0,0,1-3.32-1.19,1.42,1.42,0,0,1-.39-1.53c.25-.54,1-.86,1-1.46-1.17-.38-2.55-.08-3.6-.73a4.3,4.3,0,0,1-1.63-2.12,2.39,2.39,0,0,1-.08-1.74c.29-.58,1-.72,1.68-.81a1.34,1.34,0,0,0,.49-.15.44.44,0,0,0,.22-.43c-.05-.21-.27-.31-.47-.38-.43-.14-.88-.22-1.3-.38a2,2,0,0,1-1-.8,2.71,2.71,0,0,1-.2-1.57,24.88,24.88,0,0,1,.38-2.71,17,17,0,0,0,.22-2.34,16.39,16.39,0,0,1,6.83.15c1.24.26,3,.84,3.57,2.12a2.3,2.3,0,0,1,.14,1.16,3.13,3.13,0,0,1-.12.53c0,.11-.13.54.13.34a.55.55,0,0,0,.13-.17l.87-1.74a1.11,1.11,0,0,1,.34-.46c.35-.21,1.28,0,2.27.74a3.79,3.79,0,0,1,1.22,2.15,10.43,10.43,0,0,1-.15,4l.84-1.18c1-1.37,1.6,1.14,1.64,1.68a11.89,11.89,0,0,1-.78,5A8.16,8.16,0,0,1,262.1,291.47Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.47,285a15,15,0,0,1,1.68-6.35l0-.05a.17.17,0,1,0-.31-.15l0,.05a15.74,15.74,0,0,0-1.68,6c-2.69-4.53-6.64-8.84-8.71-10a.18.18,0,0,0-.25.07.19.19,0,0,0,.07.25c2,1.11,6,5.37,8.6,9.84a10.42,10.42,0,0,0-6.76-.45.17.17,0,0,0-.11.21.19.19,0,0,0,.14.12h.08a10,10,0,0,1,6.94.63,18.71,18.71,0,0,1,2.39,6.15.19.19,0,0,0,.12.15h.08a.2.2,0,0,0,.16-.21A19,19,0,0,0,259.47,285Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440,259.79l8.95-5.16a5.42,5.42,0,0,1,4.93,0l8.95,5.16a5.46,5.46,0,0,1,2.46,4.27v42.56l-13.88,8-13.87-8V264.06A5.46,5.46,0,0,1,440,259.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.4,272.08a5.43,5.43,0,0,0-2.46-4.27L440,262.64c-1.36-.79-2.46-.15-2.46,1.42v42.56l13.87,8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.28,264.06v42.56l-13.88,8V272.08a5.25,5.25,0,0,0-1-2.87l13.87-8A5.26,5.26,0,0,1,465.28,264.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.68 269.96 450.25 276.64 450.25 292.01 438.68 285.33 438.68 269.96",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.68 269.96 450.25 276.64 450.25 292.01 438.68 285.33 438.68 269.96",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.88 283.49 441.88 271.8 450.25 276.64 450.25 288.33 441.88 283.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.88 283.49 438.68 285.33 450.25 292.01 450.25 288.33 441.88 283.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.38,270.94l.43,2,.46.26a1.42,1.42,0,0,0,1.41,0l.09-.05.18-.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,274.17l.43,2.07.46.26a1.42,1.42,0,0,0,1.41,0l.09-.05.18-.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.05,256.05c0-1.54-1.16-3.09-3.19-4.26a18.87,18.87,0,0,0-16.91,0c-2,1.17-3.18,2.72-3.18,4.26v1.89c0,1.54,1.16,3.09,3.18,4.25a18.79,18.79,0,0,0,16.91,0c2-1.16,3.19-2.71,3.19-4.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.41,262.31a17.51,17.51,0,0,1-8.46-2c-2-1.17-3.18-2.72-3.18-4.25s1.16-3.09,3.18-4.26a18.87,18.87,0,0,1,16.91,0c2,1.17,3.19,2.72,3.19,4.26s-1.16,3.08-3.19,4.25A17.5,17.5,0,0,1,451.41,262.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.09,253.45V228.86c.25-2.05-1-4.15-3.68-5.71-5-2.87-13-2.87-18,0-2.49,1.44-3.73,3.32-3.73,5.21h0v26.18h.05c.23,1.68,1.45,3.33,3.68,4.62,5,2.87,13,2.87,18,0,2.23-1.29,3.45-2.94,3.68-4.62h0v-.07A4.35,4.35,0,0,0,464.09,253.45Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.41,259.67a16.6,16.6,0,0,1-8.18-1.93c-1.69-1-2.71-2.19-2.88-3.42l0-.24V237.14c0-1.34,1.05-2.72,2.91-3.79a18.22,18.22,0,0,1,16.36,0c2,1.15,3.06,2.65,2.88,4.09v16.2a2.29,2.29,0,0,1,0,.64v.11a5.29,5.29,0,0,1-2.87,3.35A16.6,16.6,0,0,1,451.41,259.67Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.59,233.35a17.11,17.11,0,0,0-8.18-1.94,19.3,19.3,0,0,0-8.18,1.94,4.34,4.34,0,0,0,0,8.19,19.3,19.3,0,0,0,8.18,1.94,16.6,16.6,0,0,0,8.18-1.94c2-1.15,2.88-2.59,2.88-4.1S461.65,234.48,459.59,233.35Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.41,234.6a17.51,17.51,0,0,1-8.46-2c-2-1.17-3.18-2.72-3.18-4.26s1.16-3.08,3.18-4.25a18.79,18.79,0,0,1,16.91,0c2,1.17,3.19,2.72,3.19,4.25s-1.16,3.09-3.19,4.26A17.5,17.5,0,0,1,451.41,234.6Z",
    style: {
      fill: "#0B1D51",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,270.05l-.49.28,0,.05a.63.63,0,0,0-.09.35,1.67,1.67,0,0,0,.76,1.32.58.58,0,0,0,.36.1l0,.05.5-.29h0a.55.55,0,0,0,.22-.49,1.67,1.67,0,0,0-.76-1.32A.54.54,0,0,0,447,270.05Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,270.05l-.49.28,0,.05a.63.63,0,0,0-.09.35,1.67,1.67,0,0,0,.76,1.32.58.58,0,0,0,.36.1l0,.05.5-.29h0a.55.55,0,0,0,.22-.49,1.67,1.67,0,0,0-.76-1.32A.54.54,0,0,0,447,270.05Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.78,271.7c0,.49-.35.69-.77.44a1.67,1.67,0,0,1-.76-1.31c0-.49.34-.69.76-.44A1.68,1.68,0,0,1,447.78,271.7Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.37,266.85l-.49.29,0,0a.74.74,0,0,0-.08.36,1.71,1.71,0,0,0,.76,1.32.75.75,0,0,0,.35.1l0,0,.49-.28h0a.53.53,0,0,0,.22-.5,1.67,1.67,0,0,0-.76-1.31A.52.52,0,0,0,441.37,266.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.18,268.51c0,.48-.34.68-.76.44a1.67,1.67,0,0,1-.76-1.32c0-.48.34-.68.76-.44A1.67,1.67,0,0,1,442.18,268.51Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--office-1--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boss--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.72,319.18a2.48,2.48,0,0,1,1.46-2l101.34-58.54a7.77,7.77,0,0,1,7,0l76.23,44a2.47,2.47,0,0,1,1.46,2v64.61a2.47,2.47,0,0,1-1.46,2L113.44,429.85a7.77,7.77,0,0,1-7,0l-76.23-44a2.48,2.48,0,0,1-1.46-2Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,257.77a7.17,7.17,0,0,1,3.51.84l76.23,44a2.47,2.47,0,0,1,1.46,2v64.61a2.47,2.47,0,0,1-1.46,2L113.44,429.85a7.11,7.11,0,0,1-3.5.84V363.33Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,257.77a7.17,7.17,0,0,0-3.51.84L30.19,317.15a2.47,2.47,0,0,0-1.45,2V383.8a2.47,2.47,0,0,0,1.45,2l76.24,44a7.17,7.17,0,0,0,3.51.84V363.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.41,365.24l-76.23-44c-1.94-1.12-1.94-2.94,0-4.06l101.34-58.54a7.77,7.77,0,0,1,7,0l76.23,44c1.95,1.12,1.95,2.94,0,4.06L113.44,365.24A7.77,7.77,0,0,1,106.41,365.24Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.41,365.24l-76.23-44c-1.94-1.12-1.94-2.94,0-4.06l101.34-58.54a7.77,7.77,0,0,1,7,0l76.23,44c1.95,1.12,1.95,2.94,0,4.06L113.44,365.24A7.77,7.77,0,0,1,106.41,365.24Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M115.48,352.77l-39.88-23c-.47-.28-.48-.72,0-1l65.52-38a1.87,1.87,0,0,1,1.72,0l39.88,23a.52.52,0,0,1,0,1l-65.52,38A1.87,1.87,0,0,1,115.48,352.77Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M73.86,326.87l-26.1-15c-.47-.28-.48-.73,0-1L81.2,291.46a1.9,1.9,0,0,1,1.72,0l26.1,15c.48.28.48.73,0,1L75.58,326.86A1.9,1.9,0,0,1,73.86,326.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--boss--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7,317.32a2.38,2.38,0,0,0,0,.49,1.17,1.17,0,0,0,.44.69h0a1.27,1.27,0,0,0,1.35-.11,4.12,4.12,0,0,0,1.87-3.23A1.31,1.31,0,0,0,65.9,314h0l-.09-.05h0a1.11,1.11,0,0,0-.79,0,2,2,0,0,0-.46.2A4.11,4.11,0,0,0,62.7,317.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,313.31a1.68,1.68,0,0,1,.83-.25.93.93,0,0,1,.52.15l0,0,1.2.7a1.11,1.11,0,0,0-.79,0,2,2,0,0,0-.46.2,4.11,4.11,0,0,0-1.86,3.22,2.38,2.38,0,0,0,0,.49,1.17,1.17,0,0,0,.44.69L62,317.78h0l-.1-.06,0,0a1.36,1.36,0,0,1-.46-1.15A4.13,4.13,0,0,1,63.21,313.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.89,306.47a2.46,2.46,0,0,0,0,.49,1.12,1.12,0,0,0,.44.68h0a1.29,1.29,0,0,0,1.35-.1,4.14,4.14,0,0,0,1.87-3.24,1.31,1.31,0,0,0-.53-1.18h0l-.09-.05h0a1.17,1.17,0,0,0-.79,0,2,2,0,0,0-.46.2A4.11,4.11,0,0,0,82.89,306.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,302.46a1.7,1.7,0,0,1,.83-.26,1,1,0,0,1,.52.15l0,0,1.2.69a1.17,1.17,0,0,0-.79,0,2,2,0,0,0-.46.2,4.11,4.11,0,0,0-1.86,3.23,2.46,2.46,0,0,0,0,.49,1.12,1.12,0,0,0,.44.68l-1.23-.72h0l-.1-.06,0,0a1.36,1.36,0,0,1-.46-1.15A4.12,4.12,0,0,1,83.4,302.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.29,321.56a2.43,2.43,0,0,1-.06.49,1.17,1.17,0,0,1-.44.69h0a1.29,1.29,0,0,1-1.36-.11,4.12,4.12,0,0,1-1.87-3.23,1.34,1.34,0,0,1,.53-1.19h0l.09-.05h0a1.11,1.11,0,0,1,.79,0,2,2,0,0,1,.46.2A4.1,4.1,0,0,1,79.29,321.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.78,317.55a1.71,1.71,0,0,0-.84-.25.93.93,0,0,0-.52.15l0,0-1.2.7a1.11,1.11,0,0,1,.79,0,2,2,0,0,1,.46.2,4.1,4.1,0,0,1,1.87,3.22,2.43,2.43,0,0,1-.06.49,1.17,1.17,0,0,1-.44.69L80,322h0l.1-.06,0,0a1.36,1.36,0,0,0,.46-1.15A4.12,4.12,0,0,0,78.78,317.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.39,315.14a2.38,2.38,0,0,1,0,.49,1.17,1.17,0,0,1-.44.69h0a1.29,1.29,0,0,1-1.36-.11A4.11,4.11,0,0,1,88.66,313a1.31,1.31,0,0,1,.52-1.18h0l.09-.05h0a1.14,1.14,0,0,1,.8,0,2,2,0,0,1,.45.2A4.09,4.09,0,0,1,92.39,315.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88,311.13a1.68,1.68,0,0,0-.83-.25,1,1,0,0,0-.53.15l0,0-1.21.7a1.14,1.14,0,0,1,.8,0,2,2,0,0,1,.45.2,4.09,4.09,0,0,1,1.87,3.22,2.38,2.38,0,0,1,0,.49,1.17,1.17,0,0,1-.44.69l1.23-.72h0l.11-.06,0,0a1.39,1.39,0,0,0,.46-1.15A4.13,4.13,0,0,0,91.88,311.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.06,307.27a2.46,2.46,0,0,1,0,.49,1.13,1.13,0,0,1-.45.68h0a1.31,1.31,0,0,1-1.36-.1,4.13,4.13,0,0,1-1.86-3.24,1.33,1.33,0,0,1,.52-1.18h0l.09-.06h0a1.17,1.17,0,0,1,.79,0,2,2,0,0,1,.46.2A4.13,4.13,0,0,1,67.06,307.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.55,303.26a1.7,1.7,0,0,0-.83-.25,1,1,0,0,0-.53.14l0,0-1.2.69a1.17,1.17,0,0,1,.79,0,2,2,0,0,1,.46.2,4.13,4.13,0,0,1,1.87,3.23,2.46,2.46,0,0,1,0,.49,1.13,1.13,0,0,1-.45.68l1.24-.71h0l.11-.07,0,0a1.38,1.38,0,0,0,.45-1.14A4.11,4.11,0,0,0,66.55,303.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.2 303.32 84.86 301.42 84.86 302.84 78.2 306.68 78.2 303.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.2 303.32 77.54 302.92 84.22 301.1 84.86 301.42 78.2 303.32",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.32 307.57 65.87 304.03 65.87 302.59 75.32 303.44 75.32 307.57",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.87 302.59 66.56 302.41 75.88 303.01 75.32 303.44 65.87 302.59",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.06,307.12c0,1.07,3.29,1.07,3.29,0v-9.34H75.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.53,304.69l1.8,11.73H78.1l-1.69-11.73A2.12,2.12,0,0,0,77.53,304.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.41 304.69 76.41 307.91 78.1 318.4 78.1 316.42 76.41 304.69",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1,
    y: 316.42,
    width: 1.24,
    height: 1.99,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.84 307.81 63.66 314.2 63.66 312.23 75.84 304.69 75.84 307.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,304.7a1.4,1.4,0,0,1-.79-.36L62.9,311.72l.76.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.66 314.2 63.66 312.23 62.9 311.72 62.9 313.62 63.66 314.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.2 311.94 78.19 307.49 78.19 304.56 91.2 309.98 91.2 311.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19,304.56c.11,0,.15-.21.16-.5l13.24,5.76-.39.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.59 309.82 91.59 311.72 91.2 311.94 91.2 309.98 91.59 309.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1,
    y: 316.42,
    width: 1.24,
    height: 1.99,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.66 314.2 63.66 312.23 62.9 311.72 62.9 313.62 63.66 314.2",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.59 309.82 91.59 311.72 91.2 311.94 91.2 309.98 91.59 309.82",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.49,281.5H73.92v19.27c0,1.6,5.57,1.6,5.57,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,278.83,78.3,267.69a22.33,22.33,0,0,0-3.56-15.24s1.5-14.16-1-18.88c-1.84-3.59-4-3.1-4-3.1L45.45,241.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.67,230.47,45.45,241.4l.8,2.59,26.48-12C71.17,230.14,69.67,230.47,69.67,230.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,253.13c0,.38.37.52.72.32a1.15,1.15,0,0,0,.55-1c0-.37-.38-.51-.73-.31A1.14,1.14,0,0,0,69.76,253.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.06,255.27a.45.45,0,0,0,.73.31,1.14,1.14,0,0,0,.54-1.05c0-.37-.37-.51-.72-.31A1.15,1.15,0,0,0,66.06,255.27Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.37,257.4c.05.37.38.51.73.31a1.14,1.14,0,0,0,.54-1c0-.38-.37-.52-.72-.32A1.15,1.15,0,0,0,62.37,257.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.68,259.53c0,.38.38.52.73.31a1.14,1.14,0,0,0,.54-1,.45.45,0,0,0-.73-.32A1.15,1.15,0,0,0,58.68,259.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.66,276.78V278a4.27,4.27,0,0,1-2.07,3.44L76.82,293.86a4.74,4.74,0,0,1-4.11-.08L59,285.87a4.51,4.51,0,0,1-2-3.52v-1.17a4.24,4.24,0,0,1,2.08-3.43L81.55,266a5.13,5.13,0,0,1,4.17,0l14.85,7.43A4.15,4.15,0,0,1,102.66,276.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.82,288l23.77-12.48c1.14-.6,1.13-1.55,0-2.13L85.72,266a5.13,5.13,0,0,0-4.17,0l-22.5,11.75c-1.15.6-1.17,1.61,0,2.25l13.71,7.92A4.74,4.74,0,0,0,76.82,288Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,294.27a4.59,4.59,0,0,1-2.58-.49L59,285.87a4.48,4.48,0,0,1-2-3.52v-1.18a4.27,4.27,0,0,1,1.78-3.24c-.85.6-.77,1.49.24,2.07l13.71,7.92a4.47,4.47,0,0,0,2.1.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.67,230.47a7.12,7.12,0,0,1,7.19-.24c3.7,2.14,2.48,9.31,2.08,13.94s-.52,12.68,2.72,15.61,13.84-1,18.46-1l-4.08,15a69.65,69.65,0,0,0-17.74-6.17s.19-9.37-4.11-14.73c0,0,1.59-3.75.55-11.27C73.78,234.73,72.48,232.1,69.67,230.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M69.67,230.47a7.12,7.12,0,0,1,7.19-.24c3.7,2.14,2.48,9.31,2.08,13.94s-.52,12.68,2.72,15.61,13.84-1,18.46-1l-4.08,15a69.65,69.65,0,0,0-17.74-6.17s.19-9.37-4.11-14.73c0,0,1.59-3.75.55-11.27C73.78,234.73,72.48,232.1,69.67,230.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96,273.86c-.2-1.34-1.06-9.09.39-12.46,1.25-2.93,4.55-3.1,5.58-1.84s.11,2.77-1.53,4.93c-1.4,1.81-1.9,3.51-1.9,7.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,273.86c-.2-1.34-1.06-9.09.39-12.46,1.25-2.93,4.55-3.1,5.58-1.84s.11,2.77-1.53,4.93c-1.4,1.81-1.9,3.51-1.9,7.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--legs--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.83,304.79c-.3-4.06,2.47-14.57,2.47-14.57l-7.52-4.43s-.34,2.57-.77,6a15.3,15.3,0,0,1-1.19,4.86s-1.39,1.78-1.35,2.95,1.07,3.83,1.68,5.89a20.23,20.23,0,0,0,2.25,5.61c1.21,1.92,6.59,3.42,6.29,1.41C104.27,309.73,103.17,308.11,102.83,304.79Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.82,296.67c-.44,0-.94.75-1.31,1.31s-1.29,1-1.11,2.4,1.44,2.46,1.67,4.39.34,5.25,3.18,7.58,5.81,2.52,6.89,1.88a1.38,1.38,0,0,0,.66-.85,1.08,1.08,0,0,0-.17-.9c-.33-.71-.64-1.43-.92-2.17a30.13,30.13,0,0,1-1.44-4.62c-.2-1-.25-2-.51-2.13a4,4,0,0,0-2.1-.67,4.28,4.28,0,0,0-1.9,0c-.23.14-.16.46-.18.7s0,.65-.08,1a.59.59,0,0,1,0,.22.19.19,0,0,1-.18.1.27.27,0,0,1-.16-.17,19.78,19.78,0,0,1-1-3.55,12.23,12.23,0,0,0-.75-2.13c-.19-.44-.49-1.07-.63-1.47a1,1,0,0,1,0-.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,305.51a75.86,75.86,0,0,0,3.66,7.65,24.68,24.68,0,0,0,5,5.78c.46.37,1.46,1,1.82,1.33a.69.69,0,0,1,.12,1.06c-.64.87-3.88,1.61-5.94.56s-4.31-3.35-5.6-4.26c-.64-.45-1.24-.89-1.69-1.22s-.4-.5-.35-1l-.22-.84c-.34-1.72-2.94-5.51-2.94-5.51Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.77,314.54c-.38.24-.36,1.16-.34,1.83s-.5,1.54.44,2.61,2.59,1.21,3.88,2.67,3.25,4.13,6.9,4.44,6.22-1.22,6.75-2.36a1.45,1.45,0,0,0,.07-1.08c-.13-.36-.34-.45-.66-.64-.68-.4-1.34-.82-2-1.27a28.9,28.9,0,0,1-3.8-3c-.75-.73-1.32-1.48-1.63-1.47a4,4,0,0,0-2.11.65,4.28,4.28,0,0,0-1.57,1.07c-.11.24.13.46.25.67l.49.86a.7.7,0,0,1,.08.2.17.17,0,0,1-.09.19.28.28,0,0,1-.23-.05,19.36,19.36,0,0,1-2.86-2.34,10,10,0,0,0-1.63-1.26c-.41-.25-.94-.52-1.35-.78s-.42-.27-.46-.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,295.9c.34-2.82.85-7.14,1.15-10,.48-4.59.72-9.36-.21-11.37s-5-4.2-9.41-6.55S85,262,85,262l-22.2,4.66c.71,3.86,1,5.75,3.15,9.12s4.81,5.26,10.12,7.68c4.77,2.18,10.4,4.48,11.65,5,1.58.7,3,1.23,3.88,3.59a41.42,41.42,0,0,0,5,10.82l6.78,10s5.32.31,8-4C111.39,308.86,108.62,302.57,105.62,295.9Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,295.9c.34-2.82.85-7.14,1.15-10,.48-4.59.72-9.36-.21-11.37s-5-4.2-9.41-6.55S85,262,85,262l-22.2,4.66c.71,3.86,1,5.75,3.15,9.12s4.81,5.26,10.12,7.68c4.77,2.18,10.4,4.48,11.65,5,1.58.7,3,1.23,3.88,3.59a41.42,41.42,0,0,0,5,10.82l6.78,10s5.32.31,8-4C111.39,308.86,108.62,302.57,105.62,295.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.92,294.32c-2.81-6.25-5.64-12.44-6.42-13.75-1.64-2.79-14.74-10.08-15.15-10.31h0l.54-.89a8.42,8.42,0,0,0,1-3.38,9,9,0,0,1-.34,3.79c2,1.17,7.15,4.15,9.2,5.42,2.59,1.61,5.36,3.57,6.62,6.51C101.34,283.89,103.74,290.86,104.92,294.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.91,310.82l1.31,2.17s6.38.61,8.34-4.12l-1-2.16C109.66,309.37,105,311.31,101.91,310.82Z",
    style: {
      fill: "#0B1D51"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.17,236.73c5-.45,6.21,1.57,7.42,3.57,2,3.38,5.87,14.16,5.87,14.16L101.94,261l-2.53,4.71s-13.58-4-15.47-4.84a4.62,4.62,0,0,1-2.68-2.46c-1.73-3.16-4.48-9.16-4.48-9.16Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.17,236.64a8,8,0,0,1,5.18.86c1.54,1,2.16,2.13,4,5.81s4.27,11.06,4.27,11.06l3,1.47c-1.25.53-3.5,4.53-3,6.3l-4.48-1.41c-1.21-.37-1.51-1.19-2.49-3s-4.11-8.62-4.11-8.62S73.6,236.87,74.17,236.64Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.17,236.64a8,8,0,0,1,5.18.86c1.54,1,2.16,2.13,4,5.81s4.27,11.06,4.27,11.06l3,1.47c-1.25.53-3.5,4.53-3,6.3l-4.48-1.41c-1.21-.37-1.51-1.19-2.49-3s-4.11-8.62-4.11-8.62S73.6,236.87,74.17,236.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.61,254.37a6.69,6.69,0,0,0-3.87,1.16,4.72,4.72,0,0,1,3.65-1.8Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.12,238.47,60,240.42c-1,.46.82,6.51,1.26,13.6.46,7.28,1.85,16.44,1.85,16.44s5.65,1.56,13.78-2C84.11,265.38,85,262,85,262l-2.26-3.15-.8-6.64a7.79,7.79,0,0,0,.43-7.8c-2.17-4.08-8.21-7.73-8.21-7.73l-2.68.42Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.12,238.47,60,240.42c-1,.46.82,6.51,1.26,13.6.46,7.28,1.85,16.44,1.85,16.44s5.65,1.56,13.78-2C84.11,265.38,85,262,85,262l-2.26-3.15-.8-6.64a7.79,7.79,0,0,0,.43-7.8c-2.17-4.08-8.21-7.73-8.21-7.73l-2.68.42Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.06,254.31a5.88,5.88,0,0,0,5.41,2A5.81,5.81,0,0,0,76.81,253a4.81,4.81,0,0,1-4.57,4.23C67.9,257.79,67.06,254.31,67.06,254.31Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.18,223.8c-.83-3.74-3.94-6.5-8.84-5.49s-7.23,5.56-6.27,9a13.94,13.94,0,0,0,2.3,5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.26,226.48c1.53-1,2.55,1,2.55,1,1.11.66,1.69-1.55,1.91-2.21.39-1.17.75-2.82,2-3.33a3.43,3.43,0,0,1,2.9.45,2.32,2.32,0,0,0,1.73.51c.51-.15.82-.68,1.29-1,1.34-.76,2.19.88,2.53,1.92a13.52,13.52,0,0,1,.51,4c0,4.88-1.67,7.21-2.48,7.68a6.1,6.1,0,0,1-3.48.52v2.09s3.76,3.34,4.37,7.88c0,0-4.58-2.06-7-3.5-4.25-2.53-4.57-3.65-4.57-3.65l-.21-7.74c-.1.53-1,.61-1.71-.46C61.57,229.13,61.84,226.76,62.26,226.48Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.74,236.08c-1.58-.21-4.5-1-5-2.31a2.52,2.52,0,0,0,1.2,2,12.1,12.1,0,0,0,3.81,1.18Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52,213c-3.6-2-10.37,1.62-9.71,7.59S74.93,217.19,69.52,213Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52,213c-3.6-2-10.37,1.62-9.71,7.59S74.93,217.19,69.52,213Z",
    style: {
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.18,223.8c-.86-1.93-1.9-3.76-6-3.57-3.85.18-4.77,1.89-5.55,3.14a19,19,0,0,0-2.42,6c-.42,2.49,1.1,1.83,1.1,1.83l.11,4.09c-.43-2.78-3.61-6.77-4.24-8.43a9.3,9.3,0,0,1,1.66-9.89c2.9-3.33,7.54-5.22,10.91-3.74C75.26,214.28,77.5,220.62,77.18,223.8Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.18,223.8c-.86-1.93-1.9-3.76-6-3.57-3.85.18-4.77,1.89-5.55,3.14a19,19,0,0,0-2.42,6c-.42,2.49,1.1,1.83,1.1,1.83l.11,4.09c-.43-2.78-3.61-6.77-4.24-8.43a9.3,9.3,0,0,1,1.66-9.89c2.9-3.33,7.54-5.22,10.91-3.74C75.26,214.28,77.5,220.62,77.18,223.8Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,230l.1.18a15.53,15.53,0,0,1,1.9,5.06l-.11-4.09s-1.52.66-1.1-1.83a18.66,18.66,0,0,1,2.43-6c.77-1.25,1.68-3,5.54-3.14,2.25-.1,3.57.41,4.45,1.21l1.1-1.45.45-.58c0-1.77-.5-4-2.63-4.52a4.83,4.83,0,0,0-1.69-.07c-3.58.42-9.07,1.11-10.84,5.8S61.06,227.52,62.45,230Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.45,230l.1.18a15.53,15.53,0,0,1,1.9,5.06l-.11-4.09s-1.52.66-1.1-1.83a18.66,18.66,0,0,1,2.43-6c.77-1.25,1.68-3,5.54-3.14,2.25-.1,3.57.41,4.45,1.21l1.1-1.45.45-.58c0-1.77-.5-4-2.63-4.52a4.83,4.83,0,0,0-1.69-.07c-3.58.42-9.07,1.11-10.84,5.8S61.06,227.52,62.45,230Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7,227.88a31.1,31.1,0,0,1,.19-3.7,8,8,0,0,0,0-3.81c-.8-2.92-6.18-5.2-9.56-2.67A10.11,10.11,0,0,0,63.9,227s1.92-4.83,5.72-6.1c2.83-.95,5.68-.74,7.09,2.21A11,11,0,0,1,77.7,227.88Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Earing--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.89,235.5A2.74,2.74,0,0,1,62,230.82a.25.25,0,0,1,.35.35,2.22,2.22,0,0,0-.66,1.59,2.25,2.25,0,1,0,2.25-2.25.25.25,0,1,1,0-.49,2.74,2.74,0,0,1,0,5.48Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M71.47,231.72l1.63.43a.84.84,0,0,1-1,.63A.89.89,0,0,1,71.47,231.72Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.75,224.35,75.1,224a.82.82,0,0,1,1-.64A.89.89,0,0,1,76.75,224.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.35,225.47l1.46-.87a.82.82,0,0,0-1.14-.31A.88.88,0,0,0,69.35,225.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.62,226.71a.69.69,0,1,1-.76-.64A.7.7,0,0,1,76.62,226.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.29,227.28a.69.69,0,1,1-1.38.14.69.69,0,1,1,1.38-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,227a.14.14,0,0,0-.1-.07l-.22-.08-.3-.09-.25-.08-.16,0a.52.52,0,0,0-.21,0c-.05,0-.06.08,0,.13a.18.18,0,0,0,.12.12l.12,0h.21l.26.08a1.05,1.05,0,0,0,.35.08.32.32,0,0,0,.17,0S69.53,227,69.5,227Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.46,227.54a.31.31,0,0,0-.25-.14,3.1,3.1,0,0,0-.43,0l-.48,0c-.16,0-.06.25.06.26a3,3,0,0,0,.6,0h.43s0,0,.07,0A0,0,0,0,0,69.46,227.54Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,227.88s-.1,0-.15,0l-.11,0L69,228l-.21.06-.08,0-.11,0a.1.1,0,0,0-.06.09v0s0,.1.08.11a.1.1,0,0,0,.09,0h0l.1,0,.11,0,.21-.07a1.08,1.08,0,0,0,.26-.14s0-.05.06-.09A.11.11,0,0,0,69.45,227.88Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,224.67h-.33a9.58,9.58,0,0,0-3.29.42c-1,.43-1.42.83-2,.89s-1-.27-2.12-.49a11.09,11.09,0,0,0-3.51.23l-.36.08a.65.65,0,0,0-.39.63,1.14,1.14,0,0,0,.33.66.78.78,0,0,1,.11.27,11.86,11.86,0,0,0,.41,1.87,2.1,2.1,0,0,0,.44.64,1.3,1.3,0,0,0,.23.18l.13.08a2.26,2.26,0,0,0,.39.15l.07,0,.1,0,.11,0,.35,0h.15l.19,0a2.69,2.69,0,0,0,2.41-1.65c.37-.76.29-1.77,1-1.83h.13c.49.07.42,1,.72,1.66a2.45,2.45,0,0,0,.46.69l.11.11.06,0,.07.05,0,0,.06,0,0,0,0,0a1.82,1.82,0,0,0,.57.18h0a2.73,2.73,0,0,0,.7,0,2.3,2.3,0,0,0,2-1.52,13.53,13.53,0,0,0,.44-1.95A.57.57,0,0,1,79,226a1.5,1.5,0,0,0,.31-.74C79.37,224.93,79.18,224.67,79,224.67Zm-7,3.37a2.51,2.51,0,0,1-.51,1.05h0a2.21,2.21,0,0,1-1.58.73,1.56,1.56,0,0,1-1.51-.59.43.43,0,0,1,0-.07l0-.06,0-.07,0-.05,0,0s0,0,0,0a.13.13,0,0,1,0-.07h0a1.8,1.8,0,0,1-.08-.21h0l0-.13a1.77,1.77,0,0,1,0-.2v-.07c-.11-.5-.23-1.48,0-1.73a3.05,3.05,0,0,1,2-.54h.12l.49,0,.19,0,.47.11.15,0,.16.06,0,0,.06,0a.8.8,0,0,1,.31.23A2.23,2.23,0,0,1,72.05,228Zm6.26-.82a2.46,2.46,0,0,1-1,1.72,2,2,0,0,1-.8.25,1.56,1.56,0,0,1-1.6-.6h0l0,0,0,0,0,0a.3.3,0,0,0,0-.08l0-.09s0,0,0,0v-.09a2.06,2.06,0,0,1-.1-.37,2.43,2.43,0,0,1,.05-1.53,3.27,3.27,0,0,1,1.76-.92c.18,0,.34-.06.5-.08H77l.17,0h.28a1.75,1.75,0,0,1,.24,0h.12l0,0h.08l.11,0h0a.84.84,0,0,1,.27.14C78.56,225.69,78.42,226.7,78.31,227.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,225.88l-3,.87a3.26,3.26,0,0,1,.51.75l2.57-.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.09,227l.53,4,2.32-.88-2.62-3.19A.54.54,0,0,0,73.09,227Z",
    style: {
      fill: "#874c4c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--writting-hand--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.18,268.27l1.73,2.11a.09.09,0,0,1-.08.14l-2.68-.63Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.83,270.52a.09.09,0,0,0,.08-.14l-.34-.41h0a.47.47,0,0,1-.27.39l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.35,263.79l.21.13.26.16,9.33,5.81a1.26,1.26,0,0,0,.75-.49,1.25,1.25,0,0,0,.27-1.13l-9.31-5.8-.5-.31C77.67,262.37,76.66,264,76.35,263.79Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.17,264.3l.48.3c.13.09.41-.15.65-.48s.53-1,.35-1.16l-.35-.22-.13-.08c.18.13,0,.74-.35,1.17s-.5.54-.64.48h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.29,264.37c.31.21,1.32-1.42,1-1.63l-.48-.3c.32.21-.69,1.84-1,1.63Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.35,263.79l.47.29c.31.21,1.3-1.36,1-1.61l0,0-.48-.29C77.67,262.37,76.66,264,76.35,263.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.91,270.48v-.1l-1.86-1.21L77.19,263s0,0,0,0c-.26.46-.65.92-.83.8l.21.13.26.16,9.33,5.81h0l2.68.63A.09.09,0,0,0,88.91,270.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.34,262.53l2,1.26c.13.09.41-.15.65-.47s.54-1,.36-1.16h0l-2-1.26c-.4-.25-1,.5-1.14,1.09A.5.5,0,0,0,74.34,262.53Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,262.34a1.53,1.53,0,0,0,.5-1.22.32.32,0,0,0-.19-.25c-.4-.14-1,.56-1.07,1.12a.49.49,0,0,0,.13.53C74.48,262.62,74.72,262.56,75,262.34Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,264.39a1.86,1.86,0,0,1,1.62.37c.53.33,1.3.38,1.36.64s-.31.65-.31.65Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,272.52c1.12-.11,4.75-.19,5.93-.45a4.79,4.79,0,0,0,2.68-1.49c.17-.2.32-.41.49-.61a1.54,1.54,0,0,1,.44-.44c.15-.08.31-.14.46-.23a1.31,1.31,0,0,0,.62-1,1.9,1.9,0,0,1,0-.25.29.29,0,0,1,.14-.2.42.42,0,0,1,.25,0,3.79,3.79,0,0,0,1,0,1.89,1.89,0,0,0,.68-.23c.15-.1.43-.39.17-.54a10.51,10.51,0,0,0-1-.56,11.38,11.38,0,0,0-4.21-.94c-.72-.06-1.74-.06-2.47-.11-.31,0-.64-.08-1-.12l-.48-.3a2.07,2.07,0,0,0-.85.3c-.42.25-.88.64-1.3.87a10.62,10.62,0,0,1-4.61.54",
    style: {
      fill: "#9e6767"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--notebook--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "100.93 254.22 89.07 259.86 85.97 273.72 86.98 274.75 98.14 269.08 101.94 255.25 100.93 254.22",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.08 260.89 86.98 274.75 85.97 273.72 89.07 259.86 90.08 260.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.09 254.97 89.97 260.73 86.77 274.94 87.08 275.27 98.51 269.47 102.4 255.3 102.09 254.97",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.09 254.97 89.97 260.73 86.77 274.94 87.08 275.27 98.51 269.47 102.4 255.3 102.09 254.97",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.28 261.07 87.08 275.27 86.77 274.94 89.97 260.73 90.28 261.07",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.28 261.07 87.08 275.27 86.77 274.94 89.97 260.73 90.28 261.07",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.4 255.3 90.28 261.07 87.08 275.27 98.51 269.47 102.4 255.3",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.24,266.08a3.29,3.29,0,0,0,2.93,1l.28-1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M90.79,261.72c-.05.19,0,.28.17.21a.77.77,0,0,0,.35-.45c0-.19,0-.28-.17-.22A.83.83,0,0,0,90.79,261.72Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,258.56a.89.89,0,0,0-.86-.32,1,1,0,0,0-.6.78,2.25,2.25,0,0,0,0,.64l.23-.11a2.34,2.34,0,0,1,.05-.47c.07-.33.23-.55.42-.6a.63.63,0,0,1,.62.25,2.69,2.69,0,0,1,.61,2.23,1.33,1.33,0,0,1-.11.32.59.59,0,0,1-.31.28h-.13a1,1,0,0,0-.07.15s0,.06,0,.08h.1a.5.5,0,0,0,.17,0,.43.43,0,0,0,.12-.05,1,1,0,0,0,.48-.73A3,3,0,0,0,91,258.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.46,260.93c0,.18,0,.28.16.21a.76.76,0,0,0,.35-.46c0-.18,0-.28-.16-.21A.8.8,0,0,0,92.46,260.93Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.64,257.77a.87.87,0,0,0-.86-.32.93.93,0,0,0-.59.78,2.25,2.25,0,0,0,0,.64l.24-.11a2.45,2.45,0,0,1,0-.48.76.76,0,0,1,.43-.6.67.67,0,0,1,.62.26,2.71,2.71,0,0,1,.61,2.22,1.19,1.19,0,0,1-.12.32.52.52,0,0,1-.31.28.27.27,0,0,1-.13,0,.67.67,0,0,0-.06.15s0,.05,0,.08h.1l.18,0,.12-.05a1,1,0,0,0,.47-.74A2.93,2.93,0,0,0,92.64,257.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.12,260.14c-.05.18,0,.27.17.21a.83.83,0,0,0,.35-.46c0-.19,0-.28-.17-.21A.8.8,0,0,0,94.12,260.14Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.31,257a.89.89,0,0,0-.86-.31,1,1,0,0,0-.6.78,2.23,2.23,0,0,0,0,.64L93,258a2.42,2.42,0,0,1,0-.47.74.74,0,0,1,.43-.6.65.65,0,0,1,.61.26,2.67,2.67,0,0,1,.61,2.22,1,1,0,0,1-.11.32.55.55,0,0,1-.31.28.28.28,0,0,1-.13,0,.47.47,0,0,0-.06.15.29.29,0,0,0,0,.09h.1a.57.57,0,0,0,.18,0l.12-.05a1.05,1.05,0,0,0,.47-.73A3,3,0,0,0,94.31,257Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.79,259.34c-.05.19,0,.28.17.21a.81.81,0,0,0,.35-.45c0-.19,0-.28-.17-.22A.83.83,0,0,0,95.79,259.34Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,256.18a.89.89,0,0,0-.86-.32,1,1,0,0,0-.59.78,2.25,2.25,0,0,0,0,.64l.24-.11a1.83,1.83,0,0,1,.05-.47c.07-.33.22-.55.42-.6a.65.65,0,0,1,.62.25,2.74,2.74,0,0,1,.61,2.23,1.33,1.33,0,0,1-.12.32.58.58,0,0,1-.3.28h-.13a.51.51,0,0,0-.07.15s0,.06,0,.08h.11a.52.52,0,0,0,.17,0l.12-.05a1,1,0,0,0,.47-.73A3,3,0,0,0,96,256.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.46,258.55c-.06.18,0,.28.16.21a.8.8,0,0,0,.35-.46c0-.18,0-.28-.16-.21A.76.76,0,0,0,97.46,258.55Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.64,255.39a.89.89,0,0,0-.86-.32,1,1,0,0,0-.6.78,2.69,2.69,0,0,0,0,.64l.24-.11a2.45,2.45,0,0,1,0-.48.74.74,0,0,1,.43-.6.65.65,0,0,1,.61.26,2.67,2.67,0,0,1,.61,2.22.93.93,0,0,1-.11.32.52.52,0,0,1-.31.28.27.27,0,0,1-.13,0,.39.39,0,0,0-.06.15.24.24,0,0,0,0,.08h.1l.18,0,.12-.05a1.07,1.07,0,0,0,.47-.74A3,3,0,0,0,97.64,255.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.12,257.76c-.05.18,0,.28.17.21a.8.8,0,0,0,.35-.46c0-.18,0-.28-.17-.21A.8.8,0,0,0,99.12,257.76Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,254.59a.87.87,0,0,0-.86-.31,1,1,0,0,0-.59.78,2.23,2.23,0,0,0,0,.64l.23-.12a2.42,2.42,0,0,1,0-.47.74.74,0,0,1,.42-.6.66.66,0,0,1,.62.26,2.67,2.67,0,0,1,.61,2.22,2,2,0,0,1-.11.32.59.59,0,0,1-.31.28.29.29,0,0,1-.13,0,.77.77,0,0,0-.07.16s0,.05,0,.08h.1a.51.51,0,0,0,.17,0l.12-.05A1,1,0,0,0,100,257,3,3,0,0,0,99.3,254.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.79,257c-.05.19,0,.28.16.21a.74.74,0,0,0,.35-.45c0-.19,0-.28-.16-.22A.79.79,0,0,0,100.79,257Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,253.8a.89.89,0,0,0-.86-.32,1,1,0,0,0-.59.79,2.15,2.15,0,0,0,0,.63l.24-.11a2.42,2.42,0,0,1,0-.47c.07-.33.23-.55.43-.6s.4,0,.62.25a2.77,2.77,0,0,1,.61,2.23,1.33,1.33,0,0,1-.12.32.59.59,0,0,1-.31.28h-.13a.47.47,0,0,0-.06.15s0,.06,0,.08h.1a.55.55,0,0,0,.18,0l.12,0a1,1,0,0,0,.47-.73A3,3,0,0,0,101,253.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.63,258.09s-.53,1.94-.66,2.44c-.33,1.18-2.58,1.62-3.81,1.77-2.34.29-2.6.8-2,2.46s2,2.11,4.15,1.86a3.85,3.85,0,0,0,2.9-2.53c.68-2,.32-4,.59-5.19S102.23,257.41,101.63,258.09Z",
    style: {
      fill: "#9e6767"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7,266.81c-3.06-.12-10.05-1.08-10.05-1.08l1.55-13.59c.79-3.23-1.43-10.63-3.18-11.72-.78.23-2.37.69-4.13,3.35-1,1.46-1.19,3.95-1.85,10-.48,4.27-.66,10.13-.73,14-.06,4.31,1.69,5.49,5.58,5.72,6.51.39,13.25-.7,15.8-.93",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4,240.25a6.47,6.47,0,0,0-4.78,3.52c-1.25,2.07-1.74,8.34-2.31,15A74.74,74.74,0,0,0,53,270.46c.11,1.12,1.08,2.82,3.84,3.05a40,40,0,0,0,5.54,0s-.53-4.83,1.51-7.51l-2.1-.38,2-14.85S63.6,243.13,60.4,240.25Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4,240.25a6.47,6.47,0,0,0-4.78,3.52c-1.25,2.07-1.74,8.34-2.31,15A74.74,74.74,0,0,0,53,270.46c.11,1.12,1.08,2.82,3.84,3.05a40,40,0,0,0,5.54,0s-.53-4.83,1.51-7.51l-2.1-.38,2-14.85S63.6,243.13,60.4,240.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81,265.64a8.92,8.92,0,0,0-4.65.91s1-1.61,4.78-1.93Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.09,285.42l16.46,8.27-.35-6.07,2.54-1.46c-.18-4.7-1.47-9.53-4.8-10.6-4.16-1.31-9.56-1.74-12.8-4.67s-3.11-11-2.71-15.61,1.61-11.8-2.08-13.94a7.14,7.14,0,0,0-7.2.24c-1.58,1-3.41,1.77-3.26,3A1.33,1.33,0,0,0,43,245.86l9.19,34.77A7.5,7.5,0,0,0,56.09,285.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.93,245.63c1.48,1.77,2.24,4.58,2,11.48s-.17,12.48,2.54,15.86c3.2,4,14.18,7.21,14.18,7.21l4.29-2a5.37,5.37,0,0,0-3-2.66c-4.16-1.31-9.56-1.74-12.8-4.67s-3.11-11-2.71-15.61,1.61-11.8-2.08-13.94a7.14,7.14,0,0,0-7.2.24c-1.58,1-3.41,1.77-3.26,3A1.33,1.33,0,0,0,43,245.86C45.07,245.18,48.45,243.86,49.93,245.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.93,245.63c1.48,1.77,2.24,4.58,2,11.48s-.17,12.48,2.54,15.86c3.2,4,14.18,7.21,14.18,7.21l4.29-2a5.37,5.37,0,0,0-3-2.66c-4.16-1.31-9.56-1.74-12.8-4.67s-3.11-11-2.71-15.61,1.61-11.8-2.08-13.94a7.14,7.14,0,0,0-7.2.24c-1.58,1-3.41,1.77-3.26,3A1.33,1.33,0,0,0,43,245.86C45.07,245.18,48.45,243.86,49.93,245.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,287.62l2.54-1.46c0-2.81-.72-8.93-4.28-10.41-2.83-1.17-4.2.55-4.17,1.62s.9,2,2.33,2.81C70.52,281.27,72.2,283.23,72.2,287.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,287.62l2.54-1.46c0-2.81-.72-8.93-4.28-10.41-2.83-1.17-4.2.55-4.17,1.62s.9,2,2.33,2.81C70.52,281.27,72.2,283.23,72.2,287.62Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M178.75,302.06c-4,2.31-4,6.05,0,8.36a16,16,0,0,0,14.47,0c4-2.31,4-6.05,0-8.36A16,16,0,0,0,178.75,302.06Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,307.07c-3.2-3.31-5.09-16.78-2-19.4H194c3.12,2.62,1.24,16.08-2,19.39l-.09.09a1.14,1.14,0,0,1-.11.11l-.29.26-.08.07-.24.18a4.81,4.81,0,0,1-.41.27,10.47,10.47,0,0,1-9.56,0h0l-.42-.27-.22-.17-.1-.08-.27-.25-.13-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.56,286.61c3.64,2.12,3.64,5.56,0,7.68a14.39,14.39,0,0,1-13.15,0c-3.63-2.12-3.63-5.56,0-7.68A14.39,14.39,0,0,1,192.56,286.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.56,286.61c3.64,2.12,3.64,5.56,0,7.68a14.39,14.39,0,0,1-13.15,0c-3.63-2.12-3.63-5.56,0-7.68A14.39,14.39,0,0,1,192.56,286.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.82,287.63c2.66,1.56,2.66,4.08,0,5.64a10.62,10.62,0,0,1-9.66,0c-2.67-1.56-2.67-4.08,0-5.64A10.55,10.55,0,0,1,190.82,287.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.16,290.31a10.55,10.55,0,0,1,9.66,0,4.33,4.33,0,0,1,1.59,1.48,4.33,4.33,0,0,1-1.59,1.48,10.62,10.62,0,0,1-9.66,0,4.45,4.45,0,0,1-1.6-1.48A4.45,4.45,0,0,1,181.16,290.31Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.13,262.83l-6,4.79,5.84-2.7a16.16,16.16,0,0,1-1,5.54,35.42,35.42,0,0,0-4.54,3.22l4.47-1.77a22.35,22.35,0,0,1-.92,7.46,42.8,42.8,0,0,1-2.48,5.11,20.43,20.43,0,0,1-1.3,2.25l-.09.13c-1-.58-2.09-1.15-3.19-1.7a32.87,32.87,0,0,1-2-8.32c-1.29-11.72,7.57-18.44,14.7-20.7A21.26,21.26,0,0,0,193.13,262.83Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.13,262.83l-6,4.79,5.84-2.7a16.16,16.16,0,0,1-1,5.54,35.42,35.42,0,0,0-4.54,3.22l4.47-1.77a22.35,22.35,0,0,1-.92,7.46,42.8,42.8,0,0,1-2.48,5.11,20.43,20.43,0,0,1-1.3,2.25l-.09.13c-1-.58-2.09-1.15-3.19-1.7a32.87,32.87,0,0,1-2-8.32c-1.29-11.72,7.57-18.44,14.7-20.7A21.26,21.26,0,0,0,193.13,262.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,263.32a11.31,11.31,0,0,0-2.51,4.5,23.82,23.82,0,0,0-1.08,5.08,22.16,22.16,0,0,0,1.28,10.18h0a.17.17,0,1,1-.32.12h0a22.11,22.11,0,0,1-1.13-10.32,23.47,23.47,0,0,1,1.16-5.09A11.42,11.42,0,0,1,188.08,263.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,269h0a89.05,89.05,0,0,1,6.32,8.88l6.13,1-4.52.79,2.42,3.85,6,1.25-4.71.76s1.3,4.6,4.68,6.52c1.86,1.05,2.77,1.22,3.33.68.39-.37.48-2.57.81-4.54a15.06,15.06,0,0,0-1.51-9,12,12,0,0,0-1.93-2.84C179.58,271.31,171.14,268.92,167,269Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.39,271a25,25,0,0,1,8.53,5.89,17.05,17.05,0,0,1,2.92,4.34,16,16,0,0,1,1.33,5l0,0h0a20.7,20.7,0,0,0-1.61-4.9,18.78,18.78,0,0,0-2.82-4.3,25.55,25.55,0,0,0-8.34-6,0,0,0,0,1,0,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,271.51h0a12.1,12.1,0,0,0-1.54.07,24.85,24.85,0,0,0-5.9,1.43c-.71.27-1.41.56-2.11.9-.35.16-.69.34-1,.52a17.16,17.16,0,0,0-4.52,3.42,10.41,10.41,0,0,0-1.56,2.19c-.05.1-.11.2-.17.3h0c-.13.27-.25.54-.36.8A14.81,14.81,0,0,0,185,288.4a9.14,9.14,0,0,0,1,4.1.61.61,0,0,0,.15.12c.5.32,1.3.13,2.79-.71,3-1.67,4.16-5.9,4.16-5.9l-4.15-.7,5.33-1.07,2.17-3.38-4-.72,5.42-.83a80.92,80.92,0,0,1,5.62-7.8Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,271.58a24.85,24.85,0,0,0-5.9,1.43c-.71.27-1.41.56-2.11.9-.35.16-.69.34-1,.52a17.16,17.16,0,0,0-4.52,3.42,10.41,10.41,0,0,0-1.56,2.19c-.05.1-.11.2-.17.3h0c-.13.27-.25.54-.36.8A14.81,14.81,0,0,0,185,288.4a9.14,9.14,0,0,0,1,4.1.61.61,0,0,0,.15.12,1.18,1.18,0,0,0,.33.12c-.37-2.73,1-9.65,3-12.49a24.33,24.33,0,0,1,14-8.74h0A12,12,0,0,0,202,271.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.45,292.74a23.54,23.54,0,0,1,.39-6,19.47,19.47,0,0,1,2-5.72,17,17,0,0,1,4-4.52,22.54,22.54,0,0,1,5.2-3.11,0,0,0,0,1,0,0s0,0,0,0a29.24,29.24,0,0,0-5,3.34,21.35,21.35,0,0,0-2.2,2,13,13,0,0,0-1.83,2.35,19.29,19.29,0,0,0-2.07,5.62,23.21,23.21,0,0,0-.53,6h0Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "115.47 312.21 80.97 292.29 143.24 256.35 177.74 276.26 115.47 312.21",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.47 312.21 80.97 292.29 143.24 256.35 177.74 276.26 115.47 312.21",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.97 292.29 80.97 329.81 82.68 330.79 82.68 326.84 113.76 344.79 113.76 348.74 115.47 349.72 115.47 312.21 80.97 292.29",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.97 292.29 80.97 329.81 82.68 330.79 82.68 326.84 113.76 344.79 113.76 348.74 115.47 349.72 115.47 312.21 80.97 292.29",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.68 330.79 84.39 329.81 84.39 327.83 82.68 326.84 82.68 330.79",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.47 349.72 117.18 348.74 117.18 344.79 176.03 310.81 176.03 314.76 177.74 313.78 177.74 276.26 115.47 312.21 115.47 349.72",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.47 349.72 117.18 348.74 117.18 344.79 176.03 310.81 176.03 314.76 177.74 313.78 177.74 276.26 115.47 312.21 115.47 349.72",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.03 314.76 174.32 313.78 174.32 311.8 176.03 310.81 176.03 314.76",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "176.03 314.76 174.32 313.78 174.32 311.8 176.03 310.81 176.03 314.76",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--things--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheets--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.7,284.79l14,8.11a.85.85,0,0,0,.79,0l10.34-6a.24.24,0,0,0,0-.45l-14.05-8.11a.85.85,0,0,0-.79,0l-10.33,6C110.48,284.46,110.48,284.66,110.7,284.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,284.06l14,8.11a.91.91,0,0,0,.79,0l10.34-6c.22-.13.22-.33,0-.46l-14.05-8.11a.91.91,0,0,0-.79,0l-10.33,6C110.48,283.73,110.48,283.93,110.7,284.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,277.63l-9.81,5.67,13.52,7.81a.85.85,0,0,0,.79,0l9.82-5.67-13.53-7.81A.91.91,0,0,0,121,277.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,282.63l14,8.11a.85.85,0,0,0,.79,0l10.34-6a.24.24,0,0,0,0-.45l-14.05-8.11a.85.85,0,0,0-.79,0l-10.33,6C110.48,282.3,110.48,282.5,110.7,282.63Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M124,273.43l6.36,3.7a.74.74,0,0,0,.68,0l17.89-10.31a.21.21,0,0,0,0-.4l-6.36-3.7a.74.74,0,0,0-.68,0L124,273A.21.21,0,0,0,124,273.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.45,265.66a.23.23,0,0,0-.14-.19l-5.66-3.27a.74.74,0,0,0-.68,0l-17.27,10a.24.24,0,0,0-.14.2V273a.23.23,0,0,0,.14.19l5.66,3.27a.72.72,0,0,0,.67,0l17.28-10a.26.26,0,0,0,.14-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.36,275.83l-5.66-3.25c-.19-.11-.19-.28,0-.39l17.27-10a.74.74,0,0,1,.68,0l5.66,3.27c.19.11.19.28,0,.39l-17.28,10A.72.72,0,0,1,130.36,275.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67,275.91v.61a.62.62,0,0,1-.31-.08l-5.66-3.26a.26.26,0,0,1-.14-.2v-.59a.23.23,0,0,0,.14.19l5.66,3.26A.74.74,0,0,0,130.67,275.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59,272.34l.76-.44.56.33-.76.44-.56-.32Zm.88.5.59-.34.57.33-.6.35-.56-.33h0Zm.18-1.12.6-.34.56.33-.59.35-.56-.33h0Zm.7,1.63,1-.56.56.34-1,.55-.56-.32h0Zm0-1,.47-.27.56.34-.47.27-.56-.32h0Zm.18-1.12.6-.34.56.33-.6.35-.56-.32h0Zm.59.68.48-.28.56.34-.47.27-.56-.32Zm.08,2,.76-.44.57.33-.76.44-.56-.32Zm.23-3.17,4.31-2.49.57.33L129,271l-.56-.32Zm.16,1.93.48-.27.56.33-.47.27-.57-.32Zm.31-1.19.47-.28.57.34-.48.27-.56-.32Zm.18,2.93.47-.27.57.33-.48.28-.56-.33h0Zm.18-1.12.48-.27.56.33-.47.28-.56-.33h0Zm.11-1.07.47-.27.57.33-.48.28-.56-.33Zm.31-1.19.47-.27.56.33-.47.27-.56-.32h0Zm.18,2.93.47-.27.56.34-.47.27-.56-.32h0Zm.18-1.12.47-.27.57.34-.48.27-.56-.32h0Zm.1-1.07.48-.27.56.33-.47.28-.56-.33h0Zm0,3.26.6-.35.56.34-.59.34-.56-.32Zm.31-4.45.47-.27.57.33-.48.28-.56-.33h0Zm.18,2.94.48-.28.56.34-.47.27-.57-.32Zm.19-1.12.47-.28.56.34-.47.27-.56-.32Zm.1-1.08.47-.27.57.34-.48.27-.56-.32h0Zm.31-1.19.47-.27.56.33-.47.28-.56-.32h0Zm.15,4.18.47-.27.57.33-.48.28-.56-.33h0Zm0-1.24.47-.28.57.34-.48.27-.56-.32Zm.18-1.12.48-.27.56.33-.47.27-.56-.32Zm.11-1.07.47-.28.56.34-.47.27-.56-.32h0Zm.3-1.19.48-.28.56.34-.47.27-.56-.32Zm.16,4.18.47-.28.56.34-.47.27-.56-.32Zm0-1.25.48-.27.56.33-.47.27-.56-.32Zm.19-1.12.47-.27.57.33-.48.28-.56-.33Zm.1-1.07.48-.28.56.34-.47.27-.57-.32Zm.31-1.19.47-.28.57.34-.48.27-.56-.32Zm.15,4.18.48-.28.56.34-.47.27-.56-.32Zm0-1.25.47-.27.57.33-.48.28-.56-.33h0Zm.09-4.1.59-.34.57.33-.6.35-.56-.33Zm.09,3,.48-.27.56.33-.47.28-.56-.33h0Zm.11-1.07.47-.27.57.33-.48.27-.56-.32Zm.31-1.19.47-.27.56.33-.47.27-.56-.32h0Zm.15,4.18.47-.27.57.33-.48.27-.56-.32Zm0-1.25.47-.27.56.33-.47.28-.56-.32h0Zm.18-1.12.47-.27.57.34-.48.27-.56-.32h0Zm0-3.05.6-.34.56.33-.59.35-.56-.33h0Zm.08,2,.48-.27.56.33-.47.28-.56-.33h0Zm.31-1.19.48-.27.56.33-.47.28-.57-.33h0Zm.18,2.94L135,271l.56.34-.47.27-.56-.32Zm.19-1.12.47-.28.56.34-.47.27-.56-.32Zm.1-1.08.47-.27.57.33-.48.28-.56-.32h0Zm0,3.25.48-.28.56.34-.47.27-.56-.32Zm0-5.3.6-.34.56.33-.59.35-.56-.33h0Zm.27.86.47-.27.57.33-.48.28-.56-.33h0Zm.18,2.94.47-.28.57.34-.48.27-.56-.32Zm.18-1.12.48-.28.56.34-.47.27-.56-.32Zm.11-1.07.47-.28.56.34-.47.27-.56-.32Zm0,3.24.47-.28.57.34-.48.27-.56-.32Zm.14-5.37.76-.43.57.33-.76.44-.56-.32h0Zm.14.94,1.5-.87.56.34-1.49.86-.56-.32Zm.18,2.93.48-.27.56.33-.47.27-.56-.32Zm.19-1.12.47-.27.57.33-.48.27-.56-.32Zm.1-1.07.48-.28.56.34-.47.27-.56-.32Zm0,3.24.48-.27.56.33-.47.27-.56-.32Zm.47-1.5.47-.27.57.33-.48.28-.56-.33h0Zm.13-4.12.47-.28.56.34-.47.27-.56-.32Zm.06,3,.47-.27.56.33-.47.28-.56-.33h0Zm.1-1.07,1.13-.65,1.44.84-.56.32-.73-.42a.33.33,0,0,0-.15,0l-.13,0-.44.25-.56-.32Zm0,3.24.47-.27.57.33-.48.28-.56-.33h0Zm.47-1.5.47-.27.56.33-.47.28-.56-.33h0Zm.12-4.12.48-.27.56.33-.47.27-.56-.32Zm.06,3,.47-.27.57.33-.47.28-.57-.32h0Zm.46,2,.48-.27.56.33-.47.27-.56-.32Zm.13-1.3.48-.28.56.34-.47.27-.56-.32Zm.13-4.13.47-.27.57.33-.48.28-.56-.33Zm.1,1,.47-.28.57.34-.48.27-.56-.32Zm.42,4,.47-.27.57.33-.48.28-.56-.33Zm.13-1.3.84-.49.56.34-.84.48-.56-.32Zm.29-4.22,1.25-.72.56.33-1.25.72-.56-.32Zm.14,3,.47-.28.57.34-.48.27-.56-.32Zm.22,2.11.47-.27.56.33-.47.28-.56-.33h0Zm.52-4.57.47-.27.56.34-.47.27-.56-.32h0Zm0,2,.47-.28.56.34-.47.27-.56-.32h0Zm.1.95.47-.27.56.33-.47.28-.56-.33h0Zm.11,1.16.48-.27.56.34-.47.27-.56-.32h0Zm.42-5.52.47-.27.57.33-.48.28-.56-.33h0Zm.1,1,.48-.28.56.34-.47.27-.56-.32Zm0,2,.47-.27.57.33-.48.27-.56-.32Zm.06-1.05.48-.27.56.33-.47.28-.56-.33h0Zm0,2,.48-.27.56.34-.47.27-.56-.32h0Zm.29,1.07.47-.28.57.34-.48.27-.56-.32Zm.25-5.43.47-.27,1.44.84-.47.28-1.44-.83h0Zm.1,1,.47-.28.57.34-.48.27-.56-.32Zm.1.95.47-.27.57.33-.48.28-.56-.33h0Zm0,2,.47-.28.57.34-.48.27-.56-.32Zm.06-1.05.47-.28.57.34-.48.27-.56-.32Zm.23,2.11.47-.27.56.33-.47.27-.56-.32Zm.45-3.52.47-.27.56.34-.47.27-.56-.32h0Zm.1,1,.47-.27.56.33-.47.27-.56-.32Zm.1.95.47-.27.57.34-.48.27-.56-.32h0Zm.12,1.16.48-.27.56.33-.47.28-.56-.33h0Zm.45-3.51.48-.28,1.44.84-.48.28-1.43-.83Zm.1.95.48-.27.56.33-.47.28-.56-.33h0Zm.1,1,.48-.28.56.34-.47.27-.56-.32Zm.52,1.19.47-.27.24.15-.47.27-.24-.14Zm.26-1.64.47-.28.57.34-.48.27-.56-.32Zm.51,1.19.48-.27.24.15-.48.27-.23-.14Zm.27-1.64.47-.27.56.33-.47.27-.56-.32Zm.51,1.19.47-.27.25.15-.48.27-.24-.14h0Zm.78-.45.47-.27.24.15-.47.28-.24-.14h0Z",
    style: {
      fill: "#0B1D51"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--monitor--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.16,279.72a1,1,0,0,0,.93,0l26.18-15.11a1.07,1.07,0,0,0,.48-.84V242.69a1,1,0,0,0-.45-.82,1,1,0,0,0-.93,0L137.19,257a1.05,1.05,0,0,0-.48.83V278.9A1,1,0,0,0,137.16,279.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.09,279.7l26.18-15.11a1.07,1.07,0,0,0,.48-.84V242.69c0-.31-.21-.44-.48-.28l-26.18,15.11a1.08,1.08,0,0,0-.48.84v21.06C137.61,279.73,137.83,279.85,138.09,279.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.85,257.36l.9.52a1.06,1.06,0,0,0-.14.48v21.12c0,.28.18.41.41.31a1,1,0,0,1-.86,0,1,1,0,0,1-.45-.82V257.83A.94.94,0,0,1,136.85,257.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "148.73 276.06 151.17 274.65 151.66 277.92 148.73 276.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16,274.93,153,279.05a.86.86,0,0,1-.45.11.93.93,0,0,1-.39-.1h0L149,277.24h0a.93.93,0,0,1-.41-.73v-.16c0-.28.19-.39.43-.25l1.89,1.09.43.25-.1-.49-.67-9.17,5.86-3.4,1,.58,3.05,9.26A.74.74,0,0,1,160.16,274.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.58 268.35 157.44 264.94 156.44 264.37 150.58 267.77 151.58 268.35",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.58,268.35l-1-.58.67,9.17c.06.27-.1.38-.33.24L149,276.09c-.24-.14-.43,0-.43.25v.16a.93.93,0,0,0,.41.73h0l3.14,1.81h0a.93.93,0,0,0,.39.1Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--files--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--File--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.94,296.14a.32.32,0,0,0,.16.25l16.34,9.43a.38.38,0,0,0,.33,0l14.64-7.41v-.32l-16.66-9.62L93.1,295.88A.34.34,0,0,0,92.94,296.14Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,305.53v.33a.47.47,0,0,1-.17,0L93.1,296.39a.28.28,0,0,1,0-.51c-.09.05-.09.13,0,.19l16.34,9.43A.47.47,0,0,0,109.61,305.53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,298.09l-14.65,7.41a.45.45,0,0,1-.16,0,.47.47,0,0,1-.17,0L93.1,296.07c-.09-.06-.09-.14,0-.19l14.66-7.41Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,298.09v.32l-14.64,7.41a.32.32,0,0,1-.16,0v-.33a.45.45,0,0,0,.16,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.19 298.22 107.53 288.6 107.53 284.32 124.19 293.98 124.19 298.22",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.19 298.22 107.53 288.6 107.53 284.32 124.19 293.98 124.19 298.22",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.14,293.83a.46.46,0,0,0-.2.35v.87a.44.44,0,0,0,.2.35l16.26,9.38a.43.43,0,0,0,.41,0l12.41-6.71v-1.34l-16.66-9.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56,287.11l-12.42,6.72a.13.13,0,0,0,0,.24l16.26,9.38a.49.49,0,0,0,.41,0l12.41-6.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.64,296.84l.14.05a.54.54,0,0,0,.22,0l.07,0c.11-.06.1-.18,0-.25a.46.46,0,0,0-.2-.05.43.43,0,0,0-.23,0l0,0C120.5,296.68,120.52,296.77,120.64,296.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,303.49v1.34a.36.36,0,0,1-.21-.05L93.14,295.4a.44.44,0,0,1-.2-.35v-.87a.48.48,0,0,1,.15-.31c-.06.06,0,.14,0,.2l16.26,9.37A.3.3,0,0,0,109.61,303.49Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.82,295a.8.8,0,0,0-.85.05,2.93,2.93,0,0,0-1.15,1.7l.28,0a2.7,2.7,0,0,1,1-1.51.79.79,0,0,1,.35-.1.38.38,0,0,1,.21.05,1.06,1.06,0,0,1,.34.95,2.93,2.93,0,0,1-1.14,2.24.63.63,0,0,1-.41.1l-.31.18h0a.73.73,0,0,0,.35.09,1,1,0,0,0,.49-.14,3.15,3.15,0,0,0,1.27-2.47A1.27,1.27,0,0,0,122.82,295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.94,293.42a.32.32,0,0,0,.16.25l16.34,9.43a.38.38,0,0,0,.33,0l14.64-9v-.33l-16.66-9.61-14.66,9A.34.34,0,0,0,92.94,293.42Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,302.81v.33a.47.47,0,0,1-.17,0L93.1,293.67a.32.32,0,0,1-.16-.25.34.34,0,0,1,.16-.26c-.09,0-.09.13,0,.19l16.34,9.43A.47.47,0,0,0,109.61,302.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,293.82l-14.65,9a.45.45,0,0,1-.16,0,.47.47,0,0,1-.17,0L93.1,293.35c-.09-.06-.09-.14,0-.19l14.66-9Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,293.82v.33l-14.64,9a.32.32,0,0,1-.16,0v-.33a.45.45,0,0,0,.16,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.42 298.09 124.42 293.83 124.19 293.98 124.19 298.22 124.42 298.09",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.42 298.09 124.42 293.83 124.19 293.98 124.19 298.22 124.42 298.09",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--file--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.87,292.25A.26.26,0,0,0,123,292v-.33L107,282.63a.83.83,0,0,0-.75,0L91.77,291l16.67,9.61Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.87,292.25A.26.26,0,0,0,123,292v-.33L107,282.63a.83.83,0,0,0-.75,0L91.77,291l16.67,9.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.87,291.92c.21-.12.21-.31,0-.43L107,282.31a.83.83,0,0,0-.75,0l-14.44,8.33,16.67,9.62Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.87,291.92c.21-.12.21-.31,0-.43L107,282.31a.83.83,0,0,0-.75,0l-14.44,8.33,16.67,9.62Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1,288.46l10.69-6.17a.87.87,0,0,1,.74,0l14.68,8.48,1.39-.81v1.64l0,0a.23.23,0,0,1-.13.29L110.2,299l-16.66-9.62v-1.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.45,290.11a.23.23,0,0,0,0-.43l-15.92-9.18a.81.81,0,0,0-.74,0l-12.25,7.06,16.66,9.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.2 297.18 110.2 298.98 93.54 289.36 93.54 287.56 110.2 297.18",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,296.48a.28.28,0,0,0,.13,0,.41.41,0,0,0,.22,0,.09.09,0,0,0,.07,0c.11-.06.1-.17,0-.24a.53.53,0,0,0-.19-.06.47.47,0,0,0-.24,0l0,0C109.87,296.31,109.88,296.41,110,296.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,297.88a1,1,0,0,0,.19.63.67.67,0,0,0,.53.25h0a1.09,1.09,0,0,0,.52-.15l.09-.06-.21-.12c-.51.28-.92,0-.92-.55a2.07,2.07,0,0,1,.93-1.6.6.6,0,0,1,.69,0,.46.46,0,0,1,.19.27.41.41,0,0,0,.22,0,.84.84,0,0,0-.15-.33.68.68,0,0,0-.54-.25,1,1,0,0,0-.52.16A2.24,2.24,0,0,0,108.12,297.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.65,296.18l14.38-7v.24a.43.43,0,0,1-.19.32l-14.19,6.79Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.65,296.18l14.38-7v.24a.43.43,0,0,1-.19.32l-14.19,6.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.87,289.37c.21-.11.21-.31,0-.43L107,279.76a.83.83,0,0,0-.75,0l-14.44,6.93,16.67,9.61Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.44 300.58 91.77 290.97 91.77 286.68 108.44 296.31 108.44 300.58",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.44 300.58 91.77 290.97 91.77 286.68 108.44 296.31 108.44 300.58",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,297.83a.68.68,0,0,0,.54-.25,1,1,0,0,0,.19-.62,2.25,2.25,0,0,0-1-1.79,1,1,0,0,0-.52-.16c-.43,0-.73.35-.73.88a2.27,2.27,0,0,0,1,1.79,1.06,1.06,0,0,0,.52.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.66,297c0,.59-.41.83-.92.53a2,2,0,0,1-.93-1.6c0-.59.41-.83.93-.54A2.06,2.06,0,0,1,105.66,297Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3,294.81v.32c0,.65-.45.91-1,.59l-7.23-4.17a2.23,2.23,0,0,1-1-1.76v-.32c0-.65.45-.92,1-.59l7.23,4.17A2.23,2.23,0,0,1,102.3,294.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.66 300.45 108.66 296.2 108.44 296.31 108.44 300.58 108.66 300.45",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.66 300.45 108.66 296.2 108.44 296.31 108.44 300.58 108.66 300.45",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.83,277.66l11.26,6.51,1.78.36a.06.06,0,0,0,.06-.08l-.56-1-11.27-6.51C109.75,276.72,108.55,277.5,108.83,277.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110,275.92l0,0-.1-.06h-.12a.49.49,0,0,0-.22.06,1.05,1.05,0,0,0-.47.83.49.49,0,0,0,0,.12v0h0v0a.16.16,0,0,0,0,.07v0h0l0,0h0l.11.06a.1.1,0,0,1,0,0,.36.36,0,0,0,.27-.06,1,1,0,0,0,.48-.82A.37.37,0,0,0,110,275.92Zm-.7,1.14Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.82,282.17l-.67,1.17-.12-.07-10.67-6.16a.1.1,0,0,1,0,0,.37.37,0,0,1-.09-.27,1,1,0,0,1,.48-.82.37.37,0,0,1,.21-.07H110l0,0h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,282.2c.27-.15.48,0,.48.28a1,1,0,0,1-.48.82c-.26.15-.47,0-.47-.27A1.05,1.05,0,0,1,120.48,282.2Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.51,282.91h0l-.61-.67h0a.33.33,0,0,0-.39,0,1.05,1.05,0,0,0-.47.83.32.32,0,0,0,.18.33h0l.89.19a.22.22,0,0,0,.15,0,.61.61,0,0,0,.27-.48A.2.2,0,0,0,121.51,282.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.86,278.08h0a.15.15,0,0,0-.11,0,.39.39,0,0,0-.17.29.12.12,0,0,0,0,.11h0l8.1,4.67.48-.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,282.78l.67.38.48-.27-.91-.53A1.18,1.18,0,0,0,120.05,282.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.75,283.23h0l-.55-.61,0,0a.22.22,0,0,0-.27,0,.77.77,0,0,0-.34.59.22.22,0,0,0,.13.23h0l.81.18h0s0,0,.09,0a.35.35,0,0,0,.15-.26A.12.12,0,0,0,121.75,283.23Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.75,283.23h0l-.55-.61,0,0a.22.22,0,0,0-.27,0,.77.77,0,0,0-.34.59.22.22,0,0,0,.13.23h0l.81.18h0s0,0,.09,0a.35.35,0,0,0,.15-.26A.12.12,0,0,0,121.75,283.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.78,283.32a.35.35,0,0,1-.15.26s-.07,0-.09,0h0l-.41-.09c-.06,0-.11-.07-.11-.17a.54.54,0,0,1,.25-.43.18.18,0,0,1,.2,0v0l.27.3h0A.12.12,0,0,1,121.78,283.32Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.63,283.23c.08-.05.15,0,.15.09a.35.35,0,0,1-.15.26c-.09.05-.16,0-.16-.09A.34.34,0,0,1,121.63,283.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.05,277s-.07,0-.12,0a.37.37,0,0,0-.16.3c0,.05,0,.09,0,.11h0l1.78,1a.12.12,0,0,1,0-.11.39.39,0,0,1,.17-.29.15.15,0,0,1,.11,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,277.14a.34.34,0,0,1-.17.29.12.12,0,0,1-.11,0s0-.06,0-.11a.37.37,0,0,1,.16-.3s.09,0,.12,0A.13.13,0,0,1,111.1,277.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,276.42h0l-.7-.4h0a.35.35,0,0,0-.29,0,1,1,0,0,0-.43.74.29.29,0,0,0,.13.28h0l.71.41h0a.31.31,0,0,0,.29,0,1,1,0,0,0,.43-.75A.31.31,0,0,0,110.73,276.42Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,276.42h0l-.7-.4h0a.35.35,0,0,0-.29,0,1,1,0,0,0-.43.74.29.29,0,0,0,.13.28h0l.71.41h0a.31.31,0,0,0,.29,0,1,1,0,0,0,.43-.75A.31.31,0,0,0,110.73,276.42Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41,276.44c.24-.13.43,0,.43.25a1,1,0,0,1-.43.75.27.27,0,0,1-.43-.25A1,1,0,0,1,110.41,276.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,283.48h0l-.3-.17h-.05a.17.17,0,0,0-.08.14.08.08,0,0,0,0,.05h0l.29.18h.06a.11.11,0,0,0,.11-.11A.12.12,0,0,0,122,283.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,283.5h0v0h-.06a.19.19,0,0,0-.07.14s0,0,0,.05h0a.11.11,0,0,0,.11-.11A.12.12,0,0,0,122,283.5Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cup--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.75,291.28c-1.69.72-1.7,1.9,0,2.64a8.71,8.71,0,0,0,6.08.06c1.69-.72,1.7-1.9,0-2.64A8.71,8.71,0,0,0,134.75,291.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M134,291.33a2,2,0,0,1-1.14-.13c-.46-.2-.73-.74-1.06-1.63s-.72-2.89-.4-3.42c.48-.83,1.51-.7,2.36-.68h.29v1h-.32c-.47,0-1.27,0-1.4.23a6.85,6.85,0,0,0,.81,3.54,2.13,2.13,0,0,0,1.24,0l.37.9A2.84,2.84,0,0,1,134,291.33Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134,291.33a2,2,0,0,1-1.14-.13c-.46-.2-.73-.74-1.06-1.63s-.72-2.89-.4-3.42c.48-.83,1.51-.7,2.36-.68h.29v1h-.32c-.47,0-1.27,0-1.4.23a6.85,6.85,0,0,0,.81,3.54,2.13,2.13,0,0,0,1.24,0l.37.9A2.84,2.84,0,0,1,134,291.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.5,284.08c.11-.42.52-.81,1.25-1.12a8.71,8.71,0,0,1,6.08.05c.73.33,1.14.73,1.23,1.14h0a14.47,14.47,0,0,1-1.23,7.6l0,0,0,0h0a2,2,0,0,1-.8.74,5.06,5.06,0,0,1-4.61,0,2,2,0,0,1-.79-.76h0v0l0,0a14.42,14.42,0,0,1-1.1-7.61Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.75,283c-1.69.71-1.7,1.9,0,2.64a8.71,8.71,0,0,0,6.08.06c1.69-.72,1.7-1.9,0-2.65A8.71,8.71,0,0,0,134.75,283Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.33,283.42c-1.35.47-1.36,1.24,0,1.73a8.55,8.55,0,0,0,4.91,0c1.36-.46,1.36-1.24,0-1.72A8.64,8.64,0,0,0,135.33,283.42Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.33,283.42c-1.35.47-1.36,1.24,0,1.73a8.55,8.55,0,0,0,4.91,0c1.36-.46,1.36-1.24,0-1.72A8.64,8.64,0,0,0,135.33,283.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M135.32,284.46a2.68,2.68,0,0,0-.68.34,3,3,0,0,0,.68.35,8.55,8.55,0,0,0,4.91,0,2.69,2.69,0,0,0,.68-.33,2.39,2.39,0,0,0-.68-.35A8.64,8.64,0,0,0,135.32,284.46Z",
    style: {
      fill: "#37474f"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--room-for-printing--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Archive--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--block--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.59,408.21a2.47,2.47,0,0,1,1.46-2l95.2-55a7.71,7.71,0,0,1,7,0L332,397.86a2.48,2.48,0,0,1,1.46,2v22.85a2.47,2.47,0,0,1-1.46,2l-95.19,55a7.77,7.77,0,0,1-7,0l-80.76-46.65a2.47,2.47,0,0,1-1.46-2C147.59,430.32,147.6,408.94,147.59,408.21Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.77,350.38a7.17,7.17,0,0,1,3.51.84L332,397.86a2.48,2.48,0,0,1,1.46,2v22.85a2.47,2.47,0,0,1-1.46,2l-95.19,55a7.17,7.17,0,0,1-3.51.84V453.08Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.77,350.38a7.17,7.17,0,0,0-3.51.84l-95.2,55a2.46,2.46,0,0,0-1.45,2v22.84a2.46,2.46,0,0,0,1.45,2l80.76,46.65a7.17,7.17,0,0,0,3.51.84V453.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.81,456.88l-80.76-46.64c-1.94-1.12-1.94-2.94,0-4.06l95.2-55a7.71,7.71,0,0,1,7,0L332,397.86c1.94,1.12,1.94,2.94,0,4.06l-95.19,55A7.71,7.71,0,0,1,229.81,456.88Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.81,456.88l-80.76-46.64c-1.94-1.12-1.94-2.94,0-4.06l95.2-55a7.71,7.71,0,0,1,7,0L332,397.86c1.94,1.12,1.94,2.94,0,4.06l-95.19,55A7.71,7.71,0,0,1,229.81,456.88Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-26",
    points: "193.26 385.02 152.11 408.78 180.49 425.17 221.65 401.4 193.26 385.02",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-26",
    points: "230.81 371.31 201.54 388.26 223.66 401.04 252.93 384.08 230.81 371.31",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M257,384.23a1.78,1.78,0,0,1-.91-.23l-22.63-13.06a1,1,0,0,1-.56-.88,1,1,0,0,1,.56-.87l18.3-10.57a1.94,1.94,0,0,1,1.83,0l22.63,13.07a1,1,0,0,1,0,1.74L257.94,384A1.85,1.85,0,0,1,257,384.23Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M271,412.74c2.16.27,4.38.25,6.54.5a24,24,0,0,1,10.23,3.27,26.61,26.61,0,0,0,3.95,2.47,7.59,7.59,0,0,0,8.42-12.26,11.66,11.66,0,0,0-3.07-2.16c-8.43-4.4-19.47-2.63-27.58,1.72-1.72.92-5.39,3.8-2.29,5.52A10.22,10.22,0,0,0,271,412.74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 381.91 257.02 369.13 273.63 359.55 273.63 372.33 257.02 381.91",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 369.13 236.27 357.15 236.27 369.93 257.02 381.91 257.02 369.13",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 369.13 236.27 357.15 236.27 369.93 257.02 381.91 257.02 369.13",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 369.13 274.12 359.26 252.87 346.99 235.78 356.86 257.02 369.13",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 369.13 274.12 359.26 252.87 346.99 235.78 356.86 257.02 369.13",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 369.13 257.02 372.33 274.12 362.46 274.12 359.26 257.02 369.13",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 372.33 273.63 362.74 273.63 363.44 257.02 373.03 257.02 372.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.78 356.86 257.02 369.13 257.02 372.33 235.78 360.06 235.78 356.86",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.78 356.86 257.02 369.13 257.02 372.33 235.78 360.06 235.78 356.86",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 372.33 236.27 360.35 236.27 361.05 257.02 373.03 257.02 372.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.49,371.07l5.67-3.27c.25-.14.44,0,.44.26v3.35a1,1,0,0,1-.44.77l-5.67,3.27c-.24.14-.44,0-.44-.26v-3.35A1,1,0,0,1,262.49,371.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,371.46l4.95-2.86c.16-.09.29,0,.29.17v2.51a.68.68,0,0,1-.29.52l-4.95,2.85c-.16.09-.29,0-.29-.17V372A.64.64,0,0,1,262.85,371.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263,372.12a.06.06,0,0,1-.06,0,.06.06,0,0,1,0-.09l4.66-2.7a.07.07,0,0,1,.1,0,.07.07,0,0,1,0,.09l-4.67,2.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,372.74a.08.08,0,0,1-.06,0,.07.07,0,0,1,0-.1l4.66-2.69a.07.07,0,1,1,.08.12l-4.67,2.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,373.35a.07.07,0,0,1-.06,0,.07.07,0,0,1,0-.1l4.66-2.7a.08.08,0,0,1,.08.13L263,373.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,374a.07.07,0,0,1-.06,0,.07.07,0,0,1,0-.1l4.66-2.7a.07.07,0,0,1,.1,0,.08.08,0,0,1,0,.1L263,374Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 367.53 257.02 354.74 273.63 345.16 273.63 357.94 257.02 367.53",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 354.74 236.27 342.76 236.27 355.54 257.02 367.53 257.02 354.74",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 354.74 236.27 342.76 236.27 355.54 257.02 367.53 257.02 354.74",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 354.74 274.12 344.87 252.87 332.6 235.78 342.48 257.02 354.74",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 354.74 274.12 344.87 252.87 332.6 235.78 342.48 257.02 354.74",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 354.74 257.02 357.94 274.12 348.07 274.12 344.87 257.02 354.74",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 357.94 273.63 348.35 273.63 349.06 257.02 358.64 257.02 357.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.78 342.48 257.02 354.74 257.02 357.94 235.78 345.67 235.78 342.48",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.78 342.48 257.02 354.74 257.02 357.94 235.78 345.67 235.78 342.48",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.02 357.94 236.27 345.96 236.27 346.66 257.02 358.64 257.02 357.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.49,356.69l5.67-3.28c.25-.14.44,0,.44.26V357a1,1,0,0,1-.44.77l-5.67,3.27c-.24.14-.44,0-.44-.25v-3.36A1,1,0,0,1,262.49,356.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,357.07l4.95-2.86c.16-.09.29,0,.29.17v2.52a.66.66,0,0,1-.29.51l-4.95,2.85c-.16.1-.29,0-.29-.17v-2.51A.64.64,0,0,1,262.85,357.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263,357.73a.07.07,0,0,1-.06,0,.07.07,0,0,1,0-.1l4.66-2.7a.07.07,0,0,1,.1,0,.08.08,0,0,1,0,.1L263,357.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,358.35a.06.06,0,0,1-.06,0,.07.07,0,0,1,0-.1l4.66-2.69a.07.07,0,0,1,.1,0,.07.07,0,0,1,0,.09l-4.67,2.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,359a.08.08,0,0,1-.06,0,.07.07,0,0,1,0-.1l4.66-2.69a.07.07,0,1,1,.08.12L263,359Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,359.58a.07.07,0,0,1-.06,0,.07.07,0,0,1,0-.1l4.66-2.7a.08.08,0,0,1,.08.13L263,359.57Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabinet--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabinet--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "223.66 399.39 204.89 388.55 204.89 329.7 223.66 340.54 223.66 399.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.66 340.54 250.49 325.06 250.49 383.9 223.66 399.39 223.66 340.54",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.49 325.06 223.66 340.54 204.89 329.7 231.71 314.21 250.49 325.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.35 378.68 247.81 366.29 247.81 381.21 248.3 381.49 226.84 393.88 226.34 393.6 226.35 378.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.84 378.97 248.3 366.58 248.3 381.49 226.84 393.88 226.84 378.97",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "226.84 378.97 248.3 366.58 248.3 381.49 226.84 393.88 226.84 378.97"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,376.64l3.65-2.11c.47-.27.86-.15.86.28a1.72,1.72,0,0,1-.86,1.27l-3.65,2.11c-.47.27-.86.15-.86-.28A1.72,1.72,0,0,1,235.25,376.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.35 360.67 247.81 348.28 247.81 363.2 248.3 363.49 226.84 375.87 226.34 375.59 226.35 360.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.84 360.96 248.3 348.57 248.3 363.49 226.84 375.87 226.84 360.96",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "226.84 360.96 248.3 348.57 248.3 363.49 226.84 375.87 226.84 360.96"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,358.63l3.65-2.11c.47-.27.86-.14.86.28a1.72,1.72,0,0,1-.86,1.27l-3.65,2.11c-.47.27-.86.15-.86-.28A1.72,1.72,0,0,1,235.25,358.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.34 342.67 247.81 330.27 247.8 345.19 248.3 345.48 226.84 357.87 226.34 357.58 226.34 342.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.84 342.95 248.3 330.56 248.3 345.48 226.84 357.87 226.84 342.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "226.84 342.95 248.3 330.56 248.3 345.48 226.84 357.87 226.84 342.95"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M235.25,340.62l3.65-2.11c.47-.27.86-.14.86.28a1.72,1.72,0,0,1-.86,1.27l-3.65,2.11c-.47.27-.86.15-.86-.28A1.74,1.74,0,0,1,235.25,340.62Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Photocopier--inject-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "156.39 405.39 180.81 419.49 218.79 397.56 194.37 383.46 156.39 405.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.81,419.48l-24.42-14.09v2.3a1.62,1.62,0,0,0,.72,1.25l3.35,1.93V409.3l14.92,8.62v1.56l4.7,2.72a1.45,1.45,0,0,0,1.45,0h0l-.72-.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,397.56v2.29a1.6,1.6,0,0,1-.73,1.26L214.72,403v-1.57l-28.49,16.45v1.56l-4.7,2.72c-.4.23-.72,0-.72-.42v-2.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.46 410.87 161.82 410.09 160.46 409.3 160.46 410.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.72 403.04 213.36 402.26 214.72 401.47 214.72 403.04",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.05,396.93a1.67,1.67,0,0,0,.76-1.31V380.1l-24.13-13.92-6.38,3.68v16.39l24.12,13.92Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.05,396.93a1.67,1.67,0,0,0,.76-1.31V380.1l-24.13-13.92-6.38,3.68v16.39l24.12,13.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.3 369.86 188.3 386.25 212.43 400.18 212.43 383.79 188.3 369.86",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.3 369.86 188.3 386.25 212.43 400.18 212.43 383.79 188.3 369.86",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.3 369.86 194.68 366.18 218.81 380.1 212.43 383.79 188.3 369.86",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.3 369.86 194.68 366.18 218.81 380.1 212.43 383.79 188.3 369.86",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.21 405.5 174.82 414.51 174.82 411.24 159.21 402.23 159.21 405.5",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.21 405.5 174.82 414.51 174.82 411.24 159.21 402.23 159.21 405.5",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,418.17,211,401a1.69,1.69,0,0,0,.75-1.31v-4l-24.12-13.93-31.22,18v4a1.67,1.67,0,0,0,.76,1.31l2.08,1.2v-2.46l15.61,9v2.45l4.92,2.84A1.61,1.61,0,0,0,181.25,418.17Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,418.17,211,401a1.69,1.69,0,0,0,.75-1.31v-4l-24.12-13.93-31.22,18v4a1.67,1.67,0,0,0,.76,1.31l2.08,1.2v-2.46l15.61,9v2.45l4.92,2.84A1.61,1.61,0,0,0,181.25,418.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 413.69 211.71 395.67 187.59 381.74 156.37 399.77 180.49 413.69",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 413.69 211.71 395.67 187.59 381.74 156.37 399.77 180.49 413.69",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71,395.67v4.92l-30.46,17.58c-.42.24-.76.05-.76-.43v-4.05Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71,395.67v4.92l-30.46,17.58c-.42.24-.76.05-.76-.43v-4.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.21 406.32 159.92 405.91 159.92 404.27 159.21 403.86 159.21 406.32",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.21 406.32 159.92 405.91 159.92 404.27 159.21 403.86 159.21 406.32",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,413.29c.39-.23.71-.05.71.4a1.55,1.55,0,0,1-.71,1.23c-.39.23-.71.05-.71-.41A1.55,1.55,0,0,1,184,413.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.87,399v.82c0,.45-.67,1.21-1.51,1.69L189.1,412c-.83.48-1.51.51-1.51.06v-.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,412.44,211,395.29a1.69,1.69,0,0,0,.75-1.31v-4L187.59,376l-31.22,18v4a1.66,1.66,0,0,0,.76,1.31l22.61,13.06A1.67,1.67,0,0,0,181.25,412.44Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,412.44,211,395.29a1.69,1.69,0,0,0,.75-1.31v-4L187.59,376l-31.22,18v4a1.66,1.66,0,0,0,.76,1.31l22.61,13.06A1.67,1.67,0,0,0,181.25,412.44Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 407.96 211.71 389.94 187.59 376.01 156.37 394.03 180.49 407.96",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 407.96 211.71 389.94 187.59 376.01 156.37 394.03 180.49 407.96",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71,389.94v4.91l-30.46,17.59c-.42.24-.76,0-.76-.44v-4Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71,389.94v4.91l-30.46,17.59c-.42.24-.76,0-.76-.44v-4Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,407.55c.39-.23.71,0,.71.41a1.59,1.59,0,0,1-.71,1.23c-.39.22-.71,0-.71-.41A1.59,1.59,0,0,1,184,407.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.87,393.21V394c0,.45-.67,1.21-1.51,1.69L189.1,406.27c-.83.48-1.51.5-1.51.05v-.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,406.7,211,389.55a1.69,1.69,0,0,0,.75-1.31v-4l-24.12-13.93-31.22,18v4a1.67,1.67,0,0,0,.76,1.31l22.61,13.05A1.61,1.61,0,0,0,181.25,406.7Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,406.7,211,389.55a1.69,1.69,0,0,0,.75-1.31v-4l-24.12-13.93-31.22,18v4a1.67,1.67,0,0,0,.76,1.31l22.61,13.05A1.61,1.61,0,0,0,181.25,406.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 402.23 211.71 384.2 187.59 370.27 156.37 388.3 180.49 402.23",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 402.23 211.71 384.2 187.59 370.27 156.37 388.3 180.49 402.23",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71,384.2v4.92L181.25,406.7c-.42.24-.76.05-.76-.43v-4Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71,384.2v4.92L181.25,406.7c-.42.24-.76.05-.76-.43v-4Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,401.82c.39-.23.71-.05.71.4a1.55,1.55,0,0,1-.71,1.23c-.39.23-.71.05-.71-.41A1.55,1.55,0,0,1,184,401.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.87,387.48v.82c0,.45-.67,1.21-1.51,1.69L189.1,400.53c-.83.48-1.51.51-1.51.06v-.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 401.4 218.81 379.28 218.81 361.26 194.68 347.33 156.37 369.45 156.37 387.48 180.49 401.4",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 401.4 218.81 379.28 218.81 361.26 194.68 347.33 156.37 369.45 156.37 387.48 180.49 401.4",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.81 361.26 180.49 383.38 156.37 369.45 194.68 347.33 218.81 361.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 389.94 180.49 401.4 156.37 387.48 156.37 376.01 180.49 389.94",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.49 389.94 180.49 401.4 156.37 387.48 156.37 376.01 180.49 389.94",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.37 369.45 156.37 376.01 180.49 389.94 180.49 383.38 156.37 369.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.49,383.38l34.06-19.66v4.92a2.83,2.83,0,0,1-1.42,2.45l-32.64,18.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.13,368.63c0-.45-.32-.63-.71-.41a1.59,1.59,0,0,0-.71,1.23c0,.46.32.64.71.41A1.55,1.55,0,0,0,213.13,368.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.54,369.89l-4.17,2.4a1.64,1.64,0,0,0-.75,1.26c0,.45.34.62.75.38l4.17-2.4a1.64,1.64,0,0,0,.75-1.26C210.29,369.82,210,369.65,209.54,369.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,358v2.46l-4.26,2.46v-2.46a14.2,14.2,0,0,0-7.1-12.29l-17-9.83,4.25-2.46,17,9.83A14.2,14.2,0,0,1,218.81,358Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,358v2.46l-4.26,2.46v-2.46a14.2,14.2,0,0,0-7.1-12.29l-17-9.83,4.25-2.46,17,9.83A14.2,14.2,0,0,1,218.81,358Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.49,380.11v2.45l-24.12-13.93V358l17,9.83A14.2,14.2,0,0,1,180.49,380.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.55,360.44v2.46l-34.06,19.66v-2.45a14.19,14.19,0,0,0-7.1-12.3l-17-9.83,34.06-19.66,17,9.83A14.2,14.2,0,0,1,214.55,360.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.04 399.77 162.04 387.48 162.75 387.07 172.69 392.8 172.69 405.09 171.98 405.5 162.04 399.77",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.04 399.77 162.04 387.48 162.75 387.07 172.69 392.8 172.69 405.09 171.98 405.5 162.04 399.77",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.04 399.77 162.04 387.48 171.98 393.21 171.98 405.5 162.04 399.77",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.04 399.77 162.04 387.48 171.98 393.21 171.98 405.5 162.04 399.77",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.75 387.07 162.04 387.48 171.98 393.21 172.69 392.8 162.75 387.07",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.75 387.07 162.04 387.48 171.98 393.21 172.69 392.8 162.75 387.07",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,349a.37.37,0,0,0-.22-.29l-10.28-5.94a1.12,1.12,0,0,0-1,0L175,351.53a.36.36,0,0,0-.21.29v.47a.36.36,0,0,0,.21.3l10.28,5.94a1.19,1.19,0,0,0,1,0l15.13-8.74a.4.4,0,0,0,.22-.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,351.53l15.13-8.74a1.12,1.12,0,0,1,1,0l10.28,5.94a.31.31,0,0,1,0,.59l-15.13,8.74a1.19,1.19,0,0,1-1,0L175,352.12A.31.31,0,0,1,175,351.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.83,358.18v.47a1.11,1.11,0,0,1-.52-.12L175,352.59a.36.36,0,0,1-.21-.3v-.47a.36.36,0,0,0,.21.3l10.28,5.94A1.11,1.11,0,0,0,185.83,358.18Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,348.3a.37.37,0,0,0-.22-.3l-10.28-5.94a1.12,1.12,0,0,0-1,0L175,350.8a.36.36,0,0,0-.21.3v.46a.36.36,0,0,0,.21.3l10.28,5.94a1.19,1.19,0,0,0,1,0l15.13-8.74a.4.4,0,0,0,.22-.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,350.8l15.13-8.74a1.12,1.12,0,0,1,1,0L201.48,348a.31.31,0,0,1,0,.59l-15.13,8.74a1.12,1.12,0,0,1-1,0L175,351.39A.31.31,0,0,1,175,350.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.83,357.45v.47a1.11,1.11,0,0,1-.52-.12L175,351.86a.36.36,0,0,1-.21-.3v-.47a.35.35,0,0,0,.21.3l10.28,5.94A1.11,1.11,0,0,0,185.83,357.45Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.63,357.16l15.61,9,18.44-10.66v-4.91l-15.61-9-14.19,8.19a8.51,8.51,0,0,0-4.25,7.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.68,350.61l-14.19,8.19a8.52,8.52,0,0,0-4.25,7.38h0l18.44-10.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.38,361.92a8.43,8.43,0,0,0-1.15,4.25h0l-15.6-9a8.58,8.58,0,0,1,1.13-4.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 351.43 179.07 344.87 187.59 349.79 176.24 356.34 167.72 351.43",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.43 351.84 176.24 356.34 186.88 350.2 179.07 345.69 168.43 351.84",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.07 344.87 179.07 345.69 168.43 351.84 167.72 351.43 179.07 344.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.12,355l-.37-.21a.13.13,0,0,1,0-.24l1.14-.66a.49.49,0,0,1,.41,0l.36.21c.12.07.12.18,0,.24l-1.13.66A.49.49,0,0,1,176.12,355Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.44,353.7l-.36-.21c-.12-.07-.12-.17,0-.24l1.13-.66a.49.49,0,0,1,.41,0l.37.21c.11.07.11.18,0,.24l-1.14.66A.49.49,0,0,1,178.44,353.7Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.76,352.36l-.36-.21c-.12-.07-.12-.18,0-.24l1.13-.66a.51.51,0,0,1,.42,0l.36.21a.13.13,0,0,1,0,.24l-1.14.66A.49.49,0,0,1,180.76,352.36Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,351l-.36-.21c-.11-.07-.11-.18,0-.24l1.13-.66a.51.51,0,0,1,.42,0l.36.21a.13.13,0,0,1,0,.24l-1.14.66A.49.49,0,0,1,183.08,351Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.88,351.66a4,4,0,0,1,.76-.28l.14.19-.4.08a1.42,1.42,0,0,0-.33.12c-.36.21-.2.52.45.9a1.65,1.65,0,0,0,1.55.26.58.58,0,0,0,.21-.2l.13-.23.33.08a1.74,1.74,0,0,1-.48.44l-.06,0a2.21,2.21,0,0,1-2.13-.13c-.71-.41-.8-.9-.23-1.23Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176,350.63c.71.41.78.91.19,1.26a2.23,2.23,0,0,1-2.17-.12c-.71-.4-.78-.9-.19-1.25A2.25,2.25,0,0,1,176,350.63Zm-1.54.89a1.6,1.6,0,0,0,1.62.21c.31-.18.13-.47-.51-.84a1.66,1.66,0,0,0-1.62-.22C173.66,350.85,173.84,351.15,174.48,351.52Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M176.32,349.13a1.79,1.79,0,0,1,1.72-.06c.52.29.5.7,0,1l-.48.28.63.36-.42.25-2.29-1.33Zm1,1.13.38-.22c.38-.21.34-.47-.1-.72a1.18,1.18,0,0,0-1.2,0l-.38.22Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.58,348.41l.42-.28,1.95.35-.09-.18a2.75,2.75,0,0,0-.68-.86l.4-.18.63,1.21.93.54-.42.24-.77-.45Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "159.82 373.65 175.43 382.67 175.43 384.65 159.82 375.64 159.82 373.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.82 383.75 174.82 393.21 160.63 385.02 160.63 375.76 174.82 383.75",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,382.84l-14.19-8.19-16.19,4.67c-.25.07-.38.19-.38.33v.9c0,.12.1.25.29.36L157,388.23a2.33,2.33,0,0,0,1.6.19l16.19-4.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,382.84l-16.19,4.67a2.33,2.33,0,0,1-1.6-.19L144.35,380c-.41-.24-.38-.54.09-.68l16.19-4.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,387.55v.91a2.12,2.12,0,0,1-.76-.23l-12.68-7.32c-.19-.11-.29-.24-.29-.36v-.9c0,.11.1.24.29.35L157,387.32A1.94,1.94,0,0,0,157.79,387.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.67,381.07c0-.06,0-.12-.14-.18l-9.18-5.3a1.17,1.17,0,0,0-.8-.09l-14.16,4.1c-.12,0-.18.1-.18.17v.67c0,.06,0,.12.14.18l9.18,5.3a1.17,1.17,0,0,0,.8.09l14.15-4.1c.13,0,.19-.1.19-.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,381.23l-14.15,4.11a1.23,1.23,0,0,1-.8-.1l-9.18-5.3c-.21-.12-.19-.27,0-.34l14.16-4.1a1.17,1.17,0,0,1,.8.09l9.18,5.3C171.73,381,171.72,381.16,171.48,381.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.67,381.07v.68c0,.06-.07.12-.18.16L157.33,386a1,1,0,0,1-.35,0v-.67a1,1,0,0,0,.35,0l14.16-4.11C171.61,381.19,171.67,381.14,171.67,381.07Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--files--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.79,300.38a.25.25,0,0,0-.23,0,2.67,2.67,0,0,1-.24.14l.15,15.62a.69.69,0,0,0,.32.55L246,323.72V307.43Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.79,300.38a.25.25,0,0,0-.23,0,2.67,2.67,0,0,1-.24.14l.15,15.62a.69.69,0,0,0,.32.55L246,323.72V307.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.55,300.51c-.17-.1-.32,0-.32.19v15.55a.72.72,0,0,0,.32.55l12.23,7.06V307.57Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.55,300.51c-.17-.1-.32,0-.32.19v15.55a.72.72,0,0,0,.32.55l12.23,7.06V307.57Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.77,322.34l-9.05-5.23a.69.69,0,0,1-.31-.54V302.22l-1.19-.68,1.21-.69h0a.19.19,0,0,1,.27,0l10.37,6V323.1l-1.32.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.4,301.59c-.17-.1-.31,0-.31.18v15.56a.71.71,0,0,0,.31.55l10.37,6V307.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.77 307.58 244.09 306.81 244.09 323.1 242.77 323.87 242.77 307.58",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.34,308a.53.53,0,0,0,0-.12.42.42,0,0,0-.09-.16l-.05,0c-.09-.06-.17,0-.17.12a.33.33,0,0,0,0,.17.35.35,0,0,0,.13.16h0C242.27,308.19,242.34,308.14,242.34,308Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.17,308.81a.85.85,0,0,0,.37-.41.56.56,0,0,0,0-.5h0a.83.83,0,0,0-.33-.31l-.08,0v.21c.42.25.42.65,0,.9a1.72,1.72,0,0,1-1.56,0,.54.54,0,0,1-.32-.5.42.42,0,0,1,.12-.25.42.42,0,0,0-.09-.16.59.59,0,0,0-.14.75,1.05,1.05,0,0,0,.34.32A1.93,1.93,0,0,0,244.17,308.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.69,309.13l-11.23-7.56.17-.1a.36.36,0,0,1,.32,0l11,7.53Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.69,309.13l-11.23-7.56.17-.1a.36.36,0,0,1,.32,0l11,7.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,301.59c-.17-.1-.31,0-.31.18v15.56a.71.71,0,0,0,.31.55l11.2,7.65V309.24Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.01 307.43 246.01 323.72 242.87 325.53 242.87 309.24 246.01 307.43",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.01 307.43 246.01 323.72 242.87 325.53 242.87 309.24 246.01 307.43",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.39,311a.59.59,0,0,0-.42-.28.77.77,0,0,0-.53.12,1.91,1.91,0,0,0-.88,1.52.94.94,0,0,0,.11.45.66.66,0,0,0,1,.16,1.92,1.92,0,0,0,.87-1.52.93.93,0,0,0-.1-.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.53,311c.43-.25.78-.05.78.45a1.74,1.74,0,0,1-.78,1.36c-.44.25-.79.05-.79-.45A1.72,1.72,0,0,1,244.53,311Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.37,314.37l.24-.13c.48-.28.86-.06.86.49v7.06a1.88,1.88,0,0,1-.86,1.49l-.24.14c-.47.27-.86.05-.86-.5v-7.06A1.92,1.92,0,0,1,244.37,314.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.82 307.32 242.7 309.12 242.87 309.24 246.01 307.43 245.82 307.32",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.82 307.32 242.7 309.12 242.87 309.24 246.01 307.43 245.82 307.32",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.13,325.81a.28.28,0,0,0,.12-.23v-16a.29.29,0,0,0-.14-.24l-11.63-7.6-.24.14v16.28l11.64,7.61A.28.28,0,0,0,242.13,325.81Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,309.61l.24-.14a.43.43,0,0,1,0,.14v16a.24.24,0,0,1-.37.22c.07,0,.13,0,.13-.08v-16A.25.25,0,0,0,242,309.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.24,301.91l11.63,7.6a.24.24,0,0,1,.1.1.25.25,0,0,1,0,.14v16c0,.08-.06.12-.13.08l-11.64-7.61Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.24,301.91l.24-.14,11.63,7.6a.32.32,0,0,1,.1.1l-.24.14a.24.24,0,0,0-.1-.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.43 302.01 230.44 318.3 227.3 320.12 227.33 303.81 230.43 302.01",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.43 302.01 230.44 318.3 227.3 320.12 227.33 303.81 230.43 302.01",
    style: {
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.36,326.63a.34.34,0,0,0,.34,0l.64-.36a.4.4,0,0,0,.17-.3V310.08a.39.39,0,0,0-.18-.3l-10.17-6.26-1,.57v16.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.18,320.37l10.18,6.26c.1.06.17,0,.17-.1V310.64a.35.35,0,0,0-.18-.29l-10.17-6.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.93,305.2a.53.53,0,0,0,0-.12.42.42,0,0,0-.09-.16l-.05,0c-.09-.06-.17,0-.17.13a.32.32,0,0,0,0,.16.35.35,0,0,0,.13.16h0C230.86,305.37,230.93,305.32,230.93,305.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.47,310.48l1-.57a.27.27,0,0,1,.06.17V326a.4.4,0,0,1-.17.3l-.64.36a.33.33,0,0,1-.29,0c.07,0,.12,0,.12-.11V310.65A.27.27,0,0,0,240.47,310.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.65,304.39a.67.67,0,0,0,.39.6,2.44,2.44,0,0,0,1.73.12c0-.08-.07-.18-.08-.22a2.16,2.16,0,0,1-1.53-.11.47.47,0,0,1-.23-.21.35.35,0,0,1-.05-.18c0-.21.21-.46.56-.64a2.44,2.44,0,0,1,2.11-.12.62.62,0,0,1,.26.27l.25.15v0a.52.52,0,0,0-.08-.3.75.75,0,0,0-.31-.3,2.72,2.72,0,0,0-2.35.11A1.08,1.08,0,0,0,228.65,304.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.14,327a.28.28,0,0,0,.12-.23v-16a.33.33,0,0,0-.14-.24l-12.76-6.95-.24.14V320L239.88,327A.3.3,0,0,0,240.14,327Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,310.76l.23-.14a.48.48,0,0,1,0,.14v16a.28.28,0,0,1-.12.23.3.3,0,0,1-.26,0c.08,0,.14,0,.14-.08v-16A.37.37,0,0,0,240,310.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.12,303.71l12.76,7a.32.32,0,0,1,.1.1.37.37,0,0,1,0,.14v16c0,.09-.06.12-.14.08l-12.76-7Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.12,303.71l.24-.14,12.76,6.95a.22.22,0,0,1,.09.1l-.23.14a.32.32,0,0,0-.1-.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.24 301.91 227.12 303.71 227.33 303.81 230.43 302.01 230.24 301.91",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.24 301.91 227.12 303.71 227.33 303.81 230.43 302.01 230.24 301.91",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.29,304.13a.23.23,0,0,0-.22,0l-.24.14.15,15.62a.71.71,0,0,0,.31.55l12.23,7.06V311.18Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.29,304.13a.23.23,0,0,0-.22,0l-.24.14.15,15.62a.71.71,0,0,0,.31.55l12.23,7.06V311.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06,304.26c-.18-.1-.32,0-.32.19V320a.69.69,0,0,0,.32.55l12.22,7.06V311.32Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.06,304.26c-.18-.1-.32,0-.32.19V320a.69.69,0,0,0,.32.55l12.22,7.06V311.32Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,326.09l-9.05-5.23a.68.68,0,0,1-.32-.54V306l-1.18-.68,1.21-.69h0c0-.08.15-.1.27,0l10.36,6v16.29l-1.32.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91,305.34c-.17-.1-.32,0-.32.18v15.56a.74.74,0,0,0,.32.55l10.37,6V311.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.27 311.33 237.59 310.56 237.6 326.85 236.28 327.61 236.27 311.33",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.84,311.77a.5.5,0,0,0,0-.12.44.44,0,0,0-.1-.16.1.1,0,0,0-.05,0c-.09-.06-.17,0-.16.12a.33.33,0,0,0,0,.17.27.27,0,0,0,.12.15h0C235.78,311.94,235.84,311.89,235.84,311.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.67,312.56a.83.83,0,0,0,.38-.41.59.59,0,0,0,0-.5h0a.86.86,0,0,0-.34-.31l-.08,0v.21c.43.25.42.65,0,.9a1.72,1.72,0,0,1-1.56,0c-.24-.14-.35-.32-.32-.5a.37.37,0,0,1,.12-.25.44.44,0,0,0-.1-.16.59.59,0,0,0-.17.25.56.56,0,0,0,0,.5.92.92,0,0,0,.33.32A1.93,1.93,0,0,0,237.67,312.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.2,312.88,225,305.32l.17-.1a.34.34,0,0,1,.31,0l11,7.52Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.2,312.88,225,305.32l.17-.1a.34.34,0,0,1,.31,0l11,7.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.19,305.34c-.18-.1-.32,0-.32.18v15.56a.69.69,0,0,0,.32.55l11.19,7.65V313Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.51 311.18 239.52 327.47 236.38 329.28 236.38 312.99 239.51 311.18",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.51 311.18 239.52 327.47 236.38 329.28 236.38 312.99 239.51 311.18",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.89,314.75a.54.54,0,0,0-.41-.28.79.79,0,0,0-.54.12,1.9,1.9,0,0,0-.87,1.52.87.87,0,0,0,.1.44.65.65,0,0,0,1,.17,1.9,1.9,0,0,0,.88-1.52.94.94,0,0,0-.11-.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,314.75c.44-.25.79-.05.79.45a1.72,1.72,0,0,1-.79,1.36c-.43.25-.78.05-.78-.45A1.74,1.74,0,0,1,238,314.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.88,318.12l.24-.14c.47-.27.86-.05.86.5v7.06a1.91,1.91,0,0,1-.86,1.49l-.24.14c-.48.27-.86.05-.86-.5v-7.06A1.89,1.89,0,0,1,237.88,318.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.33 311.07 236.21 312.87 236.38 312.99 239.51 311.18 239.33 311.07",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.33 311.07 236.21 312.87 236.38 312.99 239.51 311.18 239.33 311.07",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-26",
    d: "M227.42,327.41c2.78,1.6,2.78,4.21,0,5.81a11.12,11.12,0,0,1-10.08,0c-2.78-1.6-2.78-4.2,0-5.81A11.12,11.12,0,0,1,227.42,327.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.61,330.63c2.25-2.29,3.56-8,1.37-9.84H216.84c-2.19,1.82-.88,7.54,1.37,9.84l.06.06.08.07a1.12,1.12,0,0,0,.2.18l0,.05.17.12.29.19a7.39,7.39,0,0,0,6.7,0h0l.29-.19.16-.12.06-.05.2-.17.09-.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.8,320.06c-2.54,1.47-2.54,3.85,0,5.32a10.19,10.19,0,0,0,9.22,0c2.54-1.47,2.54-3.85,0-5.32A10.19,10.19,0,0,0,217.8,320.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.61,321.1c-1.55.9-1.55,2.35,0,3.24a6.21,6.21,0,0,0,5.6,0c1.55-.89,1.55-2.34,0-3.24A6.21,6.21,0,0,0,219.61,321.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.21,322.64a6.21,6.21,0,0,0-5.6,0,.85.85,0,1,0,0,1.7,6.21,6.21,0,0,0,5.6,0,.85.85,0,1,0,0-1.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.32,323.87a10.12,10.12,0,0,1-.54-5.14,11.17,11.17,0,0,1,4-7.1c2-1.29,4.64.25,2.34,2.91s-4.45,6.35-4.26,9.18Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.32,323.87a10.12,10.12,0,0,1-.54-5.14,11.17,11.17,0,0,1,4-7.1c2-1.29,4.64.25,2.34,2.91s-4.45,6.35-4.26,9.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M224.16,323.54a.16.16,0,0,0,.1,0,.14.14,0,0,0,.09-.17,9.91,9.91,0,0,1,1-7.76,8.35,8.35,0,0,1,3.25-3.45.16.16,0,0,0,.1-.17.15.15,0,0,0-.17-.1,8.58,8.58,0,0,0-3.42,3.59,10.16,10.16,0,0,0-1,8A.13.13,0,0,0,224.16,323.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.82,323.84a1.33,1.33,0,0,0-.55-.73,5.91,5.91,0,0,0-1-.43c-.6-.21-1.37-.53-1.45-1.25a2,2,0,0,1,.1-.77,1.74,1.74,0,0,0,.1-1.05c-.13-.33-.48-.5-.77-.69a2.42,2.42,0,0,1-.8-.76,1.55,1.55,0,0,1-.24-.93c.06-.67.7-1.12.72-1.78,0-1-2.25-2.3-1-3.22,1.55-1.17,4,.19,4.68,1.19s.7,1.45,2,2.29c1.06.71,2.3.85,2.3,2.23s-1.77,1.45-.37,3c.84,1-.55,1.76-1.06,2.88A2.32,2.32,0,0,1,220.82,323.84Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.23,324.24h0a.13.13,0,0,1-.13-.14c.31-8.05-3.79-10.88-4.61-11.1a.13.13,0,0,1-.09-.17.13.13,0,0,1,.16-.09c1.39.37,5.1,3.77,4.81,11.37A.13.13,0,0,1,222.23,324.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.43,318.24a.16.16,0,0,1-.09,0,6.18,6.18,0,0,0-3.53-1,.14.14,0,0,1-.14-.14.13.13,0,0,1,.13-.14,6.34,6.34,0,0,1,3.72,1.09.14.14,0,0,1,0,.2A.12.12,0,0,1,221.43,318.24Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.22,407.93a1.36,1.36,0,0,0,.3,1.47,7.32,7.32,0,0,0,5,1,9.18,9.18,0,0,0,4.84-1.76,10.73,10.73,0,0,1,3.53-2.06,7.29,7.29,0,0,0,2.52-.94c.33-.3.29-1.61.29-1.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.73,399a.4.4,0,0,1,.38.31c.08.36.16,1.42.33,2a9.61,9.61,0,0,1,.24,3.19c-.14.67-1.85,1.14-2.94,1.52a14.55,14.55,0,0,0-3.54,2,10.6,10.6,0,0,1-5.26,1.79c-1.93,0-4.09-.58-4.59-1.4-.61-1-.13-1.59,2.72-2.79.54-.23,2.44-1.25,3.08-1.62a10.13,10.13,0,0,0,4.29-4.18.77.77,0,0,1,1-.59,5,5,0,0,1,1.37.38c.38.16.93.36.92.8a1.47,1.47,0,0,1-.11.46c0,.09-.06.21,0,.26s.19,0,.26-.06a7.59,7.59,0,0,0,.77-.84,2.55,2.55,0,0,1,.45-.42,4.53,4.53,0,0,0,.49-.29C283.77,399.42,283.73,399.22,283.73,399Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.2,408.08c.5-.37,1-.74,1.56-1.06h0s-3.36,1.86-4.71,1a1,1,0,0,1-.44-1.41,5.62,5.62,0,0,0-2.62-1.39l-1.08.44c-2.86,1.21-2.93,1.72-2.79,2.69.49.82,2.3,1.56,4.78,1.56A10.86,10.86,0,0,0,278.2,408.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.43,411.94a6.62,6.62,0,0,0,.58,3.55,2.6,2.6,0,0,0,2.78,1.18c1.18-.16,2.73-.73,3.2-2a7.72,7.72,0,0,0,.41-3.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.23,401.22c.47.08.38,2.16.43,4.25s.67,3.23.73,5.07c.07,2.1-.16,3-1.1,4.2s-3.91,2.15-5.11.23c-1-1.57-.84-3.2-.51-5.27a46.06,46.06,0,0,0,.69-5.26c.08-1.56.13-3.08.56-3.22,0,.23,0,.53,0,.75s0,1,.22,1.06a3,3,0,0,0,.07-.59.67.67,0,0,1,.19-.49.91.91,0,0,1,.54-.16,13.83,13.83,0,0,1,1.43-.07,5.53,5.53,0,0,1,.71,0,2,2,0,0,1,.6.13.43.43,0,0,1,.23.23.65.65,0,0,1,0,.24,1.24,1.24,0,0,0,0,.43c0,.07.05.15.12.14s.08-.07.09-.12c0-.25,0-.44,0-.73,0-.14,0-.32,0-.46S299.23,401.36,299.23,401.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.35,409.94c0,.3.07,2.31-.56,2.61s-1.14-1.25-1.14-1.25a4.93,4.93,0,0,0-3.34-.08c-.08.46-.53,1.54-1.11,1.26s-.55-2.57-.55-2.6c-.32,2-.41,3.56.53,5.09,1.2,1.92,4.17.95,5.11-.23s1.17-2.1,1.1-4.2C300.38,410.33,300.37,410.13,300.35,409.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.37,337.34a29.39,29.39,0,0,1,2.27,8.51c.82,10.67,1.23,26.16,1.23,26.16.1,1.12.81,3.65,1.28,8.56.56,5.79-.7,26.71-.7,26.71s-4,2.65-6.71.29c0,0-2.89-29-3.62-34.79-.63-5-2.06-13.48-2.06-13.48l-1.29,14.61s-.23,4.13-.37,7c-.15,3.41-1.67,21.41-1.67,21.41s-5.35,2.86-7.65-.54c0,0,.1-25.4,0-29.5-.14-8,.28-23,.56-31.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.06,359.3,287,351.74s-4.33-.58-6.29-2.42a7.12,7.12,0,0,0,5.1,3.22l.76,4.63.39,15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,338.83l3.16,3.51s2.58-3.22,2.48-3.22-3-4.73-3-4.73Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.24,313.5c-4.22,1.2-4.27.92-6.94,4.47-1.85,2.47-5.55,7-6.63,8.92-1.22,2.12-1.39,3-.43,4.57s6.21,7.62,6.21,7.62c1.27-1,2.68-1.92,3.38-3.71l-3.38-5.65,7-7.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.44,312.37a32.13,32.13,0,0,1,6.09,2.82,100.65,100.65,0,0,1-1.91,12c-.88,3.43-1.37,15.29-1.37,15.29a27.22,27.22,0,0,1-12.35,2,24.92,24.92,0,0,1-8.35-1.91s-.28-7.46.25-16.79c.39-6.87.65-10.48,2.32-11.49,1-.6,5.33-2.31,5.33-2.31a9.7,9.7,0,0,0,1,3.12C287.91,314.33,295.44,312.37,295.44,312.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,344.4l-1-.12a88.54,88.54,0,0,1,2.47-29.19S283.48,329.85,285,344.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.65,344.66v16.68a.35.35,0,0,0,.13.31l.75.44a.27.27,0,0,0,.12,0,.49.49,0,0,0,.22-.06l18.91-10.92a1.09,1.09,0,0,0,.48-.85V333.63a.33.33,0,0,0-.14-.31l0,0h0l-.7-.41a.28.28,0,0,0-.13,0,.51.51,0,0,0-.22.07l-9.91,5.71-1.17.68-1.75,1-.05,0-6,3.47-.09.08a.89.89,0,0,0-.25.29A1,1,0,0,0,293.65,344.66Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.79,344.18l.73.43h0a.41.41,0,0,1,.07-.11,1,1,0,0,1,.17-.19l.1-.07,6-3.47,1.79-1,.72-.42,10.38-6a.34.34,0,0,1,.31-.05l-.7-.41a.28.28,0,0,0-.13,0,.4.4,0,0,0-.22.07l-9.91,5.71-1.17.68-1.75,1-.05,0-6,3.47-.09.08A.89.89,0,0,0,293.79,344.18Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.26,333.63v16.66a1.07,1.07,0,0,1-.49.85l-19,10.95a.29.29,0,0,1-.43-.25V345.09a1,1,0,0,1,.14-.48,1,1,0,0,1,.35-.37l6-3.47,1.79-1,11.1-6.4a.35.35,0,0,1,.32-.05h0A.35.35,0,0,1,314.26,333.63Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,344.61h0a.41.41,0,0,1,.07-.11A.44.44,0,0,0,294.52,344.61Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.56,362.1s0,0,0,0l-.76-.44a.35.35,0,0,1-.13-.31V344.66a1,1,0,0,1,.14-.48l.73.43h0a1,1,0,0,0-.14.48v16.75A.28.28,0,0,0,294.56,362.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.3,358.41c-.23.14-.33-.29-.38-.92l0-1.16s-.88.8-1.1-1.88c-.24-2.95,1.08-3.49,1.08-3.49s0-.49,0-1.46.2-1.21.43-1.37l.33-.17V358.2A4,4,0,0,0,293.3,358.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.38,357c0-.88.08-1.4.65-1.74a9.93,9.93,0,0,1,.92-.53l.16-5.43s-.93.62-1.24.81-.51-.92-.49-1.25l-.76.35-.09,8.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,356.42l-.66.4c-.37.22-.53-.9-.36-2.51l-.16-3.59c.17-1.61.19-3.09.56-3.31l.67-.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,335.78c-4-16.37-6.07-21.4-10.93-21.33-1.42,1.7.07,7,1,9.55,0,0,4.31,10.51,5.11,14.27a53,53,0,0,1,1.44,10.28,2.06,2.06,0,0,1-.55,1.35c-.92,1-.92,1.79-1.51,2.88-.47.86-1,1.18-.83,1.38a1.12,1.12,0,0,0,1.5.11,5.68,5.68,0,0,0,1.14-1.09,12.65,12.65,0,0,1-.89,3.76l-1,.59s.31,1.05,2.77.35c2.77-.8,3.77-1.14,4.06-5.85a34.44,34.44,0,0,0,.05-5.22A90.06,90.06,0,0,0,308.25,335.78Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.19,313.05s4.91,1.14,6.09,2.94c1.36,2.08,1.87,4.77,4.16,12.89A70.37,70.37,0,0,1,310,347.6a6.47,6.47,0,0,1-5.5-.19s-1.17-7.07-2.21-10.83S298,324.67,298,324.67,295.34,318.71,297.19,313.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.52,300.27a1.7,1.7,0,0,0,.37,2.87,10.24,10.24,0,0,0,2.24,2.07,13.27,13.27,0,0,0,6.51,1.94c.29,0,.54-.13.94-.17.57-.06,1.39-.05,1.6.43a2.13,2.13,0,0,0,1.91,1.1,1.69,1.69,0,0,0,1.54-1.63,1.87,1.87,0,0,0,2-.56,1.64,1.64,0,0,0,0-1.94,1.92,1.92,0,0,0,1.42-1.44,1.55,1.55,0,0,0-.74-1.7,1.73,1.73,0,0,0,1.3-1.54c.06-.54-.37-1.81-1.43-1.9a2.29,2.29,0,0,0,.2-2.39,2.42,2.42,0,0,0-2.76-1.21,2.32,2.32,0,0,0-.44-1.91,2.64,2.64,0,0,0-1.95-.89,2.7,2.7,0,0,0-1.56.42,2.32,2.32,0,0,0-2.15-1.48,2.47,2.47,0,0,0-1.34.3,2.83,2.83,0,0,0-.57.45c-.06.06-.44.49-.39.56a1.87,1.87,0,0,0-2-.63,1.75,1.75,0,0,0-1.19,1.69,1.58,1.58,0,0,0-2.13.06,1.39,1.39,0,0,0,.17,2,1.35,1.35,0,0,0-1.41.62,1.19,1.19,0,0,0,.25,1.45,2,2,0,0,0-1.18,1.62A2,2,0,0,0,280.52,300.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.62,306.35a1.56,1.56,0,0,1-1.89-.06l0,3.91s0,1-2.25,2.35c-1.38.85-2.56.9-4,2.54A6.41,6.41,0,0,1,286,312v-1.83a11,11,0,0,1-2.09,0,3.3,3.3,0,0,1-2.54-2.72c-.63-2.31-.32-5.58.6-10.06,1.49-1.14,6.24-1.48,9.35.52-.17,2.64.55,3.82.54,4.78a2.48,2.48,0,0,0,.57.74c.48.43.88-.66,1.29-1.09a1.44,1.44,0,0,1,2.4.42C296.8,304.15,295.55,305.76,294.62,306.35Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.41,315.09c-1.22-.81-2.21,1.23-2.42.92s1.09-4.79,2-5v1.76A14.44,14.44,0,0,0,286.41,315.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.71,309.7v.5c-.09.47-1,1.56-3.36,2.61s-2.94,2.28-2.94,2.28a1.55,1.55,0,0,1,1.48.23c1,.59,2,2.09,2.47,2.07s2.07-1.75,3.4-3.15c1.11-1.17,1.68-1.87,1.68-1.87S293.62,309.71,292.71,309.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,301.83a.6.6,0,0,0,.58.62.6.6,0,0,0,.6-.61.59.59,0,1,0-1.18,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,300l1.4.38a.76.76,0,0,0-.53-.91A.7.7,0,0,0,287,300Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.15,300.06l1.43-.33a.71.71,0,0,0-.86-.56A.78.78,0,0,0,282.15,300.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.47,301.76a.6.6,0,1,0,.6-.61A.6.6,0,0,0,282.47,301.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.6 300.54 285.14 304.81 282.86 304.1 285.6 300.54",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.92,302.3c-.29,2.83-1.31,3.27-2.3,3.53-1.57.4-2.74-.41-4.55-.81-1.2-.27-1.7.21-2.87.37-.38.05-.78.05-.92-.44a10.24,10.24,0,0,1,0-3.29l-.17-.81s-.33,3.91-.26,5.26,0,2.44,1,3.29,3.26,1.3,6,.86,3.73-1.26,4.1-2.18c1.22-3,.89-4.47,1.27-5S291.92,302.3,291.92,302.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.24,306.47l-1.29.28a.65.65,0,0,0,.77.53A.69.69,0,0,0,286.24,306.47Z",
    style: {
      fill: "#874c4c"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plaque--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--comapany-title--inject-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--block--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.09,467.35l3.79,2.19a4.79,4.79,0,0,0,4.33,0l109.41-63.17a4.8,4.8,0,0,0,2.16-3.75V370.1a4.8,4.8,0,0,0-2.16-3.75l-3.8-2.19a4.73,4.73,0,0,0-4.33,0l-109.4,63.16a4.78,4.78,0,0,0-2.17,3.75V463.6A4.8,4.8,0,0,0,313.09,467.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.62,368.85,321.21,432a4.8,4.8,0,0,0-2.16,3.75v32.53c0,1.38,1,1.94,2.16,1.25l109.41-63.17a4.8,4.8,0,0,0,2.16-3.75V370.1C432.78,368.72,431.81,368.16,430.62,368.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.84,469.71a4.83,4.83,0,0,1-4-.17l-3.79-2.19a4.78,4.78,0,0,1-2.17-3.75V431.07a4.43,4.43,0,0,1,.63-2.13l8.13,4.69a4.31,4.31,0,0,0-.64,2.13v32.53C319.05,469.53,319.82,470.1,320.84,469.71Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,433.53c0,.23,0,.53,0,.93s0,.79,0,1.2,0,.82,0,1.21,0,.7,0,.91a6.11,6.11,0,0,0,.14,1,1.62,1.62,0,0,0,.37.73.88.88,0,0,0,.62.28,1.8,1.8,0,0,0,.94-.3,3.85,3.85,0,0,0,.92-.73,5.37,5.37,0,0,0,.59-.84,4.12,4.12,0,0,0,.35-.85c.08-.28.15-.54.19-.76a2.68,2.68,0,0,1,.18-.68.92.92,0,0,1,.38-.38l2.15-1.24a.21.21,0,0,1,.26,0,.46.46,0,0,1,.1.34,10.12,10.12,0,0,1-.41,2.66,12.09,12.09,0,0,1-1.08,2.6,12.22,12.22,0,0,1-1.62,2.26,8.38,8.38,0,0,1-2,1.66,4.28,4.28,0,0,1-2.11.67,2.39,2.39,0,0,1-1.59-.56,3.54,3.54,0,0,1-1-1.61,8.2,8.2,0,0,1-.4-2.41c0-.68,0-1.41,0-2.2s0-1.56,0-2.3a13.11,13.11,0,0,1,.39-2.87,13.44,13.44,0,0,1,1-2.77,11.12,11.12,0,0,1,1.59-2.4,8.06,8.06,0,0,1,2.12-1.76,4.46,4.46,0,0,1,2-.67,2.72,2.72,0,0,1,1.62.39,2.86,2.86,0,0,1,1.08,1.35,5.66,5.66,0,0,1,.41,2.19,1,1,0,0,1-.1.45.69.69,0,0,1-.26.31l-2.15,1.25c-.19.1-.31.12-.38.05a1,1,0,0,1-.18-.47,3.51,3.51,0,0,0-.19-.54,1.06,1.06,0,0,0-.35-.45,1.08,1.08,0,0,0-.59-.15,2.19,2.19,0,0,0-.92.33,3.46,3.46,0,0,0-.94.78,4.35,4.35,0,0,0-.62,1,4.91,4.91,0,0,0-.37,1.14A9.81,9.81,0,0,0,347.84,433.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.35,428.49a13.86,13.86,0,0,1,.4-2.9,12.7,12.7,0,0,1,1-2.75,11.32,11.32,0,0,1,1.58-2.38,8.29,8.29,0,0,1,2.14-1.78,4.4,4.4,0,0,1,2.14-.69,2.34,2.34,0,0,1,1.58.55,3.45,3.45,0,0,1,1,1.6,8.69,8.69,0,0,1,.4,2.43c0,.72,0,1.47,0,2.26s0,1.54,0,2.25a14.55,14.55,0,0,1-.4,2.9,13,13,0,0,1-1,2.76,11.14,11.14,0,0,1-1.58,2.39,8.56,8.56,0,0,1-2.14,1.76,4.52,4.52,0,0,1-2.14.71,2.35,2.35,0,0,1-1.58-.56,3.53,3.53,0,0,1-1-1.61,8.35,8.35,0,0,1-.4-2.44c0-.67,0-1.41,0-2.2S356.32,429.23,356.35,428.49Zm7.21.21c0-.31,0-.65,0-1s0-.76,0-1.15,0-.76,0-1.11,0-.68,0-1a4.52,4.52,0,0,0-.17-1.06,1.74,1.74,0,0,0-.4-.7.94.94,0,0,0-.63-.25,1.78,1.78,0,0,0-.89.28,3.5,3.5,0,0,0-.88.74,4.3,4.3,0,0,0-.64,1,5.37,5.37,0,0,0-.39,1.15,7.49,7.49,0,0,0-.17,1.26c0,.3,0,.64-.05,1v2.27c0,.36,0,.69.05,1a2.85,2.85,0,0,0,.56,1.78c.34.36.84.34,1.52-.05a3.53,3.53,0,0,0,1.51-1.7A7.21,7.21,0,0,0,363.56,428.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.33,425.33a1.22,1.22,0,0,1-.23-.29l-1.54-3.28v8.37a1.3,1.3,0,0,1-.13.56.87.87,0,0,1-.31.38L369,432.31a.24.24,0,0,1-.31,0,.52.52,0,0,1-.13-.4V415.54a1.23,1.23,0,0,1,.13-.55.77.77,0,0,1,.31-.38l1.91-1.11c.22-.12.38-.12.49,0a2.27,2.27,0,0,1,.22.28l2.66,5.47,2.66-8.54a4.55,4.55,0,0,1,.21-.53,1.15,1.15,0,0,1,.5-.56l1.9-1.1a.23.23,0,0,1,.31,0,.52.52,0,0,1,.14.4v16.34a1.29,1.29,0,0,1-.14.56.81.81,0,0,1-.31.38l-2.15,1.24a.23.23,0,0,1-.31,0,.52.52,0,0,1-.13-.4v-8.38l-1.55,5.07a4.49,4.49,0,0,1-.22.55.91.91,0,0,1-.39.43l-1.05.61C373.55,425.41,373.42,425.42,373.33,425.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4,404a5.47,5.47,0,0,1,1.89-.72,2,2,0,0,1,1.43.29,2.55,2.55,0,0,1,.91,1.33,7.59,7.59,0,0,1,.32,2.39,11.74,11.74,0,0,1-.32,2.79,9.8,9.8,0,0,1-.91,2.38,9.12,9.12,0,0,1-1.43,1.93,8.77,8.77,0,0,1-1.89,1.48L385.3,417v5.16a1.29,1.29,0,0,1-.14.56.81.81,0,0,1-.31.38l-2.15,1.24a.24.24,0,0,1-.31,0,.53.53,0,0,1-.13-.41V407.61a1.23,1.23,0,0,1,.13-.55.77.77,0,0,1,.31-.38Zm-2.1,9.13,2-1.16a3.24,3.24,0,0,0,1.14-1.13,3.35,3.35,0,0,0,.45-1.79c0-.71-.15-1.13-.45-1.27a1.23,1.23,0,0,0-1.14.19l-2,1.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.8,397.38c.22-.13.39-.13.5,0a.89.89,0,0,1,.24.42l3.58,13.86a1.52,1.52,0,0,1,.07.35,1.06,1.06,0,0,1-.11.45.68.68,0,0,1-.26.31l-2.07,1.2c-.21.12-.37.14-.46.05a.57.57,0,0,1-.18-.32l-.46-1.83-4.37,2.52-.46,2.37a2,2,0,0,1-.17.52,1.14,1.14,0,0,1-.47.48l-2.07,1.2a.2.2,0,0,1-.25,0,.45.45,0,0,1-.11-.33,1.86,1.86,0,0,1,.07-.42l3.58-18a3.06,3.06,0,0,1,.24-.7,1.15,1.15,0,0,1,.5-.56ZM396.14,410l2.66-1.54-1.33-5.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,407.47a.38.38,0,0,1-.45,0,.75.75,0,0,1-.22-.22l-3.76-6.48v8.55a1.38,1.38,0,0,1-.13.55.86.86,0,0,1-.32.39L405,411.53a.24.24,0,0,1-.31,0,.55.55,0,0,1-.13-.41V394.76a1.23,1.23,0,0,1,.13-.55.85.85,0,0,1,.31-.39l1.71-1c.19-.11.34-.12.45,0a.65.65,0,0,1,.22.23l3.77,6.48V391a1.27,1.27,0,0,1,.13-.56.81.81,0,0,1,.31-.38l2.15-1.24a.23.23,0,0,1,.31,0,.52.52,0,0,1,.14.4v16.34a1.29,1.29,0,0,1-.14.56.76.76,0,0,1-.31.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.46,400.74a1.39,1.39,0,0,1-.13.56.83.83,0,0,1-.32.38l-2.15,1.25a.24.24,0,0,1-.31,0,.52.52,0,0,1-.13-.4v-5.39l-3.8-8.56a.72.72,0,0,1-.06-.29,1,1,0,0,1,.1-.45.69.69,0,0,1,.26-.31l2.25-1.3c.22-.13.38-.14.49,0a.76.76,0,0,1,.2.27l2.07,5L423,384a2.38,2.38,0,0,1,.19-.49,1.19,1.19,0,0,1,.5-.54l2.25-1.3a.18.18,0,0,1,.25,0,.45.45,0,0,1,.11.33,1.08,1.08,0,0,1-.07.36l-3.79,12.95Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Logo--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331,433.84v3.88a13.71,13.71,0,0,0-4.34,8.45l-3,1.74v-7.49a4.19,4.19,0,0,1,1.75-3.34Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,452.07v4.21l-5.61,3.24c-1,.56-1.75,0-1.75-1.32v-7.49l3.06-1.77C327.2,451.51,328.9,452.76,331,452.07Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.51,441v7.49a4.22,4.22,0,0,1-1.75,3.35l-5.62,3.24v-4.22a13.69,13.69,0,0,0,4.3-8.09Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.51,430.71v7.49l-3,1.74c-.38-2.77-2.12-4.14-4.35-3.43v-3.88l5.62-3.24C339.72,428.83,340.51,429.42,340.51,430.71Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.09,
    cy: 444.29,
    rx: 6.19,
    ry: 3.5,
    transform: "translate(-206.75 575.9) rotate(-66.95)",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.09,
    cy: 444.29,
    rx: 6.19,
    ry: 3.5,
    transform: "translate(-206.75 575.9) rotate(-66.95)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrmsLogin3);
export default __webpack_public_path__ + "static/media/HRMS-Login-3.4765e416d43a1b9e33b2b0d7815780dc.svg";
export { ForwardRef as ReactComponent };